import type { Dict } from '../types';

export const id: Dict = {
  "collab.contentUpdate.available": "Versi cloud baru tersedia",
  "collab.contentUpdate.updating": "Memperbarui…",
  "collab.contentUpdate.askAgain": "Pulihkan pemberitahuan pembaruan",
  "collab.contentUpdate.title": "Pembaruan cloud tersedia",
  "collab.contentUpdate.description": "Sinkronkan konten terbaru dari perangkat lain ke perangkat ini? Konten proyek lokal akan diganti. Halaman dapat dipulihkan dari riwayat versi lokal; gambar dan berkas lain mungkin tidak dapat dipulihkan.",
  "collab.contentUpdate.dontPrompt": "Jangan beri tahu tentang proyek ini selama 24 jam",
  "collab.contentUpdate.later": "Tidak sekarang",
  "collab.contentUpdate.replace": "Ganti dengan versi cloud",
  "collab.contentUpdate.failed": "Pembaruan gagal. Coba lagi.",
  "collab.contentUpdate.busy": "Pembuatan atau pengunggahan sedang berlangsung. Coba setelah selesai.",
  "collab.contentUpdate.unsupported": "Penggantian cloud tidak mendukung folder yang diimpor.",
  "fileViewer.versions.sourceSync": "Disinkronkan",
  'billing.wallet': 'Saldo dompet',
  'billing.codingPlanDesignPlan': 'Design Plan',
  'billing.codingPlanPeriodHours': '{count} jam',
  'billing.codingPlanPeriodDays': '{count} hari',
  'billing.codingPlanRemainingPercent': 'Sisa {percent}%',
  "campaign.testReplay": "Buka kembali aktivitas uji",
  'invite.header.eyebrow': "Team invitation",
  'invite.loading': "Loading invitation…",
  'invite.landing.title': "Join the team",
  'invite.landing.subtitle': "You’ve been invited to collaborate in OpenDesign.",
  'invite.landing.roleLabel': "Role",
  'invite.landing.invitedEmail': "Invited email",
  'invite.landing.expires': "Expires",
  'invite.role.admin': "Admin",
  'invite.role.member': "Member",
  'invite.role.admin.desc': "Can manage members, seats, and all project settings.",
  'invite.role.member.desc': "Can create your own projects, and view and comment on shared team projects.",
  'invite.accept.cta': "Accept invitation",
  'invite.accountMismatch.title': "You’re signed in as a different account",
  'invite.accountMismatch.body': "This invitation was sent to a different email address. You can continue with your current account, or switch accounts.",
  'invite.accountMismatch.continue': "Continue with current account",
  'invite.accountMismatch.switch': "Switch account",
  'invite.accepting.title': "Joining the team…",
  'invite.accepting.body': "Setting up your membership.",
  'invite.success.title': "You’re in",
  'invite.success.body': "Opening OpenDesign so you can start collaborating.",
  'invite.success.roleReceipt': "Joined as",
  'invite.success.enter': "Enter workspace",
  'invite.open.cta': "Open OpenDesign",
  'invite.open.opening': "Opening OpenDesign…",
  'invite.open.retry': "Already installed? Try opening again",
  'invite.notInstalled.title': "Didn’t open automatically?",
  'invite.notInstalled.body': "You may not have OpenDesign installed yet. Install it, then reopen this link to finish joining.",
  'invite.notInstalled.download': "Download OpenDesign",
  'invite.error.title': "Can’t accept this invitation",
  'invite.error.invite_expired': "This invitation has expired. Ask an admin to send a new one.",
  'invite.error.invite_consumed': "This invitation has already been used.",
  'invite.error.workspace_seat_limit_reached': "The team has no seats left. Ask an admin to free up a seat or add more.",
  'invite.error.workspace_subscription_locked': "The team’s subscription is inactive, so new members can’t join right now.",
  'invite.error.workspace_not_found': "This workspace no longer exists.",
  'invite.error.workspace_forbidden': "Your account isn’t allowed to accept this invitation.",
  'invite.error.invite_unavailable': "This invitation is no longer available.",
  'invite.error.generic': "Something went wrong. Please try again.",
  'invite.error.retry': "Try again",
  "workspaceInvite.dialogAria": "Invite members",
  "workspaceInvite.title": "Invite members to your team",
  "workspaceInvite.freePlanBody": "The free plan includes 1 seat. Inviting teammates will guide you to upgrade to Teams.",
  "workspaceInvite.teamPlanBody": "Invite teammates to share projects, design systems, and plugins together.",
  "workspaceInvite.seatsExhaustedBody": "Ruang kerja ini tidak memiliki kursi tersisa. Tambahkan kursi untuk mengundang rekan tim.",
  "workspaceInvite.seatsExhaustedAction": "Lihat kursi dan paket",
  "workspaceInvite.emailLabel": "Invite members by email",
  "workspaceInvite.roleLabel": "Assign role",
  "workspaceInvite.defaultRoleLabel": "Default role",
  "workspaceInvite.emailPlaceholder": "Enter email address…",
  "workspaceInvite.removeRow": "Remove",
  "workspaceInvite.addMember": "Add member",
  "workspaceInvite.visibilityQuestion": "Will team members see my designs?",
  "workspaceInvite.visibilityAnswer": "Team members can see designs you share to the team space. Private designs kept in Personal projects are not visible to others.",
  "workspaceInvite.sent": "Invitation sent",
  "workspaceInvite.sending": "Inviting…",
  "workspaceInvite.confirm": "Confirm and invite",
  "workspaceInvite.submitFailed": "Failed to send invitation. Try again later.",
  "workspaceInvite.errorAlreadyMember": "Email ini sudah menjadi anggota tim.",
  "workspaceInvite.errorPendingInvite": "Email ini sudah memiliki undangan yang menunggu.",
  "workspaceInvite.errorNoSession": "Masuk ke akun Vela Anda sebelum mengundang anggota.",
  "workspaceInvite.errorNoWorkspace": "Belum ada ruang tim untuk mengundang anggota.",
  "workspaceInvite.errorUnreachable": "Undangan tidak dapat dikirim. Silakan coba lagi nanti.",
  'chat.amrCard.switchTitle': 'Panggilan model gagal — proses ini dijeda',
  'chat.amrCard.switchBody': 'Beralih ke layanan model resmi OpenDesign Cloud — tanpa perlu mengatur API Key. Setelah masuk, otorisasi, dan isi ulang, proses ini akan dicoba ulang otomatis.',
  'chat.amrCard.chipOfficial': 'Hosting resmi',
  'chat.amrCard.chipNoKey': 'Tanpa API Key',
  'chat.amrCard.chipAutoRetry': 'Coba ulang otomatis setelah masuk',
  'chat.amrCard.switchCta': 'Beralih ke OpenDesign Cloud',
  "chat.amrCard.switchedResend": "Beralih ke OpenDesign Cloud. Silakan kirim ulang tugas Anda.",
  'chat.amrError.authMessage': 'Akun OpenDesign Cloud Anda belum diotorisasi. Otorisasi sekarang dan proses ini akan dicoba ulang otomatis.',
  'chat.amrError.balanceMessage': 'Saldo OpenDesign Cloud Anda habis. Isi ulang untuk melanjutkan proses ini.',
  'chat.amrError.authorizeCta': 'Otorisasi & coba lagi',
  'chat.amrError.rechargeCta': 'Isi ulang',
  'chat.amrBalanceGate.title': 'Saldo yang tersedia tidak cukup',
  'chat.amrBalanceGate.message': 'Saldo Anda tidak cukup. Isi ulang atau tingkatkan paket, lalu coba lagi.',
  'chat.amrBalanceGate.benefitsTitle': 'Yang Anda dapatkan dengan OpenDesign Cloud',
  'chat.amrBalanceGate.benefit1': 'Tanpa API key, banyak model tersedia',
  'chat.amrBalanceGate.benefit2': 'Agen desain SOTA bawaan, tanpa konfigurasi',
  'chat.amrBalanceGate.benefit3': 'Layanan resmi dan tepercaya',
  'chat.amrBalanceGate.benefit4': 'Terus berkembang: deploy sekali klik, multimodal, tim, dan lainnya',
  'chat.amrBalanceGate.laterCta': 'Nanti saja',
  'chat.amrBalanceGate.plansCta': 'Tingkatkan paket',
  'chat.amrBalanceGate.signedOutTitle': 'Open Design belum masuk',
  'chat.amrBalanceGate.signedOutMessage': 'Masuk untuk melihat proyek Anda dan melanjutkan percakapan.',
  'chat.amrBalanceGate.signInCta': 'Masuk',
  'chat.amrBalanceGate.watchingWallet': 'Kami akan melanjutkan otomatis begitu saldo Anda diperbarui.',
  'chat.amrArtifactUpgrade.title': 'Terus sempurnakan dengan model yang lebih kuat',
  'chat.amrArtifactUpgrade.message': 'Buka model canggih, lebih banyak tugas paralel, dan lebih banyak kredit bulanan.',
  'chat.amrArtifactUpgrade.benefit1': 'Lebih banyak model canggih, termasuk Fable 5 dan GPT-5.6',
  'chat.amrArtifactUpgrade.benefit2': 'Jalankan hingga 10× lebih banyak tugas sekaligus',
  'chat.amrArtifactUpgrade.benefit3': 'Hingga 300× lebih banyak kredit bulanan',
  'chat.amrArtifactUpgrade.benefit4': 'Antrean prioritas saat jam sibuk untuk generasi lebih cepat',
  'chat.amrArtifactUpgrade.promoBanner': 'Waktu terbatas: hemat hingga 67% untuk paket langganan',
  'chat.amrArtifactUpgrade.countdownLabel': 'Berakhir dalam',
  'chat.amrArtifactUpgrade.plansCta': 'Upgrade sekarang, diskon hingga 67%',
  'chat.amrArtifactUpgrade.homePlansCta': 'Hemat 67%',
  'chat.amrArtifactUpgrade.laterCta': 'Lanjutkan dengan Free dan kirim',
  'chat.amrArtifactUpgrade.homeTitle': 'Karya Anda siap. Bawa ide berikutnya lebih jauh.',
  'chat.amrArtifactUpgrade.homeMessage': 'Tingkatkan untuk model yang lebih kuat, lebih banyak tugas paralel, dan lebih banyak kredit.',
  'chat.amrArtifactUpgrade.homeArtifactCta': 'Lihat karya',
  'chat.antigravityError.launchTerminalCta': 'Masuk melalui terminal',
  'chat.antigravityError.launchSwitchModelCta': 'Ganti model di terminal',
  'chat.connectionDropped': 'Pastikan koneksi jaringan Anda berfungsi, lalu coba lagi.',
  'chat.runError.title.authRequired': 'Perlu otorisasi',
  'chat.runError.title.balance': 'Saldo tidak cukup',
  'chat.runError.title.connectionDropped': 'Koneksi jaringan terputus',
  'chat.runError.title.signInRequired.other': '{agent} belum masuk',
  'chat.runError.title.signInRequired.amr': 'Open Design belum masuk',
  'chat.runError.title.rateLimited': 'Layanan model sedang sibuk',
  'chat.runError.title.modelWindowLimit': 'Sedang ramai',
  'chat.runError.title.membershipConcurrencyLimit': 'Batas tugas bersamaan tercapai',
  'chat.runError.title.strategyTaskHalted': "Tugas dihentikan oleh gerbang kualitas",
  "chat.runError.title.agentReplyIncomplete": "Tugas tidak dapat diselesaikan",
  'chat.runError.title.noDeliverable': "Putaran ini tidak menghasilkan berkas",
  'chat.runError.title.clarificationRepeated': "Agen mengajukan pertanyaan lagi",
  "chat.runError.title.regionNotSupported": "Layanan ini saat ini tidak tersedia di wilayah Anda",
  'chat.runError.title.clientEnvironment': 'Masalah lingkungan jaringan',
  "chat.runError.title.certificateFailure": "Tidak dapat terhubung ke layanan dengan aman",
  "chat.runError.certificateFailureMessage": "Koneksi ke layanan tidak lolos verifikasi keamanan. Coba gunakan jaringan lain.",
  "chat.runError.title.proxyConfiguration": "Tidak dapat terhubung ke proksi",
  "chat.runError.proxyConfigurationMessage": "Proksi yang dikonfigurasi tidak dapat dihubungi. Pastikan proksi aktif dan pengaturannya benar, lalu coba lagi.",
  "chat.runError.title.networkConfiguration": "Tidak dapat terhubung ke layanan",
  "chat.runError.networkConfigurationMessage": "Layanan sementara tidak dapat diakses. Periksa koneksi jaringan, lalu coba lagi.",
  "chat.runError.title.hostPolicyBlock": "Program diblokir saat dimulai",
  "chat.runError.hostPolicyBlockMessage": "Windows memblokir program agar tidak dimulai. Periksa pengaturan keamanan sistem.",
  "chat.runError.title.localStorageFailure": "Tidak dapat menyimpan file",
  "chat.runError.localStorageFailureMessage": "File tidak dapat ditulis ke disk. Pastikan ruang kosong mencukupi, lalu coba lagi.",
  "chat.runError.title.tierUpgradeRequired": "Paket saat ini tidak mendukung tugas ini",
  "chat.runError.tierUpgradeRequiredMessage": "Paket saat ini tidak dapat melanjutkan tugas ini. Tingkatkan paket, lalu coba lagi.",
  "chat.runError.title.generic": "Tugas tidak dapat diselesaikan",
  'chat.runError.title.artifactMissing': "Tidak ada file untuk dipratinjau",
  'chat.runError.artifactMissingMessage': "Tugas ini tidak menghasilkan file untuk dipratinjau. Tambahkan apa yang ingin dibuat lalu coba lagi.",
  'chat.runError.signInMessage.amr': 'Masuk untuk melihat proyek Anda dan melanjutkan percakapan.',
  'chat.runError.signInMessage.other': 'Masuk ke {agent} terlebih dahulu, lalu coba lagi.',
  'chat.runError.agentFallback': 'agen',
  'chat.runError.sourceLabel': 'Detail kesalahan',
  'chat.runError.sourceExpandAria': 'Perluas sumber kesalahan',
  'chat.runError.sourceCollapseAria': 'Ciutkan sumber kesalahan',
  'chat.runError.title.cliMissing': '{agent} tidak terdeteksi',
  'chat.runError.title.promptTooLarge': 'Percakapan terlalu panjang',
  'chat.runError.title.modelUnavailable': "Model saat ini tidak tersedia",
  'chat.runError.title.modelCapabilityUnsupported': "Model saat ini tidak mendukung tugas ini",
  'chat.runError.title.upstreamUnavailable': 'Layanan model tidak tersedia',
  "chat.runError.title.toolLoop": "Tugas tidak dapat dilanjutkan",
  'chat.runError.title.outputInvalid': 'Tidak ada balasan valid yang dihasilkan',
  'chat.runError.title.runtimeConfig': "Kesalahan pada Open Design",
  'chat.runError.title.apiKeyInvalid': 'Pengaturan model belum lengkap',
  'chat.runError.cliMissingMessage': 'Pastikan {agent} sudah terpasang di komputer ini, lalu coba lagi.',
  "chat.runError.promptTooLargeMessage": "Konteks saat ini melebihi panjang yang dapat diproses model. Buat percakapan baru, lalu coba lagi.",
  'chat.runError.modelUnavailableMessage': "Silakan pilih model lain yang tersedia, lalu coba lagi.",
  'chat.runError.modelCapabilityUnsupportedMessage': "Model ini tidak mendukung kemampuan yang dibutuhkan tugas ini. Ganti model lalu coba lagi.",
  'chat.runError.rateLimitedMessage': 'Saat ini ada banyak permintaan ke layanan model ini dan batas frekuensi permintaan penyedia telah tercapai. Coba lagi nanti, atau coba beralih ke model lain.',
  'chat.runError.modelWindowLimitMessage': 'Sedang ramai saat ini. Coba lagi setelah {retryAt}. Permintaan ini tidak dikenai biaya.',
  'chat.runError.modelWindowLimitMessageNoTime': 'Sedang ramai saat ini. Coba lagi sebentar lagi. Permintaan ini tidak dikenai biaya.',
  'chat.runError.membershipConcurrencyLimitMessage': 'Batas tugas bersamaan untuk keanggotaan Anda sudah penuh. Tunggu hingga {retryAt}, lalu coba lagi, atau ganti agen. Mencoba ulang segera tidak akan membantu.',
  'chat.runError.membershipConcurrencyLimitMessageNoTime': 'Batas tugas bersamaan untuk keanggotaan Anda sudah penuh. Tunggu tugas lain selesai, lalu coba lagi, atau ganti agen.',
  'chat.runError.upstreamUnavailableMessage': 'Model saat ini sementara tidak tersedia. Coba lagi nanti, atau ganti model.',
  "chat.runError.toolLoopMessage": "AI terhenti pada langkah yang sama dan tidak dapat melanjutkan setelah beberapa kali mencoba. Coba lagi, atau ganti model lalu coba lagi.",
  'chat.runError.outputInvalidMessage': 'Coba buat ulang, atau ganti model lalu coba lagi. Jika terus terjadi, hubungi dukungan.',
  'chat.runError.runtimeConfigMessage': 'Coba buat ulang, atau ganti model lalu coba lagi. Jika terus terjadi, hubungi dukungan.',
  'chat.runError.apiKeyInvalidMessage': 'Kunci API salah dikonfigurasi. Masukkan ulang, lalu coba lagi.',
  'chat.runError.title.quotaExhausted': "Kuota habis",
  'chat.runError.title.timedOut': "Waktu tunggu balasan habis",
  "chat.runError.title.emptyOutput": "Tidak dapat menghasilkan konten",
  "chat.runError.title.sessionExpired": "Tidak dapat melanjutkan tugas sebelumnya",
  'chat.runError.title.gitBashMissing': "Git Bash tidak ada",
  "chat.runError.title.cpuUnsupported": "Perangkat ini tidak dapat menjalankan program",
  "chat.runError.title.osUnsupported": "Versi Windows terlalu lama",
  'chat.runError.title.cliSessionRefused': "Versi agen tidak kompatibel",
  'chat.runError.quotaExhaustedMessage': "Kuota atau batas tagihan layanan model Anda sudah habis, jadi mencoba lagi tidak akan membantu. Isi ulang di penyedia Anda, atau beralih ke model atau layanan lain.",
  'chat.runError.workspaceCreditsMessage': "Kredit ruang kerja Anda habis. Tambahkan kredit (atau minta pemilik ruang kerja mengisi ulang), atau beralih ke model atau layanan lain.",
  'chat.runError.timedOutMessage': "Sudah lama tidak ada balasan baru dari AI, jadi proses ini dihentikan. Silakan coba lagi nanti.",
  'chat.runError.inactivityTimeoutMessage': "Sudah lama tidak ada balasan baru dari AI, jadi proses ini dihentikan. Silakan coba lagi nanti.",
  "chat.runError.emptyOutputMessage": "AI tidak dapat menghasilkan konten. Mulai kembali tugas, atau ganti model lalu coba lagi.",
  "chat.runError.sessionExpiredMessage": "Tugas sebelumnya tidak dapat dilanjutkan lagi. Mulai kembali tugas.",
  'chat.runError.gitBashMissingMessage': "Git Bash diperlukan untuk menjalankan agen ini di Windows, tetapi tidak ditemukan. Pasang Git for Windows, lalu coba lagi.",
  "chat.runError.cpuUnsupportedMessage": "Prosesor komputer ini tidak mendukung fitur yang diperlukan program. Gunakan perangkat yang memenuhi persyaratan sistem.",
  "chat.runError.osUnsupportedMessage": "Versi Windows ini terlalu lama untuk menjalankan runtime AMR. Perbarui ke Windows 10 versi 1809 (build 17763) atau yang lebih baru, lalu coba lagi.",
  'chat.runError.title.agentCrashed': 'Tugas terhenti tak terduga',
  'chat.runError.agentCrashedMessage': 'Coba buat ulang, atau ganti model lalu coba lagi. Jika terus terjadi, hubungi dukungan.',
  'chat.runError.title.accountSuspended': 'Akun ditangguhkan',
  'chat.runError.accountSuspendedMessage': 'Untuk mengetahui alasannya atau mengajukan pemulihan, hubungi dukungan.',
  "chat.runError.fallbackMessage": "Tugas ini gagal dijalankan. Coba lagi. Jika gagal lagi, hubungi dukungan.",
  "chat.runError.cliSessionRefusedMessage": "Open Design belum mendukung versi agen ini. Ganti ke versi yang didukung, lalu coba lagi.",
  'chat.runError.strategyTaskStateMismatchMessage': "Tugas ini sudah dihentikan oleh gerbang kualitas strategi, sehingga putaran formulir ini tidak dapat dilanjutkan. Coba lagi permintaannya atau mulai yang baru.",
  "chat.runError.agentReplyIncompleteMessage": "Tugas ini gagal dijalankan. Coba lagi. Jika gagal lagi, hubungi dukungan.",
  'chat.runError.noDeliverableMessage': "Agen sudah selesai, tetapi belum ada berkas yang bisa dibuka di proyek ini, jadi tugasnya tidak bisa dicatat sebagai terkirim. Tidak ada yang hilang dari yang kamu kirim — coba lagi, atau tambahkan satu kalimat tentang apa yang kamu inginkan.",
  'chat.runError.clarificationRepeatedMessage': "Agen meminta detail tambahan untuk kedua kalinya, padahal satu tugas hanya menyediakan satu putaran pertanyaan, jadi prosesnya berhenti di sini. Jawaban Anda tetap tersimpan di percakapan — mencoba lagi akan menjalankan permintaan dari awal, dan menuliskan detail tambahan itu sekaligus biasanya cukup untuk satu putaran.",
  "chat.runError.regionNotSupportedMessage": "Penyedia saat ini tidak menawarkan layanan di wilayah Anda. Tugas saat ini tidak dapat dilanjutkan.",
  'chat.runError.clientEnvironmentMessage': 'Sepertinya permintaan melewati proxy atau jaringan perusahaan, dan {agent} menolaknya ({cause}). Coba jalur jaringan lain, atau atur proxy di Pengaturan.',
  'chat.runError.clientEnvironmentCause.certificate': 'verifikasi sertifikat gagal',
  'chat.runError.clientEnvironmentCause.proxy': 'masalah konfigurasi proxy',
  'chat.runError.clientEnvironmentCause.network': 'jaringan tidak dapat dijangkau',
  'chat.runError.clientEnvironmentCause.hostPolicy': 'diblokir oleh kebijakan sistem',
  'chat.runError.clientEnvironmentCause.localStorage': 'gagal membaca/menulis penyimpanan lokal',
  'common.cancel': 'Batal',
  'chat.selectFromLibrary': 'Impor dari pustaka',
  'chat.importFigma': 'Impor dari Figma',
  'chat.plus.group.files': 'Files',
  'chat.plus.group.code': 'Code',
  'chat.plus.group.designs': 'Designs',
  'chat.plus.group.other': 'Other',
  'chat.plus.attachFiles': 'Attach files',
  'chat.plus.referenceProject': 'Reference another project',
  'chat.plus.linkLocalCode': 'Link local code',
  'chat.plus.uploadFig': 'Upload .fig file',
  'chat.plus.learnHow': 'Learn how',
  'chat.plus.designSystem': 'Design system',
  'chat.plus.skills': 'Skills',
  'chat.plus.noSkills': 'No skills available',
  'chat.plus.connectors': 'Connectors',
  'chat.plus.plugins': 'Plugins',
  'chat.plus.mcp': 'MCP',
  'chat.referenceProject.title': 'Reference another project',
  'chat.referenceProject.search': 'Search projects…',
  'chat.referenceProject.empty': 'No projects match “{query}”',
  'chat.referenceProject.emptyAll': 'No other projects yet',
  'chat.referenceProject.loadFailed': 'Could not load projects. Check that the daemon is running and try again.',
  'chat.referenceProject.confirm': 'Reference project',
  'chat.contextPrompt.referenceProject': 'Use the OpenDesign project “{name}” as reference context. Its local path is: {path}. Before designing or modifying anything, search and read this directory when useful.',
  'chat.contextPrompt.localCode': 'Use the local code folder “{name}” as code reference. Its absolute path is: {path}. Read relevant files when useful and stay consistent with the existing implementation.',
  'chat.figmaHelp.title': 'How to download a .fig file',
  'chat.figmaHelp.intro': 'From the Figma web or desktop app:',
  'chat.figmaHelp.step1': 'Open the file in Figma.',
  'chat.figmaHelp.step2': 'Go to File → Save local copy... (web: main menu → File).',
  'chat.figmaHelp.step3': 'Figma downloads a .fig file. Drop it onto the composer or upload it.',
  'chat.figmaHelp.note': 'The .fig file is parsed locally and is not uploaded to Figma.',
  'designFiles.library.label': 'Impor dari pustaka',
  'designFiles.library.title': 'Impor dari pustaka',
  'libraryPicker.title': 'Impor dari pustaka',
  'libraryPicker.searchPlaceholder': 'Cari di pustaka…',
  'libraryPicker.empty': 'Belum ada aset di pustaka Anda',
  'libraryPicker.allKinds': 'Semua',
  'libraryPicker.add': 'Impor',
  'libraryPicker.loading': 'Memuat…',
  'common.save': 'Simpan',
  'common.close': 'Tutup',
  'common.clear': 'Bersihkan',
  'common.delete': 'Hapus',
  'common.rename': 'Ganti nama',
  'common.edit': 'Edit',
  'common.preview': 'Pratinjau',
  'common.share': 'Bagikan',
  'common.search': 'Cari',
  'common.searchEllipsis': 'Cari...',
  'common.loading': 'Memuat...',
  'common.all': 'Semua',
  'common.none': 'Tidak ada',
  'common.default': 'Default',
  'common.installed': 'terpasang',
  'common.notInstalled': 'belum terpasang',
  'common.active': 'aktif',
  'common.inactive': 'nonaktif',
  'common.offline': 'offline',
  'common.selected': 'dipilih',
  'common.create': 'Buat',
  'common.openPreview': 'Buka pratinjau',
  'common.exitFullscreen': 'Keluar layar penuh',
  'common.fullscreen': 'Layar penuh',
  'common.openInNewTab': 'Buka di tab baru',
  'common.exportPdf': 'Ekspor sebagai PDF',
  'common.exportZip': 'Unduh sebagai .zip',
  'common.exportHtml': 'Ekspor sebagai HTML mandiri',
  'common.exportImage': 'Ekspor sebagai gambar',
  'common.exportImageFailed': 'Gagal menangkap gambar. Silakan coba lagi atau gunakan alat tangkapan layar browser Anda.',
  'common.justNow': 'baru saja',
  'common.minutesAgo': '{n}m lalu',
  'common.hoursAgo': '{n}j lalu',
  'common.daysAgo': '{n}h lalu',
  'common.weeksAgo': '{n} mgg lalu',
  'common.now': 'sekarang',
  'common.minutesShort': '{n}m',
  'common.hoursShort': '{n}j',
  'common.daysShort': '{n}h',
  'common.untitled': 'Tanpa judul',
  'designBrowser.savePageBrief': 'Save page brief',
  'designBrowser.viewport.desktop': 'Desktop',
  'designBrowser.viewport.desktopTitle': 'Gunakan ukuran penuh tab browser',
  'designBrowser.viewport.tablet': 'Tablet',
  'designBrowser.viewport.tabletTitle': 'Pratinjau dengan lebar 820px',
  'designBrowser.viewport.mobile': 'Seluler',
  'designBrowser.viewport.mobileTitle': 'Pratinjau dengan lebar 390px',
  'designBrowser.menu': 'Browser menu',
  'designBrowser.copyScreenshot': 'Copy screenshot',
  'designBrowser.hardReload': 'Hard reload',
  'designBrowser.copyUrl': 'Copy URL',
  'designBrowser.openExternal': 'Open externally',
  'designBrowser.downloadPage': 'Download page',
  'designBrowser.downloadPageBusy': 'Downloading page...',
  'designBrowser.clearHistory': 'Clear history',
  'designBrowser.clearCookies': 'Clear cookies',
  'designBrowser.clearAllData': 'Clear all browser data',
  'designBrowser.status.noUrlToCopy': 'No URL to copy.',
  'designBrowser.status.urlCopied': 'URL copied.',
  'designBrowser.status.openHttpFirst': 'Open an http or https page first.',
  'designBrowser.status.openBeforeScreenshot': 'Open a page before taking a screenshot.',
  'designBrowser.status.screenshotSaved': 'Screenshot saved.',
  'designBrowser.addImageToChatButton': 'Tambahkan ke Chat',
  'designBrowser.status.imageAddedToChat': 'Gambar ditambahkan ke chat.',
  'designBrowser.status.screenshotFailed': 'Screenshot failed.',
  'designBrowser.status.openBeforeBrief': 'Open a page before saving a brief.',
  'designBrowser.status.briefSaveFailed': 'Page brief save failed.',
  'designBrowser.status.openBeforeDownload': 'Open a page before saving a snapshot.',
  'designBrowser.status.pageSnapshotStarted': 'Saving page snapshot...',
  'designBrowser.status.pageSnapshotUnsupported': 'This page cannot be archived.',
  'designBrowser.status.pageSnapshotFailed': 'Page snapshot save failed.',
  'designBrowser.status.pageSnapshotSaved': 'Saved page snapshot (HTML + CSS).',
  'designBrowser.status.viewDesignFiles': 'View Design Files',
  'designBrowser.status.downloadAssistHint': 'When the page is ready, click Download Page. Return to chat after it is saved.',
  'designBrowser.status.desktopDataUnavailable': 'Desktop browser data is unavailable here.',
  'designBrowser.status.browserDataCleared': 'Browser data cleared.',
  'designBrowser.status.browserDataClearFailed': 'Browser data clear failed.',
  'designBrowser.status.historyCleared': 'History cleared.',
  'plugins.availableDetails.provenance': 'Asal-usul',
  'plugins.availableDetails.provenanceLine': 'dari {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'dari {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'Instal',
  'plugins.availableDetails.version': 'Versi',
  'plugins.availableDetails.pluginVersion': 'Versi plugin',
  'plugins.availableDetails.copyInstallCommand': 'Salin perintah instalasi',
  'plugins.availableDetails.copied': 'Tersalin',
  'plugins.availableDetails.deprecatedPrefix': 'Usang: {message}',
  'plugins.availableDetails.deprecatedFallback': 'Versi ini telah ditandai usang.',
  'plugins.availableDetails.yanked': 'Ditarik.',
  'plugins.availableDetails.yankedWithReason': 'Ditarik: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (usang)',
  'plugins.availableDetails.versionYankedSuffix': ' (ditarik)',
  'plugins.availableDetails.ref': 'Ref',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'Izin',
  'plugins.availableDetails.capabilitySummary': 'Ringkasan kemampuan',
  'plugins.actions.copyInstallCommand': 'Salin perintah instal',
  'plugins.actions.copyPluginId': 'Salin ID plugin',
  'plugins.actions.copyReadmeBadge': 'Salin lencana README',
  'plugins.actions.openSourceGithub': 'Buka sumber di GitHub',
  'plugins.actions.openSource': 'Buka sumber',
  'plugins.actions.openHomepage': 'Buka beranda',
  'plugins.actions.openMarketplace': 'Buka di marketplace',
  'app.brand': 'OpenDesign',
  'app.brandPill': 'Pratinjau Riset',
  'app.brandSubtitle': 'oleh Nexu Labs',
  'app.welcomeLoading': 'Memuat workspace...',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'Selamat datang di OpenDesign',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'Mulai dari sebuah brief',
  'settings.onboardingCreateBody': 'Jelaskan situs, aplikasi, deck, gambar, atau video yang Anda inginkan. OpenDesign akan membuat proyek dan menjaga hasil kerja tetap dapat diedit.',
  'settings.onboardingMemoryTitle': 'Simpan konteks kerja',
  'settings.onboardingMemoryBody': 'Tambahkan preferensi, fakta proyek, dan aturan berulang agar chat berikutnya menggunakan konteks yang tepat.',
  'settings.onboardingMemoryCalloutTitle': 'Tersimpan ke Memory Anda',
  'settings.onboardingMemoryCalloutBody': 'Jawaban ini menjadi dasar profil Memory Anda. OpenDesign menggunakannya kembali di setiap tugas — dan terus belajar saat Anda bekerja.',
  'settings.onboardingMemoryBenefitIntent': 'Memahami maksud Anda dari permintaan singkat',
  'settings.onboardingMemoryBenefitFewerQuestions': 'Melewati pertanyaan penyiapan yang berulang',
  'settings.onboardingMemoryBenefitPersonalized': 'Menyesuaikan hasil dengan peran, audiens, dan selera Anda',
  'settings.onboardingSystemsTitle': 'Bawa sistem desain Anda',
  'settings.onboardingSystemsBody': 'Pilih atau buat sistem brand agar hasil kerja yang dihasilkan mengikuti warna, tipografi, dan bahasa produk yang sesungguhnya.',
  'settings.onboardingExecutionTitle': 'Pilih sumber model',
  'settings.onboardingExecutionBody': 'Gunakan OpenDesign Hosted, hubungkan agen lokal, atau gunakan kunci model Anda sendiri.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Direkomendasikan resmi',
  'settings.onboardingAmrCloudBenefitReady': 'Tanpa deploy',
  'settings.onboardingAmrCloudBenefitModels': 'Akses Claude, GPT, Fable 5, dan 5.6 sol dengan diskon terbatas dan konkurensi tinggi.',
  'settings.onboardingAmrCloudBenefitPricing': 'Harness SOTA',
  'settings.onboardingAmrCloudUpcomingLabel': 'Segera hadir',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'Gambar dan video',
  'settings.onboardingAmrCloudUpcomingSkills': 'Banyak Skills',
  'settings.onboardingAmrCloudUpcomingRouting': 'Routing cerdas',
  'settings.onboardingAmrModelSourceLabel': 'OpenDesign Hosted',
  'settings.onboardingAmrCloudAuthorizeAction': 'Otorisasi OpenDesign Cloud',
  'settings.onboardingAmrCloudAuthorizedAction': 'Diotorisasi',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'Buat design system',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': 'Stay updated',
  'settings.onboardingNewsletterTitle': 'Stay in the loop',
  'settings.onboardingNewsletterBody': 'Get product updates, new templates, design-system drops, and ambassador work in your inbox. Optional — you can skip this.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'Selamat datang di OpenDesign',
  'settings.onboardingCloudBody': 'Wujudkan ide Anda menjadi desain.',
  'settings.onboardingCloudSignIn': 'Masuk / Daftar',
  'settings.onboardingFreeCredits': 'Kredit gratis',
  'settings.onboardingFreeCreditsHint': 'Pengguna baru mendapat kredit awal gratis untuk mencoba DeepSeek V4.1 Flash.',
  'settings.onboardingOwnAi': 'Atau gunakan AI Anda sendiri',
  'settings.onboardingLocalAi': 'AI lokal',
  'settings.onboardingApiKey': 'Kunci API',
  'settings.onboardingCloudContinue': 'Lanjutkan (sudah masuk)',
  'settings.onboardingCloudAlternative': 'Gunakan CLI lokal atau kunci API Anda sendiri',
  'settings.onboardingCloudRights': 'Semua hak dilindungi.',
  'settings.onboardingCloudOr': 'atau',
  'settings.onboardingGateTooltipNoRuntime': 'Langkah berikutnya berjalan dengan AI — pilih runtime untuk melanjutkan.',
  'settings.onboardingGateTooltipAmr': 'Langkah berikutnya berjalan dengan AI — masuk ke OpenDesign Cloud untuk melanjutkan.',
  'settings.onboardingGateTooltipLocal': 'Langkah berikutnya berjalan dengan AI — pilih CLI lokal yang tersedia untuk melanjutkan.',
  'settings.onboardingGateTooltipByok': 'Langkah berikutnya berjalan dengan AI — tambahkan dan uji kunci model Anda untuk melanjutkan.',
  'settings.onboardingRecommended': 'Direkomendasikan',
  'settings.onboardingAmrCloudOfficialBadge': 'Resmi',
  'settings.onboardingLocalTitle': 'Agen lokal',
  'settings.onboardingLocalBody': 'Gunakan Claude Code, Codex, Cursor, OpenCode, Kimi, Qwen, Hermes, Kiro, dan lainnya.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Gunakan kunci Anda',
  'settings.onboardingByokBody': 'Hubungkan penyedia model pilihan Anda dengan aman menggunakan kunci API sendiri.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'Tentang Anda',
  'settings.onboardingProfileBody': 'Detail opsional untuk pengaturan default yang lebih baik.',
  'settings.onboardingRoleLabel': 'Peran Anda',
  'settings.onboardingOrgSizeLabel': 'Ukuran organisasi',
  'settings.onboardingUseCaseLabel': 'Kasus penggunaan',
  'settings.onboardingSourceLabel': 'Dari mana Anda mengetahui kami?',
  'settings.onboardingSourceX': '🐦 X / Twitter',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceTiktok': '🎵 TikTok',
  'settings.onboardingSourceReddit': '👽 Reddit',
  'settings.onboardingSourceLinkedin': '💼 LinkedIn',
  'settings.onboardingSourceMetaSocial': '📸 Instagram / Threads / Facebook',
  'settings.onboardingSourceSearch': '🔍 Penelusuran (Google / Bing)',
  'settings.onboardingSourceAiTool': '🤖 Alat AI (ChatGPT / Perplexity)',
  'settings.onboardingSourceFriend': '👥 Teman atau kolega',
  'settings.onboardingSourceCommunity': '💬 Discord / komunitas',
  'settings.onboardingSourceEmail': '✉️ Email / Newsletter',
  'settings.onboardingSourceBlog': '📝 Blog / artikel',
  'settings.onboardingSourceOther': '✨ Lainnya',
  'settings.onboardingSourceOtherPlaceholder': 'Beri tahu kami di mana (opsional)',
  'settings.onboardingSelectPlaceholder': 'Pilih satu',
  'settings.onboardingSelectMultiplePlaceholder': 'Pilih satu atau beberapa',
  'settings.onboardingOrgSolo': 'Perorangan / pribadi (1)',
  'settings.onboardingOrgTeam': 'Tim kecil (2-10)',
  'settings.onboardingOrgStartup': 'Startup / UKM (11-50)',
  'settings.onboardingOrgGrowth': 'Perusahaan berkembang (51-200)',
  'settings.onboardingOrgMidMarket': 'Pasar menengah (201-1000)',
  'settings.onboardingOrgEnterprise': 'Perusahaan besar (1000+)',
  'settings.onboardingRolePm': '📋 Manajer produk',
  'settings.onboardingRoleDesigner': '🎨 Desainer',
  'settings.onboardingRoleEngineer': '💻 Insinyur',
  'settings.onboardingRoleMarketing': '📣 Pemasaran',
  'settings.onboardingRoleAgency': '📣 Agensi pemasaran',
  'settings.onboardingRoleGrowth': '📈 Pertumbuhan',
  'settings.onboardingRoleOps': '⚙️ Operasional',
  'settings.onboardingRoleFounder': '🚀 Pendiri / eksekutif',
  'settings.onboardingRoleStudent': '🎓 Pelajar / pengajar',
  'settings.onboardingRoleOther': '✨ Lainnya',
  'settings.onboardingUseProduct': '🎨 Desain produk',
  'settings.onboardingUseDesignSystem': '🧩 Sistem desain',
  'settings.onboardingUsePrototype': '📱 Prototipe / UI aplikasi',
  'settings.onboardingUseLanding': '🌐 Halaman landing',
  'settings.onboardingUseAds': '📣 Iklan / konten media sosial',
  'settings.onboardingUseDashboard': '📊 Dasbor / alat internal',
  'settings.onboardingUseDeck': '🖥️ Presentasi / slide',
  'settings.onboardingUseMarketing': '📈 Pemasaran / pertumbuhan',
  'settings.onboardingUseEngineering': '🤝 Serah terima ke engineering',
  'settings.onboardingUseAgency': '💼 Agensi / pekerjaan klien',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.kicker': 'Pengaturan',
  'settings.title': 'Model & penyedia',
  'settings.subtitle': 'Pilih antara CLI lokal dan BYOK.',
  'settings.general': 'Umum',
  'settings.generalHint': 'Bahasa, tampilan, notifikasi, lokasi proyek, privasi, dan detail aplikasi.',
  'settings.modeAria': 'Mode eksekusi',
  'settings.protocolAria': 'Protokol API',
  'settings.modeDaemon': 'CLI lokal',
  'settings.modeDaemonHelp': 'Jalankan lewat code-agent CLI di komputer ini',
  'settings.modeDaemonOffline': 'Daemon tidak berjalan',
  'settings.modeDaemonOfflineMeta': 'daemon offline',
  'settings.modeDaemonInstalledMeta': '{count} terpasang',
  'settings.modeApi': 'Anthropic API',
  'settings.cloudCalloutTitle': 'Use OpenDesign Cloud',
  'settings.cloudCalloutBody': 'Sign in to the cloud version to enable team spaces, shared projects, member permissions, and the audit dashboard.',
  'settings.cloudCalloutButton': 'Sign in / Register',
  'settings.modeApiMeta': 'Penyedia API',
  'settings.byokNoFileToolsNotice': 'BYOK tidak dapat membaca, menulis, atau mengedit file proyek. Gunakan Local CLI saat Anda perlu mengubah kode.',
  'settings.byokDraftNotice': 'Lengkapi bidang wajib untuk menyimpan penyedia ini. Konfigurasi saat ini akan tetap aktif.',
  'settings.codeAgent': 'Agent kode',
  'settings.codeAgentHint': 'Terdeteksi dari PATH. Pilih CLI yang ingin dipakai untuk menjalankan generasi.',
  'settings.rescan': 'Pindai ulang',
  'settings.rescanTitle': 'Pindai ulang PATH',
  'settings.rescanRunning': 'Memindai...',
  'settings.rescanSuccess': 'Pemindaian selesai. {count} tersedia.',
  'settings.designSystemRenameFailed': 'Gagal mengganti nama. Periksa daemon lalu coba lagi.',
  'settings.rescanFailed': 'Pemindaian gagal. Periksa daemon lalu coba lagi.',
  'settings.test': 'Tes',
  'settings.testTitle': 'Kirim prompt kecil untuk memverifikasi koneksi',
  'settings.testRunning': 'Menguji koneksi...',
  'settings.byokReadyToTest': 'Siap diuji',
  'settings.testCancel': 'Batal',
  'settings.testRetry': 'Coba lagi tes',
  'settings.required': 'wajib',
  'settings.testMissingFields': 'Isi {fields} untuk menguji koneksi.',
  'settings.testSuccessApi': 'Tersambung. Membalas dalam {ms} md — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} membalas dalam {ms} md — \'{sample}\'',
  'settings.testAuthFailed': 'Autentikasi gagal. Periksa API key kamu.',
  'settings.testForbidden': 'Akses ditolak. Verifikasi akun, wilayah, atau organisasi kamu.',
  'settings.testNotFoundModel': 'Model \'{model}\' tidak ditemukan di endpoint ini.',
  'settings.testInvalidModelId': 'ID model \'{model}\' tidak valid. ID kustom harus diawali huruf atau angka dan tidak boleh berisi spasi.',
  'settings.testInvalidBaseUrl': 'Base URL tidak valid atau tidak dapat dijangkau.',
  'settings.testRateLimited': 'Provider membatasi laju tes. Konfigurasi tampak valid.',
  'settings.testUpstream': 'Provider mengembalikan {status}. Coba lagi sebentar lagi.',
  'settings.testTimeout': 'Tes melewati batas waktu setelah {ms} md.',
  'settings.testAgentMissing': '{agentName} tidak terpasang atau tidak ada di PATH.',
  'settings.testAgentSpawn': 'Tidak dapat memulai {agentName}: {detail}.',
  'settings.testUnknown': 'Tes gagal: {detail}',
  'settings.agentInstall.install': 'Instal',
  'settings.agentInstall.docs': 'Dokumentasi',
  'settings.agentInstall.pathHint': 'Jika Anda memasang CLI dengan npm atau Homebrew tetapi masih tampil sebagai belum terpasang, pastikan direktori bin alat ada di PATH yang diwarisi daemon OpenDesign (PATH Terminal dan aplikasi GUI bisa berbeda di macOS). Lihat QUICKSTART.md (bagian "Local agent CLI and PATH").',
  'settings.agentInstall.stepOpenLinks': 'Buka Instal atau Dokumentasi untuk agen pilihan Anda.',
  'settings.agentInstall.stepAuth': 'Lakukan autentikasi di CLI vendor (masuk atau tambahkan kredensial API) sebelum kembali ke OpenDesign.',
  'settings.agentInstall.stepRescan': 'Klik Pindai ulang di bagian ini.',
  'settings.agentInstall.stepSelect': 'Pilih kartu agen setelah statusnya terpasang.',
  'settings.noAgentsDetected': 'Belum ada agent terdeteksi. Pasang salah satu dari Claude Code, Codex, Devin for Terminal, OpenCode, Cursor Agent, Qwen, atau GitHub Copilot CLI, lalu klik pindai ulang.',
  'settings.agentInstalledGroup': 'CLI Anda ({count})',
  'settings.agentInstallGroup': 'Tersedia untuk dipasang ({count})',
  'settings.agentAuthRequired': 'Autentikasi diperlukan',
  'settings.agentAuthUnknown': 'Status autentikasi tidak diketahui',
  'settings.amrCloud': 'OpenDesign Cloud',
  'settings.amrAuthorize': 'Otorisasi',
  'settings.amrBenefitOfficial': 'Officially maintained',
  'settings.amrBenefitLowerPrice': 'Lower price',
  'settings.amrBenefitManyModels': 'Banyak model',
  'settings.amrPromoBonus': 'Bonus terbatas: +100%',
  'settings.amrSignInToContinue': 'Masuk untuk melanjutkan',
  'settings.amrSignIn': 'Masuk',
  'settings.amrSignedIn': 'Sudah masuk',
  'settings.amrWalletBalance': 'Wallet balance',
  'settings.amrWalletUnavailable': 'Balance temporarily unavailable',
  'settings.amrWalletUpdatedAt': 'Updated {time}',
  'settings.amrWalletCached': 'cached',
  'settings.amrWalletRefresh': 'Refresh',
  'settings.amrWalletRefreshTitle': 'Refresh OpenDesign Cloud wallet balance',
  'settings.amrNotSignedIn': 'Belum masuk',
  'settings.amrSigningIn': 'Sedang masuk…',
  'settings.amrActivationHint': 'Halaman masuk tidak terbuka? Ketuk tombol di bawah untuk membukanya lagi.',
  'settings.amrActivationBrowserFailedTitle': 'Tidak dapat membuka halaman masuk',
  'settings.amrActivationBrowserFailedDescription': 'Browser tidak terbuka secara otomatis. Silakan coba masuk lagi.',
  'settings.amrActivationOpen': 'Buka halaman masuk',
  'settings.amrCancelSignIn': 'Batalkan proses masuk',
  'settings.onboardingActivationPrompt': 'Halaman masuk tidak terbuka?',
  'settings.onboardingActivationBrowserFailed': 'Tidak dapat membuka browser secara otomatis.',
  'settings.onboardingActivationReopen': 'Buka lagi',
  'settings.amrAccountStatus': 'Status akun OpenDesign Cloud',
  'settings.amrConsole': 'Kelola',
  'settings.amrBalance': 'Kuota',
  'settings.amrPlan': 'Paket',
  'settings.amrUpgrade': 'Tingkatkan',
  'settings.amrModelUpgradeHint': 'Upgrade untuk memakai',
  'settings.amrLoginErrorCompact': 'Proses masuk OpenDesign Cloud gagal.',
  'settings.advanced': 'Lanjutan',
  'settings.amrLogin': 'Masuk',
  'settings.amrLogout': 'Keluar',
  'settings.amrLoggingIn': 'Sedang masuk…',
  'settings.amrLoggingOut': 'Sedang keluar…',
  'settings.amrLoggedInAs': 'Masuk sebagai {email}',
  'settings.amrLoggedInWithPlan': 'Masuk sebagai {email} · {plan}',
  'settings.amrLoggedInPill': 'Sudah masuk',
  'settings.amrNotLoggedIn': 'Belum masuk',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'Provider isi cepat',
  'settings.providerPreset': 'Preset penyedia',
  'settings.protocolGroupProtocols': 'Protokol',
  'settings.protocolGroupGateways': 'Gateway',
  'settings.customProvider': 'Provider kustom',
  'settings.apiKey': 'API key',
  'settings.apiKeyGetLink': 'Dapatkan key ↗',
  'settings.showKey': 'Tampilkan key',
  'settings.hideKey': 'Sembunyikan key',
  'settings.show': 'Tampilkan',
  'settings.hide': 'Sembunyikan',
  'settings.model': 'Model',
  'settings.apiKeyInvalid': 'API key tidak valid.',
  'settings.apiKeyCleaned': 'Spasi berlebih dihapus dari API key.',
  'settings.modelsLoadedFromAccount': '✓ Memuat {count} model dari akun Anda.',
  'settings.modelsLoadedCount': '✓ Memuat {count} model.',
  'settings.modelSourceAccount': 'Dari akun Anda',
  'settings.modelSourceSuggested': 'Disarankan',
  'modelCapability.standard': 'Standard',
  'modelCapability.advanced': 'Advanced',
  'modelCapability.bestQuality': 'Best Quality',
  'modelCapability.standardDescription': 'Solid quality for regular tasks.',
  'modelCapability.advancedDescription': 'Stronger quality for more demanding tasks.',
  'modelCapability.bestQualityDescription': 'Best output quality for the most demanding work.',
  'modelCost.upToHalf': 'Biaya rendah',
  'modelCost.halfToOne': 'Biaya sedang',
  'modelCost.oneToFour': 'Biaya tinggi',
  'modelCost.overFour': 'Biaya tertinggi',
  'settings.fetchModels': 'Ambil model',
  'settings.fetchModelsTitle': 'Ambil model yang tersedia dari penyedia ini',
  'settings.fetchModelsRunning': 'Mengambil model…',
  'settings.fetchModelsMissingFields': 'Isi {fields} untuk mengambil model.',
  'settings.fetchModelsInvalidBaseUrl': 'Masukkan Base URL yang valid untuk mengambil model.',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI menggunakan nama deployment, sehingga penemuan model tidak tersedia di sini.',
  'settings.fetchModelsUnsupportedOllama': 'Penemuan model Ollama Cloud belum tersedia. Pilih atau ketik sebuah model.',
  'settings.fetchModelsSuccess': '{count} model berhasil diambil.',
  'settings.fetchModelsEmpty': 'Tidak ada model teks yang kompatibel yang dikembalikan.',
  'settings.fetchModelsUnsupported': 'Penemuan model tidak tersedia untuk protokol ini.',
  'settings.fetchModelsFailed': 'Tidak dapat mengambil model: {detail}',
  'settings.suggestedModelsHint': 'Ini model yang disarankan untuk protokol ini. Provider kamu mungkin mendukung model lain.',
  'settings.baseUrl': 'Base URL',
  'settings.baseUrlInvalid': 'Gunakan URL publik http:// atau https://.',
  'settings.baseUrlCustomize': 'Sesuaikan URL',
  'settings.baseUrlDefaultHint': 'Ubah hanya jika Anda menggunakan proxy atau gateway yang kompatibel.',
  'settings.azureBaseUrlPlaceholder': 'Tempel URL endpoint Azure',
  'settings.azureBaseUrlHint': 'Temukan ini di portal Azure → resource Anda → Endpoint.',
  'settings.azureDeploymentModel': 'Nama deployment',
  'settings.azureCustomDeploymentName': 'Nama deployment kustom',
  'settings.azureDeploymentModelHint': 'Untuk Azure OpenAI, field ini digunakan sebagai nama deployment di /openai/deployments/<model>. Masukkan nama deployment yang kamu buat di Azure.',
  'settings.azureModelFetchHint': 'Masukkan nama deployment dari resource Azure Anda. Deployment Azure tidak dapat diambil secara otomatis.',
  'settings.apiVersion': 'Versi API',
  'settings.byokImageModel': 'Model pembuatan gambar',
  'settings.byokVideoModel': 'Model pembuatan video',
  'settings.byokVideoI2vHint': 'Model gambar-ke-video: perlu gambar referensi (jika tidak dipilih, gambar terbaru di proyek dipakai otomatis)',
  'settings.byokSpeechModel': 'Model suara',
  'settings.byokSpeechVoice': 'Suara',
  'settings.byokModelDefaultOption': 'Default',
  'settings.maxTokens': 'Token maks (opsional)',
  'settings.maxTokensHint': 'Panjang respons maksimum. Kosongkan untuk menggunakan default model.',
  'settings.apiHint': 'Disimpan secara lokal di perangkat ini.',
  'settings.skipForNow': 'Lewati dulu',
  'settings.getStarted': 'Mulai',
  'settings.envConfigure': 'Model & penyedia',
  'settings.localCli': 'CLI lokal',
  'settings.dshSetupTitle': 'Connect DeepSeek Harness',
  'settings.dshSetupDescription': 'OpenDesign will install its connection component through the dsh CLI on this computer.',
  'settings.dshSetupNote': 'Only the OpenDesign profile component is installed. DeepSeek Harness remains user-installed and user-managed.',
  'settings.dshSetupConfirm': 'Install and select',
  'settings.dshSetupInstalling': 'Installing…',
  'settings.dshSetupRequired': 'Connection setup required',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'belum ada agent dipilih',
  'settings.language': 'Bahasa',
  'settings.languageHint': 'Ganti bahasa antarmuka. Disimpan di browser ini.',
  'settings.agentModelHead': 'Model untuk:',
  'settings.modelPicker': 'Model',
  'settings.modelSourceLive': 'Langsung dari CLI',
  'settings.modelUsesCliDefault': 'Default CLI',
  'settings.modelSourceFallback': 'Daftar bawaan',
  'settings.reasoningPicker': 'Kekuatan penalaran',
  'settings.serviceTierPicker': 'Tingkat layanan',
  'settings.modelPickerHint': 'Diambil dari CLI jika tersedia. "Default" mengikuti konfigurasi CLI; "Custom..." untuk mengetik model id sendiri.',
  'settings.modelPickerLiveHint': 'Model diperbarui dari CLI yang terpasang. Default tetap memakai konfigurasi CLI.',
  'settings.modelPickerLiveCatalogOnlyHint': 'Model diperbarui dari CLI yang terpasang.',
  'settings.modelPickerFallbackHint': 'Menampilkan default bawaan. Klik Pindai ulang untuk mengambil model langsung dari CLI.',
  'settings.cliEnvTitle': 'Lanjutan: proxy & path kustom',
  'settings.cliEnvHint': 'Gunakan ini untuk menimpa environment CLI yang dipilih: API key, proxy base URL, home kustom, atau path binary non-standar. Tanpa base URL, CLI memakai endpoint defaultnya. Secret tetap berada di konfigurasi app lokal dan hanya dilihat oleh CLI yang dipilih.',
  'settings.cliEnvClaudeConfigDir': 'Direktori konfigurasi Claude Code',
  'settings.cliEnvClaudeBaseUrl': 'Base URL proxy Claude',
  'settings.cliEnvClaudeApiKey': 'API key Claude CLI',
  'settings.cliEnvCodexHome': 'Home Codex',
  'settings.cliEnvCodexBin': 'Path executable Codex',
  'settings.cliEnvCodexBaseUrl': 'Base URL proxy Codex/OpenAI',
  'settings.cliEnvCodexApiKey': 'API key Codex/OpenAI CLI',
  'settings.modelCustom': 'Kustom (isi di bawah)...',
  'settings.modelCustomLabel': 'ID model kustom',
  'settings.modelCustomPlaceholder': 'mis. anthropic/claude-sonnet-4-6',
  'settings.onboardingModelUseCustom': 'Use "{query}"',
  'settings.mediaProviders': 'Provider media',
  'settings.mediaProvidersHint': 'API key untuk generasi gambar, video, dan audio. Disimpan lokal dan disinkronkan ke daemon lokal.',
  'settings.mcpServerTitle': 'OpenDesign MCP',
  'settings.mcpServerHint': 'Ekspos OpenDesign sebagai server MCP untuk agen koding Anda.',
  'settings.externalMcpTitle': 'MCP eksternal',
  'settings.externalMcpHint': 'Tambahkan alat MCP dari layanan eksternal (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'API key',
  'settings.mediaProviderBaseUrl': 'Base URL',
  'settings.mediaProviderConfigured': 'Sudah diatur',
  'settings.mediaProviderUnset': 'Belum diatur',
  'settings.mediaProviderClear': 'Bersihkan',
  'settings.mediaProviderClearConfirm': 'Hapus pengaturan {name} yang tersimpan? Anda perlu memasukkannya lagi untuk menggunakan {name}.',
  'settings.mediaProviderPlaceholder': 'Tempel API key',
  'settings.mediaProviderBaseUrlPlaceholder': 'Timpa base URL default',
  'settings.mediaProviderReload': 'Muat ulang dari daemon',
  'settings.mediaProviderReloadError': 'Tidak dapat memuat ulang pengaturan penyedia media dari daemon lokal.',
  'settings.mediaProviderReloadSuccess': 'Pengaturan penyedia media berhasil dimuat ulang dari daemon lokal.',
  'settings.mediaProviderLoadError': 'Tidak dapat memuat pengaturan penyedia media dari daemon lokal. Untuk sementara menggunakan pengaturan yang tersimpan di browser.',
  'settings.mediaProviderComingSoonHint': 'Kami melacak ini untuk roadmap; daemon belum mengirimkan klien, jadi tidak ada yang perlu dikonfigurasi.',
  'settings.privacy': 'Privasi',
  'settings.privacyHint': 'Data apa yang dibagikan kepada tim OpenDesign',
  'settings.privacyConsentKicker': 'Bantu kami meningkatkan OpenDesign',
  'settings.privacyConsentLead': 'Berbagi data penggunaan membantu kami memahami performa OpenDesign dalam alur kerja nyata, sehingga kami bisa memperbaiki bagian yang paling memengaruhi pengalaman Anda.',
  'settings.privacyConsentFooter': 'Anda dapat mengubah opsi ini kapan saja di Settings → Privacy.',
  'settings.privacyConsentShare': 'Bagikan',
  'settings.privacyConsentDecline': 'Jangan bagikan',
  'settings.privacyConsentAccept': 'Saya mengerti',
  'settings.privacyConsentBannerFooter': 'Berbagi data aktif secara default. Anda dapat menonaktifkannya kapan saja di Settings → Privacy.',
  'settings.privacyConsentPolicyLink': 'Baca kebijakan privasi',
  'settings.privacyMetrics': 'Metrik anonim',
  'settings.privacyMetricsHint': 'Jumlah run, penggunaan token, tingkat error, dan durasi sebagai metrik penggunaan dasar.',
  'settings.privacyContent': 'Conversation content',
  'settings.privacyContentHint': 'Setelah rahasia dan informasi sensitif lainnya dihapus, kami menggunakan prompt, respons asisten, input/output alat, dan konteks yang diperlukan untuk peninjauan kualitas.',
  'settings.privacyInstallationId': 'ID anonim',
  'settings.privacyOptedOut': 'tidak ikut serta',
  'settings.privacyDataDeletion': 'Hapus data saya',
  'settings.privacyDataDeletionHint': 'Memutar ID anonim Anda dan menghentikan pengiriman. Trace yang sudah ada akan kedaluwarsa sesuai kebijakan retensi kami.',
  'settings.about': 'Tentang',
  'settings.aboutHint': 'Detail versi dan runtime',
  'settings.appVersion': 'Versi',
  'settings.appChannel': 'Channel',
  'settings.appRuntime': 'Runtime',
  'settings.appPlatform': 'Platform',
  'settings.appArchitecture': 'Arsitektur',
  'settings.runtimePackaged': 'Aplikasi paket',
  'settings.runtimeDevelopment': 'Pengembangan',
  'settings.versionUnavailable': 'Detail versi tidak tersedia saat daemon offline.',
  "settings.allowSilentUpdates": "Izinkan instal otomatis pembaruan in-app di masa depan",
  "settings.allowSilentUpdatesDesc": "Saat pembaruan in-app siap, instal otomatis saat mulai berikutnya. Tidak meningkatkan sesi saat ini. Pembaruan installer tetap meminta konfirmasi.",
  'settings.installLatest': 'Pasang versi terbaru',
  'settings.alreadyLatest': 'Anda sudah menggunakan versi terbaru',
  'settings.updateCheck': 'Periksa pembaruan',
  'settings.updateNow': 'Perbarui sekarang',
  'settings.updateRecheck': 'Periksa lagi',
  'settings.updateRetry': 'Coba lagi',
  'settings.updateViewReleases': 'Catatan rilis',
  'settings.updateActionFailed': 'Tindakan pembaruan gagal.',
  'settings.updateQuitFailed': 'Installer terbuka, tetapi OpenDesign tidak dapat keluar otomatis.',
  'settings.updateStatusNotChecked': 'Belum diperiksa',
  'settings.updateStatusDevelopment': 'Build pengembangan tidak mendukung pembaruan dalam aplikasi.',
  'settings.updateStatusUnsupported': 'Lingkungan ini tidak mendukung pembaruan dalam aplikasi.',
  'settings.updateStatusChecking': 'Memeriksa pembaruan...',
  'settings.updateStatusUpToDate': 'Anda sudah memakai versi terbaru.',
  'settings.updateStatusAvailable': 'Versi {version} ditemukan. Menyiapkan unduhan.',
  'settings.updateStatusAvailableUnknown': 'Versi baru ditemukan. Menyiapkan unduhan.',
  'settings.updateStatusDownloading': 'Mengunduh pembaruan...',
  'settings.updateStatusDownloadingPercent': 'Mengunduh pembaruan {percent}%.',
  'settings.updateStatusReady': 'Versi {version} siap dipasang.',
  'settings.updateStatusReadyUnknown': 'Pembaruan siap dipasang.',
  'settings.updateStatusInstalling': 'Memasang pembaruan...',
  'settings.updateStatusFailed': 'Pemeriksaan gagal. Coba lagi.',
  'settings.mcpTitle': 'Server MCP',
  'settings.mcpHint': 'Biarkan coding agent (Cursor, Claude Code, VS Code…) membaca proyek OpenDesign Anda secara langsung.',
  'settings.mcpDaemonError': 'Tidak dapat menjangkau daemon lokal untuk menentukan jalur instalasi ({error}). Pastikan OpenDesign sedang berjalan, lalu buka kembali panel ini.',
  'settings.mcpBuildDaemon': 'Build daemon terlebih dahulu.',
  'settings.mcpNodeMissing': 'Node binary tidak ditemukan.',
  'settings.mcpBuildHint': 'apps/daemon/dist/cli.js tidak ditemukan. Jalankan `pnpm --filter @open-design/daemon build` dan segarkan.',
  'settings.mcpMethodCli': 'Perintah CLI',
  'settings.mcpInstructionCli': 'Jalankan ini di terminal Anda.',
  'settings.mcpMethodToml': 'Konfigurasi TOML',
  'settings.mcpInstructionCodex': 'Tambahkan tabel ini ke {path}. Konfigurasi yang sama dibagikan antara Codex CLI dan ekstensi Codex IDE.',
  'settings.mcpMethodOneClick': 'Instalasi satu klik',
  'settings.mcpInstructionCursor': 'Klik "Install in Cursor" untuk memasang dengan dialog persetujuan, atau gabungkan JSON ini ke {path}.',
  'settings.mcpDeeplinkInstallCursor': 'Install di Cursor',
  'settings.mcpMethodJson': 'Konfigurasi JSON',
  'settings.mcpInstructionKiro': 'Buka {path} dan gabungkan JSON ini. Untuk konfigurasi level workspace, gunakan .kiro/settings/mcp.json.',
  'settings.mcpInstructionCopilot': 'Buka Command Palette ({shortcut}), jalankan "MCP: Open User Configuration", dan gabungkan JSON ini. Copilot Chat harus dalam mode Agent agar tools muncul.',
  'settings.mcpInstructionAntigravity': 'Di Antigravity: panel Agent menu "..." → MCP Servers → Manage MCP Servers → View raw config. Gabungkan JSON ini.',
  'settings.mcpInstructionZed': 'Buka Zed Settings ({shortcut}) dan gabungkan ini ke dalam objek tingkat atas. Zed menggunakan "context_servers", bukan "mcpServers".',
  'settings.mcpInstructionWindsurf': 'Buka {path} (atau gunakan ikon MCPs di Cascade → Configure) lalu gabungkan:',
  'settings.mcpCopyAria': 'Salin cuplikan konfigurasi MCP',
  'settings.mcpResolvingFailed': '# penentuan jalur gagal, lihat error di atas',
  'settings.mcpLoadingPaths': '# memuat jalur instalasi dari daemon lokal…',
  'settings.mcpCopied': 'Tersalin',
  'settings.mcpCopy': 'Salin',
  'settings.mcpCursorApproval': 'Cursor menampilkan dialog persetujuan sebelum menulis konfigurasi.',
  'settings.mcpCodexOneClickInstall': 'Pasang di Codex',
  'settings.mcpCodexOneClickUninstall': 'Hapus dari Codex',
  'settings.mcpCodexOneClickUnavailable': 'Codex CLI tidak ditemukan di PATH — pasang Codex atau tempel cuplikan secara manual.',
  'settings.mcpCodexInstallSuccess': 'Terpasang. Mulai ulang Codex untuk memuat server baru.',
  'settings.mcpCodexUninstallSuccess': 'Dihapus dari Codex.',
  'settings.mcpCodexBusy': 'Sedang bekerja…',
  'settings.mcpCodexInstallError': 'Operasi gagal: {error}',
  'settings.mcpRestartNote': 'Mulai ulang klien Anda untuk memuat server baru.',
  'settings.mcpRestartDetail': 'Sebagian besar editor hanya memuat server MCP saat memulai. Di Cursor / VS Code / Antigravity / Windsurf Anda dapat menjalankan `Developer: Reload Window` dari command palette alih-alih memulai ulang sepenuhnya. Zed dan Claude Code perlu ditutup lalu dibuka kembali.',
  'settings.mcpCapabilitiesTitle': 'Apa yang dapat dilakukan Agent Anda',
  'settings.mcpCapabilityRead': 'Membaca atau mencari file apa pun dalam sebuah project (HTML, JSX, CSS, JSON, SVG, Markdown).',
  'settings.mcpCapabilityPull': 'Menarik design bundle dalam satu panggilan: file entri beserta setiap CSS variable, komponen, dan font yang dirujuknya.',
  'settings.mcpCapabilityDefault': 'Secara default menggunakan project dan file yang sedang Anda buka di OpenDesign, sehingga Anda bisa berkata "buat ini di aplikasi saya" tanpa menyebutkan ulang desain mana yang dimaksud.',
  'settings.mcpRunningNote': 'OpenDesign harus berjalan agar panggilan tool MCP berhasil. Jika Anda memulai coding Agent sebelum membuka OpenDesign, mulai ulang Agent agar dapat menjangkau daemon yang aktif.',
  'entry.tabDesigns': 'Desain',
  'entry.tabTemplates': 'Templat',
  'entry.tabDesignSystems': 'Sistem desain',
  'entry.tabConnectors': 'Konektor',
  'entry.openSettingsTitle': 'Pengaturan',
  'entry.openSettingsAria': 'Buka pengaturan',
  'entry.discordLabel': 'Gabung Discord',
  'entry.discordAria': 'Gabung Discord dan dapatkan kredit',
  'entry.discordAriaWithOnline': 'Gabung Discord OpenDesign - {online}',
  'entry.discordOnlineLabel': '{count} online',
  'entry.xAria': 'Ikuti @OpenDesignHQ untuk info terbaru',
  'entry.mailAria': 'Ada pertanyaan? Email kami',
  'entry.accountSettings': 'Pengaturan',
  'chat.collapsePane': 'Ciutkan panel percakapan',
  'collabPresence.ariaOne': '1 collaborator online',
  'collabPresence.aria': '{count} collaborators online',
  'collabPresence.ariaWithSelfOne': '1 collaborator online, including you',
  'collabPresence.ariaWithSelf': '{count} collaborators online, including you',
  'collabPresence.moreOnline': '{count} more online',
  'collabPresence.dialogTitle': 'Online collaborators',
  'collabPresence.onlineCount': '{count} online',
  'collabPresence.selfBadge': 'You',
  'collabPresence.roleOwner': 'Owner',
  'collabPresence.roleAdmin': 'Admin',
  'collabPresence.roleMember': 'Member',
  'collabPresence.viewingFileSelf': 'You are viewing {file}',
  'collabPresence.viewingFileOther': 'Viewing {file}',
  'collabPresence.viewingProjectSelf': 'You are viewing this project',
  'collabPresence.viewingProjectOther': 'Viewing this project',
  'entry.followXLabel': 'Ikuti @OpenDesignHQ di X',
  'entry.followThreadsLabel': 'Follow OpenDesign on Threads',
  'entry.youtubeLabel': 'OpenDesign on YouTube',
  'entry.followInstagramLabel': 'Ikuti @opendesign.ai di Instagram',
  'entry.followLinkedinLabel': 'Ikuti OpenDesign di LinkedIn',
  'entry.followXiaohongshuLabel': 'Ikuti OpenDesign di Xiaohongshu',
  'entry.resizeAria': 'Ubah ukuran sidebar',
  'entry.loadingWorkspace': 'Memuat workspace...',
  'entry.useEverywhereTitle': 'Gunakan di mana saja',
  'entry.useEverywhereAria': 'Buka panduan “Gunakan di mana saja” (CLI, MCP, HTTP, Skills)',
  'entry.workspaceTeamsLabel': 'Teams',
  'workspaceSwitcher.invite': 'Invite colleague',
  'workspaceSwitcher.createTeam': 'New team',
  "workspaceSwitcher.draftsTooltip": "Semua proyek",
  "workspaceSwitcher.allProjectsTooltip": "Proyek tim",
  "entry.primaryNavAria": "Primary",
  "entry.billingTierTeam": "Teams",
  "entry.billingTierFree": "Free",
  "entry.billingTierPro": "Pro",
  "entry.billingTierPlus": "Plus",
  "entry.billingTierMax": "Max",
  "entry.billingTierGo": "Go",
  "entry.billingFamilyCreator": "Creator",
  "entry.creditsAria": "{tier} · credits remaining",
  "entry.creditsAriaWithBalance": "{tier} · {balance} credits remaining",
  "entry.creditsGrantTip": "Teams credits are granted by subscription allowance. Usage is available in billing.",
  "entry.creditsUpgrade": "Tingkatkan",
  "entry.creditsManage": "Kelola",
  "entry.creditsOpening": "Opening...",
  "entry.creditsRemaining": "Credits remaining",
  "entry.credits": "Kuota",
  "entry.creditsUsage": "Lihat penggunaan",
  "entry.creditsMemberNoticeTitle": "Need more credits?",
  "entry.creditsMemberNoticeBody": "You are currently a Member and cannot add credits yourself. Ask a team Admin to increase the allowance when you need more.",
  "entry.creditsMemberNoticeAction": "Ask Admin to increase allowance",
  "entry.accountToggleTheme": "Ganti tema",
  "entry.accountSwitchLanguage": "Ganti bahasa",
  "entry.accountLanguageMeta": "中文 / English",
  "entry.accountGithubHelp": "Dapatkan bantuan",
  "entry.accountFeatureRequest": "Submit feature request",
  "entry.accountBilling": "Penagihan",
  "entry.accountAddAccount": "Tambah akun",
  "entry.accountSignOut": "Keluar",
  "signOut.confirmTitle": "Keluar",
  "signOut.confirmMessage": "Yakin ingin keluar dari akun?",
  "signOut.confirmAction": "Keluar",
  "entry.navRecents": "Beranda",
  "entry.navDashboard": "Dashboard",
  "entry.blankDraftsTitle": "Start a private draft",
  "entry.blankDraftsDescription": "Create a project here first. It stays private until you move it into the team space.",
  "entry.projectsLoadFailed": "Proyek tidak dapat dimuat. Silakan coba lagi.",
  "entry.blankAllProjectsTitle": "No team projects yet",
  "entry.blankAllProjectsDescription": "Projects shared to the team will appear here for everyone in the workspace.",
  "entry.blankCreate": "New project",
  'entry.workspaceTeamsTitle': 'Workspace untuk Tim — beri tahu kami kebutuhan tim Anda',
  'entry.workspaceTeamsAria': 'Buka halaman Workspace untuk Tim',
  'entry.navExpand': 'Buka bilah sisi',
  'entry.navCollapse': 'Tutup bilah sisi',
  'entry.navNewProject': 'Proyek baru',
  'entry.navHome': 'Beranda',
  'entry.navProjects': 'Proyek',
  'entry.navTasks': 'Otomatisasi',
  'entry.navPlugins': 'Plugin',
  'entry.navDesignSystems': 'Sistem desain',
  'entry.navBrands': 'Kit Merek',
  'entry.navIntegrations': 'Integrasi',
  'entry.navMembers': 'Members',
  'entry.navWorkspaceSettings': 'Workspace settings',
  'entry.navDrafts': 'Semua proyek',
  'entry.navAllProjects': 'Proyek tim',
  'entry.draftsDescription': 'Projects you created, visible only to you',
  'entry.allProjectsDescription': 'Projects owned by everyone on the team',
  'entry.navBoard': 'Board',
  'entry.navTeamSection': 'Team',
  'entry.teamSlotNote': 'This space is provided by the team service. Integration is in progress.',
  "entry.cloudCalloutTitle": "OpenDesign Cloud",
  'entry.cloudRecovering': 'Account connection interrupted. Recovering automatically…',
  'entry.authExpiredBody': 'Open Design belum masuk\nMasuk untuk melihat proyek Anda dan melanjutkan percakapan.',
  'home.createFailed': 'Failed to start the run. Try again.',
  'home.daemonRecovering': 'Koneksi lokal terputus\nSaat ini tidak dapat terhubung ke layanan Open Design di komputer ini. Silakan mulai ulang aplikasi.',
  'home.createTimedOut': 'Persiapan proyek melebihi batas waktu sebelum dimulai. Coba kirim lagi.',
  'home.amrGateUnavailable': 'Saldo OpenDesign Cloud tidak dapat dikonfirmasi. Coba kirim lagi.',
  'home.bundledScenarioMissing': 'Bundled scenario "{scenarioId}" is not installed. Reinstall the daemon to restore the default plugin set.',
  "entry.cloudCalloutBody": "Masuk untuk menggunakan OpenDesign Cloud dan berkolaborasi di cloud",
  "entry.cloudCreditsTitle": "Dapatkan kredit gratis",
  "entry.cloudCreditsBody": "Buat akun OpenDesign untuk mendapatkan kredit gratis dan berkarya dengan model paling canggih.",
  "entry.cloudCreditsCta": "Daftar / Masuk",
  "entry.localAccountName": "Mode lokal",
  "entry.cloudCalloutDismissAria": "Tutup catatan OpenDesign Cloud",
  'entry.workspaceLockedNote': 'This workspace is locked. Restore billing to resume editing shared projects.',
  'entry.workspaceLockedRecover': 'Restore access',
  'messageCenter.openAria': 'Open message center',
  'messageCenter.unreadCount': '{count} unread',
  'messageCenter.title': 'Message center',
  'messageCenter.subtitle': 'OpenDesign updates, platform announcements, and account notices.',
  'messageCenter.filterAll': 'All',
  'messageCenter.filterUnread': 'Unread',
  'messageCenter.filterRead': 'Read',
  'messageCenter.markAllRead': 'Mark all read',
  'messageCenter.emptyAllTitle': 'No messages yet',
  'messageCenter.emptyUnreadTitle': 'All caught up',
  'messageCenter.emptyReadTitle': 'No read messages',
  'messageCenter.archive': 'Arsipkan',
  'messageCenter.unarchive': 'Kembalikan ke kotak masuk',
  'messageCenter.archivedTitle': 'Diarsipkan',
  'messageCenter.emptyArchivedTitle': 'Tidak ada pesan yang diarsipkan',
  'messageCenter.emptyBody': 'New platform messages will appear here.',
  'messageCenter.close': 'Close message center',
  'messageCenter.desktopSettings': 'Desktop notification settings',
  'messageCenter.desktopSettingsHint': 'Task completion sounds and system notifications stay in Settings.',
  'goPlanSunset.closeAria': 'Close announcement',
  'goPlanSunset.title': 'Notice: Go subscriptions are ending',
  'goPlanSunset.subtitle': 'We’ve heard your feedback and recognize that Go’s allowance rules and product experience need improvement. We’re sorry.',
  'goPlanSunset.decisionsAria': 'What’s changing',
  'goPlanSunset.decisionsIntro': 'What’s changing',
  'goPlanSunset.decisionStopSales': 'New Go subscriptions end today',
  'goPlanSunset.decisionRefund': 'Existing subscribers will receive full refunds by August 31; Go access ends after refund',
  'goPlanSunset.decisionUnaffected': 'Other plans are unaffected',
  'goPlanSunset.closing': 'Refunds return to the original payment method; timing depends on the provider. Thank you for your feedback and support.',
  'goPlanSunset.dismissError': 'Could not confirm. Please try again.',
  'goPlanSunset.viewSubscriptions': 'View other plans',
  'goPlanSunset.confirming': 'Confirming…',
  'goPlanSunset.acknowledge': 'Got it',
  'workspaceTabs.project': 'Proyek',
  'workspaceTabs.pluginDetails': 'Detail plugin',
  'workspaceTabs.marketplace': 'Marketplace',
  'homeHero.title': 'Mari membuat {word}',
  'homeHero.titleWords': 'prototipe,presentasi,dokumen',
  'homeHero.subtitle': 'Karya yang baik dimulai di sini',
  'homeHero.startWithTemplate': 'Mulai dengan templat…',
  'homeHero.startBlankProject': 'mulai proyek kosong',
  'homeHero.templatePicker.label': 'Jenis kreasi',
  'homeHero.templatePicker.searchPlaceholder': 'Cari templat',
  'homeHero.templatePicker.projectTypes': 'Tipe proyek',
  'homeHero.subtitlePrefix': 'Alternatif Claude Design dengan kode sumber tersedia.',
  'homeHero.placeholder': 'Jelaskan apa yang ingin Anda hasilkan…',
  'homeHero.placeholderActive': 'Edit contoh kueri atau tulis kueri Anda sendiri…',
  'homeHero.carousel.hint': 'Lampirkan file, hubungkan design system, atau jelaskan apa yang ingin kamu buat',
  'homeHero.carousel.onePageBrief': 'Buat brief proyek satu halaman',
  'homeHero.carousel.notesToDeck': 'Ubah catatan saya menjadi presentasi',
  'homeHero.carousel.signupFlow': 'Buat mockup alur pendaftaran',
  'homeHero.carousel.improveBrief': 'Sempurnakan brief proyek yang ada',
  'homeHero.carousel.loadingAnimation': 'Buat animasi loading',
  'homeHero.carousel.teamUpdateSlides': 'Rancang slide untuk update tim',
  'homeHero.carousel.ordersDashboard': 'Buat prototipe dasbor pelacakan pesanan',
  'homeHero.carousel.productDetail': 'Tata letak halaman detail produk',
  'homeHero.carousel.caseStudy': 'Susun kerangka studi kasus',
  'homeHero.carousel.landingIntro': 'Rancang intro singkat untuk landing page',
  'homeHero.carousel.pitchDeck': 'Buat pitch deck untuk produk baru',
  'homeHero.carousel.appIdea': 'Jelaskan ide aplikasi',
  'homeHero.carousel.landingLayout': 'Sketsa tata letak landing page',
  'homeHero.skills': 'Skill',
  'homeHero.addMenu': 'Tambah konteks',
  'homeHero.addPlugin': 'Tambah plugin',
  'homeHero.addConnectors': 'Tambah konektor',
  'homeHero.addMcp': 'Tambah server MCP',
  'homeHero.noPlugins': 'Tidak ada plugin terpasang',
  'homeHero.noMcp': 'Tidak ada server MCP',
  'homeHero.noConnectors': 'Tidak ada konektor terhubung',
  'homeHero.applying': 'Menerapkan…',
  'homeHero.pluginTitle': 'Plugin: {title}',
  'homeHero.pluginPrefix': 'Plugin: {title}',
  'homeHero.skillPrefix': 'Skill: {title}',
  'homeHero.removePlugin': 'Hapus plugin',
  'homeHero.removePluginAria': 'Hapus plugin {title}',
  'homeHero.clearActivePlugin': 'Bersihkan plugin aktif',
  'homeHero.clearActiveSkill': 'Bersihkan skill aktif',
  'homeHero.contextItemsResolved': '{n} item konteks teratasi',
  'homeHero.attachmentsScrollPrev': 'Gulir lampiran ke kiri',
  'homeHero.attachmentsScrollNext': 'Gulir lampiran ke kanan',
  'homeHero.removeFile': 'Hapus file',
  'homeHero.contextSearchResults': 'Hasil pencarian konteks',
  'homeHero.contextSurfaces': 'Permukaan konteks',
  'homeHero.loadingContext': 'Memuat konteks…',
  'homeHero.noResults': 'Tidak ada hasil untuk "{query}".',
  'homeHero.searchPrompt': 'Cari file, plugin, skill, server MCP, dan konektor.',
  'homeHero.parameters': '{n} parameter',
  'homeHero.details': 'Detail',
  'homeHero.toRun': 'untuk menjalankan',
  'homeHero.forNewLine': 'untuk baris baru',
  'homeHero.run': 'Jalankan',
  'homeHero.typeSomethingToRun': 'Ketik sesuatu untuk dijalankan',
  'homeHero.promptExamples': 'Contoh',
  'homeHero.footer.designSystem': 'Gaya',
  'homeHero.footer.autoDesignSystem': 'Otomatis',
  'homeHero.footer.autoDesignSystemSummary': 'Otomatis memilih sistem desain dan gaya visual yang paling cocok untuk prompt saat ini.',
  'homeHero.footer.ratio': 'Rasio',
  'homeHero.footer.duration': 'Durasi',
  'homeHero.footer.resolution': 'Resolusi',
  'homeHero.footer.speakerNotes': 'Catatan',
  'homeHero.footer.noSpeakerNotes': 'Tanpa catatan',
  'homeHero.footer.availableCount': '{n} tersedia',
  'homeHero.footer.noMatches': 'Tidak ada yang cocok',
  'homeHero.moreShortcuts': 'Lainnya',
  'homeHero.railAria': 'Pilih kategori project atau pintasan starter',
  'homeHero.subTypeAria': 'Pilih sub-tipe',
  'homeHero.subTypeMore': 'Lainnya',
  'homeHero.confirmReplaceTitle': 'Ganti prompt saat ini?',
  'homeHero.confirmReplaceBody': 'Menggunakan {title} akan mengganti teks yang ada di input saat ini.',
  'homeHero.confirmReplace': 'Ganti',
  'homeHero.chip.prototype': 'Prototipe',
  'homeHero.chip.webClone': 'Klon situs web',
  'homeHero.chip.liveArtifact': 'Artefak langsung',
  'homeHero.chip.deck': 'Dek slide',
  'homeHero.chip.image': 'Gambar',
  'homeHero.chip.video': 'Video',
  "homeHero.chip.motionDesign": "Desain gerak",
  "homeHero.chip.motionDesignDesc": "Grafis gerak, seni, dan video produk",
  "homeHero.chip.motionDesignHint": "Jelaskan ide, gaya visual, dan durasi untuk membuat video animasi.",
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.webgl': 'WebGL',
  'homeHero.chip.webglDesc': 'Shader, 3D & visual GPU generatif',
  'homeHero.chip.worker': 'Visualizer Worker',
  'homeHero.chip.workerDesc': 'Simulasi off-thread, partikel & visualisasi data',
  'homeHero.chip.audio': 'Audio',
  'homeHero.chip.createBrandKit': 'Buat Kit Merek',
  'homeHero.chip.createPlugin': 'Buat plugin',
  'homeHero.chip.figma': 'Dari Figma',
  'homeHero.chip.folder': 'Dari folder',
  'homeHero.chip.template': 'Dari templat',
  'homeHero.chip.liveArtifactHint': 'Bangun artefak HTML/CSS/JS interaktif yang bisa Anda pratinjau secara langsung.',
  'homeHero.chip.hyperframesHint': 'Buat animasi berbasis HTML: keterangan, visual reaktif-audio, transisi adegan.',
  'homeHero.chip.createBrandKitHint': 'Ekstrak kit merek dari situs web, lalu terapkan di obrolan mana pun.',
  'homeHero.chip.createPluginHint': 'Buat plugin OpenDesign yang dapat digunakan ulang dan tambahkan ke My plugins.',
  'homeHero.chip.figmaHint': 'Migrasikan frame Figma ke design system yang aktif.',
  'homeHero.chip.folderHint': 'Impor folder lokal yang sudah ada dan lanjutkan menyunting.',
  'homeHero.chip.templateHint': 'Mulai dari templat bawaan.',
  'homeHero.chip.wireframe': 'Wireframe',
  'homeHero.chip.mobile': 'Aplikasi mobile',
  'homeHero.chip.document': 'Dokumen',
  'homeHero.chip.prototypeDesc': 'Mockup aplikasi interaktif',
  'homeHero.chip.webCloneDesc': 'Reproduksi situs berbasis kode sumber',
  'homeHero.chip.wireframeDesc': 'Layar & alur low-fi',
  'homeHero.chip.mobileDesc': 'Layar iOS & Android',
  'homeHero.chip.deckDesc': 'Presentasi & pitch deck',
  'homeHero.chip.documentDesc': 'Resume, laporan & PDF',
  'homeHero.chip.imageDesc': 'Poster, grafik & karya seni',
  'homeHero.chip.videoDesc': 'Klip, reels & promo',
  'homeHero.chip.audioDesc': 'Sulih suara, musik & efek suara',
  'homeHero.chip.hyperframesDesc': 'Motion graphics & loop',
  'homeHero.chip.liveArtifactDesc': 'Dasbor langsung berbasis data',
  'homeHero.chip.createBrandKitDesc': 'Ekstrak design system merek',
  'homeHero.chip.prototypeNext': 'Membuka obrolan yang membangun prototipe web high-fidelity yang bisa diklik dan Anda sempurnakan langkah demi langkah.',
  'homeHero.chip.webCloneNext': 'Membuka obrolan yang meminta URL target, membangun ulang situs, dan mengaudit hasil klonnya.',
  'homeHero.chip.wireframeNext': 'Membuka obrolan yang membuat sketsa layar dan alur low-fi untuk memvalidasi struktur terlebih dahulu.',
  'homeHero.chip.mobileNext': 'Membuka obrolan yang menyusun layar mobile untuk iOS dan Android.',
  'homeHero.chip.deckNext': 'Membuka obrolan yang membuat presentasi yang bisa Anda tampilkan dan ekspor.',
  'homeHero.chip.documentNext': 'Membuka obrolan yang menyusun dokumen rapi — resume, laporan, atau PDF.',
  'homeHero.chip.imageNext': 'Membuka obrolan yang menghasilkan gambar sesuai merek yang bisa Anda iterasi.',
  'homeHero.chip.videoNext': 'Membuka obrolan yang memproduksi video pendek yang bisa Anda sempurnakan.',
  'homeHero.chip.audioNext': 'Membuka obrolan yang membuat sulih suara, musik, atau efek suara.',
  'homeHero.chip.webClonePromptSeed': 'URL situs web yang ingin dikloning: ',
  'homeWorkingDir.trigger': 'Pilih direktori kerja',
  'homeWorkingDir.triggerShort': 'Direktori kerja',
  'homeWorkingDir.pick': 'Pilih folder',
  'homeWorkingDir.replace': 'Ubah direktori kerja',
  'homeWorkingDir.recent': 'Folder terbaru',
  'homeWorkingDir.clear': 'Hapus direktori kerja',
  'homeWorkingDir.hint': 'Izinkan agen membaca folder lokal ini (tidak diimpor ke Design Files)',
  'homeWorkingDir.missing': 'Folder kerja ini sudah tidak ada — pilih yang lain',
  'homeWorkingDir.applyFailed': 'Tidak dapat mengatur direktori kerja — folder mungkin sudah tidak ada',
  'workingDirPicker.title': 'Folder',
  'workingDirPicker.homeTitle': 'Disimpan di penyimpanan lokal — klik untuk memilih folder',
  'workingDirPicker.processing': 'Memproses…',
  'workingDirPicker.select': 'Penyimpanan lokal',
  'workingDirPicker.clearAria': 'Kosongkan direktori kerja',
  'workingDirPicker.replaceFailed': 'Tidak dapat mengganti direktori kerja',
  'workingDirPicker.unavailable': 'Pemilih folder tidak tersedia di build ini. Jalankan aplikasi desktop untuk memilih folder.',
  'workingDirPicker.openUnavailable': 'Buka proyek ini di aplikasi desktop untuk menampilkan folder.',
  'workingDirPicker.openFailed': 'Tidak dapat menampilkan folder ini',
  'workingDirPicker.showInFileManager': 'Tampilkan di pengelola berkas',
  'workingDirPicker.replace': 'Pilih folder…',
  'workingDirPicker.recent': 'Direktori terbaru',
  'workingDirPicker.defaultLabel': 'Penyimpanan lokal',
  'handoff.toTarget': 'Serahkan ke {target}',
  'handoff.openInTarget': 'Buka di {target}',
  'handoff.openAction': 'Buka',
  'handoff.menuTitle': 'Buka di editor mana?',
  'handoff.action': 'Serahkan',
  'handoff.fallbackTitle': 'Tidak ada editor yang ditemukan di $PATH - membuka di {target}',
  'handoff.chooseTargetAria': 'Pilih target penyerahan',
  'handoff.optionsAria': 'Opsi penyerahan',
  'handoff.editorSection': 'Buka dengan editor',
  'handoff.cliSection': 'Salin untuk CLI',
  'handoff.clickOpen': 'Klik untuk membuka',
  'handoff.framework': 'Framework kode',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'vanilla JavaScript, HTML, dan CSS',
  'handoff.amrWebsite': 'Buka situs web OpenDesign Cloud',
  'handoff.copyPrompt': 'Salin prompt',
  'handoff.copyPromptForTarget': 'Salin prompt untuk {target}',
  'handoff.copied': 'Tersalin',
  'handoff.projectPathUnavailable': 'Path proyek masih dimuat. Coba lagi sebentar.',
  'handoff.copyFailed': 'Penulisan ke clipboard diblokir. Coba lagi sebentar.',
  'handoff.promptIntro': 'Lanjutkan dari folder proyek OpenDesign lokal ini:',
  'handoff.promptTarget': 'Target',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'Anda mengambil alih di {cli}. Silakan:',
  'handoff.promptReadFiles': 'Masuk atau baca direktori ini terlebih dahulu. Prioritaskan DESIGN.md, README, HTML/CSS/JS yang ada, aset, dan package.json jika tersedia.',
  'handoff.promptKeepDesign': 'Pertahankan desain visual, tata letak, interaksi, dan aset saat ini. Jangan berhenti pada sebuah rencana.',
  'handoff.promptProduceCode': 'Hasilkan atau modifikasi kode {framework} yang benar-benar dapat dijalankan. Jika proyek sudah memiliki stack yang lebih jelas, sampaikan konfliknya dan jaga agar hasilnya tetap dapat dijalankan.',
  'handoff.promptVerify': 'Akhiri dengan memberi tahu saya perintah untuk menjalankan, pratinjau, dan verifikasi.',
  'handoff.promptCommandHint': 'Untuk memulai dari direktori proyek, gunakan:',
  'handoff.promptProject': 'Proyek',
  'handoff.promptProjectId': 'ID Proyek',
  'handoff.notInstalled': 'Belum terpasang',
  'handoff.notDetectedTitle': '{target} - tidak terdeteksi di $PATH',
  'designSystemPicker.select': 'Pilih design system',
  'designSystemPicker.loading': 'Memuat design system…',
  'designSystemPicker.searchPlaceholder': 'Cari sistem desain (judul / kategori / ringkasan)',
  'designSystemPicker.searchCompactPlaceholder': 'Cari sistem desain',
  'designSystemPicker.noneTitle': 'Tanpa sistem desain',
  'designSystemPicker.noneSummary': 'Biarkan model memilih dengan bebas',
  'designSystemPicker.empty': 'Tidak ada sistem desain yang cocok',
  'designSystemPicker.openPreview': 'Buka pratinjau',
  'designSystemPicker.loadingPreview': 'Memuat pratinjau…',
  'designSystemPicker.noPreview': 'Tidak ada halaman pratinjau. Buka Sistem Desain untuk melihat pratinjau lengkap.',
  'designSystemPicker.previewHint': 'Arahkan kursor ke sistem desain untuk melihat pratinjaunya',
  'designSystemPicker.fullscreenAria': 'Pratinjau layar penuh {title}',
  'designSystemPicker.closeFullscreen': 'Tutup pratinjau layar penuh',
  'designSystemPicker.closeEsc': 'Tutup (Esc)',
  'designSystemPicker.previewFrameTitle': 'Pratinjau {title}',
  'designSystemPicker.fullscreenFrameTitle': 'Pratinjau layar penuh {title}',
  'recentProjects.title': 'Proyek terbaru',
  'recentProjects.viewAll': 'Lihat semua',
  'recentProjects.empty': 'Belum ada proyek — ketik prompt untuk memulai.',
  'recentProjects.ownerAll': 'All',
  'recentProjects.ownerMine': 'Mine',
  'recentProjects.ownerOthers': 'Others',
  'recentProjects.kindAll': 'Any type',
  'recentProjects.kindPrototype': 'Prototype',
  'recentProjects.kindSlides': 'Slides',
  'recentProjects.kindDocument': 'Document',
  'recentProjects.kindImage': 'Gambar',
  'recentProjects.kindMedia': 'Media',
  'recentProjects.kindOther': 'Other',
  'recentProjects.inviteTeammates': 'Invite teammates',
  'recentProjects.multiSelect': 'Multi-select',
  'recentProjects.sortAria': 'Sort projects',
  'recentProjects.sortNewest': 'Newest first',
  'recentProjects.sortOldest': 'Oldest first',
  'recentProjects.sortName': 'Name',
  'recentProjects.collectionRecent': 'Recently viewed',
  'recentProjects.collectionPersonalProjects': 'Proyek pribadi',
  'recentProjects.collectionTeamProjects': 'Proyek tim',
  'recentProjects.viewList': 'List view',
  'recentProjects.sharedBadge': 'Shared',
  'recentProjects.sharedProjectFallbackName': 'Shared project',
  'recentProjects.creatorLine': 'Created by {name}',
  'recentProjects.selfCreator': 'Me',
  'recentProjects.teamMemberCreator': 'Team member',
  'recentProjects.ownOnlyMutation': 'Only projects you created can be changed or deleted.',
  'recentProjects.shareInProgress': 'Sharing…',
  'recentProjects.duplicateInProgress': 'Menduplikasi…',
  'recentProjects.sharedInTeam': 'In team space',
  'recentProjects.moveToTeam': 'Move to team space',
  'recentProjects.moveToTeamDescPre': 'Once moved to the team space, ',
  'recentProjects.moveToTeamDescStrong': 'all team members can view and comment',
  'recentProjects.moveToTeamDescPost': ', and only the creator can edit. You can find it under "Team projects".',
  'recentProjects.moveToPersonalDescPre': 'Once moved out of the team space, it returns to a personal project, ',
  'recentProjects.moveToPersonalDescStrong': 'only you can view and edit it',
  'recentProjects.moveToPersonalDescPost': '.',
  'recentProjects.moveDontRemind': 'Don\'t remind me again',
  'recentProjects.confirmMoveToTeam': 'Confirm move',
  'recentProjects.confirmMoveToPersonal': 'Confirm move',
  'recentProjects.unshareInProgress': 'Moving out…',
  'recentProjects.moveOutOfTeam': 'Move out of team space',
  'recentProjects.unshareFailed': 'Could not move out of team space. Try again.',
  'recentProjects.shareFailed': 'Could not move to team space. Try again.',
  'recentProjects.shareOwnerConflict': 'Could not move to team space: another member already shares this project with the team.',
  'recentProjects.clearFilters': 'Hapus filter',
  'pluginsHome.title': 'Komunitas',
  'pluginsHome.subtitle': 'Alur kerja OpenDesign siap pakai yang disertakan dengan runtime ini. Pilih salah satu untuk memuat prompt awal, atau jelajahi registry untuk lebih banyak.',
  'pluginsHome.browseRegistry': 'Jelajahi registry',
  'pluginsHome.count': '{filtered} dari {total}',
  'pluginsHome.loadingCatalog': 'Memuat katalog…',
  'pluginsHome.emptyCatalog': 'Katalog kosong. Plugin bawaan disertakan dengan OpenDesign dan seharusnya muncul di sini secara otomatis — coba mulai ulang daemon jika masalah ini berlanjut.',
  'pluginsHome.emptyFiltered': 'Tidak ada plugin yang cocok dengan filter saat ini.',
  'pluginsHome.clearFilters': 'Hapus filter',
  'pluginsHome.modeAria': 'Mode plugin',
  'pluginsHome.featured': 'Tersimpan',
  'pluginsHome.totalInCatalog': '{n} di katalog',
  'pluginsHome.categoryFilterAria': 'Filter kategori',
  'pluginsHome.subcategoryFilterAria': 'Filter subkategori {label}',
  'pluginsHome.allCategory': 'Semua {label}',
  'pluginsHome.searchPlaceholder': 'Cari plugin…',
  'pluginsHome.searchAria': 'Cari plugin',
  'pluginsHome.clearSearch': 'Hapus pencarian',
  'pluginsHome.sortAria': 'Urutan penyortiran',
  'pluginsHome.sortHot': 'Sedang tren',
  'pluginsHome.sortNewest': 'Terbaru',
  'pluginsHome.facet.import': 'Impor',
  'pluginsHome.facet.create': 'Buat',
  'pluginsHome.facet.export': 'Ekspor',
  'pluginsHome.facet.share': 'Bagikan',
  'pluginsHome.facet.deploy': 'Deploy',
  'pluginsHome.facet.refine': 'Sempurnakan',
  'pluginsHome.facet.extend': 'Perluas',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'Kode / folder',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'Tangkapan layar',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'Slide',
  'pluginsHome.facet.publicLink': 'Tautan publik',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': 'Dasbor',
  'pluginsHome.subfacet.app-prototypes': 'Aplikasi',
  'pluginsHome.subfacet.landing-marketing': 'Landing / pemasaran',
  'pluginsHome.subfacet.developer-tools': 'Alat developer',
  'pluginsHome.subfacet.docs-reports': 'Dokumen / laporan',
  'pluginsHome.subfacet.brand-design': 'Brand / desain',
  'pluginsHome.subfacet.pitch-business': 'Pitch / bisnis',
  'pluginsHome.subfacet.course-training': 'Kursus / pelatihan',
  'pluginsHome.subfacet.reports-briefings': 'Laporan / ringkasan',
  'pluginsHome.subfacet.product-sales': 'Produk / penjualan',
  'pluginsHome.subfacet.engineering-talks': 'Talk teknis',
  'pluginsHome.subfacet.creative-decks': 'Deck kreatif',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / mockup produk',
  'pluginsHome.subfacet.brand-visuals': 'Brand / logo',
  'pluginsHome.subfacet.storyboards-motion-refs': 'Storyboard',
  'pluginsHome.subfacet.social-content': 'Sosial / konten',
  'pluginsHome.subfacet.avatar-portrait': 'Avatar / potret',
  'pluginsHome.subfacet.illustration-style': 'Ilustrasi / gaya',
  'pluginsHome.subfacet.motion-effects': 'Motion / efek',
  'pluginsHome.subfacet.social-short-form': 'Sosial / video pendek',
  'pluginsHome.subfacet.marketing-product': 'Pemasaran / produk',
  'pluginsHome.subfacet.data-explainers': 'Data / penjelasan',
  'pluginsHome.subfacet.cinematic-story': 'Sinematik / cerita',
  'pluginsHome.commercialCategory.student-coursework': 'Student coursework',
  'pluginsHome.commercialCategory.corporate-strategy': 'Corporate strategy',
  'pluginsHome.commercialCategory.professional-training': 'Professional training',
  'pluginsHome.commercialCategory.b2b-sales': 'B2B sales',
  'pluginsHome.commercialCategory.academic-research': 'Academic research',
  'pluginsHome.commercialCategory.marketing-gtm': 'Marketing & GTM',
  'pluginsHome.commercialCategory.data-finance': 'Data & finance',
  'pluginsHome.commercialCategory.fundraising-pitch': 'Fundraising pitch',
  'pluginsHome.commercialCategory.government-policy': 'Government & policy',
  'pluginsHome.commercialCategory.product-management': 'Product management',
  'pluginsHome.commercialCategory.consulting': 'Consulting',
  'pluginsHome.commercialCategory.career': 'Career',
  'pluginsHome.commercialCategory.ai-literacy': 'AI literacy',
  'pluginsHome.commercialCategory.life': 'Life & story',
  'pluginsHome.commercialCategory.design-craft': 'Design craft',
  'pluginsView.lede': 'Jelajahi alur kerja terpasang, temukan entri registry, kelola sumber, dan siapkan plugin untuk distribusi tim.',
  'pluginsView.importPlugin': 'Impor plugin',
  'pluginsView.agentContext': 'Konteks Agent',
  'pluginsView.summaryAria': 'Ringkasan plugin',
  'pluginsView.areasAria': 'Area plugin',
  'pluginsView.loading': 'Memuat plugin…',
  'pluginsView.tab.installed': 'Terpasang',
  'pluginsView.tab.available': 'Tersedia',
  'pluginsView.tab.sources': 'Sumber',
  'pluginsView.tab.team': 'Tim',
  'pluginsView.tabHint.installed': 'Plugin Anda',
  'pluginsView.tabHint.available': 'Dari sumber',
  'pluginsView.tabHint.sources': 'Katalog',
  'pluginsView.tabHint.team': 'Enterprise',
  'pluginsView.installedTitle': 'Plugin terpasang',
  'pluginsView.installedSubtitle': 'Plugin yang Anda impor atau pasang dari sumber marketplace.',
  'pluginsView.installedEmpty': 'Belum ada plugin pengguna yang terpasang. Gunakan Buat / Impor atau pasang entri yang Tersedia.',
  'pluginsView.availableTitle': 'Tersedia dari sumber',
  'pluginsView.availableSubtitle': 'Entri katalog yang ditemukan dari marketplace yang dikonfigurasi.',
  'pluginsView.availableFiltersAria': 'Filter plugin yang tersedia',
  'pluginsView.searchAvailableAria': 'Cari plugin yang tersedia',
  'pluginsView.searchAvailablePlaceholder': 'Cari plugin yang tersedia',
  'pluginsView.clearAvailableSearch': 'Hapus pencarian plugin yang tersedia',
  'pluginsView.source': 'Sumber',
  'pluginsView.availableEmptyInstalled': 'Belum ada entri yang tersedia. Entri katalog yang terpasang dihapus dari Tersedia; copot pemasangan salah satunya untuk membuatnya tersedia lagi.',
  'pluginsView.availableEmptyFiltered': 'Tidak ada entri tersedia yang cocok dengan filter Anda.',
  'pluginsView.availableEmptyNoSources': 'Belum ada entri yang tersedia. Tambahkan sumber di tab Sumber.',
  'pluginsView.installing': 'Memasang…',
  'pluginsView.installWaiting': 'Menunggu…',
  'pluginsView.installQueuedHint': 'Plugin lain sedang dipasang. Pemasangan berjalan satu per satu — tombol ini tersedia setelah selesai.',
  'pluginsView.install': 'Pasang',
  'pluginsView.sourcesTitle': 'Sumber registry',
  'pluginsView.sourcesSubtitle': 'Katalog marketplace yang mengisi entri plugin Tersedia.',
  'pluginsView.sourceUrl': 'URL Sumber',
  'pluginsView.defaultTrust': 'Tingkat kepercayaan default',
  'pluginsView.trust.restricted': 'Dibatasi',
  'pluginsView.trust.trusted': 'Tepercaya',
  'pluginsView.trust.official': 'Resmi',
  'pluginsView.adding': 'Menambahkan…',
  'pluginsView.addSource': 'Tambah sumber',
  'pluginsView.sourcesEmpty': 'Belum ada sumber registry yang dikonfigurasi.',
  'pluginsView.pluginsCount': '{n} plugin',
  'pluginsView.catalogVersion': 'katalog v{version}',
  'pluginsView.trustFor': 'Kepercayaan untuk {name}',
  'pluginsView.refreshing': 'Menyegarkan…',
  'pluginsView.removing': 'Menghapus…',
  "pluginsView.marketplaceTitle": "Extensions",
  "pluginsView.marketplaceBody": "Install expert suites, skills, and connectors to add new work capabilities to OpenDesign.",
  "pluginsView.marketplaceModeAria": "Marketplace mode",
  "pluginsView.marketplaceSourceFiltersAria": "Marketplace source filters",
  "pluginsView.scope.official": "OpenDesign official",
  "pluginsView.scope.team": "Team",
  "pluginsView.scope.personal": "Personal",
  "pluginsView.kind.plugins": "Expert suites",
  "pluginsView.kind.skills": "Skills",
  "pluginsView.searchPlugins": "Search expert suites",
  "pluginsView.searchSkills": "Search skills",
  "pluginsView.modeNote.plugins": "Expert suites are role- and industry-focused toolkits. Type @ or slash in the composer to use them.",
  "pluginsView.modeNote.skills": "Skills are reusable task workflows and review rules. Use them directly or compose them into expert suites.",
  "pluginsView.create": "Add",
  "pluginsView.createTitle": "Add {kind}",
  "pluginsView.createWithAgent": "Describe it and let the agent build it",
  "pluginsView.createWithAgentBody": "Start from a prompt in the home composer instead of importing an existing extension.",
  "pluginsView.createWithAgentAction": "Start from a prompt",
  "pluginsView.createPluginBody": "Import a plugin from GitHub or a local folder, then upload it for team use.",
  "pluginsView.createSkillBody": "Create a reusable task workflow or review rule that can later be reused by plugins.",
  "pluginsView.createClose": "Close add panel",
  "pluginsView.createTypeAria": "Create type",
  "pluginsView.importFromUrl": "Import from link",
  "pluginsView.importUrlBody": "Paste a public link for a {kind}. OpenDesign will fetch the manifest, validate capabilities, and upload it to the team space.",
  "pluginsView.uploadFolder": "Upload local folder",
  "pluginsView.uploadFolderBody": "Choose a local folder containing {manifest}. After validation, it will upload as a team {kind}.",
  "pluginsView.importing": "Importing…",
  "pluginsView.importAndUpload": "Import and upload",
  "pluginsView.uploading": "Uploading…",
  "pluginsView.uploadKind": "Upload {kind}",
  "pluginsView.filesSelected": "{count} files selected",
  "pluginsView.chooseFolder": "Choose folder",
  "pluginsView.emptyNoMatchTitle": "No matching results",
  "pluginsView.emptyNoMatchHint": "Try another keyword.",
  "pluginsView.emptyTeamTitle": "No content shared to the team yet",
  "pluginsView.emptyTeamHint": "Share expert suites or skills from Personal to Team, and they will appear here.",
  "pluginsView.emptyPersonalPluginsTitle": "No personal expert suites yet",
  "pluginsView.emptyPersonalSkillsTitle": "No personal skills yet",
  "pluginsView.emptyPersonalHint": "Install from OpenDesign official, or use Add in the top right to create one.",
  "pluginsView.emptyOfficialPluginsTitle": "No official expert suites available",
  "pluginsView.emptyOfficialSkillsTitle": "No official skills available",
  "pluginsView.emptyOfficialHint": "Check back later, or add a marketplace in plugin sources.",
  "pluginsView.teamSharedBadge": "Shared with team",
  "pluginsView.tryIt": "Try it",
  "pluginsView.categoriesAria": "Categories",
  "pluginsView.statSkills": "{count} skills",
  "pluginsView.statConnectors": "{count} connectors",
  "pluginsView.uninstall": "Uninstall",
  "pluginsView.uninstalling": "Uninstalling…",
  "pluginsView.uninstallConfirm": "Uninstall {title}?",
  "pluginsView.uninstallSuccess": "Uninstalled {title}",
  "pluginsView.uninstallFailed": "Could not uninstall {title}",
  "pluginsView.sharing": "Sharing…",
  "pluginsView.unsharing": "Removing…",
  "pluginsView.shareToTeam": "Share with team",
  "pluginsView.syncToTeam": "Sinkronkan ke tim",
  "pluginsView.unshareFromTeam": "Remove from team",
  "pluginsView.moreActions": "{title} more actions",
  "pluginsView.skillUrlUnsupported": "Skills do not support import from link yet. Use Upload local folder instead.",
  "pluginsView.importPluginSuccess": "Imported and uploaded expert suite",
  "pluginsView.importFailed": "Import failed. Check the link and try again.",
  "pluginsView.uploadPluginSuccess": "Uploaded expert suite",
  "pluginsView.uploadFailed": "Upload failed. Check the folder contents.",
  "pluginsView.importSkillSuccess": "Imported Skill \"{name}\". You can share it with the team from Personal.",
  "pluginsView.shareSuccess": "Shared \"{title}\" with the team. Teammates can now use it.",
  "pluginsView.shareUnavailable": "Could not share \"{title}\" yet. Confirm you are in a team workspace.",
  "pluginsView.shareFailed": "Failed to share \"{title}\". Try again later.",
  "pluginsView.syncSuccess": "Versi terbaru \"{title}\" telah disinkronkan ke tim.",
  "pluginsView.syncUnavailable": "Belum dapat menyinkronkan \"{title}\". Pastikan Anda berada di ruang kerja tim.",
  "pluginsView.syncFailed": "Gagal menyinkronkan \"{title}\" ke tim. Coba lagi nanti.",
  "pluginsView.unshareSuccess": "Removed \"{title}\" from team sharing.",
  "pluginsView.unshareUnavailable": "Could not remove \"{title}\" from team sharing. Confirm you have permission.",
  "pluginsView.unshareFailed": "Failed to remove \"{title}\" from team sharing. Try again later.",
  "pluginsView.installSuccess": "Installed \"{title}\"",
  "pluginsView.installFailed": "Failed to install \"{title}\"",
  "pluginsView.skillMissingFile": "No SKILL.md was found in the selected folder.",
  "pluginsView.skillReadFailed": "Could not read SKILL.md. Try again.",
  "pluginsView.skillMissingName": "SKILL.md is missing a name field.",
  "pluginsView.skillEmptyBody": "SKILL.md content is empty.",
  'pluginsView.teamTitle': 'Marketplace tim privat',
  'pluginsView.teamBody': 'Area ini disediakan untuk katalog enterprise dan tim, kebijakan kepercayaan privat, serta kontrol siklus hidup plugin bersama.',
  'pluginCard.details': 'Detail',
  'pluginCard.use': 'Gunakan',
  'pluginCard.useWithQuery': 'Gunakan dengan kueri',
  'pluginCard.applying': 'Menerapkan…',
  'pluginCard.duplicate': 'Remix',
  'pluginCard.duplicating': 'Meremix…',
  'pluginCard.duplicateFailed': 'Tidak dapat meremix template ini.',
  'pluginCard.saved': 'Tersimpan',
  'pluginCard.publish': 'Terbitkan',
  'pluginCard.contribute': 'Berkontribusi',
  'pluginCard.starting': 'Memulai…',
  'pluginCard.detailsAria': 'Lihat detail untuk {title}',
  'pluginCard.chooseUseAria': 'Pilih cara menggunakan {title}',
  'pluginCard.useOptionsAria': 'Opsi penggunaan untuk {title}',
  'pluginCard.duplicateAria': 'Remix {title} sebagai proyek baru',
  'pluginCard.saveAria': 'Simpan {title}',
  'pluginCard.savedAria': '{title} tersimpan',
  'pluginCard.shareAria': 'Bagikan {title}',
  'pluginCard.publishAria': 'Terbitkan {title} sebagai repositori GitHub',
  'pluginCard.publishTitle': 'Terbitkan plugin sebagai repositori GitHub',
  'pluginCard.contributeAria': 'Kontribusikan {title} ke OpenDesign',
  'pluginCard.contributeTitle': 'Kontribusikan plugin ke OpenDesign dengan pull request',
  'integrations.kicker': 'Integrasi',
  'integrations.lede': 'Hubungkan sistem eksternal, bawa alat MCP ke dalam loop agent Anda, dan gunakan OpenDesign dari IDE, skrip, dan otomatisasi lainnya.',
  'integrations.agentReady': 'Siap untuk agent',
  'integrations.areasAria': 'Area integrasi',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Skill',
  'integrations.tabHint.mcp': 'Alat eksternal',
  'integrations.tabHint.connectors': 'Akun dan API',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'Integrasi Skill',
  'integrations.skillsBody': 'Manajemen integrasi tingkat Skill sedang dipindahkan dari branch lain. Tab ini disediakan agar pengaturan MCP, Connector, dan Skill di masa mendatang berada dalam rute Integrasi yang sama.',
  'mcpClient.title': 'Server MCP eksternal',
  'mcpClient.subtitle': 'Alat pihak ketiga untuk coding agent Anda.',
  'mcpClient.addServer': 'Tambah server',
  'mcpClient.emptyTitle': 'Belum ada server MCP yang dikonfigurasi.',
  'mcpClient.emptyBody': 'Klik "Add server" untuk memulai — pilih template (Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…) atau siapkan server stdio / HTTP kustom.',
  'mcpClient.saveChanges': 'Simpan perubahan',
  'mcpClient.storedAt': 'Disimpan di',
  'mcpClient.daemonError': 'Tidak dapat menjangkau daemon lokal. Pastikan OpenDesign berjalan, lalu buka kembali panel ini.',
  'mcpClient.saveFailed': 'Gagal menyimpan. Pastikan daemon berjalan dan coba lagi.',
  'useEverywhere.modalAria': 'Gunakan OpenDesign di mana saja',
  'useEverywhere.modalTitle': 'Gunakan OpenDesign di mana saja',
  'useEverywhere.modalSubtitle': 'Sematkan OpenDesign ke IDE, agent, atau skrip apa pun — CLI, HTTP, MCP, dan Skills. Gunakan “Copy guide for an agent” lalu tempel ke Claude Code, Codex, Cursor, openclaw, atau hermes untuk menyiapkan semuanya.',
  'useEverywhere.closeAria': 'Tutup gunakan di mana saja',
  'useEverywhere.closeTitle': 'Tutup (Esc)',
  'useEverywhere.tabsAria': 'Permukaan integrasi',
  'useEverywhere.footStrong': 'Serah terima sekali klik.',
  'useEverywhere.footBody': 'Menyalin panduan markdown terstruktur yang dapat langsung ditindaklanjuti agent Anda — pasang, verifikasi, dan gunakan.',
  'useEverywhere.configureMcp': 'Konfigurasi server MCP',
  'useEverywhere.copyGuide': 'Salin panduan untuk Agent',
  'useEverywhere.copy': 'Salin',
  'useEverywhere.copied': 'Tersalin',
  'useEverywhere.copyFailed': 'Gagal menyalin',
  'useEverywhere.copySnippetAria': 'Salin cuplikan: {label}',
  'useEverywhere.section.overview.tab': 'Ikhtisar',
  'useEverywhere.section.overview.heading': 'OpenDesign bekerja di mana pun Agent Anda bekerja',
  'useEverywhere.section.overview.intro': 'OpenDesign lebih dari sekadar jendela — ini adalah daemon lokal dengan hak istimewa (`od`) ditambah registry Skills + Design-Systems + Atoms. Setelah berjalan di mesin Anda, setiap code agent (Claude Code, Codex, Cursor, OpenCode/openclaw, Hermes, skrip Anda sendiri) dapat menjalankan generasi, memeriksa proyek, dan menghasilkan artefak desain melalui empat permukaan yang dapat dipertukarkan.',
  'useEverywhere.section.overview.bullet1': 'CLI — `od <command>` untuk skrip headless, CI, dan otomatisasi shell.',
  'useEverywhere.section.overview.bullet2': 'Server MCP — menghubungkan OpenDesign sebagai server Model Context Protocol sehingga agent yang mendukung MCP dapat mendaftar skill, menjalankan skenario, dan membaca artefak.',
  'useEverywhere.section.overview.bullet3': 'API HTTP — endpoint REST + SSE `http://127.0.0.1:7456/api/*`; permukaan yang sama dengan yang digunakan UI web.',
  'useEverywhere.section.overview.bullet4': 'Skills — paket `SKILL.md` siap pakai (kompatibel dengan Claude) yang dapat dipanggil oleh agent mana pun yang sudah ada di PATH Anda tanpa OpenDesign sama sekali.',
  'useEverywhere.section.overview.bullet5': 'Artefak standar — buat proyek HTML nyata dari Skills, plugin default bawaan, dan contoh plugin komunitas sebelum daemon dimulai.',
  'useEverywhere.section.overview.snippet1': 'Jalankan daemon (dan web UI) secara lokal',
  'useEverywhere.section.overview.snippet2': 'Konfirmasi bahwa daemon dapat dijangkau',
  'useEverywhere.section.overview.snippet3': 'Ingest artefak standar sebelum boot',
  'useEverywhere.section.overview.footer': 'Daemon menulis ke `./.od/` (lokal proyek) secara default. Atur `OD_DATA_DIR=~/.open-design` untuk berbagi data lintas proyek.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'Kendalikan OpenDesign dari shell apa pun',
  'useEverywhere.section.cli.intro': 'Bin `od` disertakan dengan daemon dan merupakan biner yang sama yang digunakan Claude Code / Codex saat menjalankan generasi. Sebagian besar subperintah adalah klien tipis yang melakukan POST ke daemon lokal, sehingga bekerja sama baik Anda meluncurkannya melalui `pnpm tools-dev` maupun sebagai aplikasi terpaket.',
  'useEverywhere.section.cli.bullet1': '`od` (tanpa argumen) — menjalankan daemon dan membuka UI web.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — menghasilkan byte gambar / video / audio melalui protokol media terpadu.',
  'useEverywhere.section.cli.bullet3': '`od run ...` — memulai run proyek dari prompt + skill.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — memasang dan menerapkan plugin komunitas.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — memeriksa apa yang tersedia secara lokal.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — memverifikasi kesehatan daemon dan mendeteksi CLI agent di PATH Anda.',
  'useEverywhere.section.cli.snippet1': 'Hasilkan gambar (mendelegasikan ke penyedia media yang dikonfigurasi)',
  'useEverywhere.section.cli.snippet2': 'Jalankan plugin skenario secara headless dan alirkan event sebagai baris JSON',
  'useEverywhere.section.cli.snippet3': 'Inventarisasi skill dan design system yang tersedia secara lokal',
  'useEverywhere.section.cli.snippet4': 'Periksa artefak yang di-seed melalui CLI',
  'useEverywhere.section.cli.snippet5': 'Verifikasi lingkungan + agent yang terdeteksi (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': 'Semua subcommand menerima `--daemon-url http://127.0.0.1:<port>` untuk menargetkan daemon tertentu yang sedang berjalan — berguna saat menjalankan instance kedua dalam sandbox untuk pengujian.',
  'useEverywhere.section.mcp.tab': 'Server MCP',
  'useEverywhere.section.mcp.heading': 'Ekspos OpenDesign sebagai server MCP ke coding agent mana pun',
  'useEverywhere.section.mcp.intro': 'OpenDesign disertai server Model Context Protocol (`od mcp`) yang memungkinkan klien apa pun yang mendukung MCP — Cursor, Claude Code, Antigravity, VS Code Copilot Chat, openclaw, hermes — menemukan tool OpenDesign (daftar skill, render pratinjau, hasilkan media, jalankan plugin) tanpa perlu menjalankan shell secara manual. Daemon mempublikasikan cuplikan instalasi siap tempel melalui `GET /api/mcp/install-info` untuk setiap klien utama.',
  'useEverywhere.section.mcp.bullet1': 'Transport stdio — tanpa port tambahan, klien menjalankan `od mcp` secara langsung.',
  'useEverywhere.section.mcp.bullet2': 'Menemukan URL daemon aktif secara otomatis melalui socket status IPC lokal saat diluncurkan sebagai sidecar.',
  'useEverywhere.section.mcp.bullet3': 'Beralih ke `--daemon-url http://127.0.0.1:<port>` untuk instalasi biasa sehingga proses MCP selalu menemukan daemon yang berjalan.',
  'useEverywhere.section.mcp.bullet4': 'Menetapkan `OD_DATA_DIR` agar proses MCP yang di-spawn menulis ke tempat yang sama yang sudah digunakan daemon (menghindari EPERM pada bundel aplikasi macOS terpaket).',
  'useEverywhere.section.mcp.snippet1': 'Konfigurasi klien MCP generik (berfungsi di Cursor, Claude Code, Codex, …)',
  'useEverywhere.section.mcp.snippet2': 'Atau: minta daemon menyediakan cuplikan yang disesuaikan dengan instalasi Anda',
  'useEverywhere.section.mcp.snippet3': 'Varian MCP live-artifacts (baca & segarkan dasbor)',
  'useEverywhere.section.mcp.footer': 'Di aplikasi OpenDesign, buka Settings → Integrations untuk menyalin perintah instalasi spesifik klien (Cursor, Claude Code, Antigravity, VS Code) alih-alih mengedit JSON secara manual.',
  'useEverywhere.section.http.tab': 'HTTP API',
  'useEverywhere.section.http.heading': 'Permukaan REST + SSE yang sama dengan yang digunakan web UI',
  'useEverywhere.section.http.intro': 'Daemon lokal menyajikan HTTP API di `http://127.0.0.1:7456` (port dapat dikonfigurasi). Setiap endpoint yang dipanggil web UI juga dapat digunakan untuk skrip Anda. Endpoint streaming (giliran chat, jalannya proyek) memancarkan Server-Sent Events dengan tipe kontrak di `@open-design/contracts`.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — keaktifan daemon.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` dan `GET /api/design-systems` — registry yang tersedia.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` dan `POST /api/projects` — daftar dan buat project (POST mengembalikan project + percakapan pertama).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — aliran SSE dari event Agent untuk sebuah percakapan.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — ikat plugin yang terpasang dan dapatkan contoh query terenderan + input-nya.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — CLI code-agent yang terdeteksi di PATH Anda.',
  'useEverywhere.section.http.snippet1': 'Daftar skill yang terpasang (Agent akan menggunakannya sebagai templat)',
  'useEverywhere.section.http.snippet2': 'Buat proyek dari prompt (alur lengkap di sisi server)',
  'useEverywhere.section.http.snippet3': 'Alirkan giliran chat (SSE — setiap baris kompatibel dengan JSON-Lines)',
  'useEverywhere.section.http.footer': 'Tipe TypeScript murni untuk setiap request/response tersedia di `@open-design/contracts` — impor di skrip Anda untuk autocomplete penuh tanpa perlu menyiapkan generator.',
  'useEverywhere.section.skills.tab': 'Skill & headless',
  'useEverywhere.section.skills.heading': 'Skills siap pakai untuk Agent apa pun — bahkan tanpa OpenDesign berjalan',
  'useEverywhere.section.skills.intro': 'Skill adalah direktori dengan `SKILL.md` yang kompatibel dengan Claude (front-matter YAML + body). OpenDesign memperluas formatnya dengan namespace `od:` (`mode`, `preview`, `design_system`, `inputs`, …) sehingga artefak yang sama dapat digunakan baik di dalam OpenDesign maupun oleh Agent biasa seperti Claude Code, Codex, openclaw, atau hermes. Penemuan mengikuti rantai prioritas sehingga project dapat menggantikan skill-nya sendiri.',
  'useEverywhere.section.skills.bullet1': 'Penemuan: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (project menang).',
  'useEverywhere.section.skills.bullet2': 'Symlink satu skill ke beberapa proyek untuk membagikannya tanpa menyalin.',
  'useEverywhere.section.skills.bullet3': 'Setiap skill dapat mendeklarasikan konektor, atom, persyaratan design system, dan contoh output `preview` untuk galeri.',
  'useEverywhere.section.skills.bullet4': 'Headless: Agent dengan `od` di PATH-nya dapat memanggil `od skills list` lalu menjalankan skill apa pun; daemon bersifat opsional untuk alur baca-saja.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` menjalankan bentuk artefak yang sama dengan contoh plugin default dan contoh plugin komunitas, lalu menyimpan proyek `index.html` yang dihasilkan sebagai data uji yang dapat digunakan kembali.',
  'useEverywhere.section.skills.snippet1': 'SKILL.md minimal (front matter kompatibel dengan Claude + tambahan OpenDesign)',
  'useEverywhere.section.skills.snippet2': 'Symlink skill bersama ke dalam proyek (gaya cc-switch)',
  'useEverywhere.section.skills.snippet3': 'Headless: daftar skill yang dilihat daemon saat ini',
  'useEverywhere.section.skills.snippet4': 'Bundel fixture artefak headless',
  'useEverywhere.section.skills.footer': 'Spek: `docs/skills-protocol.md` dan `docs/agent-adapters.md` mencakup seluruh permukaan adapter (Claude Code, Codex, Cursor, Agent yang mendukung MCP, fallback API BYOK) dan strategi injeksi skill per adapter.',
  'tasks.kicker': 'Workspace otomatisasi',
  'tasks.comingSoon': 'Segera hadir',
  'tasks.lede': 'Otomatisasi mengubah prompt menjadi pekerjaan yang tahan lama: Orbit menjalankannya, routine mempertahankannya, jadwal menentukan kapan mereka dipicu, dan live artifact menunjukkan apa yang berubah.',
  'tasks.newAutomation': 'Otomatisasi baru',
  'tasks.previewNote': 'Hanya permukaan pratinjau. Pengaturan Orbit sudah tersedia hari ini; routine, jadwal, dan koneksi live artifact akan hadir seiring penggabungan cabang backend.',
  'tasks.primitivesAria': 'Primitif otomatisasi',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'Runtime persisten untuk pekerjaan Agent yang berjalan lama atau berulang.',
  'tasks.primitive.orbit.enabled': 'Ringkasan harian diaktifkan',
  'tasks.primitive.orbit.manualOnly': 'Manual saja',
  'tasks.primitive.routines.title': 'Rutinitas',
  'tasks.primitive.routines.body': 'Definisi tugas tahan lama yang bertahan setelah satu obrolan berakhir.',
  'tasks.primitive.routines.meta': 'Product shell siap',
  'tasks.primitive.schedules.title': 'Jadwal',
  'tasks.primitive.schedules.body': 'Pemicu waktu atau peristiwa yang menentukan kapan sebuah rutinitas harus dijalankan.',
  'tasks.primitive.schedules.meta': 'Branch tertunda',
  'tasks.primitive.liveArtifacts.title': 'Artefak langsung',
  'tasks.primitive.liveArtifacts.body': 'Laporan dan catatan yang terus diperbarui saat Agent bekerja.',
  'tasks.primitive.liveArtifacts.meta': 'Model pratinjau',
  'tasks.listAria': 'Daftar otomatisasi',
  'tasks.routinesAndRuns': '{n} rutinitas dan proses',
  'tasks.filtersAria': 'Filter otomatisasi',
  'tasks.filter.scheduled': 'Terjadwal',
  'tasks.filter.running': 'Sedang berjalan',
  'tasks.filter.done': 'Selesai',
  'tasks.configurationAria': 'Konfigurasi otomatisasi',
  'tasks.slot.trigger': 'Pemicu',
  'tasks.slot.pattern': 'Pola',
  'tasks.slot.runtime': 'Runtime',
  'tasks.slot.output': 'Keluaran',
  'tasks.liveArtifact': 'Artefak langsung',
  'tasks.viewProgress': 'Lihat progres',
  'tasks.pause': 'Jeda',
  'tasks.runNow': 'Jalankan sekarang',
  'tasks.openArtifact': 'Buka artefak',
  'tasks.status.dailyAt': 'Harian · {time}',
  'tasks.status.pausedManual': 'Dijeda · hanya manual',
  'tasks.sample.orbit.title': 'Ringkasan connector Orbit Daily',
  'tasks.sample.orbit.metaEnabled': 'Ringkasan connector telah dijadwalkan',
  'tasks.sample.orbit.metaDisabled': 'Buka pengaturan Orbit untuk mengaktifkan',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · artefak langsung',
  'tasks.sample.orbit.previewDisabled': 'Tidak ada proses terjadwal',
  'tasks.sample.orbit.triggerEnabled': 'Jadwal · setiap hari pukul {time}',
  'tasks.sample.orbit.triggerDisabled': 'Manual · jalankan sesuai permintaan',
  'tasks.sample.orbit.pattern': 'Rutin · ringkasan connector',
  'tasks.sample.orbit.runtime': 'Orbit · dijadwalkan daemon',
  'tasks.sample.orbit.output': 'Artefak langsung · laporan yang dapat disegarkan',
  'tasks.sample.orbit.artifactMetaEnabled': 'Disegarkan setelah setiap proses',
  'tasks.sample.orbit.artifactMetaDisabled': 'Menunggu jadwal',
  'tasks.sample.orbit.body1': '# Ringkasan aktivitas Orbit Daily',
  'tasks.sample.orbit.body2': 'Connector diperiksa · berhasil, dilewati, dan gagal',
  'tasks.sample.orbit.body3': 'Sorotan menjadi artefak langsung yang dapat disegarkan.',
  'tasks.sample.mcp.title': 'Riset alternatif MCP',
  'tasks.sample.mcp.status': 'Berjalan di orbit · 2j 14mnt',
  'tasks.sample.mcp.meta': '14 / 30 sumber diproses',
  'tasks.sample.mcp.preview': 'research_notes.md · langsung',
  'tasks.sample.mcp.trigger': 'Manual · sekali jalan',
  'tasks.sample.mcp.pattern': 'Prompt riset mendalam',
  'tasks.sample.mcp.runtime': 'Remote · persisten',
  'tasks.sample.mcp.output': 'Laporan langsung · pembaruan otomatis',
  'tasks.sample.mcp.artifactMeta': 'Diperbarui 12 dtk lalu',
  'tasks.sample.mcp.body1': '# Alternatif MCP - temuan sementara',
  'tasks.sample.mcp.body2': '14 sumber ditinjau · 3 kandidat masuk daftar pendek',
  'tasks.sample.mcp.body3': '## Daftar pendek',
  'tasks.sample.mcp.body4': '- Skema panggilan tool melalui JSON-RPC...',
  'tasks.sample.mcp.body5': '- Protokol Agent berbasis gRPC...',
  'tasks.sample.weekly.title': 'Ringkasan tim mingguan',
  'tasks.sample.weekly.status': 'Berikutnya: Sen 09.00',
  'tasks.sample.weekly.meta': 'Memperbarui dokumen mingguan Tim',
  'tasks.sample.weekly.preview': 'team_weekly.md · artefak berikutnya',
  'tasks.sample.weekly.trigger': 'Jadwal · mingguan',
  'tasks.sample.weekly.pattern': 'Rutin · ringkasan tim',
  'tasks.sample.weekly.runtime': 'Remote · berulang',
  'tasks.sample.weekly.output': 'Artefak langsung · markdown',
  'tasks.sample.weekly.artifactMeta': 'Terakhir diperbarui 4 hr lalu',
  'tasks.sample.weekly.body1': '# Tim mingguan',
  'tasks.sample.weekly.body2': '## Sedang berlangsung',
  'tasks.sample.weekly.body3': '- Tahap integrasi sistem desain',
  'tasks.sample.weekly.body4': '- Penyapuan kualitas connector',
  'tasks.sample.weekly.body5': '## Risiko',
  'tasks.sample.pr.title': 'Pengingat tinjauan PR',
  'tasks.sample.pr.status': 'Saat PR baru · dipicu 23mnt lalu',
  'tasks.sample.pr.meta': 'Mengirim DM Slack',
  'tasks.sample.pr.preview': 'Pengiriman terakhir berhasil',
  'tasks.sample.pr.trigger': 'Event · PR baru',
  'tasks.sample.pr.pattern': 'Rutin · notifikasi',
  'tasks.sample.pr.runtime': 'Lokal · jalan cepat',
  'tasks.sample.pr.output': 'Pesan · Slack DM',
  'tasks.sample.pr.artifactMeta': 'Terakhir dipicu 23 mnt lalu',
  'tasks.sample.pr.body1': 'Membuka PR #184 untuk ditinjau',
  'tasks.sample.pr.body2': 'Peninjau yang cocok: design-platform, web-runtime',
  'tasks.sample.pr.body3': 'Pengiriman: DM Slack terkirim',
  'tasks.sample.meeting.title': 'Persiapan pra-rapat',
  'tasks.sample.meeting.status': 'Besok · 10:00',
  'tasks.sample.meeting.meta': 'Sekali jalan · mengirim ringkasan',
  'tasks.sample.meeting.preview': 'meeting_brief.md · dalam antrean',
  'tasks.sample.meeting.trigger': 'Jadwal · sekali jalan',
  'tasks.sample.meeting.pattern': 'Prompt briefing',
  'tasks.sample.meeting.runtime': 'Remote · terbatas',
  'tasks.sample.meeting.output': 'Artefak + pesan',
  'tasks.sample.meeting.artifactMeta': 'Diantrekan untuk pembuatan',
  'tasks.sample.meeting.body1': '# Ringkasan rapat',
  'tasks.sample.meeting.body2': 'Sumber agenda: acara kalender + dokumen tertaut',
  'tasks.sample.meeting.body3': 'Output akan mencakup keputusan, hambatan, dan pertanyaan.',
  'tasks.sample.candidate.title': 'Pelacakan kandidat',
  'tasks.sample.candidate.status': 'Gagal · perlu perhatian',
  'tasks.sample.candidate.meta': 'Autentikasi kedaluwarsa',
  'tasks.sample.candidate.preview': 'Sambungkan kembali Greenhouse untuk melanjutkan',
  'tasks.sample.candidate.trigger': 'Jadwal · harian',
  'tasks.sample.candidate.pattern': 'Rutin · sinkronisasi pelamar',
  'tasks.sample.candidate.runtime': 'Remote · berulang',
  'tasks.sample.candidate.output': 'Artefak langsung · tabel',
  'tasks.sample.candidate.artifactMeta': 'Dijeda hingga autentikasi dipulihkan',
  'tasks.sample.candidate.body1': '# Pipeline kandidat',
  'tasks.sample.candidate.body2': 'Sinkronisasi terakhir yang berhasil: 2h lalu',
  'tasks.sample.candidate.body3': 'Tindakan diperlukan: sambungkan kembali akun sumber.',
  'routines.title': 'Otomatisasi',
  'routines.subtitle': 'Otomatisasi terjadwal yang berjalan tanpa pengawasan.',
  'routines.newAutomation': 'Otomatisasi baru',
  'routines.loading': 'Memuat…',
  'routines.empty': 'Belum ada otomatisasi.',
  'routines.emptyHint': 'Klik Otomatisasi baru untuk menjadwalkan eksekusi Agent tanpa pengawasan.',
  'routines.runHistoryLoading': 'Memuat eksekusi…',
  'routines.runHistoryEmpty': 'Belum ada eksekusi.',
  'routines.fieldName': 'Nama',
  'routines.fieldNamePlaceholder': 'Briefing pagi',
  'routines.fieldPrompt': 'Prompt',
  'routines.fieldPromptPlaceholder': 'Tarik aktivitas GitHub + Linear kemarin dan ringkas apa yang berubah.',
  'routines.fieldSchedule': 'Jadwal',
  'routines.fieldMinute': 'Menit setiap jam',
  'routines.fieldTime': 'Waktu',
  'routines.fieldTimezone': 'Zona waktu',
  'routines.fieldsetProject': 'Proyek',
  'routines.kind.hourly': 'Tiap jam',
  'routines.kind.daily': 'Harian',
  'routines.kind.weekdays': 'Hari kerja',
  'routines.kind.weekly': 'Mingguan',
  'routines.weekday.short.0': 'Min',
  'routines.weekday.short.1': 'Sen',
  'routines.weekday.short.2': 'Sel',
  'routines.weekday.short.3': 'Rab',
  'routines.weekday.short.4': 'Kam',
  'routines.weekday.short.5': 'Jum',
  'routines.weekday.short.6': 'Sab',
  'routines.weekday.long.0': 'Minggu',
  'routines.weekday.long.1': 'Senin',
  'routines.weekday.long.2': 'Selasa',
  'routines.weekday.long.3': 'Rabu',
  'routines.weekday.long.4': 'Kamis',
  'routines.weekday.long.5': 'Jumat',
  'routines.weekday.long.6': 'Sabtu',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'Berjalan setiap jam pada menit ke-:{minute}',
  'routines.describe.daily': 'Berjalan setiap hari pukul {time} {tz}',
  'routines.describe.weekdays': 'Berjalan Sen–Jum pukul {time} {tz}',
  'routines.describe.weekly': 'Berjalan setiap {day} pukul {time} {tz}',
  'routines.modeCreate': 'Buat proyek baru setiap eksekusi',
  'routines.modeCreateHint': 'Ruang kerja baru yang terisolasi untuk setiap pemicu.',
  'routines.modeReuse': 'Gunakan kembali proyek yang ada',
  'routines.modeReuseHint': 'Setiap eksekusi tersimpan sebagai percakapan baru di dalam proyek.',
  'routines.pickProject': '— Pilih project —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ project baru setiap eksekusi',
  'routines.tagPaused': 'dijeda',
  'routines.metaNext': 'berikutnya: {when}',
  'routines.metaLast': 'terakhir:',
  'routines.triggerManual': 'manual',
  'routines.triggerScheduled': 'terjadwal',
  'routines.openProject': 'Buka proyek',
  'routines.openProjectTitle': 'Buka proyek tempat eksekusi ini menulis',
  'routines.runNow': 'Jalankan sekarang',
  'routines.edit': 'Edit',
  'routines.pause': 'Jeda',
  'routines.resume': 'Lanjutkan',
  'routines.history': 'Riwayat',
  'routines.hideHistory': 'Sembunyikan riwayat',
  'routines.delete': 'Hapus',
  'routines.deleteTitle': 'Hapus otomatisasi ini',
  'routines.cancel': 'Batal',
  'routines.save': 'Simpan',
  'routines.saving': 'Menyimpan…',
  'routines.create': 'Buat',
  'routines.creating': 'Membuat…',
  'routines.status.queued': 'dalam antrean',
  'routines.status.running': 'berjalan',
  'routines.status.succeeded': 'berhasil',
  'routines.status.failed': 'gagal',
  'routines.status.canceled': 'dibatalkan',
  'routines.confirmDelete': 'Hapus otomatisasi ini? Proses sebelumnya beserta proyeknya tetap disimpan.',
  'routines.errorPickProject': 'Pilih project untuk digunakan kembali, atau beralih ke “Buat baru setiap eksekusi”',
  'routines.errorAgentEmptyOutput': 'Agent selesai tanpa menghasilkan output apa pun. Model atau penyedia mungkin mengembalikan respons kosong — periksa log Agent untuk error dari hulu.',
  'entry.githubStarLabel': 'Star',
  'entry.githubStarTitle': 'Klik untuk memberi star di GitHub',
  'entry.githubStarAria': 'Beri star OpenDesign di GitHub',
  'entry.tabImageTemplates': 'Templat gambar',
  'entry.tabVideoTemplates': 'Templat video',
  'promptTemplates.emptyNoMatch': 'Tidak ada templat yang cocok dengan pencarianmu.',
  'promptTemplates.fetchError': 'Tidak bisa memuat isi templat ini.',
  'promptTemplates.promptLabel': 'Isi prompt',
  'promptTemplates.copyPrompt': 'Salin prompt',
  'promptTemplates.copyDone': 'Tersalin!',
  'promptTemplates.allSources': 'Semua sumber',
  'promptTemplates.retry': 'Coba lagi',
  'connectors.title': 'Konektor',
  'connectors.subtitle': 'Sumber data lokal dan mendatang yang bisa mendukung live artifact.',
  'connectors.account': 'Akun',
  'connectors.noAccount': 'Belum terhubung',
  'connectors.tools': 'Alat',
  'connectors.connect': 'Hubungkan',
  'connectors.disconnect': 'Putuskan',
  'connectors.authorizationPending': 'Menunggu otorisasi...',
  'connectors.authorizationPendingHint': 'Selesaikan otorisasi di jendela yang terbuka.',
  'connectors.cancelAuthorization': 'Batal',
  'connectors.configure': 'Konfigurasikan',
  'connectors.unavailable': 'Tidak tersedia',
  'connectors.phaseStubTitle': 'API konektor hadir di Fase 3; ini adalah area pratinjau.',
  'connectors.statusAvailable': 'Tersedia',
  'connectors.statusConnected': 'Terhubung',
  'connectors.statusError': 'Error',
  'connectors.statusDisabled': 'Nonaktif',
  'connectors.gateTitle': 'Konfigurasikan API key Composio',
  'connectors.gateBody': 'Konektor membutuhkan API key Composio. Tambahkan di Pengaturan untuk membuka integrasi yang tersedia.',
  'connectors.aboutLabel': 'Tentang',
  'connectors.detailsLabel': 'Detail',
  'connectors.statusLabel': 'Status',
  'connectors.category.aiAgents': 'AI agents',
  'connectors.category.aiInfrastructure': 'AI infrastructure',
  'connectors.category.accounting': 'Accounting',
  'connectors.category.admin': 'Admin',
  'connectors.category.advertising': 'Advertising',
  'connectors.category.analytics': 'Analytics',
  'connectors.category.automation': 'Automation',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Calendar',
  'connectors.category.commerce': 'Commerce',
  'connectors.category.communication': 'Communication',
  'connectors.category.contacts': 'Contacts',
  'connectors.category.dataPlatform': 'Data platform',
  'connectors.category.database': 'Database',
  'connectors.category.design': 'Design',
  'connectors.category.developer': 'Developer',
  'connectors.category.documentation': 'Documentation',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Education',
  'connectors.category.email': 'Email',
  'connectors.category.events': 'Events',
  'connectors.category.fieldService': 'Field service',
  'connectors.category.finance': 'Finance',
  'connectors.category.fitness': 'Fitness',
  'connectors.category.forms': 'Forms',
  'connectors.category.gaming': 'Gaming',
  'connectors.category.hr': 'HR',
  'connectors.category.hospitality': 'Hospitality',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Integration',
  'connectors.category.localization': 'Localization',
  'connectors.category.logistics': 'Logistics',
  'connectors.category.maps': 'Maps',
  'connectors.category.marketing': 'Marketing',
  'connectors.category.media': 'Media',
  'connectors.category.meetings': 'Meetings',
  'connectors.category.nonprofit': 'Nonprofit',
  'connectors.category.observability': 'Observability',
  'connectors.category.payments': 'Payments',
  'connectors.category.personal': 'Personal',
  'connectors.category.presentations': 'Presentations',
  'connectors.category.procurement': 'Procurement',
  'connectors.category.product': 'Product',
  'connectors.category.productivity': 'Productivity',
  'connectors.category.projectManagement': 'Project management',
  'connectors.category.recruiting': 'Recruiting',
  'connectors.category.research': 'Research',
  'connectors.category.salesIntelligence': 'Sales intelligence',
  'connectors.category.scheduling': 'Scheduling',
  'connectors.category.search': 'Search',
  'connectors.category.security': 'Security',
  'connectors.category.signing': 'Signing',
  'connectors.category.social': 'Social',
  'connectors.category.spreadsheets': 'Spreadsheets',
  'connectors.category.storage': 'Storage',
  'connectors.category.support': 'Support',
  'connectors.category.surveys': 'Surveys',
  'connectors.category.tasks': 'Tasks',
  'connectors.category.timeTracking': 'Time tracking',
  'connectors.category.video': 'Video',
  'connectors.category.whiteboard': 'Whiteboard',
  'connectors.categoryLabel': 'Kategori',
  'connectors.providerLabel': 'Provider',
  'connectors.toolsSection': 'Alat',
  'connectors.toolsLoading': 'Memuat alat...',
  'connectors.noToolsAvailable': 'Belum ada alat tersedia. Hubungkan untuk melihat apa yang disediakan integrasi ini.',
  'connectors.toolDetailsUnavailable': 'Detail alat tidak tersedia, tetapi konektor ini melaporkan {n} alat.',
  'connectors.loadMoreTools': 'Muat alat lainnya',
  'connectors.openDetailsAria': 'Buka detail {name}',
  'connectors.toolsBadgeNone': 'Tidak ada alat',
  'connectors.toolsBadgeOne': '{n} alat',
  'connectors.toolsBadgeMany': '{n} alat',
  'connectors.searchPlaceholder': 'Cari konektor...',
  'connectors.searchAriaLabel': 'Cari konektor berdasarkan nama, provider, atau alat',
  'connectors.searchClear': 'Bersihkan pencarian',
  'connectors.emptyNoMatchTitle': 'Tidak ada konektor yang cocok dengan "{query}"',
  'connectors.emptyNoMatchBody': 'Coba kata kunci lain, atau bersihkan pencarian untuk melihat seluruh katalog.',
  'connectors.emptyNoMatchAction': 'Bersihkan pencarian',
  'newproj.tabPrototype': 'Prototype',
  'newproj.tabLiveArtifact': 'Live artifact',
  'newproj.tabDeck': 'Slide deck',
  'newproj.tabTemplate': 'Dari templat',
  'newproj.tabMedia': 'Media',
  'newproj.tabOther': 'Lainnya',
  'newproj.titlePrototype': 'Prototype baru',
  'newproj.titleLiveArtifact': 'Live artifact baru',
  'newproj.titleDeck': 'Slide deck baru',
  'newproj.titleTemplate': 'Mulai dari templat',
  'newproj.titleImage': 'Gambar baru',
  'newproj.titleVideo': 'Video baru',
  'newproj.titleAudio': 'Audio baru',
  'newproj.titleMedia': 'Media baru',
  'newproj.titleOther': 'Proyek baru',
  'newproj.namePlaceholder': 'Nama proyek',
  'newproj.fidelityLabel': 'Fidelity',
  'newproj.fidelityWireframe': 'Wireframe',
  'newproj.fidelityHigh': 'High fidelity',
  'newproj.toggleSpeakerNotes': 'Gunakan catatan pembicara',
  'newproj.toggleSpeakerNotesHint': 'Kurangi teks di slide; simpan poin bicara di catatan.',
  'newproj.toggleAnimations': 'Sertakan animasi',
  'newproj.toggleAnimationsHint': 'Tambahkan motion, hover, dan transisi di atas templat.',
  'newproj.targetPlatformsLabel': 'Platform target',
  'newproj.targetPlatformsHint': 'Pilih satu atau lebih. Web responsif hanya mencakup breakpoint browser; tambahkan aplikasi iOS, Android, tablet, atau desktop untuk varian lintas platform native.',
  'newproj.platform.responsive.label': 'Web responsif',
  'newproj.platform.responsive.hint': 'Satu pengalaman web yang disesuaikan untuk browser desktop, tablet, dan seluler',
  'newproj.platform.webDesktop.label': 'Web desktop',
  'newproj.platform.webDesktop.hint': 'Produk atau halaman arahan berbasis browser',
  'newproj.platform.mobileIos.label': 'Aplikasi iOS',
  'newproj.platform.mobileIos.hint': 'Frame iPhone dan aturan interaksi iOS',
  'newproj.platform.mobileAndroid.label': 'Aplikasi Android',
  'newproj.platform.mobileAndroid.hint': 'Frame Pixel dan aturan interaksi Material',
  'newproj.platform.tablet.label': 'Aplikasi tablet',
  'newproj.platform.tablet.hint': 'Pengalaman tablet bergaya native dengan tampilan terbagi',
  'newproj.platform.desktopApp.label': 'Aplikasi desktop',
  'newproj.platform.desktopApp.hint': 'Chrome aplikasi macOS/Windows',
  'newproj.surfaceOptionsLabel': 'Companion surfaces',
  'newproj.includeLandingPage': 'Include landing page',
  'newproj.includeLandingPageHint': 'Add a responsive marketing page for ads, waitlists, launch campaigns, app downloads, or product explanation.',
  'newproj.includeOsWidgets': 'Include OS widgets',
  'newproj.includeOsWidgetsHint': 'Add platform-native home screen, lock screen, or quick-access widgets for mobile/tablet apps.',
  'newproj.includeOsWidgetsDisabledHint': 'Available when iOS, Android, or tablet app is selected as a target platform.',
  'newproj.templateLabel': 'Templat',
  'newproj.noTemplatesTitle': 'Belum ada templat',
  'newproj.noTemplatesBody': 'Buka proyek apa pun, lalu pakai menu Share di penampil berkas untuk mengubahnya menjadi templat.',
  'newproj.savedTemplate': 'Templat tersimpan',
  'newproj.fileSingular': 'berkas',
  'newproj.filePlural': 'berkas',
  'newproj.create': 'Buat',
  'newproj.locationLabel': 'Simpan ke',
  'newproj.locationDefault': 'Proyek OpenDesign',
  'newproj.locationExternalBase': 'Basis eksternal',
  'newproj.createLiveArtifact': 'Buat live artifact',
  'newproj.createFromTemplate': 'Buat dari templat',
  'newproj.createDisabledTitle': 'Simpan proyek sebagai templat dulu.',
  'newproj.openFolder': 'Buka folder',
  'newproj.openingFolder': 'Membuka…',
  'newproj.importClaudeZip': 'Impor ZIP Claude Design',
  'newproj.importClaudeZipTitle': 'Impor file .zip hasil ekspor Claude Design',
  'newproj.importingClaudeZip': 'Mengimpor...',
  'newproj.privacyFooter': 'Secara default hanya kamu yang bisa melihat proyekmu.',
  'newproj.designSystem': 'Sistem desain',
  'newproj.dsNoneFreeform': 'Tidak ada - bebas',
  'newproj.dsNoneSubtitleEmpty': 'Tanpa token sistem, pilih palet sendiri',
  'newproj.dsNoneSubtitleSelected': 'Lewati token sistem. Agent memilih paletnya sendiri.',
  'newproj.dsCategoryFallback': 'Sistem desain',
  'newproj.dsSearch': 'Cari sistem desain...',
  'newproj.dsModeAria': 'Mode pilihan',
  'newproj.dsModeSingle': 'Tunggal',
  'newproj.dsModeMulti': 'Multi',
  'newproj.dsNoneTitle': 'Tidak ada - bebas',
  'newproj.dsNoneSub': 'Lewati token sistem. Agent memilih paletnya sendiri.',
  'newproj.dsEmpty': 'Tidak ada sistem desain yang cocok dengan "{query}".',
  'newproj.dsFootSingular': 'hanya sebagai inspirasi.',
  'newproj.dsFootPlural': 'hanya sebagai inspirasi.',
  'newproj.dsFootClear': 'Bersihkan',
  'newproj.dsBadgeDefault': 'DEFAULT',
  'newproj.dsPrimaryFallback': 'Utama',
  'newproj.surfaceImage': 'Gambar',
  'newproj.surfaceVideo': 'Video',
  'newproj.surfaceAudio': 'Audio',
  'newproj.modelLabel': 'Model',
  'newproj.modelSearch': 'Cari model…',
  'newproj.modelEmpty': 'Tidak ada model yang cocok.',
  'newproj.modelRecommended': 'Direkomendasikan',
  'newproj.modelMissingTitle': 'Pilih model',
  'newproj.modelMissingSub': 'Pilih model untuk permukaan ini.',
  'newproj.aspectLabel': 'Aspek',
  'newproj.videoLengthLabel': 'Durasi',
  'newproj.videoLengthSeconds': '{n}d',
  'newproj.audioKindLabel': 'Jenis audio',
  'newproj.audioKindMusic': 'Musik',
  'newproj.audioKindSpeech': 'Speech / TTS',
  'newproj.audioKindSfx': 'SFX',
  'newproj.audioDurationLabel': 'Durasi',
  'newproj.audioDurationSeconds': '{n}d',
  'newproj.voiceLabel': 'Suara',
  'newproj.voicePlaceholder': 'ID suara provider, opsional',
  'newproj.connectorsLabel': 'Konektor',
  'newproj.connectorsHint': 'Sumber data yang bisa diambil artifact ini.',
  'newproj.connectorsEmptyTitle': 'Belum ada konektor dikonfigurasi',
  'newproj.connectorsEmptyBody': 'Hubungkan sumber data agar live artifact dapat mengambil angka nyata, bukan placeholder.',
  'newproj.connectorsEmptyCta': 'Atur konektor ->',
  'newproj.connectorsLoading': 'Memuat konektor...',
  'newproj.connectorsCountOne': '{n} terhubung',
  'newproj.connectorsCountMany': '{n} terhubung',
  'newproj.connectorsManage': 'Kelola',
  'newproj.promptTemplateLabel': 'Templat referensi',
  'newproj.promptTemplateNoneTitle': 'Tidak ada - tulis sendiri',
  'newproj.promptTemplateNoneSub': 'Lewati galeri, jelaskan brief sendiri',
  'newproj.promptTemplateRefSub': 'Templat referensi',
  'newproj.promptTemplateSearch': 'Cari templat...',
  'newproj.promptTemplateEmpty': 'Belum ada templat untuk tipe ini.',
  'newproj.promptTemplateBodyLabel': 'Prompt (bisa diedit)',
  'newproj.promptTemplateOptimizeHint': 'Edit prompt sebelum membuat proyek agar sesuai dengan kebutuhanmu.',
  'newproj.promptTemplateBodyEmpty': 'Prompt kosong - agent tidak menerima referensi templat.',
  'newproj.deleteTemplateTitle': 'Hapus templat',
  'newproj.deleteTemplateConfirm': 'Hapus "{name}"? Tindakan ini tidak dapat dibatalkan.',
  'newproj.deleteTemplateConfirmCta': 'Hapus templat',
  'newproj.deleteTemplateError': 'Tidak dapat menghapus templat ini. Silakan coba lagi.',
  'designs.subRecent': 'Terbaru',
  'designs.subYours': 'Desainmu',
  'designs.filterAria': 'Filter proyek',
  'designs.searchPlaceholder': 'Cari...',
  'designs.emptyNoProjects': 'Belum ada proyek.',
  'designs.emptyNoMatch': 'Tidak ada proyek yang cocok dengan pencarianmu.',
  'designs.deleteTitle': 'Hapus proyek',
  'designs.deleteConfirm': 'Hapus "{name}"?',
  'designs.cardFreeform': 'Bebas',
  'designs.badgeLive': 'Live',
  'designs.liveArtifactBadgesAria': 'Badge live artifact',
  'designs.liveCount': '{n} live',
  'designs.statusLive': 'Live artifact',
  'designs.statusArchived': 'Diarsipkan',
  'designs.statusError': 'Error',
  'designs.statusRefreshing': 'Memperbarui...',
  'designs.statusRefreshFailed': 'Refresh gagal',
  'designs.statusRefreshed': 'Diperbarui',
  'designs.status.notStarted': 'Belum dimulai',
  'designs.status.queued': 'Dalam antrean',
  'designs.status.running': 'Berjalan',
  'designs.status.awaitingInput': 'Menunggu input',
  'designs.status.incomplete': 'Belum selesai',
  'designs.status.succeeded': 'Selesai',
  'designs.status.published': 'Diterbitkan',
  'designs.status.failed': 'Gagal',
  'designs.status.canceled': 'Dibatalkan',
  'designs.viewToggleAria': 'Mode tampilan',
  'designs.viewGrid': 'Tampilan grid',
  'designs.viewKanban': 'Tampilan kanban',
  'designs.kanbanEmptyColumn': 'Tidak ada desain',
  'designs.deleteAria': 'Hapus proyek {name}',
  'designs.menuMore': 'More actions',
  'designs.menuRename': 'Rename',
  'designs.menuDuplicate': 'Duplicate project',
  'designs.menuDelete': 'Delete',
  'designs.renamePrompt': 'New name for "{name}"',
  'designs.selectMode': 'Select',
  'designs.cancelSelect': 'Cancel',
  'designs.deleteSelected': 'Delete selected',
  'designs.selectedCount': '{n} selected',
  'designs.deleteSelectedConfirm': 'Delete {n} project(s)?',
  'designs.deleteSelectedSuccess': '{n} project(s) deleted successfully.',
  'designs.deleteSelectedPartial': 'Deleted {deleted} project(s); {failed} failed.',
  'designs.tagPrototype': 'Prototype',
  'designs.tagLiveArtifact': 'Live Artifact',
  'designs.tagWebClone': 'Klon situs web',
  'designs.tagSlide': 'Slide',
  'designs.tagMedia': 'Media',
  'designs.renameTitle': 'Rename project',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Cancel',
  'examples.typeLabel': 'Tipe',
  'examples.surfaceLabel': 'Surface',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': 'Gambar',
  'examples.surfaceVideo': 'Video',
  'examples.surfaceAudio': 'Audio',
  'examples.scenarioLabel': 'Skenario',
  'examples.modeAll': 'Semua',
  'examples.modePrototypeDesktop': 'Prototype - desktop',
  'examples.modePrototypeMobile': 'Prototype - mobile',
  'examples.modeDeck': 'Slide',
  'examples.modeDocument': 'Dokumen & templat',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'Langsung',
  'examples.scenarioGeneral': 'Umum',
  'examples.scenarioEngineering': 'Engineering',
  'examples.scenarioProduct': 'Produk',
  'examples.scenarioDesign': 'Desain',
  'examples.scenarioMarketing': 'Marketing',
  'examples.scenarioSales': 'Sales',
  'examples.scenarioFinance': 'Keuangan',
  'examples.scenarioHr': 'HR',
  'examples.scenarioOperations': 'Operasi',
  'examples.scenarioSupport': 'Support',
  'examples.scenarioLegal': 'Legal',
  'examples.scenarioEducation': 'Edukasi',
  'examples.scenarioPersonal': 'Personal',
  'examples.searchPlaceholder': 'Cari contoh...',
  'examples.searchAria': 'Cari contoh berdasarkan nama',
  'examples.emptyNoSkills': 'Tidak ada skill tersedia. Apakah daemon berjalan?',
  'examples.emptyNoMatch': 'Tidak ada contoh yang cocok dengan filter ini.',
  'examples.openPreview': 'Buka pratinjau',
  'examples.loadingPreview': 'Memuat pratinjau...',
  'examples.hoverPreview': 'Arahkan kursor untuk pratinjau',
  'examples.usePrompt': 'Gunakan prompt ini',
  'examples.previewModalTitle': 'Buka pratinjau penuh',
  'examples.shareTitle': 'Bagikan contoh ini',
  'examples.shareLoadFirst': 'Arahkan kursor dulu untuk memuat pratinjau',
  'examples.unavailablePlaceholder': 'Tidak ada pratinjau {kind} bawaan — buka untuk lihat detail',
  'examples.shareUnavailable': 'Tidak ada pratinjau {kind} bawaan untuk dibagikan',
  'examples.shareMenu': 'Bagikan',
  'examples.exportPdfAllSlides': 'Ekspor PDF (semua slide)',
  'examples.exportPptxLocked': 'Ekspor PPTX... (buka templat dulu)',
  'examples.tagSlideDeck': 'Slide deck',
  'examples.tagTemplate': 'Templat',
  'examples.tagDesignSystem': 'Sistem desain',
  'examples.tagMobilePrototype': 'Prototype mobile',
  'examples.tagDesktopPrototype': 'Prototype desktop',
  'examples.tagImage': 'Gambar',
  'examples.tagVideo': 'Video',
  'examples.tagAudio': 'Audio',
  'examples.previewLabel': 'Pratinjau',
  'ds.surfaceLabel': 'Surface',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': 'Gambar',
  'ds.surfaceVideo': 'Video',
  'ds.surfaceAudio': 'Audio',
  'ds.searchPlaceholder': 'Cari sistem desain...',
  'ds.emptyNoMatch': 'Tidak ada sistem desain yang cocok.',
  'ds.badgeDefault': 'Default',
  'ds.preview': 'Pratinjau',
  'ds.previewTitle': 'Pratinjau sistem desain',
  'ds.categoryAll': 'Semua',
  'ds.categoryUncategorized': 'Tanpa kategori',
  'ds.showcase': 'Showcase',
  'ds.tokens': 'Token',
  'ds.specToggle': 'Spesifikasi',
  'ds.specLoading': 'Memuat spesifikasi...',
  'avatar.title': 'Akun & pengaturan',
  'avatar.localCli': 'CLI lokal',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'Gunakan CLI lokal',
  'avatar.useApi': 'Gunakan Anthropic API',
  'avatar.codeAgent': 'Code agent',
  'avatar.rescan': 'Pindai ulang PATH',
  'avatar.amrConsole': 'OpenDesign Cloud account',
  'avatar.amrConsoleMeta': 'Balance & recharge',
  'avatar.settings': 'Pengaturan',
  'avatar.backToProjects': 'Kembali ke proyek',
  'avatar.metaActive': 'aktif',
  'avatar.metaOffline': 'offline',
  'avatar.metaSelected': 'dipilih',
  'avatar.noAgentSelected': 'Belum ada agent dipilih',
  'avatar.modelSection': 'Model',
  'avatar.modelLabel': 'Model',
  'avatar.reasoningLabel': 'Penalaran',
  'avatar.serviceTierLabel': 'Tingkat layanan',
  'avatar.customSuffix': '(kustom)',
  'socialShare.openDesignSection': 'Bagikan OpenDesign',
  'socialShare.openDesignTitle': 'OpenDesign di GitHub',
  'socialShare.openDesignText': 'OpenDesign adalah ruang kerja dengan kode sumber tersedia untuk membuat, mengedit, men-deploy, dan menyerahkan artefak desain.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'BAGIKAN KE MEDIA SOSIAL',
  'socialShare.publishPageTitle': 'Publikasikan halaman berbagi',
  'socialShare.publishPageSubtitle': 'Publikasikan pratinjau ini agar dapat dibagikan di platform sosial.',
  'socialShare.projectTitle': '{title} · OpenDesign',
  'socialShare.projectText': 'Dibuat dengan OpenDesign: {title}. Lihat artefak yang telah di-deploy dan beri bintang pada repo: {repo}',
  'socialShare.projectCopyText': 'Dibuat dengan OpenDesign: {title}\n{url}\nRepo OpenDesign: {repo}',
  'socialShare.deployFirst': 'Deploy lalu bagikan…',
  'socialShare.copied': 'Tersalin',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',
  'inlineSwitcher.chipTitle': 'Beralih CLI / model',
  'inlineSwitcher.chipCli': 'CLI Lokal',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'default',
  'inlineSwitcher.noAgent': 'tidak ada agen',
  'inlineSwitcher.modeLabel': 'Mode',
  'inlineSwitcher.agentLabel': 'Agen',
  'inlineSwitcher.providerLabel': 'Penyedia',
  'inlineSwitcher.modelLabel': 'Model',
  'inlineSwitcher.useCli': 'Gunakan CLI Lokal',
  'inlineSwitcher.useByok': 'Gunakan kunci API BYOK',
  'inlineSwitcher.daemonOffline': 'Daemon offline — buka pengaturan',
  'inlineSwitcher.noAgentsDetected': 'Tidak ada CLI di PATH',
  'inlineSwitcher.openSettingsForModel': 'Atur penyedia di Pengaturan',
  'inlineSwitcher.missingApiKey': 'Kunci API belum diatur — buka Pengaturan.',
  'inlineSwitcher.openFullSettings': 'Buka pengaturan eksekusi',
  'inlineSwitcher.customSuffix': '(kustom)',
  'inlineSwitcher.unlimitedBadge': 'Tanpa batas',
  'project.backToProjects': 'Kembali ke proyek',
  'project.brandReadyTitle': 'Sistem desain {name} sudah siap',
  'project.brandReadyTitleGeneric': 'Sistem desain Anda sudah siap',
  'project.brandReadyCta': 'Pratinjau di Sistem desain',
  'project.brandReadyDismiss': 'Tutup',
  'project.brandReadyRefineHint': 'Automatic extraction can miss details. Refine it before using this system broadly.',
  'project.brandReadyAiOptimize': 'AI Optimize',
  'project.brandReadyEditManually': 'Edit manually',
  'project.brandReadyPreviewOpened': 'Pratinjau sistem desain dibuka.',
  'project.previewCommentSaveFailed': 'Komentar tidak dapat disimpan. Coba lagi.',
  'project.previewCommentSaveFailedTitle': 'Komentar gagal disimpan',
  'project.previewCommentSaveFailedDescription': 'Komentar ini belum berhasil disimpan. Silakan coba lagi.',
  'project.previewCommentReorderFailed': 'Urutan komentar tidak dapat disimpan dan mungkin akan direset saat memuat ulang.',
  'project.metaFreeform': 'Bebas',
  'project.typePrototype': 'Prototipe',
  'project.typeDeck': 'Slide',
  'project.typeTemplate': 'Templat',
  'project.typeImage': 'Gambar',
  'project.typeVideo': 'Video',
  'project.typeAudio': 'Audio',
  'project.customInstructions': 'Instruksi proyek',
  'project.customInstructionsPlaceholder': 'Instruksi untuk proyek ini (disisipkan pada setiap pesan)…',
  'project.resizeChatPanel': 'Ubah ukuran panel chat',
  'project.instructionsActive': 'Aktif — disertakan di setiap pesan',
  'project.missing': 'This project has been deleted or no longer exists.',
  'chat.tabChat': 'Chat',
  'chat.tabComments': 'Komentar',
  'chat.commentsSoon': 'Komentar - segera hadir',
  'chat.comments.attached': 'Dilampirkan ke chat',
  'chat.comments.emptyAttached': 'Tidak ada komentar terlampir.',
  'chat.comments.saved': 'Komentar tersimpan',
  'chat.comments.emptySaved': 'Tidak ada komentar tersimpan.',
  'chat.comments.add': 'Tambah',
  'chat.comments.addAll': 'Tambah semua',
  'chat.comments.remove': 'Hapus',
  'chat.comments.placeholder': 'Komentari elemen ini...',
  'chat.comments.addSend': 'Tambah & kirim',
  'chat.comments.updateSend': 'Perbarui & kirim',
  'chat.comments.removeAttachment': 'Hapus lampiran komentar',
  'chat.comments.removeAttachmentAria': 'Hapus lampiran komentar untuk {name}',
  'chat.comments.comment': 'Comment',
  'chat.comments.sendToChat': 'Send to chat',
  'chat.comments.viewAll': 'Lihat semua komentar',
  'chat.comments.sending': 'Sending…',
  'chat.comments.edit': 'Edit',
  'chat.comments.select': 'Select',
  'chat.comments.selectAll': 'Pilih semua',
  'chat.comments.deselect': 'Deselect',
  'chat.comments.nSelected': '{n} selected',
  'chat.comments.pin': 'Pin',
  'chat.comments.addNote': 'Add note',
  'chat.comments.savedToast': 'Comment saved',
  'chat.comments.pinSavedToast': 'Pin saved',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} captured items',
  'chat.comments.clear': 'Clear',
  'chat.comments.targetImage': 'Image',
  'chat.comments.targetControl': 'Control',
  'chat.comments.targetLink': 'Link',
  'chat.comments.targetText': 'Text',
  'chat.comments.targetSection': 'Section',
  'chat.comments.targetPage': 'Page',
  'chat.comments.targetArea': 'Area',
  'chat.annotationNotePlaceholder': 'Add a note for this mark',
  'chat.annotationAttachImage': 'Lampirkan gambar',
  'chat.annotationAttachedImages': 'Gambar terlampir',
  'chat.annotationAttachedRemove': 'Hapus gambar terakhir',
  'chat.annotationAddToInput': 'Add to input',
  'chat.annotationAddingToInput': 'Adding...',
  'chat.annotationQueue': 'Queue',
  'chat.annotationQueueing': 'Queueing...',
  'chat.annotationSubmitOptions': 'Opsi kirim',
  'chat.annotationSending': 'Sending...',
  'chat.annotationSendDisabledReason': 'A task is currently running',
  'chat.annotationPreviewMissing': 'Could not capture the preview. Please try again.',
  'chat.annotationPreviewMissingInk': 'Could not capture the preview. Try again to avoid sending only ink.',
  'chat.annotationSentWithoutScreenshot': 'Tidak dapat menangkap pratinjau. Anotasi dikirim tanpa tangkapan layar.',
  'chat.annotationTimeout': 'Annotation send timed out. Please try again.',
  'chat.annotationFailed': 'Annotation send failed. Please try again.',
  'chat.annotationProjectCreateFailed': 'Could not create a project, so the annotation was not sent.',
  'chat.annotationUploadFailed': 'Attachment upload failed. Please try again.',
  'chat.attachmentFolderUnsupported': 'Folder tidak dapat dilampirkan di sini. Lampirkan file di dalamnya sebagai gantinya.',
  'chat.conversationsTitle': 'Percakapan',
  'chat.conversationsAria': 'Buka percakapan',
  'chat.newConversation': 'Percakapan baru',
  'chat.newSession': 'Percakapan baru',
  'chat.newConversationsTitle': 'Mulai percakapan baru',
  'chat.conversationsHeading': 'Percakapan',
  'chat.emptyConversations': 'Belum ada percakapan.',
  'chat.deleteConversation': 'Hapus percakapan',
  'chat.renameConversationLabel': 'Ganti nama "{title}"',
  'chat.deleteConversationConfirm': 'Hapus "{title}"? Semua pesannya ikut dihapus.',
  'chat.untitledConversation': 'Percakapan tanpa judul',
  'chat.forkConversationFailed': 'Tidak dapat memulai percakapan baru.',
  'chat.startTitle': 'Mulai percakapan',
  'chat.startHint': 'Jelaskan apa yang ingin kamu hasilkan, atau mulai dari salah satu contoh ini:',
  'chat.brandBrowserAssistDesktopOnly': 'Browser assist needs the desktop app so OpenDesign can read the live browser page.',
  'chat.brandBrowserAssistReadFailed': 'Could not read the browser page. Make sure the brand site is open and fully loaded.',
  'chat.memoryWrittenSummary': '{count} preferensi diingat',
  'chat.brandBrowserAssistMessage': 'OpenDesign needs browser assist to finish this brand extraction. Use the card below to open Browser, then click More, choose Download Page, wait for the success message, and use the left Next Step card to continue extraction.',
  'chat.brandBrowserLocalSnapshotMissing': 'No saved page snapshot is available for this URL.',
  'chat.brandBrowserLocalSnapshotReadFailed': 'Could not read the saved page snapshot.',
  'chat.brandBrowserSnapshotSaveFailed': 'Could not save a page snapshot from the browser.',
  'chat.brandBrowserAssistDownloadGuideTitle': 'Browser opened',
  'chat.brandBrowserAssistDownloadGuideDetails': 'Step 1: Browser is open. Step 2: click More, then Download Page. Step 3: wait for the saved snapshot success message. Step 4: return to the left Next Step card and click Continue extraction to continue the programmatic extraction.',
  'brandEnrichment.title': "Optimasi AI",
  'brandEnrichment.body': "OpenDesign akan menjalankan ekstraksi yang lebih dalam di latar belakang, menerapkan skill design-system yang tepat secara otomatis, dan memperbarui sistem ini di tempat. Ini bisa memakan waktu 10-20 menit; Anda bisa tetap bekerja.",
  'brandEnrichment.cta': "Optimasi AI",
  'brandEnrichment.busy': "Memulai Optimasi AI...",
  'brandExtractionTranscript.sourceDesignMd': 'DESIGN.md yang ditempel',
  'brandExtractionTranscript.user': 'Ekstrak sistem desain dari {source}.',
  'brandExtractionTranscript.doneTitle': 'Ekstraksi programatik untuk {name} selesai.',
  'brandExtractionTranscript.doneBody': 'Saya telah membuat dan mendaftarkan sistem desain {designSystemId} dari {source}. Sistem ini siap dipratinjau dan dapat digunakan dalam desain baru.',
  'brandExtractionTranscript.next': 'Berikutnya, Anda dapat menjalankan AI Optimize untuk ekstraksi yang lebih dalam, atau membuat desain baru dengan sistem ini.',
  'chat.fillInputTitle': 'Isi brief dulu',
  'chat.jumpToLatest': 'Lompat ke terbaru',
  'chat.scrollToLatest': 'Scroll ke terbaru',
  'chat.messageRail.aria': 'Navigasi pesan pengguna',
  'chat.messageRail.jumpAria': 'Lompat ke pesan pengguna {index}',
  'chat.messageRail.empty': '(Tidak ada konten)',
  'chat.you': 'Kamu',
  'chat.record.retryImage': '{count} ilustrasi gagal dibuat — coba lagi ya',
  'chat.quote.add': 'Tambahkan ke obrolan',
  'chat.quote.count': '{count} catatan',
  'chat.quote.duplicate': 'Sudah ditambahkan ke obrolan',
  'chat.quote.removeAria': 'Hapus catatan',
  'chat.support.title': 'Hubungi dukungan',
  'chat.support.join': 'Gabung',
  'chat.sendFailedRetryAria': 'Gagal terkirim — coba lagi',
  'chat.audio.play': 'Putar',
  'chat.audio.pause': 'Jeda',
  'chat.audio.download': 'Unduh {name}',
  'chat.upgrade.balance': 'Sisa saldo',
  'chat.upgrade.whyLow': 'Mungkin tidak cukup untuk tugas berikutnya — jika habis di tengah jalan, hasilnya setengah jadi',
  'chat.upgrade.whyOut': 'Kamu tidak bisa memulai tugas baru sekarang',
  'chat.upgrade.pausedTitle': 'Saldo tidak cukup, tugas dijeda',
  'chat.upgrade.pausedMessage': 'Saldo Anda tidak cukup. Isi ulang atau tingkatkan paket, lalu coba lagi.',
  'chat.upgrade.pausedTeamTitle': 'Saldo tim tidak cukup, tugas dijeda',
  'chat.upgrade.pausedTeamMessage': 'Saldo tim tidak cukup. Minta admin tim untuk mengisi ulang atau meningkatkan langganan.',
  'chat.openFile': 'Buka {name}',
  'chat.copyPrompt': 'Salin prompt',
  'chat.copyErrorDiagnostic': 'Salin diagnostik error',
  'chat.copyDone': 'Disalin!',
  'chat.inspect.noEditableTargets': 'This page has no editable elements yet.',
  'chat.inspect.noCommentTargets': 'This page has no commentable elements yet.',
  'chat.inspect.editHint': 'Click an element in the canvas to edit its styles.',
  'chat.inspect.commentHint': 'Click an element in the canvas to add a comment.',
  'chat.composerPlaceholder': 'Jelaskan apa yang ingin kamu hasilkan…',
  'chat.activeFileEditingLabel': 'Mengedit',
  'chat.activeFilePlaceholder': 'Minta OpenDesign mengubah {file}...',
  'chat.designArtifactsShowMore': 'Tampilkan {count} file desain lagi',
  'chat.mode.chat.label': 'Ask',
  'chat.mode.chat.title': 'Mode Ask',
  'chat.mode.chat.summary': 'Untuk jawaban cepat, revisi, perencanaan, dan diskusi tanpa menganggap harus membuat artefak desain.',
  'chat.mode.chat.solves': 'Gunakan untuk memperjelas ide, menyempurnakan prompt, membandingkan opsi, atau bertanya tentang pekerjaan yang sudah ada.',
  'chat.mode.chat.query1': 'Ringkas draf ini dan tunjukkan kekurangannya.',
  'chat.mode.chat.query2': 'Bantu saya memilih struktur terbaik untuk landing page ini.',
  'chat.mode.chat.query3': 'Tinjau desain ini dan sarankan perbaikan konkret.',
  'chat.mode.plan.label': "Plan",
  'chat.mode.plan.title': "Plan mode",
  'chat.mode.plan.summary': "Creates an editable plan document first, then hands off to Design after you review it.",
  'chat.mode.plan.solves': "Use it for PRDs, slide outlines, prototype briefs, wireframes, storyboards, and any broad request that needs confirmation before generation.",
  'chat.mode.plan.query1': "Create a slide-by-slide PPT outline first.",
  'chat.mode.plan.query2': "Draft a PRD before generating the prototype.",
  'chat.mode.plan.query3': "Turn this idea into an editable design plan.",
  'chat.mode.design.label': 'Desain',
  'chat.mode.design.title': 'Mode Desain',
  'chat.mode.design.summary': 'Untuk membuat atau mengubah output konkret: halaman, prototipe, live artifact, slide, gambar, video, HyperFrames, audio, dashboard, dan file proyek.',
  'chat.mode.design.solves': 'Gunakan saat Anda ingin OpenDesign membuat file, memperbarui workspace, atau mengubah brief menjadi deliverable multimodal.',
  'chat.mode.design.query1': 'Buat landing page peluncuran produk dan prototipe HyperFrames dari brief ini.',
  'chat.mode.design.query2': 'Buat deck investor 10 slide dengan catatan pembicara.',
  'chat.mode.design.query3': 'Buat konsep gambar, video, dan audio untuk kampanye ini.',
  'chat.mode.cardBestFor': 'Cocok untuk',
  'chat.mode.cardTry': 'Coba tanyakan',
  'chat.mode.cardCost': 'Perkiraan penggunaan',
  'chat.mode.chat.cost': 'Ringan',
  'chat.mode.chat.costNote': 'Hanya percakapan — tidak ada yang dibuat, jadi penggunaannya paling sedikit.',
  'chat.mode.plan.cost': 'Standar',
  'chat.mode.plan.costNote': 'Membuat satu dokumen rencana yang dapat diedit sebelum proses pembuatan.',
  'chat.mode.design.cost': 'Berat',
  'chat.mode.design.costNote': 'Membuat berkas dan media multimoda, jadi satu kali proses bisa paling banyak menggunakan.',
  'chat.modePicker.choose': 'Pilih mode',
  'chat.modePicker.current': 'Mode: {name}',
  'chat.modePicker.clear': 'Hapus mode',
  'chat.modePicker.mode': 'Mode',
  'chat.composerHint': '⌘/Ctrl + Enter untuk mengirim · sertakan tujuan, konten, gaya, dan format',
  'chat.cliSettingsTitle': 'Pengaturan CLI',
  'chat.cliSettingsAria': 'Buka pengaturan CLI',
  'chat.attachTitle': 'Lampirkan',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'Lampirkan file atau konteks',
  'chat.importTitle': 'Impor',
  'chat.importLabel': 'Impor konteks',
  'chat.importComingSoon': 'Segera hadir',
  'chat.importSoon': 'Segera',
  'chat.importFig': 'File desain',
  'chat.importGitHub': 'GitHub',
  'chat.importWeb': 'Web',
  'chat.importFolder': 'Tautkan folder kode',
  'chat.importSkills': 'Skills',
  'chat.importProject': 'Proyek',
  'chat.importDesignSystemHeader': 'Pilih design system',
  'chat.importDesignSystemBack': 'Kembali',
  'chat.importDesignSystemSearch': 'Cari design system…',
  'chat.importDesignSystemEmpty': 'Tidak ada design system yang cocok dengan "{query}"',
  'chat.importDesignSystemNone': 'Tidak ada — bebas',
  'chat.importDesignSystemNoneSub': 'Jangan terikat sistem pada giliran ini',
  'chat.importDesignSystemActive': 'Aktif',
  'chat.importDesignSystemSwitched': 'Design system beralih ke {title}',
  'chat.importDesignSystemFailed': 'Tidak dapat mengganti design system. Silakan coba lagi.',
  'chat.importDesignSystemLoadFailed': 'Tidak dapat memuat sistem desain.',
  'browserUse.title': 'Inspirasi',
  'browserUse.summary': '{count} aksi web, memprioritaskan ekstraksi aset, bahasa desain, gerak, pemeriksaan visual, dan struktur komponen.',
  'browserUse.searchAria': 'Cari inspirasi',
  'browserUse.searchPlaceholder': 'Cari tangkapan layar, font, warna, a11y...',
  'browserUse.empty': 'Tidak ada inspirasi yang cocok',
  'browserUse.unavailable': 'Inspirasi tidak tersedia di sini',
  'browserUse.added': 'Ditambahkan ke komposer',
  // Design Browser
  'designBrowser.aria': 'Design Browser',
  'designBrowser.goBack': 'Go Back',
  'designBrowser.goForward': 'Go Forward',
  'designBrowser.reload': 'Reload',

  'designBrowser.stopLoading': 'Hentikan pemuatan',
  'designBrowser.viewportAria': 'Browser viewport',
  'designBrowser.addressPlaceholder': 'Enter URL or search...',
  'designBrowser.addressAria': 'Browser address',
  'designBrowser.suggestion.reference': 'Reference',
  'designBrowser.suggestion.history': 'History',
  'designBrowser.menu.copyScreenshot': 'Copy Screenshot',
  'designBrowser.menu.hardReload': 'Hard Reload',
  'designBrowser.menu.copyUrl': 'Copy URL',
  'designBrowser.menu.openInBrowser': 'Open in Browser',
  'designBrowser.menu.savePageBrief': 'Save Page Brief',
  'designBrowser.menu.clearBrowsingHistory': 'Clear Browsing History',
  'designBrowser.menu.clearCookies': 'Clear Cookies',
  'designBrowser.menu.clearAllData': 'Clear All Data',
  'designBrowser.status.openHttpUrlFirst': 'Open an http URL first',
  'designBrowser.status.openPageBeforeScreenshot': 'Open a page before taking a screenshot',
  'designBrowser.status.screenshotCopied': 'Screenshot copied to clipboard',
  'designBrowser.status.openPageBeforeBrief': 'Open a page before saving a brief',
  'designBrowser.status.openPageBeforeTools': 'Open a page before using browser tools',
  'designBrowser.status.clickElementToComment': 'Click an element to comment',
  'designBrowser.status.clickElementToTune': 'Click an element to tune',
  'designBrowser.status.noElementSelected': 'No browser element selected',
  'designBrowser.status.addBrowserComment': 'Add a browser comment',
  'designBrowser.status.tuneElementThenSaveHtml': 'Tune the element, then save HTML',
  'designBrowser.status.tuneLiveOnly': 'Tune is live only for non-project pages',
  'designBrowser.status.pickerFailed': 'Browser element picker failed',
  'designBrowser.status.applyStyleFailed': 'Could not apply style in browser page',
  'designBrowser.status.editTextFailed': 'Could not edit text in browser page',
  'designBrowser.status.onlyProjectHtmlCanSave': 'Only project-local HTML pages can be saved',
  'designBrowser.status.htmlSaved': 'HTML changes saved',
  'designBrowser.status.htmlSaveFailed': 'HTML save failed',
  'designBrowser.status.commentSavingUnavailable': 'Comment saving is unavailable',
  'designBrowser.status.commentSaved': 'Browser comment saved',
  'designBrowser.status.commentSendingUnavailable': 'Comment sending is unavailable',
  'designBrowser.comments.aria': 'Browser comments',
  'designBrowser.comments.openFor': 'Open browser comment for {label}',
  'designBrowser.comment.dialog': 'Browser comment',
  'designBrowser.comment.elementFallback': 'Browser element',
  'designBrowser.comment.close': 'Close browser comment',
  'designBrowser.comment.noteAria': 'Browser comment note',
  'designBrowser.comment.placeholder': 'Describe the change or issue...',
  'designBrowser.comment.addNote': 'Add note',
  'designBrowser.comment.saveComment': 'Save comment',
  'designBrowser.comment.sending': 'Sending...',
  'designBrowser.comment.sendToChat': 'Send to chat',
  'designBrowser.inspect.editTitle': 'Edit HTML element',
  'designBrowser.inspect.tuneTitle': 'Tune browser element',
  'designBrowser.inspect.closeTune': 'Close browser tune',
  'designBrowser.inspect.colors': 'Colors',
  'designBrowser.inspect.text': 'Text',
  'designBrowser.inspect.fill': 'Fill',
  'designBrowser.inspect.type': 'Type',
  'designBrowser.inspect.size': 'Size',
  'designBrowser.inspect.weight': 'Weight',
  'designBrowser.inspect.spacing': 'Spacing',
  'designBrowser.inspect.pad': 'Pad',
  'designBrowser.inspect.radius': 'Radius',
  'designBrowser.inspect.content': 'Content',
  'designBrowser.inspect.elementText': 'Element text',
  'designBrowser.inspect.saving': 'Saving...',
  'designBrowser.inspect.saveHtml': 'Save HTML',
  'designBrowser.inspect.liveOnly': 'Live only',
  'designBrowser.reference.kicker': 'OpenDesign browser',
  'designBrowser.reference.title': 'Reference Board',
  'designBrowser.reference.subtitle': 'A curated set of references across inspiration, real product UI, motion, color, type, assets, and design systems. Open one to browse it live while gathering design language for the next artifact.',
  'designBrowser.reference.categoryAria': 'Reference category',
  'designBrowser.reference.searchPlaceholder': 'Search references...',
  'designBrowser.reference.searchAria': 'Search references',
  'designBrowser.reference.clearSearch': 'Clear search',
  'designBrowser.reference.noMatches': 'No references match “{query}”.',
  'designBrowser.reference.clearFilters': 'Clear filters',
  'designBrowser.reference.open': 'Open',
  'designBrowser.reference.group.inspiration': 'Inspiration',
  'designBrowser.reference.group.interfaces': 'Real Interfaces',
  'designBrowser.reference.group.motion': 'Motion',
  'designBrowser.reference.group.color': 'Color',
  'designBrowser.reference.group.type': 'Typography',
  'designBrowser.reference.group.icons': 'Icons',
  'designBrowser.reference.group.illustration': 'Illustration',
  'designBrowser.reference.group.photography': 'Photography',
  'designBrowser.reference.group.3d': '3D & Graphics',
  'designBrowser.reference.group.mockups': 'Mockups',
  'designBrowser.reference.group.systems': 'Design Systems',
  'designBrowser.reference.group.components': 'Components',
  'designBrowser.reference.group.guidelines': 'Guidelines & A11y',
  'designBrowser.reference.group.tools': 'Tools & Resources',
  'designBrowser.reference.site.dribbble.detail': 'Design shots and UI inspiration.',
  'designBrowser.reference.site.behance.detail': 'Creative portfolios and case studies.',
  'designBrowser.reference.site.awwwards.detail': 'Award-winning website design.',
  'designBrowser.reference.site.godly.detail': 'Curated modern web design.',
  'designBrowser.reference.site.land_book.detail': 'Landing page gallery and patterns.',
  'designBrowser.reference.site.mobbin.detail': 'Real app screens and UI patterns.',
  'designBrowser.reference.site.screenlane.detail': 'Latest UI design patterns from apps.',
  'designBrowser.reference.site.pageflows.detail': 'Real product user flows and onboarding.',
  'designBrowser.reference.site.uisources.detail': 'Interaction patterns from top apps.',
  'designBrowser.reference.site.collectui.detail': 'Daily UI collection by category.',
  'designBrowser.reference.site.gsap.detail': 'Production animation engine and examples.',
  'designBrowser.reference.site.animations.detail': 'Animation patterns and interaction examples.',
  'designBrowser.reference.site.transitions.detail': 'Transition patterns for modern interfaces.',
  'designBrowser.reference.site.motionsites.detail': 'High-end motion and interaction references.',
  'designBrowser.reference.site.motion.detail': 'Scroll and timeline animation inspiration.',
  'designBrowser.reference.site.animography.detail': 'Animated type and kinetic lettering.',
  'designBrowser.reference.site.reactbits.detail': 'React text animation reference for shiny kinetic type.',
  'designBrowser.reference.site.coolors.detail': 'Fast color palette generator.',
  'designBrowser.reference.site.colorhunt.detail': 'Curated color palettes.',
  'designBrowser.reference.site.realtimecolors.detail': 'Preview palettes on a real UI.',
  'designBrowser.reference.site.color_adobe.detail': 'Color wheel and harmony rules.',
  'designBrowser.reference.site.happyhues.detail': 'Palettes shown in real context.',
  'designBrowser.reference.site.fonts_google.detail': 'Open-source font library.',
  'designBrowser.reference.site.fontshare.detail': 'Quality fonts free for commercial use.',
  'designBrowser.reference.site.typewolf.detail': 'Fonts in use and pairing guidance.',
  'designBrowser.reference.site.fontpair.detail': 'Font pairing suggestions.',
  'designBrowser.reference.site.fontsinuse.detail': 'Typography in real-world design.',
  'designBrowser.reference.site.thesvg.detail': 'SVG assets and vector references.',
  'designBrowser.reference.site.svglogos.detail': 'Clean SVG logos for product and brand mocks.',
  'designBrowser.reference.site.icons_lobehub.detail': 'Product and AI-brand icons for interfaces.',
  'designBrowser.reference.site.icon_sets_iconify.detail': '200k+ open-source icons in one place.',
  'designBrowser.reference.site.lucide.detail': 'Clean, consistent open icon set.',
  'designBrowser.reference.site.heroicons.detail': 'Tailwind-made SVG icons.',
  'designBrowser.reference.site.svgrepo.detail': 'Free SVG vectors and icons.',
  'designBrowser.reference.site.storyset.detail': 'Customizable vector illustrations.',
  'designBrowser.reference.site.undraw.detail': 'Open-source MIT illustrations.',
  'designBrowser.reference.site.blush.detail': 'Mix-and-match illustrations.',
  'designBrowser.reference.site.lummi.detail': 'Free AI-generated visuals.',
  'designBrowser.reference.site.whirrls.detail': 'Hand-drawn image references.',
  'designBrowser.reference.site.worldindots.detail': 'Dot-map and data-viz references.',
  'designBrowser.reference.site.unsplash.detail': 'Free high-resolution photos.',
  'designBrowser.reference.site.pexels.detail': 'Free stock photos and video.',
  'designBrowser.reference.site.pixabay.detail': 'Royalty-free images and media.',
  'designBrowser.reference.site.cosmos.detail': 'Visual discovery and mood boards.',
  'designBrowser.reference.site.spline.detail': 'Browser-based 3D design.',
  'designBrowser.reference.site.threejs.detail': 'WebGL 3D references and demos.',
  'designBrowser.reference.site.womp.detail': 'Easy in-browser 3D creation.',
  'designBrowser.reference.site.pixcap.detail': '3D icons, mockups, and scenes.',
  'designBrowser.reference.site.shots.detail': 'Device and browser mockups.',
  'designBrowser.reference.site.mockuuups.detail': 'Drag-and-drop device mockups.',
  'designBrowser.reference.site.angle.detail': '3D device mockup library.',
  'designBrowser.reference.site.rotato.detail': 'Animated 3D product mockups.',
  'designBrowser.reference.site.impeccable.detail': 'High-quality style and interface references.',
  'designBrowser.reference.site.styles_refero.detail': 'Design style references and visual systems.',
  'designBrowser.reference.site.brandfetch.detail': 'Brand assets, logos, and identity.',
  'designBrowser.reference.site.designsystemsrepo.detail': 'Gallery of public design systems.',
  'designBrowser.reference.site.startups.detail': 'Top startup product and brand references.',
  'designBrowser.reference.site.base_ui.detail': 'Unstyled accessible primitives for custom systems.',
  'designBrowser.reference.site.ui_shadcn.detail': 'Composable React components built on Radix and Tailwind.',
  'designBrowser.reference.site.heroui.detail': 'Modern React component library and design system.',
  'designBrowser.reference.site.radix_ui.detail': 'Accessible low-level UI primitives.',
  'designBrowser.reference.site.react_spectrum_adobe.detail': 'Accessible behavior primitives from Adobe.',
  'designBrowser.reference.site.headlessui.detail': 'Unstyled accessible components for Tailwind projects.',
  'designBrowser.reference.site.mui.detail': 'Material-based React component ecosystem.',
  'designBrowser.reference.site.mantine.detail': 'Full-featured React components and hooks.',
  'designBrowser.reference.site.chakra_ui.detail': 'Accessible React components with theme tokens.',
  'designBrowser.reference.site.ant.detail': 'Enterprise component system and patterns.',
  'designBrowser.reference.site.ark_ui.detail': 'Headless components across modern frameworks.',
  'designBrowser.reference.site.daisyui.detail': 'Tailwind CSS component classes and themes.',
  'designBrowser.reference.site.developer_apple.detail': 'Apple platform design guidelines.',
  'designBrowser.reference.site.m3_material.detail': 'Google\'s Material Design 3.',
  'designBrowser.reference.site.lawsofux.detail': 'UX principles and heuristics.',
  'designBrowser.reference.site.webaim.detail': 'Color contrast checker.',
  'designBrowser.reference.site.a11yproject.detail': 'Accessibility checklist and patterns.',
  'designBrowser.reference.site.toolfolio.detail': 'Design tools, resources, and collections.',
  'designBrowser.reference.site.getdesign.detail': 'Curated design resources.',
  'designBrowser.reference.site.tasteskill.detail': 'Design taste training and critique references.',
  'designBrowser.reference.site.uigoodies.detail': 'Hand-picked design resources.',
  'designBrowser.reference.site.sidebar.detail': 'Five design links, every day.',
  'designBrowser.reference.site.github.detail': 'Reference implementation for embedded browser workflows.',
  'browserUse.category.assets': 'Ekstraksi aset',
  'browserUse.category.tokens': 'Bahasa desain',
  'browserUse.category.motion': 'Gerak',
  'browserUse.category.visual': 'Pemeriksaan visual',
  'browserUse.category.structure': 'Komponen',
  'browserUse.category.project': 'Jalankan proyek',
  'browserUse.category.general': 'Umum',
  'browserUse.input.none': 'Tidak ada input',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'Selektor opsional',
  'browserUse.input.requirementSelector': 'Persyaratan, selektor opsional',
  'browserUse.input.selectorOptional': 'Selektor opsional',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'Selektor, scale=2',
  'browserUse.input.gridOverlay': '12 kolom, maks 1200, gap 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, domain, atau kata kunci pencarian',
  'browserUse.input.selector': 'Selektor',
  'browserUse.input.selectorText': 'Selektor dan teks',
  'browserUse.input.scroll': 'Piksel, atas, bawah, atau halaman',
  'browserUse.input.terminalRun': 'Perintah, batas waktu 120 dtk',
  'browserUse.input.command': 'Perintah',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'Kandidat logo terbaik dari header, navigasi, nama kelas, posisi, OG image, dan cadangan favicon.',
  'browserUse.action.list_images.output': 'Semua img, srcset, source, dan gambar latar CSS beserta dimensi dan teks alt.',
  'browserUse.action.download_assets.output': 'Folder aset yang diunduh beserta _manifest.json dengan dukungan referer dan cookie.',
  'browserUse.action.extract_svgs.output': 'SVG inline dan berkas .svg tertaut disimpan sebagai berkas SVG individual.',
  'browserUse.action.optimize_svgs.output': 'Berkas SVG yang dioptimalkan beserta rasio kompresi.',
  'browserUse.action.extract_colors.output': 'Palet berbobot beserta variabel warna CSS :root sebagai palette.json dan palette.html.',
  'browserUse.action.extract_fonts.output': 'Famili font teratas, ukuran, ketebalan, dan aturan @font-face sebagai typography.json.',
  'browserUse.action.extract_design_tokens.output': 'Radius, bayangan, spasi, dan variabel CSS sebagai tokens.json.',
  'browserUse.action.extract_type_scale.output': 'Skala tipe heading, body, dan tombol beserta ukuran, ketebalan, line-height, dan rasio.',
  'browserUse.action.extract_buttons.output': 'Pustaka gaya tombol tanpa duplikat sebagai buttons.html dan buttons.json.',
  'browserUse.action.extract_grid_system.output': 'Kontainer grid dan flex, arah, gap, kolom, dan lebar maksimum sebagai layout.json.',
  'browserUse.action.extract_breakpoints.output': 'Breakpoint media-query responsif sebagai breakpoints.json.',
  'browserUse.action.extract_gradients.output': 'Gradien CSS sebagai gradients.css, gradients.json, dan HTML pratinjau.',
  'browserUse.action.extract_shadows.output': 'Box shadow, text shadow, dan drop shadow sebagai shadows.json beserta pratinjau.',
  'browserUse.action.extract_easings.output': 'Fungsi easing transisi dan animasi sebagai easings.json.',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js, dan style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': '@keyframes, aturan transition dan transform, pustaka motion yang terdeteksi, motion.css, dan motion.json.',
  'browserUse.action.validate_view.output': 'Path tangkapan layar beserta masalah visual dan tata letak yang terstruktur.',
  'browserUse.action.audit_layout.output': 'Cacat tata letak termasuk overflow, batas, tumpang tindih, dan teks terpotong sebagai audit.json.',
  'browserUse.action.audit_accessibility.output': 'Masalah aksesibilitas dengan selektor, label, peran, fokus, kontras, dan tangkapan layar bila berguna.',
  'browserUse.action.responsive_screenshots.output': 'Tangkapan layar mobile 390, tablet 834, dan desktop 1440.',
  'browserUse.action.screenshot_full.output': 'Tangkapan layar halaman penuh melampaui viewport.',
  'browserUse.action.screenshot_element.output': 'Tangkapan layar elemen tunggal pada 2x secara default.',
  'browserUse.action.screenshot_with_grid.output': 'Tangkapan layar dengan overlay grid tata letak.',
  'browserUse.action.screenshot_dark_mode.output': 'Tangkapan layar dengan prefers-color-scheme: dark.',
  'browserUse.action.generate_styleguide.output': 'Panduan gaya satu halaman dengan warna, skala tipe, radius, dan bayangan.',
  'browserUse.action.extract_html.output': 'HTML bersih dan mandiri tanpa script, noscript, atau atribut event inline.',
  'browserUse.action.extract_component_inventory.output': 'Pola komponen berulang, selektor, jumlah, dan tangkapan layar.',
  'browserUse.action.extract_copy.output': 'Heading, CTA, salinan body, dan deskripsi sebagai copy.md dan copy.json.',
  'browserUse.action.extract_nav.output': 'Tautan navigasi utama dan footer sebagai sitemap.md dan nav.json.',
  'browserUse.action.extract_forms.output': 'Kolom formulir, label, petunjuk validasi, dan aksi kirim sebagai forms.json.',
  'browserUse.action.run_project.output': 'URL server dev yang terdeteksi dibuka di tab Browser.',
  'browserUse.action.detect_project.output': 'Framework, package manager, perintah install, perintah dev, dan port.',
  'browserUse.action.page_info.output': 'URL, judul, deskripsi, OG image, warna tema, favicon, dan viewport.',
  'browserUse.action.snapshot.output': 'Hingga 120 elemen interaktif dan teks yang terlihat beserta tag, label, href, dan koordinat.',
  'browserUse.action.navigate.output': 'Buka halaman dan kembalikan page_info.',
  'browserUse.action.click.output': 'Klik elemen pertama yang cocok setelah menggulirkannya ke dalam tampilan.',
  'browserUse.action.type_text.output': 'Isi input dan kirim event input dan change.',
  'browserUse.action.scroll.output': 'Posisi gulir saat ini dan maksimum.',
  'browserUse.action.extract_og_metadata.output': 'Judul meta, deskripsi, URL kanonis, kartu OG/Twitter, gambar sosial, dan warna tema.',
  'browserUse.action.terminal_run.output': 'stdout, stderr, dan kode keluar.',
  'browserUse.action.terminal_run_background.output': 'ID tugas latar belakang dan output terbaru.',
  'browserUse.action.terminal_read.output': 'Output terminal bersama terbaru.',
  'chat.designToolbox.title': 'Kotak peralatan desain',
  'chat.designToolbox.tooltip': 'Kotak peralatan desain',
  'chat.designToolbox.aria': 'Buka kotak peralatan desain',
  'chat.designToolbox.searchPlaceholder': 'Cari skill / MCP / plugin / konektor / berkas desain...',
  'chat.designToolbox.searchAria': 'Cari sumber daya kotak peralatan desain',
  'chat.designToolbox.followupSection': 'Tindak lanjut',
  'chat.designToolbox.resourcesSection': 'Sumber daya global',
  'chat.designToolbox.selected': 'Dipilih',
  'chat.designToolbox.noResources': 'Tidak ada sumber daya yang ditemukan untuk "{query}".',
  'chat.designToolbox.badge.video': 'Video',
  'chat.designToolbox.badge.image': 'Gambar',
  'chat.designToolbox.badge.motion': 'Gerak',
  'chat.designToolbox.badge.polish': 'Penyempurnaan',
  'chat.designToolbox.action.auto-match.title': 'Cocokkan langkah berikutnya',
  'chat.designToolbox.action.auto-match.badge': 'Cocokkan',
  'chat.designToolbox.action.auto-match.description': 'Tentukan standar selera terlebih dahulu, lalu cocokkan skill, MCP, plugin, konektor, dan file.',
  'chat.designToolbox.action.asset-search.title': 'Find images / references',
  'chat.designToolbox.action.asset-search.badge': 'Assets',
  'chat.designToolbox.action.asset-search.description': 'Search for usable images, reference screenshots, moodboards, and source candidates for the current design.',
  'chat.designToolbox.action.icon-workflow.title': 'Find / replace icons',
  'chat.designToolbox.action.icon-workflow.badge': 'Icons',
  'chat.designToolbox.action.icon-workflow.description': 'Find, generate, or swap iconography, SVGs, Lucide icons, and visual symbols with a consistent style.',
  'chat.designToolbox.action.image-replace.title': 'Replace page images',
  'chat.designToolbox.action.image-replace.badge': 'Swap',
  'chat.designToolbox.action.image-replace.description': 'Audit current imagery and replace weak hero, section, background, or card images with better assets.',
  'chat.designToolbox.action.reference-extract.title': 'Extract visual references',
  'chat.designToolbox.action.reference-extract.badge': 'Refs',
  'chat.designToolbox.action.reference-extract.description': 'Analyze a reference screenshot or site for palette, typography, layout posture, motion, and asset direction.',
  'chat.designToolbox.action.motion.title': 'Tambahkan animasi / gerak',
  'chat.designToolbox.action.motion.badge': 'Gerak',
  'chat.designToolbox.action.motion.description': 'Tambahkan gerak masuk, gulir, transisi status, dan mikro-interaksi pada HTML atau elemen halaman saat ini.',
  'chat.designToolbox.action.motion-polish.title': 'Sempurnakan gerak',
  'chat.designToolbox.action.motion-polish.badge': 'Pengaturan waktu',
  'chat.designToolbox.action.motion-polish.description': 'Tinjau pengaturan waktu, easing, performa, dan fallback reduced-motion untuk gerak yang sudah ada.',
  'chat.designToolbox.action.transition-motion.title': 'Design transitions',
  'chat.designToolbox.action.transition-motion.badge': 'Transition',
  'chat.designToolbox.action.transition-motion.description': 'Design page, scene, loading, and state transitions with restrained timing and reduced-motion fallbacks.',
  'chat.designToolbox.action.threejs-scene.title': '3D / Three.js scene',
  'chat.designToolbox.action.threejs-scene.badge': '3D',
  'chat.designToolbox.action.threejs-scene.description': 'Add or plan Three.js, Spline, Vanta, particle, WebGL, map, or deck.gl-style interactive visuals.',
  'chat.designToolbox.action.anti-ai-polish.title': 'Hilangkan kesan AI',
  'chat.designToolbox.action.anti-ai-polish.badge': 'Selera',
  'chat.designToolbox.action.anti-ai-polish.description': 'Hilangkan kesan template, gradien AI, tumpukan kartu murahan, dan teks yang tidak jelas.',
  'chat.designToolbox.action.visual-polish.title': 'Penyempurnaan desain / siap rilis',
  'chat.designToolbox.action.visual-polish.badge': 'Penyempurnaan',
  'chat.designToolbox.action.visual-polish.description': 'Audit hierarki visual, tipografi, spasi, perilaku responsif, aksesibilitas, dan kualitas pengiriman.',
  'chat.designToolbox.action.image-gen.title': 'Hasilkan gambar / referensi visual',
  'chat.designToolbox.action.image-gen.badge': 'Gambar',
  'chat.designToolbox.action.image-gen.description': 'Hasilkan referensi bagian, aset, ikon, gambar sosial, atau moodboard untuk halaman saat ini.',
  'chat.designToolbox.action.chart-gen.title': 'Generate charts / diagrams',
  'chat.designToolbox.action.chart-gen.badge': 'Charts',
  'chat.designToolbox.action.chart-gen.description': 'Generate ECharts, React Flow, diagrams, dashboards, relationship maps, or data-visualization assets.',
  'chat.designToolbox.action.logo-gen.title': 'Generate logo / identity',
  'chat.designToolbox.action.logo-gen.badge': 'Logo',
  'chat.designToolbox.action.logo-gen.description': 'Create logo routes, wordmarks, lockups, marks, and identity-system prompts for the current brand.',
  'chat.designToolbox.action.plan-outline.title': "Generate PPT outline from idea",
  'chat.designToolbox.action.plan-outline.badge': "Plan",
  'chat.designToolbox.action.plan-outline.description': "Turn a rough idea into an editable Markdown deck outline before creating slides.",
  'chat.designToolbox.action.video-gen.title': 'Hasilkan video / skrip gerak',
  'chat.designToolbox.action.video-gen.badge': 'Video',
  'chat.designToolbox.action.video-gen.description': 'Ubah desain menjadi video pendek, storyboard Remotion / Hyperframes, atau prompt yang siap dihasilkan.',
  'chat.designToolbox.kind.skill': 'Skill',
  'chat.designToolbox.kind.plugin': 'Plugin',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'Template MCP',
  'chat.designToolbox.kind.connector': 'Konektor',
  'chat.designToolbox.kind.designFile': 'File desain',
  'chat.designToolbox.context.browser': 'Browser',
  'chat.designToolbox.context.designFiles': 'File desain',
  'chat.designToolbox.context.designSystem': 'Design system',
  'chat.designToolbox.context.folder': 'Folder',
  'chat.designToolbox.context.terminal': 'Terminal',
  'chat.designToolbox.context.sideChat': 'Obrolan samping',
  'chat.designToolbox.context.liveArtifact': 'Artefak langsung',
  'chat.designToolbox.context.file': 'Berkas',
  'chat.designToolbox.prompt.contextGeneric': 'Target saat ini: file HTML / file desain / elemen web yang sedang terbuka.',
  'chat.designToolbox.prompt.contextSpecific': 'Target saat ini: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'Pertahankan maksud yang sudah ada di composer: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'Skill yang dipilih: {skill}. Gunakan sebagai alur kerja utama untuk giliran ini.',
  'chat.designToolbox.prompt.noSkill': 'Jika tidak ada skill spesifik yang cocok, pertama pilih kombinasi terbaik dari skill, MCP, plugin, konektor, dan file desain yang tersedia.',
  'chat.designToolbox.prompt.autoMatchIntro': 'Bertindak sebagai orkestrator Creative Director dan selesaikan alur kerja desain:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. Tentukan dulu apa arti “desain yang bagus”: audiens, tujuan bisnis, nuansa brand, referensi gaya, kepadatan informasi, standar warna/tipografi/gerak/aset, serta pola AI/template yang harus dihindari.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. Cari dan cocokkan seluruh indeks sumber daya di atas. Jangan hanya menggunakan rekomendasi design toolbox; gabungkan skill, MCP, plugin, konektor, dan file desain bila berguna.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. If the target or aesthetic bar is still unclear, guide me with a structured question-form, include recommended defaults, and make each finite-choice question editable with a custom answer field. If it is clear enough, execute the next step directly.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. Selesaikan alur dalam urutan ini: diagnosis -> arah gaya -> pemilihan sumber daya -> pengeditan/penghasilan konkret -> verifikasi. Pada setiap langkah, jelaskan mengapa sumber daya tersebut dipilih dan apa yang perlu dikonfirmasi berikutnya.',
  'chat.designToolbox.prompt.assetSearch': 'Find the best image/reference assets for the current design. Search available files, connectors, MCPs, browser captures, and generation tools. Return concrete candidates with usage notes, licensing/source caveats when relevant, and a fallback generation prompt if no usable asset exists.',
  'chat.designToolbox.prompt.iconWorkflow': 'Improve the icon system for the current design: find missing icons, replace weak icons, keep stroke/fill/radius/weight consistent, prefer existing icon libraries when available, and generate SVG/icon prompts only when a library icon is insufficient.',
  'chat.designToolbox.prompt.imageReplace': 'Audit every visible image slot in the current design, identify weak or placeholder imagery, then replace or specify better hero, section, background, card, and social images. Preserve layout and provide exact file/prompt/source choices.',
  'chat.designToolbox.prompt.referenceExtract': 'Use the current reference image/site/design file as visual input. Extract palette, type scale, layout rhythm, component posture, motion cues, and asset style, then apply those findings to the current design without copying protected brand assets verbatim.',
  'chat.designToolbox.prompt.motion': 'Add high-quality motion to the current HTML / page element: choose the most useful 1-2 entrance, scroll, state-transition, transition, Rive/Lottie-style icon motion, or GSAP/Motion micro-interaction moments. Keep it restrained, prefer transform / opacity, and include prefers-reduced-motion fallbacks.',
  'chat.designToolbox.prompt.planOutline': "Create or update a Markdown planning document for a PPT/deck outline from this idea. Do not generate the final deck yet. Include slide-by-slide titles, goals, content bullets, visual direction, required data/assets, and open questions. Save it as a `.md` file in Design Files and tell me which file to review.",
  'chat.designToolbox.prompt.motionPolish': 'Tinjau dan sempurnakan pengaturan waktu, easing, performa, dan aksesibilitas gerak yang sudah ada. Hilangkan animasi yang mendadak, murahan, atau mengganggu keterbacaan; gunakan timeline yang lebih halus bila diperlukan.',
  'chat.designToolbox.prompt.transitionMotion': 'Design high-quality transitions for the current design: page/scene changes, loading bridges, state changes, and section handoffs. Use GSAP/Motion/CSS where appropriate, keep it performant, and include reduced-motion behavior.',
  'chat.designToolbox.prompt.threejsScene': 'Plan or implement a focused Three.js/WebGL visual for the current design. Consider Three.js, Spline-style scenes, Vanta backgrounds, particle systems, Mapbox/deck.gl data layers, or browser portal effects, but keep the scene useful and verify it renders.',
  'chat.designToolbox.prompt.antiAiPolish': 'Lakukan satu kali penyempurnaan anti-kesan-AI: hilangkan tata letak bergaya template, gradien/cahaya murahan, tumpukan kartu tanpa makna, dan teks yang tidak jelas. Pertahankan informasi dan buat terasa seperti dikerjakan oleh desainer sungguhan.',
  'chat.designToolbox.prompt.visualPolish': 'Sempurnakan desain ini hingga siap dirilis: periksa hierarki, tipografi, spasi, perilaku responsif, status tombol, status kosong/memuat/eror, dan aksesibilitas; perbaiki langsung masalah yang paling penting.',
  'chat.designToolbox.prompt.imageGen': 'Buat rencana aset visual berikutnya untuk desain ini: referensi bagian, aset hero, ilustrasi, ikon, gambar sosial, atau moodboard. Pertama tentukan jenis gambar apa yang kurang, lalu berikan prompt penghasilan / rencana file yang dapat dieksekusi.',
  'chat.designToolbox.prompt.chartGen': 'Generate the right chart, diagram, or data-visualization for the current design. Choose between ECharts, React Flow, SVG/CSS diagrams, radar charts, relationship maps, dashboards, or deck.gl/map visualizations based on the data and user goal.',
  'chat.designToolbox.prompt.logoGen': 'Create logo and identity directions for the current brand. Produce multiple routes for wordmark, symbol, lockup, palette, usage rules, and generation prompts; make sure the result is original and usable in the current artifact.',
  'chat.designToolbox.prompt.videoGen': 'Arahkan desain ini menuju video: buat storyboard video pendek, struktur frame Hyperframes / Remotion, atau prompt yang siap untuk Sora/fal. Utamakan membuat konten HTML / halaman yang sudah ada secara alami menjadi shot.',
  'chat.designToolbox.prompt.useSkill': 'Gunakan {skill} pada desain saat ini.',
  'chat.designToolbox.prompt.skillInstruction': 'Pertama tentukan tujuan tindak lanjut terbaik, lalu selesaikan satu kali eksekusi konkret. Jika bergantung pada aset atau API eksternal, sediakan fallback yang dapat dijalankan atau sebutkan apa yang perlu saya berikan.',
  'chat.designToolbox.prompt.selectedResource': 'Sumber daya yang dipilih: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'Deskripsi sumber daya: {description}',
  'chat.designToolbox.prompt.pluginResource': 'Gunakan plugin ini sebagai konteks utama untuk alur desain saat ini. Jika ia menyediakan input atau GenUI, pandu saya untuk memilih saat dibutuhkan; jika tidak sesuai dengan target, pilih sumber daya global yang lebih baik dan jelaskan alasannya.',
  'chat.designToolbox.prompt.mcpResource': 'Utamakan kemampuan MCP ini untuk langkah desain berikutnya. Ketika aset eksternal, penangkapan web, pembuatan gambar/video, atau data dibutuhkan, putuskan dulu apakah ia mampu melakukan tugas tersebut, lalu berikan rencana yang dapat dieksekusi.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'MCP ini adalah templat yang dapat dikonfigurasi. Jika ia merupakan alat paling berguna untuk langkah desain ini, pandu penyiapannya terlebih dahulu; jika sudah ada alternatif yang terkonfigurasi, lanjutkan dengan alternatif tersebut.',
  'chat.designToolbox.prompt.connectorResource': 'Gunakan connector ini ketika data nyata, aset, konten akun, atau akses alur kerja eksternal dibutuhkan. Sebelum menggunakannya, jelaskan apa yang akan dibaca atau ditulis dan minta konfirmasi bila perlu.',
  'chat.designToolbox.prompt.fileResource': 'Gunakan file desain ini sebagai target desain saat ini atau aset referensi dan selesaikan langkah berikutnya darinya. Jika file lain perlu dibandingkan, lanjutkan pencarian di seluruh file desain.',
  'chat.designToolbox.prompt.resourceIndex': 'Indeks sumber daya global: skill({skills}), plugin({plugins}), MCP({mcpEnabled} aktif / {mcpTemplates} templat), connector({connectors} terhubung), file desain({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'Skill yang dapat dicari',
  'chat.designToolbox.prompt.searchablePlugins': 'Plugin yang dapat dicari',
  'chat.designToolbox.prompt.availableMcp': 'MCP yang tersedia',
  'chat.designToolbox.prompt.connectedConnectors': 'Connector yang terhubung',
  'chat.designToolbox.prompt.referenceDesignFiles': 'File desain referensi',
  'chat.designToolbox.prompt.mcpTemplateName': 'Templat {name}',
  'chat.designToolbox.prompt.processRule': 'Workflow rule: define the aesthetic goal and constraints first, then search and match resources; when user choice is needed, generate a structured question-form with editable custom answers and continue after confirmation.',
  'chat.designToolbox.prompt.moreSuffix': ', +{count} lainnya',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'Permukaan penyebutan',
  'chat.mentionTabAll': 'Semua',
  'chat.mentionTabTabs': 'Tab',
  'chat.mentionTabPlugins': 'Plugin',
  'chat.mentionTabSkills': 'Skill',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'Connector',
  'chat.mentionTabFiles': 'File desain',
  'chat.mentionNoResults': 'Tidak ada hasil untuk “{query}”.',
  'chat.mentionSearchPrompt': 'Cari File Desain, tab, plugin, skill, server MCP, dan connector.',
  'chat.mentionSectionTabs': 'Tab',
  'chat.mentionSectionPlugins': 'Plugin',
  'chat.mentionSectionSkills': 'Skill',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'Connector',
  'chat.mentionSectionFiles': 'File desain',
  'chat.mentionActiveSkill': 'Aktif',
  'chat.mentionUseMcpTitle': 'Gunakan {name}',
  'chat.mentionUseConnectorTitle': 'Gunakan {name}',
  'chat.mentionPluginOfficial': 'Resmi',
  'chat.mentionPluginMine': 'Plugin saya',
  'chat.linkedFolderRemoveAria': 'Hapus folder tertaut {path}',
  'chat.linkedFolderNotFound': 'Folder tidak ada',
  'chat.linkedFolderAlready': 'Folder ini sudah tertaut',
  'chat.linkedFolderPickError': 'Tidak bisa membuka pemilih folder',
  'chat.queuedEditQueuedTaskAria': 'Edit queued task',
  'chat.queuedSave': 'Save',
  'chat.queuedCancel': 'Cancel',
  'chat.queuedReorder': 'Drag to reorder',
  'chat.queuedEdit': 'Edit',
  'chat.queuedHeader': 'Dalam antrean',
  'chat.queuedSteer': 'Arahkan giliran ini',
  'chat.queuedSteerInterrupts': 'Arahkan giliran ini — menghentikan proses yang sedang berjalan',
  'chat.queuedSteerUnsupported': 'Agen ini tidak bisa menerima pesan di tengah giliran',
  'chat.queuedSteerClosed': 'Giliran ini sudah berhenti membaca pesan',
  'chat.queuedSteerFailed': 'Gagal mengarahkan giliran',
  'chat.queuedSteerTextOnly': 'Giliran yang sedang berjalan hanya menerima teks — kirim yang ini beserta lampirannya secara terpisah',
  'chat.queuedFollowUpFallback': 'Queued follow-up',
  'chat.send': 'Kirim',
  'chat.stop': 'Stop',
  'chat.removeAria': 'Hapus {name}',
  'chat.example1Title': 'Pitch editorial',
  'chat.example1Tag': 'Majalah',
  'chat.example1Prompt': 'Buat pitch deck bergaya majalah untuk seed round startup AI.',
  'chat.example2Title': 'Dashboard analitik SaaS',
  'chat.example2Tag': 'Data',
  'chat.example2Prompt': 'Buat dashboard analitik padat untuk SaaS developer tools dengan KPI, grafik MRR, peta heatmap penggunaan, kohort retensi, dan feed event real-time.',
  'chat.example3Title': 'Laporan tahunan long-scroll',
  'chat.example3Tag': 'Editorial',
  'chat.example3Prompt': 'Buat laporan tahunan long-scroll dengan hero editorial, angka utama, timeline, dan visualisasi data.',
  'home.recommendation.eyebrow': 'Direkomendasikan untuk Anda',
  'home.recommendation.primaryCta': 'Mulai membuat',
  'home.recommendation.change': 'Coba yang lain',
  'home.recommendation.browseAll': 'Semua jenis',
  'home.recommendation.defaultProjectName': 'Proyek baru',
  'home.recommendation.startFailed': 'Tidak dapat memulai pembuatan. Coba lagi.',
  'studio.firstArtifactHint.title': 'Desain pertama Anda sudah siap',
  'studio.firstArtifactHint.body': 'Coba edit dan beri anotasi langsung — ekspor atau bagikan kapan saja setelah puas.',
  'studio.firstArtifactHint.dismiss': 'Mengerti',
  'home.starter.product_ui_prototype.title': 'Mulai dengan prototipe produk yang dapat diedit',
  'home.starter.product_ui_prototype.desc': 'Berdasarkan tujuan Anda, mulai dengan antarmuka yang dapat diklik dan bisa Anda sempurnakan.',
  'home.starter.product_ui_prototype.firstPrompt': 'Rancang prototipe produk yang dapat diedit untuk [produk Anda] dengan layar-layar utama dan alur utama yang jelas.',
  'home.starter.product_ui_component.title': 'Mulai dari komponen yang dapat digunakan ulang',
  'home.starter.product_ui_component.desc': 'Bangun satu komponen dulu, lalu susun menjadi layar penuh.',
  'home.starter.product_ui_component.firstPrompt': 'Rancang komponen [nama komponen] yang dapat digunakan ulang dengan status utama dan variannya.',
  'home.starter.product_ui_lowfi.title': 'Mulai dengan prototipe low-fidelity',
  'home.starter.product_ui_lowfi.desc': 'Sketsakan strukturnya dulu, lalu tingkatkan detailnya.',
  'home.starter.product_ui_lowfi.firstPrompt': 'Buat wireframe low-fidelity dari layar-layar utama untuk [produk Anda].',
  'home.starter.marketing_landing.title': 'Mulai dengan landing page',
  'home.starter.marketing_landing.desc': 'Ubah kampanye Anda menjadi landing page yang siap dirilis.',
  'home.starter.marketing_landing.firstPrompt': 'Rancang landing page untuk [produk Anda] dengan hero, manfaat utama, dan ajakan bertindak yang jelas.',
  'home.starter.marketing_multivariant.title': 'Mulai dengan beberapa varian landing page',
  'home.starter.marketing_multivariant.desc': 'Buat beberapa versi untuk dibandingkan sebelum Anda memutuskan.',
  'home.starter.marketing_multivariant.firstPrompt': 'Buat 3 varian landing page untuk [produk Anda] dengan pesan hero yang berbeda untuk dibandingkan.',
  'home.starter.internal_dashboard.title': 'Mulai dengan dasbor internal',
  'home.starter.internal_dashboard.desc': 'Mulai dari tata letak dasbor untuk alur kerja Anda.',
  'home.starter.internal_dashboard.firstPrompt': 'Rancang dasbor internal yang menampilkan [metrik utama] dengan filter dan tabel data.',
  'home.starter.internal_report.title': 'Mulai dengan laporan',
  'home.starter.internal_report.desc': 'Jelaskan data dan field yang ingin Anda lihat.',
  'home.starter.internal_report.firstPrompt': 'Buat halaman laporan yang merangkum [jelaskan data, field, dan metrik yang Anda pedulikan].',
  'home.starter.general_menu.title': 'Mulai dengan proyek pertama Anda',
  'home.starter.general_menu.desc': 'Jelaskan yang Anda inginkan dan kami akan menghasilkan versi pertama yang dapat diedit.',
  'home.starter.general_menu.firstPrompt': 'Buat versi pertama yang dapat diedit dari [jelaskan yang ingin Anda buat].',
  'chat.example4Title': 'Video motion produk',
  'chat.example4Tag': 'Motion',
  'chat.example4Prompt': 'Buat storyboard video motion 15 detik untuk peluncuran app produktivitas: hook pembuka, close-up UI, tipografi kinetik, transisi fitur, logo penutup, dan CTA. Sertakan timing, deskripsi scene, gerak kamera, dan teks overlay.',
  'preview.usePlugin': 'Gunakan plugin',
  'preview.usePluginOnly': 'Gunakan tanpa prompt',
  'preview.usePluginOnlyDesc': 'Gunakan struktur plugin tanpa memuat prompt contoh',
  'preview.replicateContent': 'Gunakan',
  'preview.replicateContentDesc': 'Gunakan prompt contoh untuk membuat ulang pratinjau',
  'preview.duplicateTemplate': 'Remix',
  'preview.duplicateTemplateDesc': 'Remix contoh ini menjadi proyek baru yang dapat diedit',
  'preview.shareMenu': 'Bagikan',
  'preview.exportMenu': 'Export',
  'preview.shareTemplateBadge': 'Template',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Copy template link',
  'preview.copyShareText': 'Copy share text',
  'preview.shareSocialGroup': 'Share to social',
  'preview.shareCopyGroup': 'Copy',
  'preview.shareExportGroup': 'Export files',
  'preview.shareCopied': 'Copied',
  'preview.shareCopyFailed': 'Copy failed',
  'preview.shareTextDefault': 'OpenDesign template: {title}',
  'preview.openInNewTab': 'Buka di tab baru',
  'preview.exit': 'Keluar',
  'preview.fullscreen': 'Layar penuh',
  'preview.closeTitle': 'Tutup pratinjau',
  'preview.loading': 'Memuat {label}...',
  'preview.errorTitle': 'Tidak dapat memuat contoh ini.',
  'preview.errorBody': 'Pengambilan HTML contoh gagal. Pastikan OpenDesign berjalan, lalu coba lagi.',
  'preview.retry': 'Coba lagi',
  'preview.unavailableTitle': 'Tidak ada pratinjau bawaan untuk {noun}.',
  'preview.unavailableBody': 'Jalankan prompt di chat untuk membuat keluaran {kind}.',
  'preview.nounSkill': 'skill ini',
  'preview.nounPlugin': 'plugin ini',
  'preview.nounTemplate': 'templat ini',
  'preview.showSidebar': 'Tampilkan {label}',
  'preview.hideSidebar': 'Sembunyikan {label}',
  'misc.savedTemplate': 'Templat tersimpan',
  'misc.primary': 'Utama',
  'misc.designSystem': 'Sistem desain',
  'workspace.designFiles': 'File desain',
  'workspace.focusMode': 'Fokus workspace',
  'workspace.showChat': 'Tampilkan chat',
  'workspace.closeTab': 'Tutup tab',
  'workspace.fileSyncDownloading': 'Mengunduh dari tim…',
  'workspace.fileSyncUploading': 'Menyinkronkan ke tim…',
  'workspace.deleteFileConfirm': 'Hapus "{name}" dari folder proyek?',
  'workspace.readonlyNotice': 'Ini proyek bersama — Anda dapat melihat dan mengomentari, tetapi tidak dapat mengubah artefak melalui Chat atau alat pengeditan.',
  'workspace.readonlyNoticeBy': 'Ini proyek bersama yang dibuat oleh {owner} — Anda dapat melihat dan mengomentari, tetapi tidak dapat mengubah artefak melalui Chat atau alat pengeditan.',
  'workspace.deleteSelectedFilesConfirm': 'Hapus {n} file terpilih dari folder proyek?',
  'workspace.deleteSelectedFilesPartial': 'Gagal menghapus {n} file.',
  'workspace.openFromDesignFiles': 'Buka file dari',
  'workspace.designFilesLink': 'File desain',
  'workspace.loadingSketch': 'Memuat sketsa...',
  'workspace.newTab': 'New tab',
  'workspace.searchFilesPlaceholder': 'Search files…',
  'workspace.openTabs': 'Tab terbuka',
  'workspace.searchTabs': 'Search tabs',
  'workspace.noTabsFound': 'No tabs found',
  'workspace.openFile': 'Open a file',
  'workspace.noFilesMatch': 'No files match',
  'workspace.allFiles': 'All',
  'workspace.createNew': 'Create new',
  'workspace.tabOpen': 'Open',
  'workspace.sideChatContextBanner': 'Integrated context from the current conversation',
  'workspace.sideChatDefaultTitle': 'Side chat',
  'workspace.newTerminal': 'New Terminal',
  'workspace.newTerminalDescription': 'Open a shell in the project directory in a new tab',
  'workspace.newBrowser': 'Browser Baru',
  'workspace.newBrowserDescription': 'Buka tab browser bawaan untuk situs referensi dan tugas browser',
  'workspace.newSketchDescription': 'Buat sketsa tata letak dan catatan cepat sebagai konteks desain untuk agen',
  'workspace.terminalStarting': 'Memulai terminal…',
  'workspace.terminalStartingDescription': 'Menyiapkan shell proyek. Biasanya hanya butuh beberapa detik.',
  'workspace.terminalSessionEnded': 'Session ended',
  'workspace.terminalReconnecting': 'Reconnecting…',
  'workspace.terminalStartFailed': 'Could not start the terminal session',
  'workspace.terminalRestart': 'Restart',
  'designFiles.title': 'File desain',
  'designFiles.upload': 'Upload file',
  'designFiles.pasteText': 'Tempel sebagai file teks',
  'designFiles.newSketch': 'Sketsa baru',
  'designFiles.newDocument': 'Dokumen baru',
  'designFiles.newDocumentTitle': 'Buat dokumen Markdown baru',
  'designFiles.empty': 'Belum ada file desain.',
  'designFiles.buildingPreview': 'Pratinjau layar penuh',
  'designFiles.syncing': 'Menyinkronkan file yang dibagikan tim…',
  'designFiles.refresh': 'Refresh',
  'designFiles.delete': 'Hapus',
  'designFiles.searchPlaceholder': 'Cari file...',
  'designFiles.up': 'Naik',
  'designFiles.back': 'Kembali',
  'designFiles.crumbs': 'Proyek',
  'designFiles.rowMenu': 'Menu baris',
  'designFiles.openInTab': 'Buka di tab',
  'designFiles.download': 'Unduh',
  'designFiles.downloadSelected': 'Unduh {n} sebagai ZIP',
  'designFiles.deleteSelected': 'Hapus {n}',
  'designFiles.clearSelection': 'Bersihkan',
  'designFiles.selectPage': 'Pilih semua di halaman',
  'designFiles.selectAll': 'Pilih semua',
  'designFiles.dropTitle': 'Lepaskan file di sini',
  'designFiles.dropDesc': 'Upload file desain, gambar, dokumen, atau aset lain ke proyek ini.',
  'designFiles.dropLabel': 'Letakkan berkas di sini',
  'designFiles.upload.title': 'Upload file',
  'designFiles.paste.title': "Tempel teks sebagai file",
  'designFiles.upload.label': 'Upload',
  'designFiles.paste.label': "Tempel",
  'designFiles.documentTemplate.titleFallback': 'Document',
  'designFiles.documentTemplate.goalHeading': 'Goal',
  'designFiles.documentTemplate.goalBody': 'Describe what OpenDesign should generate, edit, or decide from this document.',
  'designFiles.documentTemplate.capabilitiesHeading': 'How to use this document',
  'designFiles.documentTemplate.capabilityMarkdown': 'Use any Markdown format: headings, tables, checklists, links, quotes, code blocks, and images.',
  'designFiles.documentTemplate.capabilityAgent': 'The OpenDesign agent can read, edit, and use this file as project context.',
  'designFiles.documentTemplate.capabilityImages': 'Paste images, or drag image files onto the editor; uploaded images are inserted at the cursor.',
  'designFiles.documentTemplate.scenarioHeading': 'Scenario guide',
  'designFiles.documentTemplate.scenario.prototype': 'For prototypes, outline the product goal, target users, flows, screens, modules, interaction states, responsive breakpoints, and design tokens such as color, type, spacing, radius, and motion.',
  'designFiles.documentTemplate.scenario.wireframe': 'For wireframes, describe the user flow, screen list, layout hierarchy, content blocks, low-fidelity constraints, and the questions the structure should answer before visual design.',
  'designFiles.documentTemplate.scenario.mobile': 'For mobile apps, list target platforms, screens, navigation model, gestures, native patterns, device sizes, states, and mobile design tokens.',
  'designFiles.documentTemplate.scenario.slideDeck': 'For slides, write a paginated PPT outline: one section per slide with title, purpose, key message, evidence, visual direction, speaker notes, and export needs.',
  'designFiles.documentTemplate.scenario.document': 'For documents, define audience, tone, section structure, source material, citations or data, layout expectations, and PDF/export requirements.',
  'designFiles.documentTemplate.scenario.image': 'For images, specify subject, aspect ratio, composition, visual style, brand tokens, reference files, and negative constraints.',
  'designFiles.documentTemplate.scenario.video': 'For video, draft a storyboard with scenes, timing, captions, motion, assets, audio notes, and output format.',
  'designFiles.documentTemplate.scenario.hyperframes': 'For HyperFrames, describe the HTML motion piece: scenes, timeline, captions, audio-reactive moments, transitions, and capture/export requirements.',
  'designFiles.documentTemplate.scenario.audio': 'For audio, define voice or music direction, duration, mood, script or copy, pacing, pronunciation notes, and final use.',
  'designFiles.documentTemplate.scenario.liveArtifact': 'For live artifacts, describe data sources, refresh cadence, widgets, filters, interactions, empty/loading/error states, and any alerts or automations.',
  'designFiles.documentTemplate.scenario.designSystem': 'For design systems, list brand goals, tokens, typography, color, spacing, components, assets, references, and rules to follow or avoid.',
  'designFiles.documentTemplate.scenario.default': 'Describe the audience, deliverable, required content, references, constraints, and what done should look like.',
  'designFiles.documentTemplate.nextHeading': 'Next step',
  'designFiles.documentTemplate.nextBody': 'Review and edit this document, then ask OpenDesign to generate, revise, or operate from it.',

  'designFiles.projectMenu': 'Project actions',
  'designFiles.createDesignSystemFromProject': 'Create design system from this project',
  'designFiles.duplicateProject': 'Duplicate project',

  'designFiles.previewOpen': 'Buka',
  'designFiles.previewClose': 'Tutup pratinjau',
  'designFiles.modified': 'Diubah {time} - {size}',
  'designFiles.weeksAgo': '{n} minggu lalu',
  'designFiles.groupBy': 'Kelompokkan menurut',
  'designFiles.groupByKind': 'Jenis',
  'designFiles.groupByModified': 'Diubah',
  'designFiles.filterBy': 'Filter menurut jenis',
  'designFiles.filterClear': 'Bersihkan',
  'designFiles.filterCount': '{n} jenis',
  'designFiles.expandGroup': 'Perluas',
  'designFiles.collapseGroup': 'Ciutkan',
  'designFiles.sectionPages': 'Halaman',
  'designFiles.sectionScripts': 'Skrip',
  'designFiles.sectionImages': 'Gambar',
  'designFiles.sectionSketches': 'Sketsa',
  'designFiles.sectionLiveArtifacts': 'Live artifact',
  'designFiles.sectionOther': 'Lainnya',
  'designFiles.modifiedToday': 'Hari ini',
  'designFiles.modifiedYesterday': 'Kemarin',
  'designFiles.modifiedPrevious7Days': '7 hari sebelumnya',
  'designFiles.modifiedPrevious30Days': '30 hari sebelumnya',
  'designFiles.modifiedOlder': 'Lebih lama',
  'designFiles.showMore': 'Tampilkan +{n} lagi',
  'designFiles.kindHtml': 'Halaman HTML',
  'designFiles.kindImage': 'Gambar',
  'designFiles.kindSketch': 'Sketsa',
  'designFiles.kindText': 'Teks',
  'designFiles.kindCode': 'Skrip',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Dokumen',
  'designFiles.kindPresentation': 'Presentasi',
  'designFiles.kindSpreadsheet': 'Spreadsheet',
  'designFiles.kindLiveArtifact': 'Live artifact',
  'designFiles.kindBinary': 'Biner',
  'designFiles.kindFolder': 'Folder',
  'designFiles.folderCount': '{n} file',
  'designFiles.newFolderTitle': 'Folder baru',
  'designFiles.newFolderLabel': 'Nama folder',
  'designFiles.moveTitle': 'Pindahkan ke folder',
  'designFiles.moveLabel': 'Folder tujuan',
  'designFiles.moveRoot': 'Akar proyek',
  'designFiles.moveNewFolder': 'Folder baru…',
  'designFiles.move': 'Pindahkan',
  'designFiles.copyPath': 'Salin jalur',
  'designFiles.copiedPath': 'Jalur disalin',
  'designFiles.copyLocalPath': 'Salin jalur file lokal',
  'designFiles.copiedLocalPath': 'Jalur file lokal disalin',
  'designFiles.deleteFolderConfirm': 'Hapus folder "{name}" beserta seluruh isinya?',
  'designFiles.folderCreated': 'Folder "{name}" dibuat',
  'designFiles.folderDeleted': 'Folder "{name}" dihapus',
  'designFiles.filesMoved': 'Memindahkan {n} ke {dest}',
  'designFiles.colName': 'Nama',
  'designFiles.colKind': 'Jenis',
  'designFiles.colModified': 'Diubah',
  'designFiles.perPage': 'Tampilkan',
  'designFiles.all': 'Semua',
  'designFiles.prev': 'Sebelumnya',
  'designFiles.next': 'Berikutnya',
  'designFiles.jumpToPage': 'Lompat ke halaman',
  'designFiles.pageInfo': '{start}–{end} dari {total}',
  'designFiles.sectionFolders': 'Folders',
  'designFiles.sectionStylesheets': 'Stylesheets',
  'designFiles.sectionDocuments': 'Documents',
  'designFiles.kindStylesheet': 'Stylesheet',
  'designFiles.modifiedExt': 'Modified {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'Useful info',
  'designFiles.usefulInfoTip': 'Double-click any file to open it in a full tab.',
  'designFiles.usefulInfoTip2': 'Ketik @ di obrolan untuk merujuk berkas sebagai konteks.',
  'designFiles.usefulInfoTip4': 'Pilih design system agar hasil tetap sesuai gaya brand.',
  'designFiles.usefulInfoTip5': 'Belum ada ide? Coba template plugin di Komunitas pada halaman Beranda.',
  'designFiles.usefulInfoTip6': 'Ada pertanyaan atau saran? Gabung Discord kami.',
  'designFiles.usefulInfoTip7': 'Suka OpenDesign? Beri kami bintang di GitHub.',
  'designFiles.usefulInfoTip8': 'Ikuti @OpenDesignHQ di X untuk kabar terbaru.',
  'designFiles.usefulInfoTip9': 'Seret gambar, dokumen, atau seluruh folder ke panel ini — agen akan memakainya sebagai konteks.',
  'designFiles.usefulInfoTip10': 'Klik Sketsa baru, gambar tata letak kasar, dan biarkan agen membuatnya.',
  'designFiles.usefulInfoTip11': 'Pilih elemen apa pun di pratinjau untuk berkomentar — agen akan mengubahnya secara terarah.',
  'designFiles.usefulInfoTip12': 'Hasil kurang pas? Menandai elemen lebih cepat daripada menjelaskan ulang.',
  'designFiles.usefulInfoTip13': 'Ekspor desain apa pun ke PDF, gambar, atau HTML mandiri dalam sekali klik.',
  'designFiles.usefulInfoTip14': 'Puas dengan proyek? Simpan sebagai template lewat menu Bagikan.',
  'designFiles.usefulInfoTip15': 'Setelah deploy, langsung buat kartu berbagi media sosial.',
  'designFiles.usefulInfoTip16': 'Ikuti @opendesign.ai di Threads untuk update di balik layar.',
  'designFiles.usefulInfoTip17': 'Ikuti @opendesign.ai di Instagram untuk inspirasi desain.',
  'designFiles.usefulInfoTip18': 'Berlangganan OpenDesign di YouTube untuk tutorial dan demo.',
  'designFiles.usefulInfoTip19': 'Ikuti OpenDesign di LinkedIn untuk kabar produk.',
  'designFiles.usefulInfoTip20': 'Ikuti OpenDesign di Xiaohongshu untuk tips dan inspirasi.',
  'quickSwitcher.placeholder': 'Buka file...',
  'quickSwitcher.empty': 'Tidak ada file di proyek ini',
  'quickSwitcher.noMatches': 'Tidak ada yang cocok',
  'quickSwitcher.navigate': 'navigasi',
  'quickSwitcher.open': 'buka',
  'quickSwitcher.close': 'tutup',
  'sketch.save': 'Simpan',
  'sketch.cancel': 'Batal',
  'sketch.saving': 'Menyimpan...',
  'sketch.saved': 'Tersimpan',
  'sketch.tooltipMainMenu': 'Menu utama: simpan, ekspor, bantuan, dan pengaturan kanvas',
  'sketch.tooltipLock': "Keep the current drawing tool active for repeated use",
  'sketch.tooltipHand': "Pan the canvas without selecting objects",
  'sketch.tooltipSelection': "Select, move, resize, or edit objects on the canvas",
  'sketch.tooltipRectangle': "Draw a rectangle or card area",
  'sketch.tooltipDiamond': "Draw a diamond for decisions or branching structure",
  'sketch.tooltipEllipse': "Draw a circle or ellipse",
  'sketch.tooltipArrow': "Draw a directional connector or flow arrow",
  'sketch.tooltipLine': "Draw a straight divider or connector line",
  'sketch.tooltipFreedraw': "Draw freehand lines on the canvas",
  'sketch.tooltipText': "Add editable text to the canvas",
  'sketch.tooltipImage': "Insert an image into the canvas",
  'sketch.tooltipEraser': "Erase objects from the canvas",
  'sketch.tooltipFrame': "Create a frame to group a region of the canvas",
  'sketch.tooltipEmbeddable': "Web Embed only supports valid https:// or http:// links",
  'sketch.tooltipLaser': "Point at canvas content temporarily without changing it",
  'sketch.tooltipMoreTools': "Open additional tools such as frame, web embed, and laser pointer",
  'sketch.tooltipDirty': 'Ada perubahan belum disimpan',
  'sketch.tooltipClean': 'Tersimpan',
  'fileViewer.empty': 'Pilih file untuk dilihat.',
  'fileViewer.loading': 'Memuat file...',
  'fileViewer.exportPptx': 'Ekspor PPTX',
  'fileViewer.openInNewTab': 'Buka di tab baru',
  'fileViewer.copyPath': 'Salin path',
  'fileViewer.copied': 'Tersalin',
  'fileViewer.share': 'Bagikan',
  'fileViewer.binaryMeta': 'Biner - {size}',
  'fileViewer.binaryNote': 'Berkas biner ({size} byte). Unduh atau buka dari disk untuk memeriksanya.',
  'fileViewer.pdfMeta': 'PDF - {size}',
  'fileViewer.documentMeta': 'Dokumen',
  'fileViewer.presentationMeta': 'Presentasi',
  'fileViewer.spreadsheetMeta': 'Spreadsheet',
  'fileViewer.previewUnavailable': 'Pratinjau tidak tersedia untuk file ini.',
  'fileViewer.download': 'Unduh',
  'fileViewer.open': 'Buka',
  'fileViewer.imageMeta': 'Gambar - {size}',
  'fileViewer.reactMeta': 'Komponen React - {size}',
  'fileViewer.sketchMeta': 'Sketsa - {size}',
  'fileViewer.markdownStreamingMeta': 'Memuat pratinjau...',
  'fileViewer.markdownErrorMeta': 'Pratinjau mungkin belum lengkap (error generasi).',
  'fileViewer.markdownStreamingStatus': 'Memuat... menampilkan markdown sebagian.',
  'fileViewer.markdownErrorStatus': 'Error generasi. Menampilkan konten terakhir yang tersedia.',
  'fileViewer.markdownSaving': "Saving...",
  'fileViewer.markdownSaveFailed': "Save failed",
  'fileViewer.markdownSaved': "Saved",
  'fileViewer.markdownAutoSaved': "Auto-saved · {time}",
  'fileViewer.markdownAutoSaveHint': "Auto-save on",
  'fileViewer.markdownViewMode': "Markdown view mode",
  'fileViewer.split': "Split",
  'fileViewer.markdownEditor': "Markdown editor",
  'fileViewer.markdownEditorPlaceholder': "Type notes, requirements, or instructions for this document...",
  'fileViewer.markdownPreview': "Markdown preview",
  'fileViewer.videoMeta': 'Video - {size}',
  'fileViewer.audioMeta': 'Audio - {size}',
  'fileViewer.reload': 'Muat ulang',
  'fileViewer.reloadDisk': 'Muat ulang dari disk',
  'fileViewer.copy': 'Salin',
  'fileViewer.copyTitle': 'Salin konten',
  'fileViewer.saveDisabled': 'Tidak ada perubahan untuk disimpan',
  'fileViewer.save': 'Simpan',
  'fileViewer.preview': 'Pratinjau',
  'fileViewer.source': 'Sumber',
  'fileViewer.tweaks': 'Tweaks',
  'fileViewer.tweaksUnavailable': 'Tidak ada panel tweaks pada artefak ini',
  'fileViewer.jsxModuleTitle': 'Tidak ada pratinjau mandiri',
  'fileViewer.jsxModuleBody': 'File ini adalah modul komponen yang dimuat oleh halaman lain.',
  'fileViewer.jsxModuleCta': 'Buka halaman yang merendernya:',
  'fileViewer.comment': 'Komentar',
  'fileViewer.edit': 'Edit',
  'fileViewer.draw': 'Gambar',
  'fileViewer.mark': 'Mark',
  'fileViewer.markTool': 'Mark tool',
  'fileViewer.boxSelect': 'Box select',
  'fileViewer.textTool': 'Teks',
  'fileViewer.textAnnotationRemove': 'Hapus teks',
  'fileViewer.screenshot': 'Screenshot',
  'fileViewer.versions.entry': 'Versi',
  'fileViewer.versions.entryFull': 'Riwayat versi',
  'fileViewer.versions.title': 'Versi',
  'fileViewer.versions.countOne': '1 versi',
  'fileViewer.versions.countMany': '{count} versi',
  'fileViewer.versions.current': 'Saat ini',
  'fileViewer.versions.sourceAi': 'AI edit',
  'fileViewer.versions.sourceManual': 'Manual edit',
  'fileViewer.versions.sourceRestore': 'Restored',
  'fileViewer.versions.restoredFrom': 'Restored from v{version}',
  'fileViewer.versions.versionLabel': 'Versi {version}',
  'fileViewer.versions.listAria': 'Versi file',
  'fileViewer.versions.loading': 'Memuat versi...',
  'fileViewer.versions.empty': 'Belum ada versi.',
  'fileViewer.versions.loadFailed': 'Tidak dapat memuat versi.',
  'fileViewer.versions.previewFailed': 'Tidak dapat memuat pratinjau versi ini.',
  'fileViewer.versions.previewLoading': 'Memuat pratinjau versi...',
  'fileViewer.versions.noPrompt': 'Tidak ada prompt yang direkam',
  'fileViewer.versions.noPromptBody': 'Tidak ada prompt yang direkam untuk versi ini.',
  'fileViewer.versions.promptTitle': 'Prompt',
  'fileViewer.versions.copyPrompt': 'Salin prompt',
  'fileViewer.versions.fullscreen': 'Pratinjau layar penuh',
  'fileViewer.versions.open': 'Buka pratinjau di jendela baru',
  'fileViewer.versions.currentHelp': 'Ini sudah versi saat ini.',
  'fileViewer.versions.restoreHelp': 'Beralih akan memulihkan HTML ini sebagai versi saat ini yang baru.',
  'fileViewer.versions.restore': 'Beralih ke versi ini',
  'fileViewer.versions.restoreConfirmTitle': 'Beralih ke versi ini?',
  'fileViewer.versions.restoreConfirmCta': 'Beralih',
  'fileViewer.versions.restoring': 'Beralih...',
  'fileViewer.versions.restoreFailed': 'Tidak dapat beralih ke versi ini.',
  'fileViewer.versions.restoreSuccess': 'Beralih ke versi ini.',
  'fileViewer.editScreenshotToChat': 'Screenshot ke chat',
  'manualEdit.layers': 'Lapisan',
  'manualEdit.editableCount': '{count} dapat diedit',
  'manualEdit.hiddenBadge': 'Tersembunyi',
  'manualEdit.title': 'Editor manual',
  'manualEdit.fallbackTitle': 'Edit',
  'manualEdit.movePanel': 'Move edit panel',
  'manualEdit.editParams': 'Edit parameter',
  'manualEdit.closePanel': 'Close edit panel',
  'manualEdit.selectLayer': 'Pilih lapisan',
  'manualEdit.empty': 'Klik elemen di pratinjau atau pilih lapisan.',
  'manualEdit.noEditableLayers': 'Tidak ada lapisan yang dapat diedit.',
  'manualEdit.noClass': 'tanpa class',
  'manualEdit.tabsAria': 'Tab edit manual',
  'manualEdit.tabContent': 'Konten',
  'manualEdit.tabStyle': 'Gaya',
  'manualEdit.tabAttributes': 'Atribut',
  'manualEdit.tabHtml': 'HTML',
  'manualEdit.tabSource': 'Sumber',
  'manualEdit.attributesJson': 'JSON atribut',
  'manualEdit.selectedHtml': 'HTML elemen terpilih',
  'manualEdit.fullSource': 'Sumber artifact lengkap',
  'manualEdit.applyContent': 'Terapkan konten',
  'manualEdit.applyStyle': 'Terapkan gaya',
  'manualEdit.applyAttributes': 'Terapkan atribut',
  'manualEdit.applyHtml': 'Terapkan HTML',
  'manualEdit.applySource': 'Terapkan sumber',
  'manualEdit.invalidAttributes': 'JSON atribut tidak valid.',
  'manualEdit.changes': 'Perubahan',
  'manualEdit.undo': 'Undo',
  'manualEdit.redo': 'Redo',
  'manualEdit.noChanges': 'Belum ada edit manual.',
  'manualEdit.imageUrl': 'URL gambar',
  'manualEdit.altText': 'Teks alt',
  'manualEdit.label': 'Label',
  'manualEdit.text': 'Teks',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': 'Warna teks',
  'manualEdit.background': 'Latar belakang',
  'manualEdit.fontSize': 'Ukuran font',
  'manualEdit.weight': 'Bobot',
  'manualEdit.align': 'Rata',
  'manualEdit.textAlignLeft': 'Rata kiri',
  'manualEdit.textAlignCenter': 'Rata tengah',
  'manualEdit.textAlignRight': 'Rata kanan',
  'manualEdit.padding': 'Padding',
  'manualEdit.margin': 'Margin',
  'manualEdit.radius': 'Radius',
  'manualEdit.referenceValues': 'Nilai referensi',
  'manualEdit.referenceValuesEmpty': 'Tidak ada nilai referensi yang cocok',
  'manualEdit.referenceValuesLoading': 'Memuat…',
  'manualEdit.lineHeight': 'Tinggi baris',
  'manualEdit.letterSpacing': 'Spasi huruf',
  'manualEdit.borderStyle': 'Gaya batas',
  'manualEdit.borderStyleSolid': 'Solid',
  'manualEdit.borderStyleDashed': 'Putus-putus',
  'manualEdit.borderStyleDotted': 'Titik-titik',
  'manualEdit.borderStyleDouble': 'Ganda',
  'manualEdit.borderStyleNone': 'Tidak ada',
  'manualEdit.border': 'Border',
  'manualEdit.width': 'Lebar',
  'manualEdit.minHeight': 'Tinggi minimum',
  'manualEdit.deleteElement': 'Hapus elemen',
  'manualEdit.deleteElementConfirm': 'Hapus elemen yang dipilih? Ini dapat dibatalkan dengan Urungkan.',
  'manualEdit.alignCenter': "Center",
  'manualEdit.opacity': "Opacity",
  'manualEdit.uploadImage': 'Unggah gambar',
  'manualEdit.uploadingImage': 'Mengunggah gambar…',
  'manualEdit.uploadImageFailed': 'Tidak dapat mengunggah gambar.',
  'manualEdit.focusSlides': 'Fokus slide',
  'manualEdit.showPanels': 'Tampilkan panel',
  'manualEdit.parameters': "Parameters",
  'manualEdit.fontFamily': "Font",
  'manualEdit.borderColor': "Border color",
  'manualEdit.borderWidth': "Border width",
  'manualEdit.height': "Height",
  'manualEdit.sideTop': "Top",
  'manualEdit.sideBottom': "Bottom",
  'manualEdit.sideLeft': "Left",
  'manualEdit.sideRight': "Right",
  'manualEdit.layoutDirection': "Direction",
  'manualEdit.distribution': "Distribution",
  'manualEdit.gap': "Gap",
  'manualEdit.layoutUnavailable': "Layout controls are available for flex or grid containers.",
  'manualEdit.directionRow': "Horizontal",
  'manualEdit.directionRowReverse': "Horizontal reverse",
  'manualEdit.directionColumn': "Vertical",
  'manualEdit.directionColumnReverse': "Vertical reverse",
  'manualEdit.justifyStart': "Start",
  'manualEdit.justifyCenter': "Center",
  'manualEdit.justifyEnd': "End",
  'manualEdit.justifyBetween': "Space between",
  'manualEdit.justifyAround': "Space around",
  'manualEdit.justifyEvenly': "Space evenly",
  'manualEdit.alignStart': "Start",
  'manualEdit.alignEnd': "End",
  'manualEdit.alignStretch': "Stretch",
  'manualEdit.alignBaseline': "Baseline",
  'fileViewer.zoomOut': 'Perkecil',
  'fileViewer.zoomIn': 'Perbesar',
  'fileViewer.resetZoom': 'Atur ulang zoom',
  'fileViewer.viewportAria': 'Preview viewport',
  'fileViewer.viewportDesktop': 'Desktop',
  'fileViewer.viewportDesktopTitle': 'Full-width desktop preview',
  'fileViewer.viewportTablet': 'Tablet',
  'fileViewer.viewportTabletTitle': 'Tablet preview at 820 × 1180 (modern portrait baseline)',
  'fileViewer.viewportMobile': 'Mobile',
  'fileViewer.viewportMobileTitle': 'Mobile preview at 390 × 844',
  'fileViewer.reloadAria': 'Muat ulang file',
  'fileViewer.previousSlide': 'Slide sebelumnya',
  'fileViewer.nextSlide': 'Slide berikutnya',
  'fileViewer.slideNavAria': 'Navigasi slide',
  'fileViewer.speakerNotes': 'Catatan pembicara',
  'fileViewer.speakerNotesSlide': 'Slide {current} / {total}',
  'fileViewer.speakerNotesEmpty': 'Tidak ada catatan pembicara untuk slide ini.',
  'fileViewer.speakerNotesEdit': 'Edit',
  'fileViewer.speakerNotesSave': 'Simpan catatan',
  'fileViewer.speakerNotesSaving': 'Menyimpan…',
  'fileViewer.speakerNotesSaved': 'Tersimpan',
  'fileViewer.speakerNotesSaveFailed': 'Tidak dapat menyimpan catatan pembicara.',
  'fileViewer.speakerNotesPlaceholder': 'Tambahkan catatan pembicara untuk slide ini…',
  'fileViewer.previewAssetBlockedTitle': 'Aset pratinjau diblokir',
  'fileViewer.previewAssetBlockedDetail': '{filePath} tidak dapat dimuat. Ganti symlink eksternal dengan file di dalam proyek ini.',
  'fileViewer.presenterReset': 'Atur ulang',
  'fileViewer.present': 'Presentasikan',
  'fileViewer.presentInTab': 'Presentasikan di tab',
  'fileViewer.presentFullscreen': 'Presentasi layar penuh',
  'fileViewer.presentNewTab': 'Presentasi di tab baru',
  'fileViewer.presentFromBeginning': 'Mulai dari awal',
  'fileViewer.presentFromCurrentSlide': 'Mulai dari slide saat ini',
  'fileViewer.presenterMode': 'Mode penyaji',
  'fileViewer.exitPresentation': 'Keluar presentasi',
  'fileViewer.shareLabel': 'Bagikan',
  'fileViewer.shareMenuShareLink': 'BAGIKAN',
  'fileViewer.shareMenuPublishOnline': 'BAGIKAN DI HOSTING SENDIRI',
  'fileViewer.shareMenuDownload': 'UNDUH',
  'fileViewer.shareMenuPresentation': 'Presentasi',
  'fileViewer.shareMenuSourceFiles': 'File sumber',
  'fileViewer.shareMenuSave': 'SIMPAN',
  'fileViewer.shareMenuPublishViaOd': 'BAGIKAN CEPAT · OPENDESIGN',
  'fileViewer.unifiedShareAria': 'Share and export actions',
  'fileViewer.unifiedShareTab': 'Share',
  'fileViewer.unifiedExportTab': 'Export',
  'fileViewer.unifiedSendTab': 'Send to...',
  'fileViewer.openFileForHistory': 'Open a file to view version history',
  'fileViewer.workspaceShareTitle': 'Share project in workspace',
  'fileViewer.workspaceSharePrivateDescription': 'Only you can access this project. Choose workspace members to share it with the team.',
  'fileViewer.workspaceShareWorkspaceDescription': 'Members of this workspace can access this project.',
  'fileViewer.workspaceAccessPrivate': 'Only me',
  'fileViewer.workspaceAccessMembers': 'Workspace members',
  'fileViewer.publishSingleFileTitle': 'Dapatkan tautan berbagi',
  'fileViewer.publishSingleFileDescription': 'Siapa pun dengan tautan dapat melihatnya secara online. Saat ini hanya satu file yang dapat dibagikan — aset lokal tersemat seperti gambar belum didukung.',
  'fileViewer.openFileRequired': 'Open a file to use this.',
  'fileViewer.publishFile': 'Publish file',
  'fileViewer.publishingFile': 'Membuat tautan…',
  'fileViewer.unpublishFile': 'Hentikan berbagi',
  'fileViewer.shareEmptyStateTitle': 'Belum ada yang bisa dibagikan',
  'fileViewer.shareEmptyStateDescription': 'Buat atau gabung ke tim untuk membagikan file ini ke rekan tim',
  'fileViewer.shareEmptyStateCreateTeam': 'Buat tim',
  'fileViewer.shareTeamMissingTitle': 'Belum ada tim untuk berbagi',

  'fileViewer.publishFileRequiresTeam': 'Menerbitkan tautan publik memerlukan ruang kerja tim. Beralihlah ke ruang kerja tim, atau gunakan Deploy untuk menerbitkan berkas ini.',
  'fileViewer.publishFileRequiresWorkspace': 'Tautan berbagi memerlukan workspace yang masuk. Masuk ke OpenDesign Cloud atau bagikan file ini lewat deploy.',
  'fileViewer.publishFileFailed': 'Tidak dapat membuat tautan berbagi. Coba lagi atau gunakan opsi deploy di bawah.',
  'fileViewer.workspaceShareSuccess': 'Shared with workspace members',
  'fileViewer.workspaceShareFailed': 'Could not share with workspace',
  'fileViewer.workspaceUnshareSuccess': 'Moved back to private',
  'fileViewer.workspaceUnshareFailed': 'Could not move back to private',
  'fileViewer.readonlySharedNoExport': 'Shared project is read-only: you can comment, but cannot edit or export.',
  'fileViewer.copyShareLink': 'Salin tautan berbagi',
  'fileViewer.openSharePage': 'Buka halaman berbagi',
  'fileViewer.shareLinkRequiresDeploy': 'Publikasikan online terlebih dahulu untuk mendapatkan tautan',
  'fileViewer.shareLinkPublishGuide': 'Publikasikan online di atas untuk mengaktifkan berbagi ↑',
  'fileViewer.shareAfterGenerationComplete': 'Berbagi tersedia setelah pembuatan selesai',
  'fileViewer.copyProviderLink': 'Copy {provider} link',
  'fileViewer.copyCloudflareLink': 'Copy Cloudflare link',
  'fileViewer.screenshotCopying': 'Copying screenshot...',
  'fileViewer.screenshotCopied': 'Screenshot copied to clipboard',
  'fileViewer.screenshotClipboardDenied': 'Browser blocked clipboard access',
  'fileViewer.screenshotPreviewLoading': 'Preview is still loading. Try again in a moment.',
  'fileViewer.screenshotCaptureFailed': 'Could not capture the preview. Please try again.',
  'fileViewer.exportPdf': 'Ekspor PDF',
  'fileViewer.exportPdfAllSlides': 'Ekspor PDF semua slide',
  'fileViewer.exportPptxBusy': 'Mengekspor PPTX...',
  'fileViewer.exportPptxHint': 'Buat deck terlebih dahulu untuk mengekspor PPTX.',
  'fileViewer.exportPptxNa': 'PPTX tidak tersedia',
  'fileViewer.exportDaemonUnreachable': 'Tidak dapat menghubungi daemon. Silakan coba lagi.',
  'fileViewer.exportZip': 'Ekspor ZIP',
  'fileViewer.exportHtml': 'Ekspor HTML',
  'fileViewer.exportMd': 'Ekspor Markdown',
  'fileViewer.exportImage': 'Ekspor gambar',
  'fileViewer.exportPptxImages': 'Ekspor sebagai PPTX (gambar)',
  'fileViewer.exportPptxEditable': 'Ekspor sebagai PPTX (dapat diedit)',
  'fileViewer.exportPptxEditableHint': 'Native editable shapes & text (not pixel-perfect)',
  'fileViewer.exportPptxModalSubtitle': "Choose how to export, then download.",
  'fileViewer.exportPptxScreenshot': "Screenshot PPTX",
  'fileViewer.exportPptxScreenshotHint': "One image per slide — pixel-perfect, but not editable.",
  'fileViewer.exportPptxConfirm': "Export",
  'fileViewer.exportPptxRecommended': "Recommended",
  'fileViewer.exportingProgress': 'Mengekspor…',
  'fileViewer.exportSlideProgress': 'Mengekspor slide {current}/{total}…',
  'fileViewer.exportingElapsed': 'Mengekspor… {seconds}d',
  'fileViewer.exportSlideEta': 'Slide {current}/{total} · ~{seconds}d lagi',
  'fileViewer.exportFailedTitle': 'Ekspor gagal',
  'fileViewer.exportFailedDescription': 'Ekspor ini belum selesai. Silakan coba lagi.',
  'fileViewer.exportDone': 'Ekspor selesai',
  'fileViewer.exportImageFailed': 'Gagal menangkap gambar. Silakan coba lagi atau gunakan alat tangkapan layar browser Anda.',
  'fileViewer.exportImageModalSubtitle': 'Pilih format, lalu unduh pratinjau saat ini sebagai gambar.',
  'fileViewer.exportImageFormatLabel': 'Format',
  'fileViewer.exportImageSaving': 'Menyimpan gambar…',
  'fileViewer.exportImageSaved': 'Gambar tersimpan',
  'fileViewer.exportImageDownloadStarted': 'Unduhan dimulai',
  'fileViewer.exportImageDownloadDetails': '{filename} ada di unduhan browser jika dialog Simpan Sebagai tidak muncul.',
  'fileViewer.exportJsx': 'Ekspor JSX',
  'fileViewer.exportReactHtml': 'Ekspor React HTML',
  'fileViewer.exportStarted': 'Export started',
  'fileViewer.saveAsTemplate': 'Simpan sebagai templat',
  'fileViewer.savingTemplate': 'Menyimpan templat...',
  'fileViewer.savedTemplate': 'Disimpan sebagai "{name}"',
  'fileViewer.savedTemplateFail': 'Gagal menyimpan templat',
  'fileViewer.templateNamePrompt': 'Nama templat',
  'fileViewer.templateNameDefault': 'Templat baru',
  'fileViewer.templateDescPrompt': 'Deskripsi templat',
  'liveArtifact.refresh.button': 'Refresh',
  'liveArtifact.refresh.buttonTitle': 'Refresh live artifact ini',
  'liveArtifact.refresh.loadingTitle': 'Memuat live artifact...',
  'liveArtifact.refresh.noSourceTitle': 'Belum ada sumber refresh yang tersedia.',
  'liveArtifact.refresh.running': 'Memperbarui...',
  'liveArtifact.refresh.runningMessage': 'Memperbarui data dan pratinjau. Ini bisa butuh waktu sebentar.',
  'liveArtifact.refresh.runningAction': 'Pratinjau sebelumnya tetap terlihat sampai refresh berhasil.',
  'liveArtifact.refresh.successOne': 'Refresh selesai. Data diperbarui.',
  'liveArtifact.refresh.successMany': 'Refresh selesai. Data diperbarui.',
  'liveArtifact.refresh.successAction': 'Pratinjau sudah dimuat ulang dengan data committed terbaru.',
  'liveArtifact.refresh.previousFailure': 'Refresh sebelumnya gagal: {message}',
  'liveArtifact.refresh.failureAction': 'Periksa riwayat refresh, perbaiki sumber atau masalah izin, lalu coba lagi.',
  'liveArtifact.refresh.networkFailure': 'Permintaan refresh gagal. Periksa koneksi lalu coba lagi.',
  'liveArtifact.refresh.genericFailure': 'Refresh gagal.',
  'liveArtifact.refresh.statusNever': 'Tidak bisa di-refresh',
  'liveArtifact.refresh.statusReady': 'Siap di-refresh',
  'liveArtifact.refresh.statusSucceeded': 'Sudah terbaru',
  'liveArtifact.refresh.statusFailed': 'Refresh gagal',
  'liveArtifact.refresh.statusRunning': 'Menyegarkan',
  'liveArtifact.refresh.statusRunningDescription': 'Proses penyegaran sedang berlangsung.',
  'liveArtifact.refresh.statusSucceededDescription': 'Penyegaran terakhir selesai dengan sukses.',
  'liveArtifact.refresh.statusFailedDescription': 'Upaya penyegaran terakhir tidak selesai dengan sukses.',
  'liveArtifact.refresh.statusReadyDescription': 'Sumber yang dapat disegarkan telah dikonfigurasi tetapi tidak ada proses yang berlangsung.',
  'liveArtifact.refresh.statusNeverDescription': 'Artefak langsung ini belum memiliki sumber penyegaran.',
  'liveArtifact.refresh.eventStarted': 'Dimulai',
  'liveArtifact.refresh.eventSucceeded': 'Berhasil',
  'liveArtifact.refresh.eventFailed': 'Gagal',
  'liveArtifact.refresh.eventStartedDetail': 'Penyegaran dimulai…',
  'liveArtifact.refresh.sourcesUpdatedOne': '{n} sumber diperbarui',
  'liveArtifact.refresh.sourcesUpdatedMany': '{n} sumber diperbarui',
  'liveArtifact.refresh.timelineEmpty': 'Belum ada aktivitas penyegaran dalam sesi ini. Picu Segarkan untuk merekam linimasa, atau tunggu proses otomatis.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'Terakhir disegarkan',
  'liveArtifact.refresh.heroLastRefreshedNever': 'Tidak pernah',
  'liveArtifact.refresh.justNow': 'baru saja',
  'liveArtifact.refresh.factCreated': 'Dibuat',
  'liveArtifact.refresh.factLastUpdated': 'Terakhir diperbarui',
  'liveArtifact.refresh.factUnknown': 'Tidak diketahui',
  'liveArtifact.refresh.persistedTitle': 'Riwayat penyegaran yang dipertahankan',
  'liveArtifact.refresh.persistedHint': 'Entri dimuat dari refreshes.jsonl',
  'liveArtifact.refresh.persistedEmpty': 'Belum ada riwayat penyegaran yang dipertahankan.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'berhasil',
  'liveArtifact.refresh.persistedStatusRunning': 'berjalan',
  'liveArtifact.refresh.persistedStatusFailed': 'gagal',
  'liveArtifact.refresh.persistedStatusCancelled': 'dibatalkan',
  'liveArtifact.refresh.persistedStatusSkipped': 'dilewati',
  'liveArtifact.refresh.sessionTitle': 'Aktivitas sesi',
  'liveArtifact.refresh.sessionHint': 'Peristiwa yang teramati saat tab ini terbuka',
  'liveArtifact.refresh.docSourceTitle': 'Sumber dokumen',
  'liveArtifact.refresh.docSourceHint': 'Sumber dikonfigurasi',
  'liveArtifact.refresh.docSourceType': 'Tipe',
  'liveArtifact.refresh.docSourceTool': 'Alat',
  'liveArtifact.refresh.docSourceConnector': 'Konektor',
  'liveArtifact.refresh.debugSummary': 'Metadata debug lanjutan',
  'liveArtifact.refresh.debugNote': 'Dapat mencakup ID konektor, nama file, metadata sumber, dan jalur artefak internal.',
  'liveArtifact.viewer.tabPreview': 'Preview',
  'liveArtifact.viewer.tabCode': 'Code',
  'liveArtifact.viewer.tabData': 'Data',
  'liveArtifact.viewer.tabRefreshHistory': 'Refresh history',
  'liveArtifact.viewer.dataEmpty': 'No data.json cache available.',
  'liveArtifact.viewer.code.templateHeading': 'Template HTML',
  'liveArtifact.viewer.code.renderedHeading': 'Rendered HTML',
  'liveArtifact.viewer.code.templateHelp': 'The editable template used with data.json to generate the preview.',
  'liveArtifact.viewer.code.renderedHelp': 'The generated index.html currently loaded by Preview.',
  'liveArtifact.viewer.code.variantAria': 'Code variant',
  'liveArtifact.viewer.code.variantTemplate': 'Template',
  'liveArtifact.viewer.code.variantRendered': 'Rendered',
  'liveArtifact.viewer.code.loading': 'Loading code…',
  'liveArtifact.viewer.code.unavailable': 'Code is not available yet.',
  'liveArtifact.viewer.code.empty': 'This code file is empty.',
  'fileViewer.deployToVercel': 'Deploy ke Vercel',
  'fileViewer.redeployToVercel': 'Deploy ulang ke Vercel',
  'fileViewer.deployingToVercel': 'Deploying ke Vercel...',
  'fileViewer.deployProviderLabel': 'Provider',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployTargetLabel': 'Target',
  'fileViewer.deployTargetPreview': 'Pratinjau',
  'fileViewer.deployTargetProduction': 'Produksi',
  'fileViewer.deployToProvider': 'Deploy ke {provider}',
  'fileViewer.redeployToProvider': 'Deploy ulang ke {provider}',
  'fileViewer.deployingToProvider': 'Deploying ke {provider}...',
  'fileViewer.preparingPublicLink': 'Menyiapkan link publik...',
  'fileViewer.copyDeployLink': 'Salin link deploy',
  'fileViewer.deployModalTitle': 'Deploy ke Vercel',
  'fileViewer.deployModalSubtitle': 'Masukkan token Vercel untuk membuat link publik.',
  'fileViewer.vercelToken': 'Token Vercel',
  'fileViewer.vercelTokenGetLink': 'Buat token',
  'fileViewer.vercelTokenPlaceholder': 'Tempel token Vercel',
  'fileViewer.vercelTokenReuseHint': 'Token disimpan lokal untuk deploy berikutnya.',
  'fileViewer.vercelTokenRequired': 'Token Vercel wajib diisi.',
  'fileViewer.cloudflareApiToken': 'Token API Cloudflare',
  'fileViewer.cloudflareApiTokenGetLink': 'Dapatkan token API',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Tempelkan token API Cloudflare Anda',
  'fileViewer.cloudflareApiTokenReuseHint': 'Token API Cloudflare yang tersimpan akan digunakan. Masukkan token baru untuk menggantinya.',
  'fileViewer.cloudflareApiTokenRequired': 'Masukkan dan simpan token API Cloudflare terlebih dahulu.',
  'fileViewer.cloudflareApiTokenScopeHint': 'Pilih Pages Edit saat membuat token API; domain kustom memerlukan Zone Read / DNS Edit.',
  'fileViewer.vercelTeamId': 'Team ID Vercel',
  'fileViewer.vercelTeamSlug': 'Team slug Vercel',
  'fileViewer.cloudflareAccountId': 'ID Akun',
  'fileViewer.cloudflareAccountIdHint': 'Temukan ID akun di dasbor Cloudflare.',
  'fileViewer.cloudflareAccountIdRequired': 'Masukkan dan simpan ID Akun Cloudflare terlebih dahulu.',
  'fileViewer.cloudflareZoneLabel': 'Domain',
  'fileViewer.cloudflareZonePlaceholder': 'Save Cloudflare settings to load domains',
  'fileViewer.cloudflareZoneRequired': 'Select a Cloudflare domain first.',
  'fileViewer.cloudflareZonesLoading': 'Loading Cloudflare domains…',
  'fileViewer.cloudflareZonesRefresh': 'Refresh domains',
  'fileViewer.cloudflareZonesLoadFailed': 'Could not load Cloudflare domains.',
  'fileViewer.cloudflareZonesEmpty': 'No active full Cloudflare domains were found for this account.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Subdomain prefix',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Use one DNS label only: lowercase letters, numbers, and hyphens.',
  'fileViewer.cloudflareHostnamePreview': 'Custom domain preview: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Opsional: hubungkan domain kustom. Jika dibiarkan kosong, tautan pages.dev tetap dibuat.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'pages.dev URL',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Custom domain',
  'fileViewer.optional': 'opsional',
  'fileViewer.vercelPreviewOnly': 'Buat preview deployment saja',
  'fileViewer.cloudflarePagesPreviewHint': 'Deploy Cloudflare Pages menggunakan Direct Upload.',
  'fileViewer.savingConfig': 'Menyimpan konfigurasi...',
  'fileViewer.deployConfigSaveFailed': 'Gagal menyimpan konfigurasi deploy.',
  'fileViewer.deployFailed': 'Deploy gagal.',
  'fileViewer.deployProviderConfigSaveFailed': 'Tidak dapat menyimpan pengaturan {provider}.',
  'fileViewer.deployProviderFailed': 'Deploy {provider} gagal. Periksa pengaturan dan coba lagi.',
  'fileViewer.deployResultLabel': 'Hasil deploy',
  'fileViewer.deployLinkReady': 'Siap',
  'fileViewer.deploySuccessToast': 'Deploy berhasil diunggah',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Link deploy sedang disiapkan',
  'fileViewer.deployLinkDelayed': 'Link publik belum siap. Coba lagi sebentar lagi.',
  'fileViewer.deployLinkFailed': 'Domain kustom gagal',
  'fileViewer.deployLinkProtectedLabel': 'Deployment dilindungi',
  'fileViewer.deployLinkProtected': 'Vercel meminta autentikasi untuk membuka link ini.',
  'fileViewer.retryLink': 'Coba link lagi',
  'questionForm.submit': 'Kirim',
  'questionForm.skip': 'Lewati',
  'questionForm.locked': 'Terkunci',
  'tool.openInTab': 'Buka {name} di tab',
  'tool.open': 'Buka',
  'tool.todos': 'Todo',
  'tool.todosExpand': 'Tampilkan tugas',
  'tool.todosCollapse': 'Sembunyikan tugas',
  'tool.todosDone': 'Selesai',
  'tool.todosDismiss': 'Tutup daftar tugas',
  'tool.write': 'Tulis',
  'tool.edit': 'Edit',
  'tool.read': 'Baca',
  'tool.delete': 'Hapus',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Fetch',
  'tool.search': 'Cari',
  'tool.lines': '{n} baris',
  'tool.changeSingular': 'perubahan',
  'tool.changePlural': 'perubahan',
  'tool.in': 'di {path}',
  'tool.hide': 'Sembunyikan',
  'tool.output': 'Output',
  'tool.running': 'Berjalan',
  'tool.error': 'Error',
  'tool.done': 'Selesai',
  'assistant.role': 'Asisten',
  'assistant.workingLabel': 'Sedang bekerja',
  'assistant.doneLabel': 'Selesai',
  'assistant.awaitingReplyLabel': 'Menunggu balasan',
  'assistant.canceledLabel': 'Tugas dihentikan',
  'assistant.canceledDetail': 'Proses ini telah dihentikan sesuai tindakan Anda.',
  'assistant.copyMarkdown': 'Salin',
  'assistant.forkConversation': 'Percakapan baru',
  'assistant.forkingConversation': 'Memulai percakapan baru…',
  'assistant.forkNote': 'Lanjutan dari percakapan',
  'assistant.shareToOpenDesign': 'Bagikan ke OpenDesign',
  'assistant.shareToOpenDesignBusy': 'Menyiapkan paket…',
  'assistant.feedbackPrompt': 'Masukan',
  'assistant.feedbackPositive': 'Membantu',
  'assistant.feedbackNegative': 'Tidak membantu',
  'assistant.feedbackReasonTitle': 'Tell us why',
  "assistant.feedbackReasonTitleNegative": "Apa yang salah?",
  "assistant.feedbackDiscordNegative": "Bagikan konteks lebih lanjut di {discord} agar tim bisa memahami masalahnya dan menindaklanjuti.",
  "assistant.feedbackDiscordPositive": "Bagikan karyamu ke komunitas {discord}, atau kirim tangkapan layar dan ceritakan apa yang berhasil.",
  'assistant.feedbackReasonPositiveMatched': 'Understood my request',
  'assistant.feedbackReasonPositiveVisual': 'Looks good',
  'assistant.feedbackReasonPositiveUseful': 'Useful structure',
  'assistant.feedbackReasonPositiveEasy': 'Easy to keep editing',
  'assistant.feedbackReasonPositiveDesignSystem': 'Followed the design system',
  'assistant.feedbackReasonNegativeMissed': 'Tidak mengikuti permintaan saya',
  'assistant.feedbackReasonNegativeVisual': 'Visual tidak konsisten',
  'assistant.feedbackReasonNegativeIncomplete': 'Incomplete output',
  'assistant.feedbackReasonNegativeHard': 'Hard to use',
  'assistant.feedbackReasonNegativeCouldNotRun': 'Tidak bisa dijalankan',
  'assistant.feedbackReasonNegativeTooSlow': 'Terlalu lambat',
  'assistant.feedbackReasonNegativeDesignSystem': 'Did not follow the design system',
  'assistant.feedbackReasonOther': 'Other',
  'assistant.feedbackReasonPlaceholder': 'Tambahkan sesuatu (opsional)',
  'assistant.feedbackReasonSubmit': 'Submit',
  "assistant.emptyResponseLabel": "Tugas tidak dapat diselesaikan",
  "assistant.emptyResponseMessage": "Tugas ini gagal dijalankan. Coba lagi. Jika gagal lagi, hubungi dukungan.",
  'assistant.unfinishedLabel': 'Tugas belum selesai',
  'assistant.unfinishedDetail': 'Masih ada {n} item yang belum selesai dalam tugas ini.',
  'assistant.unfinishedSummary': '{n} tugas tersisa',
  'assistant.unfinishedMore': '+{n} lagi',
  'assistant.continueRemaining': 'Lanjutkan',
  'chat.resumeRunCta': 'Lanjutkan proses',
  'chat.runError.contactSupportCta': "Hubungi kami",
  'chat.runError.exportLogsCta': "Ekspor log",
  'chat.runError.switchModelCta': "Ganti model",
  'chat.runError.openSettingsCta': 'Buka pengaturan',
  "chat.runError.title.readOnlyAccess": "Tidak ada izin untuk mengedit proyek",
  "chat.runError.title.messagesUnavailable": "Konten percakapan gagal dimuat",
  "chat.runError.actionBlocked.readOnly": "Saat ini Anda hanya memiliki akses untuk melihat proyek ini dan tidak dapat menjalankan tugas.",
  "chat.runError.actionBlocked.messagesUnavailable": "Percakapan tidak dapat dibaca saat ini. Coba lagi. Jika kembali gagal, hubungi dukungan.",
  'chat.runError.actionBlocked.billing': "Kami masih memastikan ruang kerja mana yang membayar proyek ini. Coba lagi sebentar.",
  'chat.runError.actionBlocked.busy': "Percakapan ini masih menjalankan tugas. Coba lagi setelah selesai.",
  'chat.support.channel.feishu': "Komunitas Feishu",
  'chat.support.channel.discord': "Discord",
  'chat.amrBalanceOwner.title': 'Saldo tim tidak cukup',
  'chat.amrBalanceOwner.message': 'Saldo tim tidak cukup. Minta admin tim untuk mengisi ulang atau meningkatkan langganan.',
  'chat.amrBalanceOwner.messageNoOwnerName': 'Saldo tim tidak cukup. Minta admin tim untuk mengisi ulang atau meningkatkan langganan.',
  'chat.amrBalanceOwner.dismissCta': "Mengerti",
  'assistant.outTokens': '{n} keluar',
  'assistant.producedFiles': 'File yang dibuat',
  'assistant.openFile': 'Buka file',
  'assistant.downloadFile': 'Unduh file',
  "nextStep.imageContinue": "Lanjutkan penyempurnaan",
  "nextStep.imageVariants": "Buat variasi / kumpulan lain",
  "nextStep.imageStyle": "Sesuaikan gaya / komposisi",
  'nextStep.title': 'Langkah berikutnya',
  'nextStep.suggestionsLabel': 'Saran langkah berikutnya',
  'nextStep.more': 'Lainnya',
  'nextStep.share': 'Bagikan',
  'nextStep.download': 'Unduh',
  'nextStep.createDesignSystemTitle': 'Create design system',
  'nextStep.createDesignSystemBody': 'Duplicate this project into a design-system workspace and start an agent pass from all current files and references.',
  'nextStep.createDesignSystemBusy': 'Creating design system...',
  'nextStep.contribute': 'Berkontribusi',
  'nextStep.planGenerateTitle': "Generate from document",
  'nextStep.planGenerateBody': "Use the approved Markdown plan as the source of truth for the next design run.",
  'nextStep.planImproveTitle': "Improve document",
  'nextStep.planImproveBody': "Tighten the current plan document before generating the final artifact.",
  'nextStep.planGeneratePrompt': "Use `{file}` as the source of truth. Read the document first, preserve its decisions, then generate the final design artifact that matches it. If it is a slide outline, generate the deck; if it is a PRD/prototype plan, generate the prototype or wireframes; if it is a storyboard/creative brief, generate the matching visual/media artifact. Before generating, call out any blocking TODOs or contradictions you cannot resolve.",
  'nextStep.planImprovePrompt': "Read `{file}` and improve it in place as an editable plan document. Tighten scope, fill weak sections, add missing acceptance checks, and keep TODO/open questions where user input is still needed. Do not generate the final design artifact yet.",
  'nextStep.planImproveArtifactTitle': "Improve artifact",
  'nextStep.planImproveArtifactBody': "Keep iterating the generated artifact instead of going back to planning.",
  'nextStep.planImproveArtifactPrompt': "Improve `{artifact}` in place. Keep the existing working artifact and make the highest-impact product, visual, interaction, and content improvements. Preserve behavior that already works, then summarize changed files and any remaining risks.",
  'nextStep.planMergeTitle': "Align document and artifact",
  'nextStep.planMergeBody': "Reconcile the plan and generated artifact so they advance together.",
  'nextStep.planMergePrompt': "Read `{document}` and `{artifact}` together. Treat the document as the intent and the artifact as the current implementation. Reconcile them: update the artifact to match confirmed decisions, update the document only where it is stale, and keep explicit TODO/open questions for anything still unresolved. Preserve existing working behavior and summarize what changed in both files.",

  'nextStep.projectContinueTitle': 'Continue working',
  'nextStep.projectGenerateArtifactTitle': 'Generate artifact',
  'nextStep.designSystemAiRefineTitle': 'AI refine design system',
  'nextStep.designSystemAuditKitTitle': 'Audit tokens & kit',

  'nextStep.brandAiOptimizeTitle': 'Refine extracted design system',
  'nextStep.brandAiOptimizeBody': 'Starts an agent pass that consumes model tokens, re-extracts the source, and updates this design system in place.',
  'nextStep.brandCreateDesignTitle': 'Create with this design system',
  'nextStep.brandCreateDesignBody': 'Start a new design using the extracted colors, type, assets, and system guidance.',
  'nextStep.brandCreateDesignPrompt': 'Create a new design with the {designSystem} design system.',

  'nextStep.brandContinueExtractionTitle': 'Continue extraction',
  'nextStep.brandContinueExtractionBody': 'After the Browser tab is past any verification, read it and keep filling the saved kit.',
  'nextStep.brandContinueExtractionBusy': 'Continuing extraction...',
  'nextStep.brandContinueAiExtractionTitle': 'Continue with agent',
  'nextStep.brandContinueAiExtractionProgrammaticBody': 'Use the selected agent to extract from the saved draft if the programmatic pass still cannot finish.',
  'nextStep.brandContinueAiExtractionAiBody': 'Resume the selected agent from the current brand scaffold and finish the same design system.',
  'nextStep.brandContinueAiExtractionBusy': 'Continuing with agent...',
  'nextStep.createDesignBusy': 'Membuat desain...',
  'assistant.thinking': 'Berpikir...',
  'assistant.thought': 'Berpikir',
  'assistant.thoughtFor': 'Berpikir {s}d',
  'assistant.designSystemDirectionLocked': 'Sistem desain aktif dipilih. Arah visual sudah ditetapkan.',
  'assistant.waitingFirstOutput': 'Menunggu output pertama...',
  'assistant.statusBootingAgent': 'Menyalakan agent...',
  'assistant.statusPreparing': 'Preparing...',
  'assistant.statusStarting': 'Memulai...',
  'assistant.statusRequesting': 'Mengirim permintaan...',
  'assistant.statusThinking': 'Berpikir...',
  'assistant.statusStreaming': 'Memuat...',
  'assistant.statusCompactingContext': 'Memadatkan konteks',
  'assistant.slowHint': 'Ini mungkin butuh waktu sebentar.',
  'assistant.verbEditing': 'mengedit',
  'assistant.verbWriting': 'menulis',
  'assistant.verbReading': 'membaca',
  'assistant.verbSearching': 'mencari',
  'assistant.verbRunning': 'menjalankan',
  'assistant.verbTodos': 'memperbarui todo',
  'assistant.verbFetching': 'mengambil',
  'assistant.verbCalling': 'memanggil',
  'qf.answered': 'Terjawab',
  "qf.unanswered": "Belum dijawab",
  "qf.unansweredContinued": "Pertanyaan ini tidak dijawab. Percakapan telah berlanjut.",
  'qf.answeredConfirmed': 'Dikonfirmasi',
  'qf.answeredSkipped': 'Dilewati',
  "chat.att.cancelUpload": "Batalkan unggahan {name}",
  "chat.att.retry": "Coba lagi",
  "chat.attachments.scrollNext": "Lihat lampiran berikutnya",
  "chat.attachments.scrollPrev": "Lihat lampiran sebelumnya",
  "chat.input.collapse": "Ciutkan",
  "chat.input.expandFull": "Tampilkan pesan lengkap",
  "chat.input.viewAll": "Lihat semua",
  "chat.artifact.export": "Export",
  "chat.artifact.pending": "Membuat…",
  "chat.artifact.publish": "Bagikan",
  "chat.edge.paused": "Tugas dijeda secara manual",
  "chat.edge.reconnectCta": "Sambungkan ulang",
  "chat.edge.reconnectDetail": "Lihat detail",
  "chat.edge.reconnectFailed": "Koneksi jaringan tidak pulih",
  "chat.edge.reconnectFailedDescription": "Pastikan koneksi jaringan berfungsi, lalu coba lagi.",
  "chat.edge.reconnecting": "Memulihkan koneksi jaringan",
  "chat.edge.reconnectingDescription": "Percobaan koneksi {attempt}/{max} sedang berlangsung. Harap tunggu.",
  "chat.edge.retrying": "Mencoba ulang",
  "chat.edge.retryingRateLimitedTitle": "Layanan model sedang sibuk",
  "chat.edge.retryingRateLimitedDescription": "Saat ini ada banyak permintaan ke layanan model ini dan batas frekuensi permintaan penyedia telah tercapai. Coba lagi nanti, atau beralih ke model lain.",
  "qf.visualNext": "Gaya berikutnya",
  "qf.visualPrev": "Gaya sebelumnya",
  "qf.visualRandom": "Acak",
  "qf.visualReshuffle": "Ganti pilihan",
  "qf.visualViewFan": "Tumpuk kembali",
  "qf.visualViewGrid": "Tampilkan sebagai kisi",
  "qf.confirmed": "Dikonfirmasi",
  "qf.picked": "{count} dipilih",
  "qf.moreOptions": "Opsi lainnya",
  "qf.colorPresets": "Warna preset",
  "qf.colorCustom": "Warna kustom",
  "qf.colorPickerLabel": "Buka pemilih warna",
  "qf.colorHexLabel": "Nilai warna heks",
  "qf.colorPreview": "Pratinjau: beginilah tampilan warna aksen di antarmuka.",
  "qf.colorInvalid": "Masukkan warna heks 6 digit, misalnya #3b82f6",
  'qf.choose': 'Pilih',
  'qf.customLabel': 'Custom answer',
  'qf.customPlaceholder': 'Type your own answer...',
  'qf.otherOption': 'Lainnya',
  'qf.ownAnswer': 'Tulis sendiri',
  'qf.required': 'Wajib',
  'qf.lockedSubmitted': 'Jawaban terkunci setelah dikirim.',
  'qf.lockedPrev': 'Jawaban sebelumnya',
  'qf.hint': 'Pilih opsi atau isi jawaban singkat.',
  'qf.submitDefault': "Lanjut",
  'qf.submitDisabledTitle': 'Lengkapi pertanyaan wajib dulu.',
  'qf.submitTitle': "Lanjut",
  'questions.tabLabel': 'Questions',
  'questions.banner': 'Mind if I ask a couple of quick questions?',
  'questions.bannerAnswered': 'Questions answered',
  'questions.strategyBlockedNotice': "Tugas ini dihentikan oleh gerbang kualitas strategi, sehingga formulir ini tidak dapat dikirim lagi. Mulai permintaan baru untuk melanjutkan.",
  'questions.continue': 'Continue',
  'questions.generating': 'Generating questions…',
  'questions.skipAll': "Lewati · kamu putuskan",
  'questions.autoSkipHint': 'Auto-continues when the timer ends',
  'questions.submitting': 'Mengirim…',
  'sketch.toolSelect': 'Pilih',
  'sketch.toolPen': 'Pena',
  'sketch.toolText': 'Teks',
  'sketch.toolRect': 'Kotak',
  'sketch.toolArrow': 'Panah',
  'sketch.toolEraser': 'Penghapus',
  'sketch.color': 'Warna',
  'sketch.strokeSize': 'Ukuran garis',
  'sketch.undo': 'Undo',
  'sketch.clear': 'Bersihkan',
  'sketch.close': 'Tutup',
  'sketch.closeConfirm': 'Tutup sketsa dan buang perubahan yang belum disimpan?',
  'sketch.textPrompt': 'Teks',
  'sketch.textModalTitle': 'Tambah teks',
  'critiqueTheater.userFacingName': 'Juri Desain',
  'critiqueTheater.roleDesigner': 'Desainer',
  'critiqueTheater.roleCritic': 'Kritikus',
  'critiqueTheater.roleBrand': 'Merek',
  'critiqueTheater.roleA11y': 'Aksesibilitas',
  'critiqueTheater.roleCopy': 'Salin',
  'critiqueTheater.roundLabel': 'Putaran {n} dari {m}',
  'critiqueTheater.mustFix': '{n} wajib diperbaiki',
  'critiqueTheater.composite': 'Komposit',
  'critiqueTheater.threshold': 'Ambang batas',
  'critiqueTheater.consensus': 'Konsensus',
  'critiqueTheater.interrupt': 'Hentikan',
  'critiqueTheater.interrupting': 'Menghentikan…',
  'critiqueTheater.interrupted': 'Dihentikan',
  'critiqueTheater.degradedHeading': 'Panel offline pada proses ini',
  'critiqueTheater.degradedReasonMalformed': 'Hasil panel salah format (parser menolak blok tersebut).',
  'critiqueTheater.degradedReasonOversize': 'Output panel melebihi anggaran byte yang aman.',
  'critiqueTheater.degradedReasonAdapter': 'Adapter {adapter} tidak mendukung protokol Critique.',
  'critiqueTheater.degradedReasonProtocol': 'Adapter {adapter} mengirim versi protokol yang tidak didukung.',
  'critiqueTheater.degradedReasonMissingArtifact': 'Run selesai tanpa artefak final.',
  'critiqueTheater.replay': 'Putar ulang',
  'critiqueTheater.replaySpeed': 'Kecepatan putar ulang',
  'critiqueTheater.readOnly': 'Hanya-baca',
  'critiqueTheater.shippedSummary': 'Dikirim pada putaran {round} · komposit {composite}',
  'critiqueTheater.interruptedSummary': 'Dihentikan pada putaran {round} · komposit terbaik {composite}',
  'critiqueTheater.shippedBadge': 'Terkirim',
  'critiqueTheater.belowThresholdBadge': 'Di bawah ambang batas',
  'critiqueTheater.timedOutBadge': 'Waktu habis',
  'critiqueTheater.failedHeading': 'Run gagal',
  'critiqueTheater.failedReasonCliExit': 'Agent CLI keluar dengan kode bukan nol sebelum panel dapat diselesaikan.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'Sebuah ronde melebihi anggaran waktunya.',
  'critiqueTheater.failedReasonTotalTimeout': 'Seluruh run melebihi total anggaran waktunya.',
  'critiqueTheater.failedReasonOrchestrator': 'Galat orkestrator internal.',
  'critiqueTheater.transcriptEmpty': 'Belum ada transkrip untuk diputar ulang. Jalankan critique untuk merekamnya.',
  'critiqueTheater.transcriptLoading': 'Memuat transkrip…',
  'critiqueTheater.transcriptError': 'Tidak dapat memuat transkrip: {error}',
  'critiqueTheater.replaySpeedPaused': 'Dijeda',
  'critiqueTheater.replaySpeedInstant': 'Instan',
  'critiqueTheater.replaySpeedLive': 'Langsung',
  'critiqueTheater.replaySpeedFast': 'Cepat',
  'critiqueTheater.settingsNav': 'Juri Desain',
  'critiqueTheater.settingsNavHint': 'Ulasan desain lima panel untuk run Anda',
  'critiqueTheater.settingsEnabledLabel': 'Tampilkan Design Jury selama run agent',
  'critiqueTheater.settingsEnabledDescription': 'Ketika diaktifkan, ulasan lima panel muncul bersama generasi agent dan menilai output sebelum dikirim. Anda dapat menginterupsi kapan saja.',
  'critiqueTheater.settingsEnabledProjectHint': 'Disimpan untuk proyek ini. Run baru di proyek ini akan dialihkan melalui Design Jury di sisi server.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'Buka sebuah proyek untuk menyimpan ini di sisi server. Sampai saat itu, ini hanya mengubah preferensi di dalam browser.',
  'pet.title': 'Teman kerja',
  'pet.subtitle': 'Pilih teman kecil untuk melayang di workspace.',
  'pet.navTitle': 'Pets',
  'pet.navHint': 'Pilih teman untuk melayang di workspace.',
  'pet.tabBuiltIn': 'Bawaan',
  'pet.tabBuiltInHint': 'Pet pilihan yang disertakan dengan OpenDesign - pilih satu lalu adopsi.',
  'pet.builtInEmpty': 'Pet bawaan belum tersedia. Coba refresh tab Komunitas setelah daemon online.',
  'pet.tabCustom': 'Kustom',
  'pet.tabCustomHint': 'Buat sendiri dengan nama, glyph, warna, atau sprite.',
  'pet.tabCommunity': 'Komunitas',
  'pet.tabCommunityHint': 'Pet hasil hatch dari Codex - adopsi satu atau buat yang baru.',
  'pet.tabsAria': 'Sumber pet',
  'pet.adopt': 'Adopsi pet',
  'pet.adoptedBadge': 'Diadopsi',
  'pet.adoptCallout': 'Pet aktif akan muncul di workspace.',
  'pet.changePet': 'Ganti pet',
  'pet.wake': 'Bangunkan',
  'pet.tuck': 'Tidurkan',
  'pet.wakeTitle': 'Tampilkan pet',
  'pet.tuckTitle': 'Sembunyikan pet',
  'pet.settingsTitle': 'Kustomisasi pet',
  'pet.useCustom': 'Gunakan kustom',
  'pet.customTitle': 'Kustom Pet',
  'pet.customHint': 'Buat nama, simbol, dan sapaan sendiri.',
  'pet.customGreetingPlaceholder': 'Halo, aku siap membantu.',
  'pet.fieldName': 'Nama',
  'pet.fieldGlyph': 'Glyph',
  'pet.fieldGlyphHint': 'Satu karakter atau simbol singkat.',
  'pet.fieldGreeting': 'Sapaan',
  'pet.fieldAccent': 'Aksen',
  'pet.fieldAccentCustom': 'Kustom',
  'pet.fieldAccentDefault': 'Warna aksen default',
  'pet.overlayAria': 'Overlay pet',
  'pet.spriteAria': '{name} - geser untuk memindahkan, klik untuk chat',
  'pet.spriteTitle': 'Halo dari {name}! Klik untuk chat.',
  'pet.taskSummarySingle': '{count} tugas agent sedang berjalan.',
  'pet.taskSummaryMultiple': '{count} tugas agent sedang berjalan di {projects} proyek.',
  'pet.taskSummaryRecentSingle': '{count} tugas agent baru saja selesai.',
  'pet.taskSummaryRecentMultiple': '{count} tugas agent baru saja selesai.',
  'pet.taskListAria': 'Tugas agent aktif',
  'pet.taskOpenProject': 'Buka {project}',
  'pet.taskGroup.running': 'Berjalan',
  'pet.taskGroup.queued': 'Menunggu',
  'pet.taskGroup.recent': 'Baru saja selesai',
  'pet.idleQuote.leonardo.text': 'Belajar tidak pernah membuat pikiran lelah.',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': 'Aku melihat malaikat di dalam marmer dan memahatnya hingga ia bebas.',
  'pet.idleQuote.michelangelo.author': 'Michelangelo',
  'pet.idleQuote.bernini.text': 'Ada dua perangkat yang dapat membantu pematung: cahaya dan bayangan.',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': 'Saat seseorang melukis, ia tidak berpikir.',
  'pet.idleQuote.raphael.author': 'Raphael',
  'pet.idleQuote.caravaggio.text': 'Semua karya, apa pun dan oleh siapa pun dilukis, tidak lebih dari hal sepele dan kekanak-kanakan kecuali dibuat dan dilukis dari kehidupan nyata.',
  'pet.idleQuote.caravaggio.author': 'Caravaggio',
  'pet.idleQuote.rodin.text': 'Yang terpenting adalah tergerak, mencintai, berharap, gemetar, hidup.',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': 'Pet',
  'pet.composerMenuTitle': 'Perintah pet',
  'pet.composerMenuHint': 'Kelola pet dari composer.',
  'pet.composerOpenSettings': 'Kelola Hewan Peliharaan',
  'pet.welcomeTeaserTitle': 'Tambahkan teman kecil',
  'pet.welcomeTeaserBody': 'Pet bisa menemani workspace saat agent bekerja.',
  'pet.welcomeTeaserCta': 'Pilih pet',
  'pet.imageUpload': 'Upload sprite',
  'pet.imageReplace': 'Ganti sprite',
  'pet.imageRemove': 'Gunakan emoji',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF, atau SVG. Upload sheet? Letakkan strip horizontal dan atur jumlah frame.',
  'pet.imageHintActive': 'Sprite kamu sedang ditampilkan. Atur frame > 1 untuk menjalankan spritesheet horizontal.',
  'pet.fieldFrames': 'Frame',
  'pet.fieldFramesHint': '1 = statis. > 1 = spritesheet horizontal.',
  'pet.fieldFps': 'Kecepatan (fps)',
  'pet.fieldFpsHint': 'Seberapa cepat frame berganti.',
  'pet.atlasImport': 'Impor sprite Codex',
  'pet.atlasImportTitle': 'Impor atlas hatch-pet 8x9 / 192x208 (PNG atau WebP).',
  'pet.atlasPickerTitle': 'Pilih baris animasi',
  'pet.atlasPickerHint': 'Pet Codex memiliki 9 baris animasi. Secara default, atlas penuh dipertahankan agar pet mengganti baris saat hover, drag, dan idle. Kamu juga bisa membekukannya ke satu loop.',
  'pet.atlasCancel': 'Buang atlas',
  'pet.atlasAdopt': 'Bekukan ke baris ini',
  'pet.atlasAdoptFull': 'Gunakan atlas penuh (animasi)',
  'pet.atlasAdoptFullTitle': 'Pertahankan semua baris agar pet bereaksi terhadap hover, arah drag, dan idle lama.',
  'pet.atlasAdoptRowTitle': 'Potong baris yang disorot menjadi satu strip loop.',
  'pet.atlasActiveHint': 'Atlas animasi aktif - pet memilih baris dari interaksimu (hover, drag, idle).',
  'pet.atlasRow.idle': 'Idle',
  'pet.atlasRow.running-right': 'Lari kanan',
  'pet.atlasRow.running-left': 'Lari kiri',
  'pet.atlasRow.waving': 'Melambai',
  'pet.atlasRow.jumping': 'Melompat',
  'pet.atlasRow.failed': 'Gagal',
  'pet.atlasRow.waiting': 'Menunggu',
  'pet.atlasRow.running': 'Berjalan',
  'pet.atlasRow.review': 'Review',
  'pet.hatchTitle': 'Hatch pet baru dengan AI',
  'pet.hatchHint': 'Gunakan skill hatch-pet bawaan di chat untuk membuat spritesheet bergaya Codex, lalu impor di sini.',
  'pet.hatchConcept': 'Konsep pet (opsional)',
  'pet.hatchConceptPlaceholder': 'mis. shiba pixel-art kecil memakai sweater nyaman',
  'pet.hatchCopy': 'Salin prompt',
  'pet.hatchCopied': 'Tersalin!',
  'pet.hatchFoot': 'Setelah skill menyimpan pet, kembali ke sini dan pilih "Impor sprite Codex".',
  'pet.slashPopoverAria': 'Perintah slash',
  'pet.slashPopoverTitle': 'Perintah',
  'pet.slashPopoverHint': 'atas/bawah untuk navigasi - enter untuk pilih - esc untuk tutup',
  'pet.slashPet': 'Toggle, adopsi, atau buka pengaturan pet.',
  'pet.slashMcp': 'Open MCP server settings or insert a server tool hint.',
  'pet.slashPetWake': 'Bangunkan overlay pet melayang.',
  'pet.slashPetTuck': 'Sembunyikan pet untuk sekarang.',
  'pet.slashHatch': 'Buat pet Codex lewat skill hatch-pet.',
  'pet.slashHatchArg': '<konsep>',
  'pet.slashSearch': 'Cari web lewat perintah OD research.',
  'pet.slashSearchArg': '<kueri>',
  'pet.codexTitle': 'Baru di-hatch',
  'pet.codexSubtitle': 'Pet yang dikemas oleh skill hatch-pet muncul di sini untuk adopsi sekali klik.',
  'pet.codexSubtitleWithDir': 'Memindai {dir} untuk pet yang dikemas oleh skill hatch-pet.',
  'pet.codexEmpty': 'Belum ada pet hasil hatch. Ketik /hatch di chat untuk membuat satu.',
  'pet.codexLoading': 'Mencari pet hasil hatch...',
  'pet.codexRefresh': 'Refresh',
  'pet.codexAdopt': 'Adopsi',
  'pet.codexAdopting': 'Mengadopsi...',
  'pet.communitySync': 'Unduh pet komunitas',
  'pet.communitySyncing': 'Mengunduh...',
  'pet.communitySyncTitle': 'Sinkronkan pet terbaru dari Codex Pet Share + j20 Hatchery ke ~/.codex/pets/.',
  'pet.communitySyncDone': 'Tersinkron {wrote} pet baru ({total} total).',
  'pet.communitySyncFailed': 'Sinkronisasi gagal: {error}',
  'pet.codexBundled': 'Bawaan',
  'pet.codexBundledTitle': 'Disertakan dengan OpenDesign - tidak perlu diunduh.',
  'settings.systemPrefsTitle': 'Preferensi sistem',
  'settings.systemPrefsHint': 'Suara penyelesaian, notifikasi browser, dan peringatan status tugas.',
  'settings.notifications': 'Notifikasi',
  'settings.notificationsHint': 'Atur suara dan notifikasi desktop.',
  'settings.notifyCompletionSound': 'Suara saat selesai',
  'settings.notifyCompletionSoundHint': 'Putar suara ketika generasi selesai.',
  'settings.notifySuccessSound': 'Suara berhasil',
  'settings.notifyFailureSound': 'Suara gagal',
  'settings.notifyDesktop': 'Notifikasi desktop',
  'settings.notifyDesktopHint': 'Tampilkan notifikasi sistem saat generasi selesai.',
  'settings.notifyDesktopBlocked': 'Notifikasi diblokir oleh browser.',
  'settings.notifyDesktopUnsupported': 'Browser ini tidak mendukung notifikasi desktop.',
  'settings.notifyTest': 'Tes notifikasi',
  'settings.notifyTestSent': 'Notifikasi tes terkirim.',
  'settings.notifyTestFailed': 'Gagal mengirim notifikasi tes.',
  'settings.notifySoundDing': 'Ding',
  'settings.notifySoundChime': 'Chime',
  'settings.notifySoundTwoToneUp': 'Dua nada naik',
  'settings.notifySoundPluck': 'Pluck',
  'settings.notifySoundBuzz': 'Buzz',
  'settings.notifySoundTwoToneDown': 'Dua nada turun',
  'settings.notifySoundThud': 'Thud',
  'settings.skills': 'Keterampilan',
  'settings.skillsHint': 'Keterampilan fungsional yang dapat dipanggil agen saat tugas',
  'settings.skillsNew': 'Keterampilan baru',
  'settings.skillsEmpty': 'Pilih keterampilan di kiri, atau buat yang baru.',
  'settings.skillsEdit': 'Edit',
  'settings.skillsDelete': 'Hapus',
  'settings.skillsDeleteConfirm': 'Konfirmasi hapus',
  'settings.skillsName': 'Nama',
  'settings.skillsTriggers': 'Pemicu (dipisahkan koma atau baris baru)',
  'settings.skillsDescription': 'Deskripsi',
  'settings.skillsBody': 'Isi SKILL.md',
  'settings.skillsCreate': 'Buat',
  'settings.skillsSave': 'Simpan',
  'settings.skillsSaving': 'Menyimpan…',
  'settings.skillsOverrideCreate': 'Buat penggantian pengguna',
  'settings.skillsOverrideSave': 'Simpan sebagai penggantian pengguna',
  'settings.skillsBuiltInOverrideWarning': 'Mengedit keterampilan bawaan ini akan membuat penggantian pengguna. Entri bawaan akan disembunyikan dari daftar hingga Anda menghapus penggantian. Lanjutkan?',
  'settings.skillsFiles': 'Berkas',
  'settings.skillsNoFiles': 'Tidak ada berkas dalam folder keterampilan ini.',
  'settings.skillsNameRequired': 'Nama keterampilan wajib diisi.',
  'settings.skillsBodyRequired': 'Isi keterampilan wajib diisi.',
  'settings.designSystems': 'Sistem desain',
  'settings.designSystemsHint': 'Telusuri dan aktifkan sistem desain yang tersedia',
  'settings.designSystemsInstalled': 'Terpasang',
  'settings.designSystemsAdd': 'Tambah sistem desain',
  'settings.designSystemsHiddenCount': '{count} disembunyikan dari galeri beranda',
  'settings.designSystemsShowAll': 'Tampilkan semua',
  'settings.designSystemsShowHidden': 'Tampilkan tersembunyi',
  'settings.designSystemsSource': 'Sumber',
  'settings.designSystemsSourceLocal': 'Lokal',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'Referensi registry shadcn',
  'settings.designSystemsImportShadcn': 'Impor dari shadcn',
  'settings.designSystemsStructure': 'Struktur',
  'settings.designSystemsModeHybrid': 'Hibrida',
  'settings.designSystemsModeNormalized': 'Dinormalisasi',
  'settings.designSystemsModeVerbatim': 'Apa adanya',
  'settings.designSystemsCraft': 'Craft',
  'settings.designSystemsCraftColor': 'Warna',
  'settings.designSystemsCraftAccessibility': 'Aksesibilitas',
  'settings.designSystemsGithubUrl': 'URL GitHub',
  'settings.designSystemsProjectPath': 'Path proyek',
  'settings.designSystemsImportGithub': 'Impor dari GitHub',
  'settings.designSystemsImportProject': 'Impor dari proyek',
  'settings.designSystemsImportedStatus': '{title} diimpor',
  'settings.designSystemsViewImported': 'Lihat sistem desain yang diimpor',
  'settings.designSystemsCategory': 'Kategori',
  'settings.designSystemsAllCategories': 'Semua kategori',
  'settings.designSystemsShowInHomeGallery': 'Tampilkan di galeri beranda',
  'settings.projectLocations': 'Lokasi proyek',
  'settings.projectLocationsHint': 'Root penyimpanan workspace',
  'settings.projectLocationsDescription': 'Tambahkan basis kerja yang dapat berisi beberapa folder proyek OpenDesign. Proyek baru disimpan sebagai folder di dalam basis yang dipilih.',
  'settings.projectLocationsSaveError': 'Tidak dapat menyimpan lokasi proyek. Pastikan setiap path adalah folder yang dapat diakses.',
  'settings.projectLocationsSaved': 'Lokasi proyek disimpan.',
  'settings.projectLocationsScanError': 'Tidak dapat memindai lokasi proyek.',
  'settings.projectLocationsScanComplete': 'Pemindaian selesai: {imported} diimpor, {existing} sudah terdaftar.',
  'settings.projectLocationsNoFolderSelected': 'Tidak ada folder yang dipilih.',
  'settings.projectLocationsDuplicate': 'Basis kerja itu sudah ditambahkan.',
  'settings.projectLocationsWorkBaseMeta': 'Basis kerja · proyek dibuat di sini sebagai subfolder',
  'settings.projectLocationsAddFolder': 'Tambah folder…',
  'settings.projectLocationsDefaultBadge': 'Lokasi default',
  'settings.projectLocationsMakeDefault': 'Jadikan default',
  'settings.projectLocationsDefaultSaved': 'Lokasi proyek default diperbarui.',
  'settings.librarySkills': 'Skill',
  'settings.libraryDesignSystems': 'Sistem desain',
  'settings.librarySearch': 'Cari...',
  'settings.libraryAll': 'Semua',
  'settings.libraryPreview': 'Pratinjau',
  'settings.libraryPreviewClose': 'Tutup',
  'settings.libraryLoading': 'Memuat...',
  'settings.libraryNoResults': 'Tidak ada item yang cocok dengan pencarianmu.',
  'settings.libraryEnabled': 'Aktif',
  'settings.libraryDisabled': 'Nonaktif',
  'settings.connectorsNavHint': 'Koneksi sistem eksternal',
  'settings.connectorsHint': 'Kelola pengaturan konektor dan penyedia alat untuk perangkat ini.',
  'settings.connectorsComposioApiKey': 'API key Composio',
  'settings.connectorsSavedTitle': 'Tersimpan di daemon lokal',
  'settings.connectorsSavedWithTail': 'Tersimpan · ••••{tail}',
  'settings.connectorsSaved': 'Tersimpan',
  'settings.connectorsGetApiKey': 'Dapatkan API key',
  'settings.connectorsReplaceKeyPlaceholder': 'Tempel key baru untuk mengganti yang tersimpan',
  'settings.connectorsApiKeyPlaceholder': 'Tempel API key Composio',
  'settings.connectorsClear': 'Hapus',
  'settings.connectorsClearConfirmTitle': 'Hapus API key Composio yang tersimpan?',
  'settings.connectorsClearConfirmBody': 'Menghapus key akan memutus semua konektor Composio yang terkait dengan workspace ini. Akun terhubung, grant OAuth, dan akses alat semuanya akan dihapus.',
  'settings.connectorsClearConfirmContinue': 'Lanjutkan',
  'settings.connectorsClearFinalTitle': 'Ini akan memutus semua konektor',
  'settings.connectorsClearFinalBody': 'Tindakan ini tidak bisa dibatalkan. Kamu harus menghubungkan ulang setiap integrasi dari awal setelah menempelkan key baru.',
  'settings.connectorsClearFinalConfirm': 'Hapus key & putuskan koneksi',
  'settings.connectorsClearArming': 'Tunggu…',
  'settings.connectorsClearCancel': 'Batal',
  'settings.connectorsSaveKey': 'Simpan key',
  'settings.connectorsSaveKeyTitle': 'Kirim key ini ke daemon lokal',
  'settings.connectorsKeySaving': 'Menyimpan…',
  'settings.connectorsKeySaved': 'Tersimpan ✓',
  'settings.connectorsKeyError': 'Tidak bisa menyimpan key. Pastikan daemon lokal berjalan lalu coba lagi.',
  'settings.connectorsHelpSaved': 'Key kamu tersimpan di daemon lokal. Tempel key baru untuk menggantinya, atau Hapus untuk menghapusnya.',
  'settings.connectorsHelpUnsaved': 'Ada perubahan yang belum disimpan — klik Simpan key untuk menyimpan kredensial ini di daemon lokal dan menyegarkan katalog di bawah.',
  'settings.connectorsHelpEmpty': 'Tambahkan key untuk memuat katalog di bawah. Key disimpan secara lokal di daemon dan tidak pernah dikirim lewat environment variable.',
  'settings.connectorsLoadingSavedKey': 'Memeriksa key yang tersimpan di daemon lokal…',
  'settings.autosaveSaving': 'Menyimpan…',
  'settings.autosaveSaved': 'Semua perubahan tersimpan',
  'settings.autosaveError': 'Tidak bisa menyimpan perubahan. Daemon lokal mungkin offline.',
  'settings.libraryToggleLabel': 'Toggle',
  'settings.memory': 'Memory',
  'settings.memoryHint': 'Personal facts auto-extracted from chats',
  'settings.customInstructionsTitle': 'Aturan global',
  'settings.customInstructionsHint': 'Instruksi tetap yang harus diikuti OpenDesign di setiap chat. Simpan fakta, preferensi, dan konteks proyek sebagai memory.',
  'settings.customInstructionsPlaceholder': 'mis. "Selalu gunakan TypeScript. Utamakan komponen fungsional. Jaga agar respons tetap ringkas."',
  'settings.memoryDescription': 'Auto-extracted facts about you and your preferences. Saved as Markdown files and folded into every chat.',
  'settings.memoryEnabled': 'Enabled',
  'settings.memoryDisabled': 'Disabled',
  'settings.memoryEnableLabel': 'Enable memory injection',
  'settings.memoryDisabledBanner': 'Memory is currently OFF. Existing facts are preserved on disk but will not be folded into new chats and new turns will not extract anything new.',
  'settings.memoryNew': 'New memory',
  'settings.memoryEdit': 'Edit',
  'settings.memoryDelete': 'Delete',
  'settings.memoryPreview': 'Preview',
  'settings.memoryEmpty': 'No memory yet.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'I prefer dark mode',
  'settings.memoryName': 'Name',
  'settings.memoryDesc': 'One-line description',
  'settings.memoryBody': 'Memory body (Markdown supported)',
  'settings.memoryBodyHint': 'Lead with the rule itself; add Why and How to apply lines.',
  'settings.memoryStartersLabel': 'Need a starting point? Click to fill the form:',
  'settings.memoryStarterUserName': 'My role',
  'settings.memoryStarterUserDesc': 'I am a frontend engineer working on a SaaS design tool',
  'settings.memoryStarterUserBody': '- Role: senior frontend engineer\n- Stack: React, TypeScript, Vite\n- Domain: design / collaboration tools\n- Timezone: GMT+8 (Asia/Shanghai)\n\nWhen to apply: any chat — frame examples around web frontend.',
  'settings.memoryStarterFeedbackName': 'UI preferences',
  'settings.memoryStarterFeedbackDesc': 'Dark mode, large body text, low information density',
  'settings.memoryStarterFeedbackBody': '- Theme: dark by default\n- Body text: ≥ 18px\n- Information density: prefer whitespace, fewer items per screen\n\nWhy: less eye strain during long sessions.\nWhen to apply: whenever you generate UI, web pages, or slides.',
  'settings.memoryStarterProjectName': 'Current project',
  'settings.memoryStarterProjectDesc': 'OpenDesign v0.5 — chat-driven design editor',
  'settings.memoryStarterProjectBody': '- Goal: ship the chat-driven editor this quarter\n- Priorities: streaming render, local multimodal, offline-first\n- Stack: Next.js 16, Express daemon, SQLite\n\nWhen to apply: in any conversation about this project.',
  'settings.memorySaveHint': 'Not auto-saved — click Create / Save to apply.',
  'settings.memoryIndexSaveHint': 'Edits to the index are not auto-saved — click Save index to apply.',
  'settings.memoryIndexUnsaved': 'Unsaved changes',
  'settings.memoryFlashCreated': '✓ Memory created',
  'settings.memoryFlashSaved': '✓ Memory saved',
  'settings.memoryFlashDeleted': '✓ Memory deleted',
  'settings.memoryFlashIndexSaved': '✓ Index saved',
  'settings.memoryFlashPathCopied': '✓ Jalur disalin',
  'settings.memoryNameLabel': 'Title',
  'settings.memoryTypeLabel': 'Type',
  'settings.memoryDescLabel': 'Description',
  'settings.memoryBodyLabel': 'Content',
  'settings.memoryTypeUser': 'User',
  'settings.memoryTypeFeedback': 'Feedback',
  'settings.memoryTypeProject': 'Project',
  'settings.memoryTypeReference': 'Reference',
  'settings.memoryIndex': 'MEMORY.md (index)',
  'settings.memoryIndexSave': 'Save index',
  'settings.memoryIndexReset': 'Reset',
  'settings.memoryToastChanged': 'Memory updated',
  'settings.memoryToastClickHint': 'Lihat',
  'settings.memoryAll': 'All',
  'settings.memoryExtractions': 'Extraction history',
  'settings.memoryExtractionsHint': 'Recent LLM-backed extraction attempts. Heuristic regex extraction always runs first; LLM extraction runs in the background after each turn.',
  'settings.memoryExtractionsEmpty': 'No extractions yet. The next chat turn will populate this list.',
  'settings.memoryExtractionsRefresh': 'Refresh',
  'settings.memoryExtractionsRefreshing': 'Refreshing…',
  'settings.memoryExtractionPhaseRunning': 'Running…',
  'settings.memoryExtractionPhaseSuccess': 'Success',
  'settings.memoryExtractionPhaseSkipped': 'Skipped',
  'settings.memoryExtractionPhaseFailed': 'Failed',
  'settings.memoryExtractionSkipNoProvider': 'No API key configured for LLM memory extraction.',
  'settings.memoryExtractionSkipUnsupportedProvider': 'A saved media provider is not supported for LLM memory extraction.',
  'settings.memoryExtractionSkipDisabled': 'Memory is disabled.',
  'settings.memoryExtractionSkipEmpty': 'Empty user message — nothing to extract.',
  'settings.memoryExtractionSkipNoMatch': 'No regex pattern matched this turn.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'media settings',
  'settings.memoryExtractionProviderOverride': 'memory settings',
  'settings.memoryExtractionProposed': 'proposed',
  'settings.memoryExtractionWritten': 'written',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': 'Delete',
  'settings.memoryExtractionsClear': 'Clear',
  'settings.memoryExtractionsClearTitle': 'Clear all extraction history',
  'settings.memoryExtractionsClearConfirm': 'Bersihkan semua riwayat ekstraksi? Tindakan ini tidak dapat dibatalkan.',
  'settings.memoryNoProviderBannerTitle': 'LLM memory extraction is not running',
  'settings.memoryNoProviderBannerBody': 'No API key found for the memory extractor. Add an OpenAI key under Media providers, or set ANTHROPIC_API_KEY / OPENAI_API_KEY in the environment, to enable LLM-driven extraction. Heuristic regex extraction is still active.',
  'settings.memoryUnsupportedProviderBannerBody': 'A media provider key is saved, but Memory can only reuse text-capable providers: OpenAI, MiniMax, AIHubMix, and SenseAudio. Configure one of those under Media providers, set ANTHROPIC_API_KEY / OPENAI_API_KEY, or choose a Memory model in Advanced.',
  'settings.memoryTypeProfile': 'Profil',
  'settings.memoryTypeRule': 'Aturan',
  'settings.memoryTabMemories': 'Memori',
  'settings.memoryTabMemoriesCaption': 'Lihat dan kelola memori tersimpan',
  'settings.memoryTabHow': 'Cara kerjanya',
  'settings.memoryTabHowCaption': 'Dua loop dan kontrolnya',
  'settings.memoryAddDisclosure': 'Tambah atau impor memori',
  'settings.memoryAddDisclosureHint': 'Profil, entri manual, atau aplikasi terhubung',
  'settings.memoryProfileTab': 'Profil kerja',
  'settings.memoryProfileTabCaption': 'Siapa Anda dan setelan default Anda',
  'settings.memoryProfileTitle': 'Profil kerja Anda',
  'settings.memoryProfileHint':
    'Beberapa fakta tentang Anda dan setelan default Anda. Memori menyuntikkan ini sebelum setiap tugas agar agen memahami maksud Anda dari permintaan singkat.',
  'settings.memoryProfileName': 'Profil kerja',
  'settings.memoryProfileDescription':
    'Peran, perusahaan, domain, audiens, selera, dan default yang sebaiknya digunakan kembali oleh asisten.',
  'settings.memoryProfileSave': 'Simpan profil',
  'settings.memoryProfileSaving': 'Menyimpan…',
  'settings.memoryProfileSaved': 'Profil tersimpan',
  'settings.memoryProfileRole': 'Peran',
  'settings.memoryProfileRolePlaceholder': 'mis. Founder, desainer, PM',
  'settings.memoryProfileCompany': 'Perusahaan / Tim',
  'settings.memoryProfileCompanyPlaceholder': 'mis. Acme, growth team',
  'settings.memoryProfileDomain': 'Domain',
  'settings.memoryProfileDomainPlaceholder': 'mis. B2B SaaS, fintech, devtools',
  'settings.memoryProfileAudience': 'Audiens utama',
  'settings.memoryProfileAudiencePlaceholder': 'mis. eksekutif, engineer, pengguna akhir',
  'settings.memoryProfileAesthetic': 'Estetika / selera',
  'settings.memoryProfileAestheticPlaceholder':
    'mis. clean and editorial, latar terang, whitespace yang lega',
  'settings.memoryProfileDeliverables': 'Deliverable default',
  'settings.memoryProfileDeliverablesPlaceholder': 'mis. landing page, deck, one-pager',
  'settings.memoryProfileLocale': 'Lokal / Bahasa',
  'settings.memoryProfileLocalePlaceholder': 'mis. English (US), Simplified Chinese',
  'settings.memoryProfileGoals': 'Tujuan saat ini',
  'settings.memoryProfileGoalsPlaceholder':
    'mis. merilis halaman harga baru, meningkatkan konversi pada alur trial',
  'settings.memoryHooksTitle': 'Hook memori',
  'settings.memoryHooksHint':
    'Pilih bagian memori mana yang berjalan otomatis. Sakelar utama di atas mematikan semuanya.',
  'settings.memoryHooksProfileLabel': 'Gunakan profil saya',
  'settings.memoryHooksProfileDesc': 'Suntikkan profil kerja Anda ke setiap tugas.',
  'settings.memoryHooksRewriteLabel': 'Tulis ulang permintaan singkat',
  'settings.memoryHooksRewriteDesc': 'PRE: kembangkan permintaan singkat menjadi ringkasan tugas lengkap.',
  'settings.memoryHooksVerifyLabel': 'Verifikasi hasil sendiri',
  'settings.memoryHooksVerifyDesc': 'POST: periksa hasil terhadap aturan Anda, lalu tampilkan scorecard.',
  'settings.memoryHooksExtractionLabel': 'Belajar dari chat',
  'settings.memoryHooksExtractionDesc': 'Tangkap fakta dan preferensi berguna dari giliran chat.',
  'settings.libraryInstall': 'Instal',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Jalur lokal',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Instal',
  'settings.libraryUninstall': 'Copot',
  'settings.libraryBuiltIn': 'Bawaan',
  'settings.libraryInstalled': 'Terinstal',
  'settings.orbit.eyebrow': 'Otomatisasi',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Ringkasan konektor harian',
  'settings.orbit.lede': 'Kumpulkan aktivitas konektor sesuai jadwal dan publikasikan hasilnya sebagai live artifact yang bisa diperbarui.',
  'settings.orbit.statusOnTitle': 'Jadwal jalan harian aktif',
  'settings.orbit.statusOffTitle': 'Jadwal jalan harian nonaktif',
  'settings.orbit.statusActive': 'Aktif',
  'settings.orbit.statusOff': 'Mati',
  'settings.orbit.runTitle': 'Mulai Orbit dan buka percakapan live',
  'settings.orbit.running': 'Berjalan…',
  'settings.orbit.runOpen': 'Jalankan sekarang',
  'settings.orbit.dailySummaryTitle': 'Ringkasan harian',
  'settings.orbit.dailySummarySub': 'Berjalan sekali per hari pada waktu lokal yang dijadwalkan.',
  'settings.orbit.on': 'Nyala',
  'settings.orbit.off': 'Mati',
  'settings.orbit.runTimeTitle': 'Waktu jalan',
  'settings.orbit.runTimeSub': 'Default 08.00. Simpan untuk menerapkannya ke jadwal daemon.',
  'settings.orbit.runTimeAria': 'Waktu jalan Orbit harian',
  'settings.orbit.nextRun': 'Jalan berikutnya',
  'settings.orbit.nextRunScheduledAfterSave': 'Dijadwalkan setelah Simpan',
  'settings.orbit.schedule': 'Jadwal',
  'settings.orbit.pausedManualOnly': 'Dijeda — hanya jalan manual',
  'settings.orbit.templateTitle': 'Templat prompt',
  'settings.orbit.templateMissing': 'Templat {id} belum terpasang.',
  'settings.orbit.templateMissingOption': '{id} (belum terpasang)',
  'settings.orbit.templateMissingInstall': 'Pasang skill Orbit untuk mengarahkan prompt.',
  'settings.orbit.templateMissingPickAnother': 'Pilih templat lain dari dropdown.',
  'settings.orbit.templateResetTitle': 'Reset ke {id}',
  'settings.orbit.templateReset': 'Atur ulang',
  'settings.orbit.templateHelp': 'Arahkan Orbit dengan skill — contoh prompt templat yang dipilih akan disuntikkan ke setiap jalan Orbit agar ringkasan mengikuti bentuk templat itu.',
  'settings.orbit.templateAria': 'Templat prompt Orbit',
  'settings.orbit.templatesLoading': 'Memuat templat…',
  'settings.orbit.templatesOptgroup': 'Templat skill Orbit',
  'settings.orbit.lastRun': 'Jalan terakhir',
  'settings.orbit.triggerManual': 'Manual',
  'settings.orbit.triggerScheduled': 'Terjadwal',
  'settings.orbit.meterAria': '{succeeded} berhasil, {skipped} dilewati, {failed} gagal dari {checked} yang diperiksa',
  'settings.orbit.countChecked': 'Diperiksa',
  'settings.orbit.countSucceeded': 'Berhasil',
  'settings.orbit.countSkipped': 'Dilewati',
  'settings.orbit.countFailed': 'Gagal',
  'settings.orbit.runError': 'Tidak bisa menjalankan Orbit. Pastikan daemon lokal berjalan dan konektor sudah dikonfigurasi.',
  'settings.orbit.gateAriaLabel': 'Konektor diperlukan untuk memakai Orbit',
  'settings.orbit.gateEyebrow': 'Perlu pengaturan',
  'settings.orbit.gateTitle': 'Hubungkan alat untuk menjalankan Orbit',
  'settings.orbit.gateBody': 'Orbit merangkum aktivitas di seluruh konektormu. Belum ada yang terhubung — tambahkan setidaknya satu integrasi agar Orbit punya sesuatu untuk dilaporkan.',
  'settings.orbit.gateBodyNoKey': 'Orbit merangkum aktivitas di seluruh konektormu, dan konektor berjalan melalui Composio. Tambahkan API key Composio di Connectors untuk memuat katalog dan memilih integrasi pertamamu.',
  'settings.orbit.gateAction': 'Buka Connectors',
  'settings.orbit.gateActionNoKey': 'Konfigurasikan Composio',
  'settings.orbit.gateLoading': 'Memeriksa konektor…',
  'settings.orbit.controlsLockedBadge': 'Terkunci',
  'settings.orbit.controlsLockedHint': 'Hubungkan alat untuk membuka kontrol jadwal dan templat Orbit.',
  'settings.orbit.artifactKickerLive': 'artifact live',
  'settings.orbit.artifactKickerLegacy': 'Ringkasan lama',
  'settings.orbit.artifactTitle': 'Ringkasan aktivitas Orbit harian',
  'settings.orbit.artifactMetaLive': 'Artifact HTML yang bisa diperbarui ulang dan dihasilkan dari aktivitas konektor.',
  'settings.orbit.artifactMetaLegacy': 'Dibuat sebelum dukungan live artifact diaktifkan — jalankan Orbit lagi untuk menerbitkannya.',
  'settings.orbit.copyMarkdownTitle': 'Salin ringkasan markdown ke clipboard',
  'settings.orbit.copied': 'Tersalin',
  'settings.orbit.copy': 'Salin',
  'settings.orbit.openArtifact': 'Buka artifact',
  'settings.orbit.sourceMarkdown': 'Markdown sumber',
  'notify.successTitle': 'Pembuatan selesai',
  'notify.failureTitle': 'Pembuatan gagal',
  'notify.successBody': 'Artifact siap dilihat.',
  'notify.failureBody': 'Cek chat untuk detail error.',
  'updater.available': 'Update tersedia',
  'updater.activeRunsTitle': 'OpenDesign masih bekerja',
  'updater.activeRunsBody': '{count} tugas aktif masih berjalan. Memulai ulang sekarang akan menghentikannya.',
  'updater.activeRunsUnknownBody': 'OpenDesign tidak dapat memastikan apakah ada tugas yang masih berjalan. Memulai ulang dapat menghentikan pekerjaan aktif.',
  'updater.availableBody': 'OpenDesign {version} tersedia. Update akan diunduh sebelum installer dapat dibuka.',
  'updater.checking': 'Memeriksa update',
  'updater.download': 'Unduh update',
  'updater.downloading': 'Mengunduh update',
  'updater.downloadingPercent': 'Mengunduh update {percent}%',
  'updater.done': 'Selesai',
  'updater.failed': 'Update gagal',
  'updater.installerOpenBody': 'Installer sudah terbuka. OpenDesign sedang ditutup agar Anda dapat menyelesaikan pembaruan.',
  'updater.installerOpened': 'Installer terbuka',
  'updater.later': 'Nanti',
  "updater.allowSilentUpdates": "Izinkan instal otomatis pembaruan in-app di masa depan",
  'updater.openFailedFallback': 'Installer tidak dapat dibuka.',
  'updater.installRestart': 'Instal dan mulai ulang',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': 'Instal pembaruan',
  'updater.opening': 'Membuka installer...',
  'updater.dialogAvailableGeneric': 'Versi baru tersedia.\nUnduh untuk memasang pembaruan.',
  'updater.dialogAvailableVersion': 'v{version} tersedia.\nUnduh untuk memasang pembaruan.',
  'updater.dialogCheckFailed': 'Pembaruan tidak dapat diperiksa\nInformasi versi sementara tidak tersedia. Periksa koneksi jaringan Anda lalu coba lagi.',
  'updater.dialogDownloadFailed': 'Unduhan pembaruan belum selesai\nPastikan koneksi jaringan Anda berfungsi, lalu coba lagi.',
  'updater.downloadFailedTitle': 'Unduhan pembaruan belum selesai',
  'updater.dialogReadyGeneric': 'Versi baru siap.\nPengalaman lebih baik, desain lebih cerdas.',
  'updater.dialogReadyVersion': 'v{version} siap.\nPengalaman lebih baik, desain lebih cerdas.',
  'updater.dialogUnsupported': 'Pembaruan dalam aplikasi tidak tersedia di sini.\nUnduh versi terbaru dari halaman rilis.',
  'updater.payloadReadyGeneric': 'A new OpenDesign update is ready. OpenDesign will close and restart automatically.',
  'updater.payloadReadyVersion': 'OpenDesign {version} is ready. OpenDesign will close and restart automatically.',
  'updater.quitButton': 'Tutup OpenDesign',
  'updater.quitFailedBody': 'Installer sudah terbuka, tetapi OpenDesign tidak dapat ditutup. Tutup OpenDesign sebelum mengganti aplikasi.',
  'updater.quitFailedTitle': 'Tidak dapat menutup',
  'updater.quitting': 'Menutup...',
  'updater.ready': 'Update siap',
  'updater.readyGeneric': 'Versi baru siap. OpenDesign akan ditutup dan membuka installer.',
  'updater.readyVersion': 'OpenDesign {version} siap. OpenDesign akan ditutup dan membuka installer.',
  'updater.reinstallLearnMore': 'Pelajari lebih lanjut',
  'updater.reinstallReadyGeneric': 'Pembaruan ini memerlukan instal ulang penuh. OpenDesign akan menutup dan membuka pemasang.',
  'updater.reinstallReadyVersion': 'OpenDesign {version} memerlukan instal ulang penuh. OpenDesign akan menutup dan membuka pemasang.',
  'updater.restartAnyway': 'Tetap mulai ulang',
  'updater.upToDate': 'Anda sudah menggunakan versi terbaru.',
  'updater.viewVersionFeatures': 'Lihat fitur versi baru',
  'updater.manualDownload': 'Unduh manual',
  'whatsNew.updatedTitle': 'OpenDesign {version} sudah hadir',
  'whatsNew.cta': 'Lihat catatan rilis',
  'newsletter.label': 'Newsletter (optional)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineHintByokNeutral': 'Memori menggunakan model yang berbeda dari chat. Default-nya adalah model chat Anda.',
  'settings.memoryModelInlineFlashSaved': 'Tersimpan',
  'settings.memoryModelInlineFlashCleared': 'Dihapus',
  'diagnostics.exportTitle': 'Ekspor diagnostik',
  'diagnostics.exportButton': 'Ekspor diagnostik',
  'diagnostics.exportHint': 'Mengemas log aplikasi terbaru dan info perangkat ke dalam zip untuk dibagikan ke tim.',
  'diagnostics.exporting': 'Mengekspor…',
  'diagnostics.exportSuccess': 'Diagnostik disimpan di {path}',
  'diagnostics.exportFailed': 'Gagal mengekspor diagnostik: {message}',
  'automations.eyebrow': 'Sesi agent terjadwal',
  'automations.title': 'Automasi',
  'automations.lede': 'Rencanakan percakapan berulang untuk pekerjaan proyek, digest Orbit, dan artefak langsung.',
  'automations.summaryAria': 'Ringkasan automasi',
  'automations.metricActive': 'Aktif',
  'automations.metricPaused': 'Dijeda',
  'automations.metricTemplates': 'Templat',
  'automations.newAutomation': 'Automasi baru',
  'automations.yourAutomations': 'Automasi Anda',
  'automations.loading': 'Memuat',
  'automations.emptyTitle': 'Belum ada automasi',
  'automations.emptyBody': 'Buat dari templat atau mulai dengan jadwal kosong.',
  'automations.targetNewEachRun': 'Proyek baru setiap kali berjalan',
  'automations.targetCreateEachRun': 'Proyek baru setiap kali berjalan',
  'automations.lastRun': 'Terakhir berjalan {time}',
  'automations.openResult': 'Buka hasil',
  'automations.run': 'Jalankan',
  'automations.runNowTitle': 'Jalankan sekarang dan buka percakapan',
  'automations.history': 'Riwayat',
  'automations.hideHistory': 'Sembunyikan riwayat',
  'automations.edit': 'Edit',
  'automations.pause': 'Jeda',
  'automations.resume': 'Lanjutkan',
  'automations.deleteAria': 'Hapus automasi',
  'automations.deleteTitle': 'Hapus automasi ini',
  'automations.deleteConfirm': 'Hapus automasi ini? Riwayat proses sebelumnya dan proyeknya tetap disimpan.',
  'automations.proposalsTitle': 'Usulan evolusi',
  'automations.proposalsSub': 'Tinjau keluaran automasi sebelum mengubah memori, skill, atau design system.',
  'automations.proposalsPending': '{n} tertunda',
  'automations.apply': 'Terapkan',
  'automations.reject': 'Tolak',
  'automations.proposalsDismissReason': 'Diabaikan di Automasi',
  'automations.templatesTitle': 'Templat',
  'automations.templatesSub': 'Orbit dan artefak langsung adalah templat di dalam alur automasi yang sama.',
  'automations.templatesCount': '{filtered} dari {total}',
  'automations.templateFiltersAria': 'Filter templat',
  'automations.templatesEmptyTitle': 'Belum ada templat di kategori ini.',
  'automations.templatesEmptyBody': 'Coba filter lain, atau mulai dari automasi kosong.',
  'automations.useTemplate': 'Gunakan templat',
  'automations.runHistoryLoading': 'Memuat riwayat proses...',
  'automations.runHistoryEmpty': 'Belum ada proses.',
  'automations.runHistoryTitle': 'Riwayat proses',
  'automations.runHistoryLatest': '10 terbaru',
  'automations.crystallize': 'Kristalkan',
  'automations.crystallizing': 'Mengkristalkan',
  'automations.crystallizeTitle': 'Buat draf usulan skill dan memori dari proses ini',
  'automations.crystallizeFailed': 'Crystallize failed: {error}',
  'automations.crystallizePartialSuccess': 'Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.',
  'automations.crystallizeRefreshFailed': 'Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.',
  'automations.crystallizeNoProposals': 'Crystallize finished, but no proposals were returned. Try refreshing or check the run details.',
  'automations.openConversation': 'Buka percakapan',
  'automations.runHistoryAria': 'Riwayat proses automasi',
  'automations.proposalsAria': 'Usulan evolusi automasi',
  'automations.templatesAria': 'Templat automasi',
  'automations.runInProgress': 'Sedang berjalan',
  'automations.promptPlaceholder': 'Tarik aktivitas GitHub + Linear kemarin dan ringkas apa yang berubah.',
  'automations.scheduleStatusPaused': 'Dijeda',
  'automations.nextRunManualOnly': 'Manual saja',
  'automations.nextRunScheduled': 'Terjadwal',
  'automations.nextRunAt': 'Berikutnya {time}',
  'automations.statusSucceeded': 'Berhasil',
  'automations.statusFailed': 'Gagal',
  'automations.statusRunning': 'Berjalan',
  'automations.statusQueued': 'Dalam antrean',
  'automations.statusCanceled': 'Dibatalkan',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'Artefak langsung',
  'automations.kindAutomation': 'Automasi',
  'automations.proposalTargetMemory': 'Memori',
  'automations.proposalTargetDesignSystem': 'Sistem desain',
  'automations.proposalTargetSkill': 'Skill',
  'automations.proposalTargetTemplate': 'Templat automasi',
  'automations.proposalActionCreate': 'Buat',
  'automations.proposalActionUpdate': 'Perbarui',
  'automations.proposalActionMerge': 'Gabungkan',
  'automations.proposalActionMove': 'Pindahkan',
  'automations.proposalActionDelete': 'Hapus',
  'automations.proposalActionPromote': 'Naikkan',
  'automations.filterAll': 'Semua',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'Artefak langsung',
  'automations.filterMemory': 'Memori',
  'automations.filterDesignSystems': 'Design system',
  'automations.filterSkills': 'Skill',
  'automations.filterConnectors': 'Konektor',
  'automations.filterCompression': 'Kompresi',
  'automations.filterRelease': 'Rilis',
  'automations.filterQuality': 'Kualitas',
  'automations.tpl.memoryRefresh.title': 'Segarkan memori proyek dari pekerjaan terbaru.',
  'automations.tpl.memoryRefresh.desc': 'Mengubah keputusan, preferensi, dan masukan yang berulang menjadi pembaruan memori yang dapat digunakan kembali.',
  'automations.tpl.designSystemRefresh.title': 'Perbarui design system dari artefak yang sudah dirilis.',
  'automations.tpl.designSystemRefresh.desc': 'Menemukan token, komponen, dan aturan yang dapat digunakan kembali di seluruh pekerjaan desain terbaru.',
  'automations.tpl.liveArtifactRegistry.title': 'Audit artefak langsung dan segarkan versi yang usang.',
  'automations.tpl.liveArtifactRegistry.desc': 'Menjaga dasbor, laporan, dan pratinjau persisten tetap terkini alih-alih menggandakannya.',
  'automations.tpl.orbitDashboard.title': 'Bangun dasbor aktivitas konektor.',
  'automations.tpl.orbitDashboard.desc': 'Menggabungkan konektor terpilih menjadi dasbor langsung bergaya Orbit.',
  'automations.tpl.releaseNotes.title': 'Buat draf catatan rilis dari pekerjaan desain yang sudah dirilis.',
  'automations.tpl.releaseNotes.desc': 'Menghubungkan PR yang sudah digabung, artefak, dan perubahan yang berhadapan dengan produk menjadi catatan rilis.',
  'automations.tpl.qualityRegressionWatch.title': 'Pantau regresi desain dan implementasi.',
  'automations.tpl.qualityRegressionWatch.desc': 'Membandingkan perubahan terbaru dengan tolok ukur, jejak, dan referensi yang diterima.',
  'automations.tpl.orbitDaily.title': 'Digest konektor harian.',
  'automations.tpl.orbitDaily.desc': 'Menyegarkan digest aktivitas konektor sesuai jadwal.',
  'automations.tpl.liveStatusBoard.title': 'Jaga artefak status langsung tetap segar.',
  'automations.tpl.liveStatusBoard.desc': 'Memperbarui satu artefak persisten alih-alih membuat laporan baru setiap kali berjalan.',
  'dsManager.areaAria': 'Area design system',
  'dsManager.tabDesignSystem': 'Sistem desain',
  'dsManager.tabTemplate': 'Templat',
  'dsManager.sourceAria': 'Sumber design system',
  'dsManager.templateSourceAria': 'Sumber templat',
  'dsManager.yourSystems': 'Sistem Anda',
  'dsManager.officialPresets': 'Preset resmi',
  'dsManager.shareToTeam': 'Share to team',
  'dsManager.shareToTeamFailed': 'Couldn\'t share to team',
  'dsManager.syncToTeam': 'Sinkronkan ke tim',
  'dsManager.syncToTeamFailed': 'Gagal menyinkronkan ke tim',
  'dsManager.unshareFromTeam': 'Remove from team',
  'dsManager.unshareFromTeamFailed': 'Couldn\'t remove from team',
  'dsManager.teamSyncedReadOnly': 'Only the sharer or a workspace admin can change this',
  'dsManager.enterprise': 'Perusahaan',
  'dsManager.yourTemplates': 'Templat Anda',
  'dsManager.yourSystemsAria': 'Design system Anda',
  'dsManager.eyebrowDesignSystems': 'Design System',
  'dsManager.yourSystemsHeading': 'Sistem Anda',
  'dsManager.filterAria': 'Filter design system',
  'dsManager.filterAll': 'Semua',
  'dsManager.filterPublished': 'Diterbitkan',
  'dsManager.filterDraft': 'Draf',
  'dsManager.createTitle': 'Buat design system baru',
  'dsManager.createBody': 'Ajarkan OpenDesign tentang brand, produk, kode, aset, dan referensi desain Anda.',
  'dsManager.createAction': 'Buat',
  'dsManager.emptyMine': 'Belum ada design system. Buat dari konteks produk nyata, tinjau drafnya, lalu terbitkan untuk proyek mendatang.',
  'dsManager.badgeDefault': 'Default',
  'dsManager.rowMetaUpdated': 'Anda · diperbarui {date}',
  'dsManager.edit': 'Edit',
  'dsManager.openSystem': 'Buka',
  'dsManager.editWithAgent': 'Edit dengan Agent',
  'dsManager.downloadTitle': 'Unduh design system (.zip + SKILLS.md)',
  'dsManager.downloadAria': 'Unduh {title} sebagai .zip',
  'dsManager.downloadFailed': 'Design system tidak dapat diunduh. Coba lagi.',
  'dsManager.deleteConfirm': 'Hapus "{title}"? Ini akan menghapus draf design system dari perangkat ini.',
  'dsManager.makeDefault': 'Jadikan default',
  'dsManager.statusPublished': 'Diterbitkan',
  'dsManager.statusDraft': 'Draf',
  'dsManager.openSystemAria': 'Buka {title}',
  'dsManager.deleteSystemAria': 'Hapus {title}',
  'dsManager.deletePermissionDenied': 'Anda tidak memiliki izin untuk menghapus sistem desain ini.',
  'dsManager.presetsAria': 'Preset design system resmi',
  'dsManager.eyebrowLibrary': 'Pustaka',
  'dsManager.eyebrowTemplates': 'Templat',
  'dsManager.yourTemplatesAria': 'Templat Anda',
  'dsManager.emptyTemplates': 'Belum ada templat. Buat dari proyek mana pun yang dihasilkan melalui Bagikan setelah penerbitan templat diaktifkan.',
  'dsManager.templateDescFallback': 'Dibuat dari sebuah proyek',
  'dsManager.comingSoonBadge': 'Segera hadir',
  'dsManager.enterpriseDsTitle': 'Design system enterprise',
  'dsManager.enterpriseDsBody': 'Design system tim bersama dan pustaka brand terkelola akan segera hadir.',
  'dsManager.enterpriseTplTitle': 'Templat enterprise',
  'dsManager.enterpriseTplBody': 'Templat yang disetujui tim dan penerbitan tingkat organisasi akan segera hadir.',
  'settings.instructionsTitle': 'Instruksi dan aturan',
  'settings.instructionsSubtitle': 'Perilaku tetap yang harus diikuti asisten',
  'settings.instructionsNavSub': 'Perilaku asisten tetap',
  'settings.customInstructionsDesc': 'Instruksi tetap yang diikuti OpenDesign di setiap obrolan. Ini bukan memori tersimpan; gunakan Memori untuk fakta, preferensi, dan konteks proyek.',
  'mcpClient.forwardedToLabel': 'Diteruskan ke:',
  'mcpClient.notForwardedToLabel': 'Tidak diteruskan ke:',
  'mcpClient.forwardedAcpNote': 'Adaptor ACP yang ditandai stdio hanya menerima server MCP stdio dari daftar ini; entri HTTP dan SSE dibuang saat spawn.',
  'mcpClient.notForwardedNote': 'Untuk agent tersebut, konfigurasikan server MCP di file konfigurasi agent itu sendiri (mis. ~/.codex/config.toml, ~/.gemini/settings.json); server di bawah ini tidak digunakan di sana tanpa pemberitahuan.',

  // Brands library + extraction
  'brand.libraryTitle': 'Kit Merek',
  'brand.librarySubtitle': 'Teach OpenDesign your brand kits — extract one from a website, then apply it in any chat.',
  'brand.newBrand': 'New Brand Kit',
  'brand.searchPlaceholder': 'Search your brand kits…',
  'brand.empty': 'No brand kits yet. Extract one from a website to get started.',
  'brand.colorsCount': '{count} colors',
  'brand.extracting': 'Extracting…',
  'brand.failed': 'Extraction failed',
  'brand.needsInput': 'Needs input',
  'brand.needsInputHint': 'Extraction paused — open the project to finish verification or answer the question.',
  'brand.appliedToChat': 'Using {name}',
  'brand.previewEmpty': 'Select a brand to preview',
  'brand.viewDetails': 'View details',
  'newBrand.title': 'New Brand',
  'newBrand.subtitle': 'Tempel situs web, atau pilih brand di bawah, dan kami akan mengekstrak warna, font, dan logonya.',
  'newBrand.urlLabel': 'Brand website',
  'newBrand.urlPlaceholder': 'yourcompany.com',
  'newBrand.extract': 'Extract brand',
  'newBrand.cancel': 'Cancel',
  'newBrand.close': 'Close',
  'newBrand.stage1': 'Fetching the site & measuring its design',
  'newBrand.stage2': 'Building a brand preview',
  'newBrand.stage3': 'Deriving & registering the design system',
  'newBrand.measured': '{colors} colors · {fonts} fonts · {logos} logos',
  'newBrand.done': 'Brand ready',
  'brandDetail.identity': 'Identity',
  'brandDetail.designLanguage': 'Design Language',
  'brandDetail.colors': 'Colors',
  'brandDetail.fonts': 'Fonts',
  'brandDetail.tone': 'Tone',
  'brandDetail.aesthetic': 'Aesthetic',
  'brandDetail.tagline': 'Tagline',
  'brandDetail.voice': 'Voice',
  'brandDetail.useInChat': 'Use in new chat',
  'brandDetail.delete': 'Delete brand',
  'brandDetail.back': 'Kit Merek',
  'brandDetail.refining': 'Refining this brand…',
  'brandDetail.notFound': 'Brand not found.',
  'brandDetail.logo': 'Logo',
  'brandDetail.typography': 'Typography',
  'brandDetail.palette': 'Palette',
  'brandDetail.voiceTone': 'Voice & tone',
  'brandDetail.imageryLayout': 'Imagery & layout',
  'brandDetail.images': 'Images',
  'brandDetail.designSystem': 'Design system',
  'brandDetail.brandAssets': 'Brand assets',
  'brandDetail.openProject': 'Open project',
  'brandDetail.themeLight': 'Light',
  'brandDetail.themeDark': 'Dark',
  'brandDetail.subjects': 'Subjects',
  'brandDetail.treatment': 'Treatment',
  'brandDetail.useLabel': 'Use',
  'brandDetail.avoidLabel': 'Avoid',
  'brandDetail.layoutPosture': 'Layout posture',
  'brandDetail.deleteConfirm': 'Delete "{name}"? This removes the brand and its design system.',
  'brandDetail.viewMore': 'Show all {count}',
  'brandDetail.viewLess': 'Show less',
  'settings.resetOnboarding': 'Reset onboarding',
  'settings.resetOnboardingDesc': 'Replay the first-run setup, including brand extraction.',
  'settings.resetOnboardingButton': 'Reset',
  'settings.clearUpdaterCacheTitle': 'Bersihkan cache pembaruan',
  'settings.clearUpdaterCacheHint': 'Menghapus pembaruan yang diunduh dan cache pembaruan usang, lalu mengatur ulang status pembaruan. Gunakan saat pembaruan tampak macet.',
  'settings.clearUpdaterCacheButton': 'Bersihkan cache',
  'settings.clearUpdaterCacheConfirmButton': 'Konfirmasi pembersihan',
  'settings.clearUpdaterCacheSuccess': 'Cache pembaruan dibersihkan.',
  'settings.clearUpdaterCacheFailed': 'Tidak dapat membersihkan cache pembaruan.',
  'onboarding.brandTitle': 'Extract your brand kit',
  'onboarding.brandSubtitle': 'Paste a website and we\'ll turn its brand signals into a reusable brand kit for future work.',
  'onboarding.brandSkip': 'Skip for now',
  'onboarding.brandDone': 'Brand kit extracted',
  'onboarding.buildTitle': 'Buat sekali, bangun di mana saja',
  'onboarding.buildBody': 'OpenDesign mengubah brand Anda menjadi design system yang dapat digunakan kembali — lalu menjaga semua yang Anda buat tetap konsisten dan sesuai brand.',
  'onboarding.buildBenefitMemoryTitle': 'One brand memory',
  'onboarding.buildBenefitMemoryBody': 'Colors, type, spacing, components, and voice become a DESIGN.md your agents can reuse.',
  'onboarding.buildBenefitAlignedTitle': 'Every output stays aligned',
  'onboarding.buildBenefitAlignedBody': 'Prototype, slide, PDF, dashboard, and marketing work all pull from the same rules.',
  'onboarding.buildBenefitSourcesTitle': 'Start from what you have',
  'onboarding.buildBenefitSourcesBody': 'Use a GitHub repo, website, existing DESIGN.md, screenshots, fonts, or Figma files.',
  'onboarding.buildPreviewLabel': 'Brand system',
  'onboarding.buildStart': 'Buat design system',
  'onboarding.buildHome': 'Ke beranda',
  'dsCreate.referenceLabel': 'Copy from existing design system',
  'dsCreate.referenceLoading': 'Loading DESIGN.md...',
  'dsCreate.referenceLoadFailed': 'Could not load that design system.',
  'dsCreate.heroShowGuideAria': 'Show design system guide',
  'dsCreate.heroHideGuideAria': 'Hide design system guide',
  'dsCreate.heroShowGuideTitle': 'Show guide',
  'dsCreate.heroHideGuideTitle': 'Hide guide',
  'dsCreate.heroGuide': 'Guide',
  'dsCreate.missingSourceError': 'Add a website, DESIGN.md, description, file, Figma source, or notes to create a design system.',
  'dsCreate.continueToGeneration': 'Continue to generation',
  'dsCreate.embeddedTitle': 'Generate from your material',
  'dsCreate.embeddedBody': 'Start with a website or brand reference, then add any source files you already have.',
  'dsCreate.sourceSectionTitle': 'Extract from GitHub, websites, or source material',
  'dsCreate.sourceSectionBody': 'Start with a GitHub repo, website, DESIGN.md, or files that show your style. OpenDesign first creates a usable system quickly, then AI can refine it inside the project.',
  'dsCreate.githubWebsiteLabel': 'GitHub or website',
  'dsCreate.add': 'Add',
  'dsCreate.startFromBrand': 'Start from a brand',
  'dsCreate.brandPickerSubtitle': 'Search hundreds of brands — pick one and we\'ll add its site as a style reference.',
  'dsCreate.brandPickerQuickPicks': 'Popular brands — click to add',
  'dsCreate.addedSourceLinks': 'Added source links',
  'dsCreate.openSourceLabel': 'Open {label}',
  'dsCreate.removeSourceLabel': 'Remove {label}',
  'dsCreate.addFiles': 'Add files',
  'dsCreate.describeBrand': 'Describe brand',
  'dsCreate.optional': 'optional',
  'dsCreate.describeBrandHelp': 'Brand voice, intro and product context. Used in the fast pass and AI refinement.',
  'dsCreate.companyPlaceholder': 'e.g. Mission Impastabowl: fast-casual pasta restaurant with kiosk, mobile app and website',
  'dsCreate.pasteDesignMd': 'Paste DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Paste a DESIGN.md to create directly from tokens, rationale and component guidance.',
  'dsCreate.reference': 'Reference',
  'dsCreate.designMdViewMode': 'DESIGN.md view mode',
  'dsCreate.advancedToggle': 'Advanced — repo, local code, Figma',
  'dsCreate.githubRepo': 'GitHub repo',
  'dsCreate.localCodeLabel': 'Link local code',
  'dsCreate.localCodeHelper': 'Use a folder or selected files from this computer.',
  'dsCreate.localCodePrompt': 'Drag a folder here or browse',
  'dsCreate.uploadFigLabel': 'Upload .fig',
  'dsCreate.uploadFigHelper': 'Decoded on your machine into real tokens, components & assets — no Figma account.',
  'dsCreate.uploadFigPrompt': 'Drop .fig here or browse',
  'dsCreate.figmaUrl': 'Figma URL',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/… or /file/…',
  'dsCreate.addedFigmaUrls': 'Added Figma URLs',
  'dsCreate.savedFigmaHelp': 'Saved as a Figma design source. The agent uses it as the canonical reference; export a .fig above for a full offline decode.',
  'dsCreate.notes': 'Notes',
  'dsCreate.notesPlaceholder': 'e.g. We use a warm, earthy color palette with rounded corners. Our brand voice is playful but professional...',
  'dsCreate.back': 'Back',
  'dsCreate.generate': 'Generate',
  'dsCreate.libraryPickerTitle': 'Select from library',
  'dsCreate.libraryPickerConfirm': 'Add to assets',
  'dsCreate.designMdPreviewKicker': 'DESIGN SYSTEM',
  'dsCreate.designMdPreviewTitle': 'DESIGN.md preview',
  'dsCreate.componentKit': 'component kit',
  'dsCreate.defaultTheme': 'default theme',
  'dsCreate.componentKitTitle': '{name} — component kit',
  'dsCreate.designMdGeneratedDescription': 'Generated from pasted DESIGN.md tokens, rationale and component guidance.',
  'dsCreate.previewButtons': 'Buttons',
  'dsCreate.previewButtonsHelp': 'Five types across three sizes.',
  'dsCreate.buttonPrimary': 'Primary',
  'dsCreate.buttonDashed': 'Dashed',
  'dsCreate.buttonText': 'Text',
  'dsCreate.buttonLink': 'Link',
  'dsCreate.sizeSmall': 'Small',
  'dsCreate.sizeMedium': 'Medium',
  'dsCreate.sizeLarge': 'Large',
  'dsCreate.previewTypeScale': 'Type scale',
  'dsCreate.extractedTokens': 'Extracted DESIGN.md tokens',
  'brandPicker.categorySoftware': 'Software',
  'brandPicker.categoryFinance': 'Finance',
  'brandPicker.categoryFashion': 'Fashion',
  'brandPicker.categoryActivewear': 'Activewear',
  'brandPicker.categoryBeauty': 'Beauty',
  'brandPicker.categoryWellness': 'Wellness',
  'brandPicker.categoryFood': 'Food',
  'brandPicker.categoryBeverage': 'Beverage',
  'brandPicker.categoryMedia': 'Media',
  'brandPicker.categoryEducation': 'Education',
  'brandPicker.categoryElectronics': 'Electronics',
  'brandPicker.categoryAutomotive': 'Automotive',
  'brandPicker.categoryHealthcare': 'Healthcare',
  'brandPicker.categoryTravel': 'Travel',
  'brandPicker.heading': 'Mulai dari brand yang kamu suka',
  'brandPicker.subtext': 'Klik brand mana pun untuk mengekstrak kit-nya langsung dari situs webnya.',
  'brandPicker.quickPicksLabel': 'Brand populer — klik untuk mengekstrak',
  'brandPicker.searchPlaceholder': 'Cari brand…',
  'brandPicker.allCategories': 'Semua',
  'brandPicker.extractAction': 'Ekstrak',
  'brandPicker.showMore': 'Tampilkan lebih banyak',
  'brandPicker.opening': 'Memulai ekstraksi — membuka {brand}…',
  'ds.kitVisualize': 'Visualisasi',
  'ds.kitEdit': 'Edit',
  'ds.kitSource': 'Sumber',
  'ds.saveDesignMd': 'Simpan DESIGN.md',
  'ds.saving': 'Menyimpan…',
  'ds.copyDesignMd': 'Salin DESIGN.md',
  'ds.editDesignMd': 'Edit DESIGN.md',
  'ds.openDesignMd': 'Buka DESIGN.md',
  'ds.copyDesignMdModule': 'Salin bagian {module}',
  'ds.editDesignMdModule': 'Edit bagian {module}',
  'ds.openDesignMdModule': 'Buka bagian {module}',
  'ds.uploadMd': 'Unggah MD',
  'ds.uploadFont': 'Tambah file font',
  'ds.pasteImage': 'Tempel gambar',
  'ds.refresh': 'Segarkan',
  'ds.download': 'Unduh',
  'ds.importFolder': 'Impor folder',
  'ds.reset': 'Atur ulang',
  'ds.editingDesignMdHint': 'Mengedit Markdown ini akan memperbarui modul kit yang dirender.',
  'ds.editingModuleHint': 'Hanya modul {module} yang sedang diedit.',
  'ds.manualEditModuleHint': 'Edit {module} here. Hover this section to reveal controls.',
  'ds.saveModule': 'Simpan modul',
  'ds.uploadLogo': 'Unggah logo',
  'ds.uploadImage': 'Unggah gambar',
  'ds.uploading': 'Mengunggah…',
  'ds.moduleEmptyLogo': 'Belum ada logo',
  'ds.moduleEmptyFonts': 'Belum ada font yang ditangkap.',
  'ds.actionDone': 'Selesai',
  'ds.actionFailed': 'Ada yang salah. Coba lagi.',
  'ds.uploadDone': 'Terunggah',
  'ds.uploadFailed': 'Unggahan gagal. Coba lagi.',
  'ds.deleteLogo': 'Hapus logo',
  'ds.deleteImage': 'Hapus {caption}',
  'ds.deleteProjectConfirm': 'Hapus "{title}"? Ini akan menghapus design system dan proyeknya secara permanen dari perangkat ini.',
  'ds.deleteProjectAction': 'Hapus {title}',
  'ds.editColor': 'Edit {name}',
  'ds.colorLabel': 'Warna',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'Nilai Hex',
  'ds.saveColor': 'Simpan warna',
  'ds.invalidHexColor': 'Masukkan warna Hex yang valid, misalnya #FF6A3D.',
  'ds.colorSaveFailed': 'Warna ini tidak dapat disimpan.',
  'ds.colorResetFailed': 'Warna ini tidak dapat diatur ulang.',
  'ds.designMdSectionLabel': 'Bagian {module} DESIGN.md',
  'ds.kitErrorTitle': 'Tampilan ini mengalami masalah.',
  'ds.kitErrorRetry': 'Muat ulang',
  'ds.shortcutsLabel': 'Pintasan keyboard',
  'ds.shortcutsHint': 'Pintasan: E edit · C salin · U unggah · R segarkan · ⌫ hapus logo',
  'ds.moduleEmptyImages': 'Belum ada gambar',
  'ds.noOriginalColor': 'No original color is available for this swatch.',
  'ds.manifestReadFailed': 'Unable to read _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Collapse {title}',
  'ds.reviewExpandSection': 'Expand {title}',
  'ds.reviewNeedsReview': 'Needs review',
  'ds.reviewLooksGood': 'Looks good',
  'ds.reviewActionsLabel': '{title} review',
  'ds.reviewNeedsWorkEllipsis': 'Needs work...',
  'ds.reviewEditFile': 'Edit {file}',
  'ds.reviewFeedbackLabel': 'Tell the agent what to change',
  'ds.reviewFeedbackPlaceholder': 'e.g. tighten spacing in {title}, regenerate this preview...',
  'ds.reviewChangedAfterFeedback': 'This section changed after your feedback. Review it again before publishing.',
  'ds.reviewChangedDuringRun': 'This section changed during the latest run. Review it before publishing.',
  'ds.reviewLastFeedback': 'Last feedback',
  'ds.previewGenerating': 'Generating preview...',
  'ds.creatingProjectTitle': 'Creating your design system...',
  'ds.creatingProjectSubtitle': 'Keep this tab open. You can come back in a few minutes.',
  'ds.generationProgressLabel': 'Design system generation progress {progress}%',
  'ds.publishRepoRequiredTitle': 'Finish importing your GitHub repo before you can publish.',
  'ds.publishDesignSystem': 'Publish design system',
  'ds.unpublishDesignSystem': 'Unpublish design system',
  'ds.published': 'Published',
  'ds.publish': 'Publish',
  'ds.extractionRunningTitle': 'Extracting design system',
  'ds.extractionCompleteTitle': 'Extraction complete',
  'ds.extractionRunningBody': 'OpenDesign is updating this system in place.',
  'ds.extractionCompleteBody': 'All extracted modules are shown below; empty sections are intentionally blank.',
  'ds.publishCardPublished': 'Your team\'s new projects can use this design system as context by default.',
  'ds.publishCardDraft': 'Your design system is ready, but your feedback will improve it. Publish it when it is ready to use in future projects.',
  'ds.useSystemTitle': 'Use this system',
  'ds.useSystemBody': 'Start a new design that inherits this system\'s colors, type, and components - kept on-brand automatically.',
  'ds.createNewDesign': 'Create new design',
  'ds.openSourceContext': 'Open source context',
  'ds.manifestNeedsAttention': 'Design manifest needs attention',
  'ds.openManifest': 'Open manifest',
  'ds.workspacePreparing': 'Preparing the design system workspace.',
  'ds.workspaceLoadingLabel': 'Design system workspace is loading',
  'ds.sectionQueued': 'Queued',
  'ds.sectionReviewUpdatedFiles': 'Updated files need review',
  'ds.reviewNeedsWork': 'Needs work',
  'ds.sectionRequiredFileMissing': 'Required file missing: {file}',
  'ds.sectionNoFilesYet': 'No files yet',
  'ds.generationSourceTitle': 'Source context',
  'ds.generationSourceDetail': 'Reading linked source context and repository evidence.',
  'ds.generationGuidanceTitle': 'Brand guidance',
  'ds.generationGuidanceDetail': 'Writing DESIGN.md guidance and voice.',
  'ds.generationTokensTitle': 'Design tokens',
  'ds.generationTokensDetail': 'Extracting colors, type, and spacing tokens.',
  'ds.generationPreviewsTitle': 'Preview cards',
  'ds.generationPreviewsDetail': 'Rendering reviewable preview cards.',
  'ds.generationUiKitTitle': 'UI kit',
  'ds.generationUiKitDetail': 'Creating reusable components and patterns.',
  'ds.generationAssetsTitle': 'Brand assets',
  'ds.generationAssetsDetail': 'Collecting logos, fonts, images, and icons.',
  'ds.phaseQueuedTypography': 'Typography queued',
  'ds.phaseQueuedTokens': 'Tokens queued',
  'ds.phaseQueuedSpacing': 'Spacing queued',
  'ds.phaseQueuedUiKit': 'UI kit queued',
  'ds.phaseQueuedAssets': 'Assets queued',
  'ds.phaseReadingTypography': 'Reading typography',
  'ds.phaseReadingTokens': 'Reading tokens',
  'ds.phaseReadingSpacing': 'Reading spacing',
  'ds.phaseReadingUiKit': 'Reading UI kit',
  'ds.phaseReadingAssets': 'Reading assets',
  'ds.phaseWritingTypography': 'Writing typography',
  'ds.phaseWritingTokens': 'Writing tokens',
  'ds.phaseWritingSpacing': 'Writing spacing',
  'ds.phaseBuildingUiKit': 'Building UI kit',
  'ds.phaseUpdatingAssets': 'Updating assets',
  'ds.phaseNeedsAttention': 'Needs attention',
  'ds.phaseUpdated': 'Updated',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Read {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  'ds.sectionRunningReadingContext': 'Reading context for {title}.',
  'ds.sectionRunningNow': '{phase} now.',
  'ds.reviewLastReviewed': 'Last reviewed {time}',
  'ds.agentFeedbackQueued': 'Agent feedback queued',
  'ds.agentFeedbackSent': 'Agent feedback sent',
  'ds.agentFeedbackSentAt': 'Agent feedback sent {time}',
  'ds.agentFeedbackFailedWithError': 'Agent feedback failed: {error}',
  'ds.agentFeedbackFailed': 'Agent feedback failed',
  'ds.agentFeedbackUnknown': 'Agent feedback status unknown',
  'ds.repoConnectBannerTitle': 'Connect your repo to pull aspects of your design system',
  'ds.repoConnectCardTitle': 'Connect your repo',
  'ds.repoConnectPendingBody': 'Checking your GitHub connection...',
  'ds.repoConnectPendingButton': 'Checking GitHub...',
  'ds.repoConnectedTitle': 'GitHub is connected',
  'ds.repoConnectedBody': 'Re-import this repo to pull its files into your design system.',
  'ds.repoImportButton': 'Import repo',
  'ds.repoConnectBannerBody': 'Connect GitHub so OpenDesign can read your repository and pull colors, type, and components into this design system.',
  'ds.repoConnectCardBody': 'Pull colors, type, and components from your repository into this design system.',
  'ds.repoConnectButton': 'Connect GitHub',
  // Settings > Workspace region (E-frontend, D4.3): role-gated shell for
  // other-lane workspace destinations (members / billing / team space).
  'settings.workspace': 'Workspace',
  'settings.workspaceHint': 'Members, billing, and team spaces',
  'settings.workspaceLede': 'Team-level settings for this workspace. These areas are managed by the team service — open one to continue.',
  'settings.workspaceBack': 'Back to workspace',
  'settings.workspaceMembers': 'Members & invites',
  'settings.workspaceMembersHint': 'Manage who can access this workspace and send invitations.',
  'settings.workspaceBilling': 'Subscription & seats',
  'settings.workspaceBillingHint': 'Plan, seats, and payment for this workspace.',
  'settings.workspaceAutoRecharge': 'Auto-recharge',
  'settings.workspaceAutoRechargeHint': 'Automatically top up credits when the balance runs low.',
  'settings.workspaceTeamSpace': 'Team space',
  'settings.workspaceTeamSpaceHint': 'Shared projects and visibility for your team.',
  // Full-page Settings (`/settings`): sidebar nav head above the section list.
  'settings.pageBackToHome': 'Back to home',
  'settings.pageNavGroupPersonal': 'Personal',
  'newproj.startFromLabel': 'Mulai dari',
  'newproj.startBlank': 'Kosong',
  'newproj.startBlankHint': 'Mulai dari awal',
  'workspace.pages': 'Halaman',
  'workspace.allProjectFiles': 'Semua file proyek',
  'workspace.newBlankPage': 'Halaman kosong baru',
  'workspace.noPagesYet': 'Belum ada halaman',
  'workspace.pageCreateFailed': 'Tidak dapat membuat halaman.',
  'workspace.pageCreatorTitle': 'Buat halaman',
  'workspace.pageCreatorSearch': 'Cari templat',
  'workspace.pageCreatorCategoryAll': 'Semua skenario',
  'workspace.pageCreatorEmpty': 'Tidak ada jenis halaman yang cocok dengan pencarian Anda.',
  'workspace.pageCreatorPreview': 'Pratinjau',
  'workspace.pageCreatorUse': 'Gunakan',
  'fileViewer.presentInTabDeckHint': 'Catatan pembicara di jendela popup',
  'fileViewer.presentEscHint': 'Tekan Esc untuk keluar',
  'fileViewer.presenterPause': 'Jeda',
  'fileViewer.presenterResume': 'Lanjutkan',
  'fileViewer.presenterPrevious': 'Sebelumnya',
  'fileViewer.presenterNext': 'Berikutnya',
  'questions.uploadingFiles': 'Mengunggah file…',
  'questions.uploadNeedsProject': 'Unggah file memerlukan proyek aktif.',
  'questions.uploadPartialFailed': '{uploaded} file terunggah, tetapi {failed} gagal.',
  'questions.uploadFailed': 'Gagal mengunggah {failed} file.',
  // #5517 media-providers redesign: pill selector + single detail card.
  'settings.mediaProviderModelProviders': 'Providers',
  'settings.mediaProviderModel': 'Model',
  'settings.mediaProviderModelPlaceholder': 'Use provider default',
  'settings.mediaProviderDocsTitle': 'Documentation',
  'settings.mediaProviderDocsHint': 'View setup instructions for this provider.',
  'settings.mediaProviderSaveHint': 'Changes are not saved until you select Save.',
  'settings.mediaProviderNoKeyRequired': 'No key required',
  'settings.mediaProviderNoKeyHint': 'This provider uses a local login or bundled runtime.',
  'manualEdit.sectionImage': 'IMAGE',
  'manualEdit.sectionContent': 'CONTENT',
  'manualEdit.sectionPage': 'PAGE',
  'manualEdit.pageBackground': 'Background',
  'manualEdit.pageBaseSize': 'Base size',
  'manualEdit.pageStylesHtmlOnly': 'Page styles are available only for full HTML documents.',
  'pluginsView.createKindPlugin': 'Plugin',
  'pluginsView.createKindSkill': 'Skill',
  'pluginsView.importUrlLabel': 'URL',
  'pluginsView.shareActionBadge': 'Action plugin',
  'pluginsView.shareCloseAria': 'Close share confirmation',
  'pluginsView.shareWhatStarts': 'What this starts',
  'pluginsView.shareSourcePlugin': 'Source plugin',
  'pluginsView.shareFactPlugin': 'Plugin',
  'pluginsView.shareFactId': 'ID',
  'pluginsView.shareFactCopiedTo': 'Copied to',
  'pluginsView.shareFactTrust': 'Trust',
  'pluginsView.shareActionPrompt': 'Action prompt',
  'pluginsView.shareStarting': 'Starting…',
  'community.title': 'Community',
  'community.searchPlaceholder': 'Search',
  'community.searchAria': 'Search',
  'community.filtersAria': 'Template filters',
  'community.closePreview': 'Close preview',
  'community.typePrototype': 'Prototype',
  'community.typeLiveArtifact': 'Live Artifact',
  'community.typeSlides': 'Slides',
  'community.typeDocument': 'Document',
  'community.typeImage': 'Image',
  'community.typeVideo': 'Video',
  'community.typeHyperFrames': 'HyperFrames',
  'community.typeAudio': 'Audio',
  'community.typeWebGL': 'WebGL',
  'community.usePrompt': 'Coba sekarang',
  'community.emptyTitle': 'Belum ada template {type}',
  'community.emptyBody': 'Template yang dipublikasikan ke komunitas akan muncul di sini.',
  'marketplace.title': 'Plugins marketplace',
  'marketplace.filterTrusted': 'Trusted',
  'marketplace.filterRestricted': 'Restricted',
  'marketplace.emptyBefore': 'No plugins installed yet. Try',
  'marketplace.emptyAfter': ', or register a marketplace below.',
  'marketplace.trustPrefix': 'trust: ',
  'marketplace.catalogsTitle': 'Configured catalogs',
  'marketplace.catalogsEmpty': 'None registered. Add one with',
  'marketplace.pluginCount': '{count} plugin(s)',
  'genui.continue': 'Continue',
  'genui.authorize': 'Authorize',
  'genui.skip': 'Skip',
  'genui.acceptAll': 'Accept all',
  'genui.rejectAll': 'Reject all',
  'genui.submit': 'Submit',
  'genui.submitPartial': 'Submit partial decision',
  'genui.patchNotesPlaceholder': 'Notes for the patch author (optional)',
  'inspect.close': 'Close inspect',
  'inspect.colors': 'Colors',
  'inspect.text': 'Text',
  'inspect.background': 'Background',
  'inspect.typography': 'Typography',
  'inspect.size': 'Size',
  'inspect.weight': 'Weight',
  'inspect.align': 'Align',
  'inspect.padding': 'Padding',
  'inspect.radius': 'Radius',
  'inspect.resetElement': 'Reset element',
  'library.title': 'Library',
  'library.headerHint': 'Clip any page, design system, screenshot, image, or Figma import JSON into your Library — local-first, one click, no login.',
  'library.getClipper': 'Get the OpenDesign Web Clipper',
  'library.searchPlaceholder': 'Search captions, tags, titles…',
  'library.filterByKind': 'Filter by kind',
  'library.filterBySource': 'Filter by source',
  'library.kindAll': 'All kinds',
  'library.kindImages': 'Images',
  'library.kindElements': 'Elements',
  'library.kindDesignSystems': 'Design systems',
  'library.kindVideo': 'Video',
  'library.kindFonts': 'Fonts',
  'library.kindColors': 'Colors',
  'library.kindText': 'Text',
  'library.kindLinks': 'Links',
  'library.sourceAll': 'All sources',
  'library.sourceClipper': 'Clipper',
  'library.sourceAgent': 'Agent',
  'library.sourceDesignSystem': 'Design system',
  'library.sourceGenerated': 'Generated',
  'library.viewMode': 'View mode',
  'library.viewGrid': 'Grid',
  'library.viewGridTooltip': 'Show assets as a grid',
  'library.viewTimeline': 'Timeline',
  'library.viewTimelineTooltip': 'Group assets by day, newest first',
  'library.refresh': 'Refresh',
  'library.refreshTooltip': 'Reload the list with the current filters',
  'library.sync': 'Sync',
  'library.syncing': 'Syncing…',
  'library.syncTooltip': 'Pull your design systems and agent-generated artifacts into the Library',
  'library.upload': 'Upload',
  'library.uploadTooltip': 'Upload images, fonts, or files into the Library',
  'library.selectedCount': '{count} selected',
  'library.selectAll': 'Select all',
  'library.clear': 'Clear',
  'library.chatToDesign': 'Chat to design',
  'library.chatToDesignTitle': 'Start a chat to turn {count} into a design',
  'library.working': 'Working…',
  'library.useInDesignSystem': 'Use in design system',
  'library.createDesignSystem': 'Create new design system',
  'library.createDesignSystemSub': 'Open the create flow with these {count} attached',
  'library.refineExisting': 'Refine existing',
  'library.noEditableDesignSystems': 'No editable design systems yet.',
  'library.addAssetsAndRefine': 'Add assets & open to refine',
  'library.deleteCount': 'Delete {count}',
  'library.loading': 'Loading…',
  'library.emptyTitle': 'No assets yet.',
  'library.emptyHintBefore': 'Clip from any page with the OpenDesign Web Clipper, run',
  'library.emptyHintAfter': ', or upload inside a project — everything lands here.',
  'library.dropToUpload': 'Drop to upload to your Library',
  'library.confirmDeleteTitleOne': 'Delete {count} asset?',
  'library.confirmDeleteTitleMany': 'Delete {count} assets?',
  'library.confirmDeleteBodyOne': 'This permanently removes it from your Library. This can’t be undone.',
  'library.confirmDeleteBodyMany': 'This permanently removes them from your Library. This can’t be undone.',
  'library.cancel': 'Cancel',
  'library.today': 'Today',
  'library.yesterday': 'Yesterday',
  'library.previewAsset': 'Preview {title}',
  'library.selectAsset': 'Select asset',
  'library.deselectAsset': 'Deselect asset',
  'library.openDesignSystem': 'Open design system',
  'library.openProject': 'Open project',
  'library.opening': 'Opening…',
  'library.editAsPage': 'Edit as page',
  'library.viewSource': 'Source',
  'library.remove': 'Remove',
  'mcp.aboutTemplate': 'About {name}',
  'mcp.approvedRefresh': 'I’ve approved — Refresh',
  'mcp.approveInBrowserHint': 'Approve in the browser tab that opened. We\'ll catch the callback automatically — or click Refresh below if you completed it already.',
  'mcp.argsPlaceholder': 'space-separated',
  'mcp.authModeNone': 'No managed OAuth',
  'mcp.authModeOAuth': 'Managed OAuth',
  'mcp.browserDidntOpen': 'Browser didn\'t open?',
  'mcp.categoryDataViz': 'Data viz',
  'mcp.categoryDataVizHint': 'Charts and diagrams as proper image artifacts.',
  'mcp.categoryDesignSystems': 'Design systems',
  'mcp.categoryDesignSystemsHint': 'Figma read/write, design-token translation, brand inspiration.',
  'mcp.categoryImageEditing': 'Image editing',
  'mcp.categoryImageEditingHint': 'Local post-processing, OCR and CV-driven edits.',
  'mcp.categoryImageGeneration': 'Image generation',
  'mcp.categoryImageGenerationHint': 'Models that produce raster, vector or video assets.',
  'mcp.categoryPublishing': 'Publishing',
  'mcp.categoryPublishingHint': 'Push generated artifacts to a public URL.',
  'mcp.categoryUiComponents': 'UI components',
  'mcp.categoryUiComponentsHint': 'Designer-grade components, blocks and landing-page material.',
  'mcp.categoryUtilities': 'Utilities',
  'mcp.categoryUtilitiesHint': 'Filesystem, fetch, GitHub and similar generic tools.',
  'mcp.categoryWebCapture': 'Web capture',
  'mcp.categoryWebCaptureHint': 'Render a URL into an image so the agent can see what it built.',
  'mcp.checking': 'Checking…',
  'mcp.clickConnectHint': 'Click Connect to grant OpenDesign access via the provider\'s OAuth flow.',
  'mcp.closePicker': 'Close picker',
  'mcp.collapse': 'Collapse',
  'mcp.collapseServerAria': 'Collapse this MCP server',
  'mcp.commandPlaceholder': 'e.g. npx, node, /path/to/binary',
  'mcp.commandRequired': 'Command is required for stdio transport.',
  'mcp.completedAuthTitle': 'I\'ve completed authorization — check connection status now',
  'mcp.connect': 'Connect',
  'mcp.connected': 'Connected.',
  'mcp.connecting': 'Connecting…',
  'mcp.customServer': 'Custom server',
  'mcp.customServerDesc': 'Empty form. Pick stdio or SSE / HTTP and fill the fields yourself.',
  'mcp.disabled': 'Disabled',
  'mcp.disconnect': 'Disconnect',
  'mcp.disconnectFailed': 'Disconnect failed. Check daemon logs.',
  'mcp.disconnecting': 'Disconnecting…',
  'mcp.displayNamePlaceholder': 'Display name (optional)',
  'mcp.enabled': 'Enabled',
  'mcp.enableServerAria': 'Enable this MCP server',
  'mcp.expand': 'Expand',
  'mcp.expandServerAria': 'Expand this MCP server',
  'mcp.expandToEdit': 'Expand to edit',
  'mcp.fieldArgs': 'Args',
  'mcp.fieldCommand': 'Command',
  'mcp.fieldEnv': 'Env (KEY=VALUE)',
  'mcp.fieldEnvShort': 'Env',
  'mcp.fieldHeaders': 'Headers (KEY=VALUE)',
  'mcp.fieldId': 'ID',
  'mcp.fieldOAuthMode': 'OAuth mode',
  'mcp.fieldTransport': 'Transport',
  'mcp.fieldUrl': 'URL',
  'mcp.homepage': 'Homepage',
  'mcp.idInvalid': 'ID must start with a letter or digit and only contain letters, digits, dash, or underscore (max 64 chars).',
  'mcp.jsonHelperExampleHead': 'Example MCP JSON',
  'mcp.jsonHelperHttpNote': 'use url + headers instead of command / args',
  'mcp.jsonHelperToggle': 'Need help? Map your MCP server\'s JSON config using the example below.',
  'mcp.moveDown': 'Move down',
  'mcp.moveUp': 'Move up',
  'mcp.noManagedOAuth': 'No managed OAuth.',
  'mcp.noManagedOAuthSaveDirect': 'Save this server and OpenDesign will use it directly.',
  'mcp.noManagedOAuthUseAsConfigured': 'OpenDesign will use this server as configured. Add headers below if the server needs a token.',
  'mcp.nonExpiringToken': 'Non-expiring token.',
  'mcp.notConnected': 'Not connected.',
  'mcp.openAuthorizationPage': 'Open authorization page',
  'mcp.pickerFilterPlaceholder': 'Filter by name, transport, capability…',
  'mcp.pickerHint': 'Pre-fills the form. You can still edit any field after.',
  'mcp.pickerNoMatch': 'No templates match “{query}”. Try clearing the filter or use the custom server option below.',
  'mcp.pickTemplate': 'Pick a template',
  'mcp.reauthenticateTitle': 'Reauthenticate (replaces the existing token)',
  'mcp.recheckTokenTitle': 'Re-check token status against the daemon',
  'mcp.reconnect': 'Reconnect',
  'mcp.refresh': 'Refresh',
  'mcp.removeServer': 'Remove this MCP server',
  'mcp.saveFirstThenClick': 'Save first, then click',
  'mcp.starting': 'Starting…',
  'mcp.toGrantOAuthAccess': 'to grant OpenDesign access via the provider\'s OAuth flow.',
  'mcp.tokenExpires': 'Token expires {time}.',
  'mcp.transportAria': 'Transport: {transport}',
  'mcp.tryLabel': 'Try:',
  'mcp.tryPromptTitle': 'Paste this prompt into the chat composer to try the server end-to-end',
  'mcp.unnamedServer': 'Unnamed MCP server',
  'mcp.urlMalformed': 'URL is malformed.',
  'mcp.urlProtocolInvalid': 'URL must use http:// or https://.',
  'mcp.urlRequired': 'URL is required for SSE / HTTP transport.',
  'mcp.waitingForAuthorization': 'Waiting for authorization…',
  'memory.connectorReadFailed': 'Couldn\'t read {name}.',
  'memory.connectorNoReadableContent': 'No readable content from {name}.',
  'memory.providerLocalCli': 'Local CLI',
  'memory.providerFallbackName': 'Memory model',
  'memory.extractionSourceConnector': 'Connected apps were read, but OpenDesign could not turn that context into memory.',
  'memory.extractionSourceChat': 'OpenDesign could not run memory extraction for this chat.',
  'memory.failureAuthExpiredTitle': '{provider} authentication expired',
  'memory.failureAuthActionCli': 'Sign in to the selected Local CLI or choose a different Memory model.',
  'memory.failureAuthActionKey': 'Update the Memory extraction model key or sign in again.',
  'memory.failureQuotaTitle': '{provider} quota or rate limit hit',
  'memory.failureQuotaAction': 'Try again later or switch the Memory extraction model.',
  'memory.failureRequestTitle': '{provider} request failed',
  'memory.failureRequestActionCli': 'Check the selected Local CLI and try again.',
  'memory.failureRequestActionProvider': 'Check the model provider connection and try again.',
  'memory.failureGenericTitle': 'Memory extraction failed',
  'memory.failureGenericActionCli': 'Try again after checking the selected Local CLI.',
  'memory.failureGenericActionSettings': 'Try again after checking the Memory extraction model settings.',
  'memory.noData': 'No data',
  'memory.attemptReadTitle': 'Read {name}',
  'memory.attemptFailedTitle': 'Could not read {name}',
  'memory.attemptSkippedTitle': 'Skipped {name}',
  'memory.skipChatDisabled': 'Chat conversation learning is off.',
  'memory.kindConnectedApps': 'Connected apps',
  'memory.timeAgo': '{time} ago',
  'memory.scanRunningTitle': 'Scanning connected apps',
  'memory.scanFailedTitle': 'Connected app scan failed',
  'memory.scanSkippedTitle': 'Connected app scan skipped',
  'memory.scanSavedOne': 'Saved {count} memory',
  'memory.scanSavedOther': 'Saved {count} memories',
  'memory.scanNoNewMemories': 'No new memories found',
  'memory.scanTitle': 'Connected app scan',
  'memory.scanMetaChecking': 'Checking selected apps',
  'memory.scanMetaNeedsAttention': 'Needs attention',
  'memory.scanMetaFromConnectedApps': 'From connected apps',
  'memory.scanMetaCheckedApps': 'Checked selected apps',
  'memory.scanBusyLabel': 'Scanning apps',
  'memory.scanSelectPrompt': 'Select apps to scan',
  'memory.scanSelectedApps': 'Scan selected apps',
  'memory.connectorReadFailedRetry': 'Could not read connected apps. Try again from the Connectors tab.',
  'memory.appCountOne': '{count} app',
  'memory.appCountOther': '{count} apps',
  'memory.foundSuggestionsOne': 'Found {count} suggested memory from {apps}. Review before saving.',
  'memory.foundSuggestionsOther': 'Found {count} suggested memories from {apps}. Review before saving.',
  'memory.noSuggestionsFound': 'No memory suggestions found. OpenDesign could not read useful content from the selected app yet.',
  'memory.checkedNoSuggestionsOne': 'Checked {count} selected app, but found no new memory suggestions.',
  'memory.checkedNoSuggestionsOther': 'Checked {count} selected apps, but found no new memory suggestions.',
  'memory.savedFromConnectedAppsOne': 'Saved {count} memory from connected apps.',
  'memory.savedFromConnectedAppsOther': 'Saved {count} memories from connected apps.',
  'memory.savedPartial': 'Saved {saved} of {total} selected memories. Please try the remaining items again.',
  'memory.tabManual': 'Add manually',
  'memory.tabManualCaption': 'Write a fact or preference',
  'memory.tabConnected': 'Import from apps',
  'memory.tabConnectedCaption': 'Scan connected tools',
  'memory.storagePathAria': 'Memory storage path — click to copy',
  'memory.flowOnboarding': 'Onboarding',
  'memory.flowBrandContext': 'Brand context',
  'memory.flowChatSignals': 'Chat signals',
  'memory.flowSavedMemory': 'Saved memory',
  'memory.howCopy': 'Memory is gathered automatically from profile setup, project and brand extraction, connected apps, and useful facts learned during chats. The saved list below is the review surface; everything else stays quiet unless you open Add or Advanced.',
  'memory.areasAria': 'Memory areas',
  'memory.manualPanelHint': 'Add facts, preferences, or project context yourself. Fixed assistant behavior lives in Instructions / Rules.',
  'memory.connectedPanelHint': 'Choose apps to scan for design preferences, project context, and visual references. Nothing is scanned until you select an app.',
  'memory.loading': 'Loading',
  'memory.connectedCount': '{count} connected',
  'memory.manage': 'Manage',
  'memory.chooseSources': 'Choose sources',
  'memory.chooseSourcesHint': 'Select connected apps first. OpenDesign only scans the apps you choose.',
  'memory.selectedCount': '{count} selected',
  'memory.connectorListAria': 'Connected memory apps',
  'memory.readToolsCount': '{count} read tools',
  'memory.checkingConnectionStatus': 'Checking connection status…',
  'memory.finishAuthorization': 'Finish authorization in your browser, then return here',
  'memory.connectBeforeExtraction': 'Connect this app before extraction',
  'memory.useConnectorAria': 'Use {name} for memory extraction',
  'memory.selected': 'Selected',
  'memory.select': 'Select',
  'memory.reconnectConnectorAria': 'Reconnect {name}',
  'memory.connectConnectorAria': 'Connect {name}',
  'memory.connectStateChecking': 'Checking',
  'memory.connectStateWaiting': 'Waiting',
  'memory.connectStateConnecting': 'Connecting',
  'memory.reconnect': 'Reconnect',
  'memory.selectedOfConnectedOne': 'Selected {count} of {total} connected app.',
  'memory.selectedOfConnectedOther': 'Selected {count} of {total} connected apps.',
  'memory.suggestedMemories': 'Suggested memories',
  'memory.suggestedMemoriesHint': 'Review design-related memories before saving them.',
  'memory.saving': 'Saving',
  'memory.saveSelected': 'Save selected',
  'memory.discard': 'Discard',
  'memory.diagnosticsAria': 'Connected app read status',
  'memory.lastScan': 'Last scan',
  'memory.bytesRead': '{bytes} read',
  'memory.recentScans': 'Recent scans',
  'memory.runHistoryAria': 'Connected app memory run status',
  'memory.savedMemoryHint': 'Saved facts, preferences, and project context available to future chats.',
  'memory.savedCount': '{count} saved',
  'memory.extractionCountOne': '{count} extraction',
  'memory.extractionCountOther': '{count} extractions',
  'memory.emptyHintBefore': 'Tell the assistant a fact in chat — e.g.',
  'memory.emptyHintAfter': '— and it will be saved here automatically.',
  'memory.advancedHint': 'Inspect or edit the underlying memory index.',
  'memory.memoryTree': 'Memory tree',
  'memory.memoryTreeHint': 'Technical view of the same saved memories. Most users only need the saved-memory list above.',
  'memory.nodeCountOne': '{count} node',
  'memory.nodeCountOther': '{count} nodes',
  'dsCreate.addingSourceMaterial': 'Adding source material...',
  'dsCreate.browseFolder': 'Browse folder',
  'dsCreate.confirmBody': 'You\'ll land in a project that fills in live — logo, palette, typography, imagery — as it measures your brand. Keep the tab open.',
  'dsCreate.confirmTitle': 'OpenDesign will extract your design system.',
  'dsCreate.designMdPreviewFallbackName': 'Design system',
  'dsCreate.dropZoneSelections': '{label} selections',
  'dsCreate.extractDesignSystem': 'Extract design system',
  'dsCreate.extractionAlreadyStarting': 'Extraction is already starting. Please wait for the current request to finish.',
  'dsCreate.figmaFileFallbackLabel': 'Figma file',
  'dsCreate.figmaUrlInvalid': 'Enter a Figma file URL (https://figma.com/file/… or /design/…).',
  'dsCreate.githubAccessAutoBody': 'GitHub repo links use the first working access method; other website links are saved as source references.',
  'dsCreate.githubAccessAutoTitle': 'GitHub access: Auto',
  'dsCreate.githubAccessMethodsAria': 'GitHub repository access methods',
  'dsCreate.githubAuthorizeFailed': 'Could not start GitHub authorization.',
  'dsCreate.githubBadgeAutomatic': 'Automatic',
  'dsCreate.githubBadgeChecking': 'Checking',
  'dsCreate.githubBadgeComingSoon': 'Coming soon',
  'dsCreate.githubBadgeConnected': 'Connected',
  'dsCreate.githubBadgeNeedsAttention': 'Needs attention',
  'dsCreate.githubBadgeNotConfigured': 'Not configured',
  'dsCreate.githubBadgeOptional': 'Optional',
  'dsCreate.githubBadgePending': 'Pending',
  'dsCreate.githubComposioCheckingDesc': 'Checking connector status in the background; URL intake is not blocked.',
  'dsCreate.githubComposioConnectedAsDesc': 'Composio GitHub connector connected as {account}; it is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioConnectedDesc': 'Composio GitHub connector is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioDefaultDesc': 'Composio GitHub connector access for agent tools; repo URLs still work with local git or GitHub CLI.',
  'dsCreate.githubComposioErrorDesc': 'Reconnect the Composio GitHub connector, or continue with local git/GitHub CLI.',
  'dsCreate.githubComposioNotConfiguredDesc': 'Add a Composio API key only if this project needs connector-backed GitHub tools.',
  'dsCreate.githubComposioPendingDesc': 'Finish the Composio authorization window; local GitHub intake remains available.',
  'dsCreate.githubConfigureComposio': 'Configure Composio',
  'dsCreate.githubConnecting': 'Connecting...',
  'dsCreate.githubConnectorCheckFailed': 'Could not check the GitHub connector.',
  'dsCreate.githubConnectorCheckTimeout': 'Could not finish checking GitHub connector. You can still add repository URLs or connect GitHub manually.',
  'dsCreate.githubConnectViaComposio': 'Connect via Composio',
  'dsCreate.githubDisconnect': 'Disconnect',
  'dsCreate.githubDisconnectFailed': 'Could not disconnect GitHub.',
  'dsCreate.githubDisconnecting': 'Disconnecting...',
  'dsCreate.githubHideAccessMethods': 'Hide access methods',
  'dsCreate.githubMethodConnectorPlatform': 'Connector platform',
  'dsCreate.githubMethodOdAccount': 'OpenDesign account',
  'dsCreate.githubMethodOdAccountDesc': 'Native GitHub sign-in managed by OpenDesign; this build does not use an OD-managed GitHub token yet.',
  'dsCreate.githubMethodThisDevice': 'This device',
  'dsCreate.githubMethodThisDeviceDesc': 'Uses public git clone, local git credentials, or GitHub CLI auth available on this machine.',
  'dsCreate.githubOpenAuthorization': 'Open authorization',
  'dsCreate.githubShowAccessMethods': 'Show access methods',
  'dsCreate.libraryPartiallyAdded': 'Added {added} of {total} item(s) from the library.',
  'dsCreate.localCodeFilesSelected': '{count} local code files selected',
  'dsCreate.prepareProjectFailed': 'Could not prepare the design system project.',
  'dsCreate.removeFile': 'Remove {name}',
  'dsCreate.startingExtraction': 'Starting extraction...',
  'dsFlow.activityDetailFailed': 'The chat message has the run details. You can adjust the request and try again.',
  'dsFlow.activityDetailReady': 'Review the updated Design System and Design Files tabs.',
  'dsFlow.activityDetailRunning': 'Watching project files and preparing the review draft.',
  'dsFlow.activityFailedTitle': 'Workspace update needs attention',
  'dsFlow.activityProgressAria': 'Workspace update progress {progress}%',
  'dsFlow.activityReadyTitle': 'Workspace update ready',
  'dsFlow.activityRunningTitle': 'OpenDesign is updating this system',
  'dsFlow.addBrandFonts': 'Add brand font files',
  'dsFlow.agentMsgCapturedDirection': 'Captured direction: {summary}',
  'dsFlow.agentMsgCreating': 'I am creating the design system workspace, preview cards, and supporting files from the context you provided.',
  'dsFlow.agentMsgReady': 'Your design system draft is ready. Review the Design System tab, inspect generated files, publish it, or ask me for changes here.',
  'dsFlow.agentMsgRevision': 'I am applying your feedback to the design system. You can keep reviewing the current draft while the revision runs.',
  'dsFlow.agentMsgTokenRebuild': 'I am preparing a token contract rebuild for review. The active contract will stay unchanged until the revision is accepted.',
  'dsFlow.agentPushLayer': 'Agent push layer',
  'dsFlow.assetsLabel': 'Assets',
  'dsFlow.auditNeedsRepair': '{summary} Review the audit details before running a repair.',
  'dsFlow.brandFontsMissingBody': 'Typography previews are using substitute web fonts until brand font files are added.',
  'dsFlow.brandFontsMissingTitle': 'Brand font files missing',
  'dsFlow.chatCreateRequest': 'Create design system',
  'dsFlow.chatSeedUpdateSystem': 'Update this design system: ',
  'dsFlow.composerPlaceholder': 'Follow-up action: use AI extraction to refine this system. Longer run; updates land here.',
  'dsFlow.conversationCreateFailed': 'Could not create a design system conversation.',
  'dsFlow.evidenceFallbackTokens': 'Fallback tokens',
  'dsFlow.evidenceFonts': 'Fonts',
  'dsFlow.evidenceIndexes': 'Evidence indexes',
  'dsFlow.evidenceScannedFiles': 'Scanned files',
  'dsFlow.evidenceSnippets': 'Snippets',
  'dsFlow.evidenceSourceTokens': 'Source tokens',
  'dsFlow.fileDraftPreview': 'File draft preview',
  'dsFlow.filesTouched': 'Files touched',
  'dsFlow.forceRebuild': 'Force',
  'dsFlow.generalRevision': 'General revision',
  'dsFlow.generationCompleted': 'Generation completed',
  'dsFlow.generationProgressAria': 'Generation progress {progress}%',
  'dsFlow.generationStopped': 'Generation stopped',
  'dsFlow.generationStoppedWithError': 'Generation stopped: {error}',
  'dsFlow.jobCompleted': '{noun} completed',
  'dsFlow.jobDetailGeneration': 'Preparing the remaining files.',
  'dsFlow.jobDetailReady': 'Review workspace is ready.',
  'dsFlow.jobDetailRevision': 'Applying your feedback.',
  'dsFlow.jobDetailTokenRebuild': 'Preparing a reviewable token contract draft.',
  'dsFlow.jobNeedsAttention': '{noun} needs attention',
  'dsFlow.jobNounGeneration': 'Generation',
  'dsFlow.jobNounRevision': 'Revision',
  'dsFlow.jobNounTokenRebuild': 'Token rebuild',
  'dsFlow.jobRebuildingTokens': 'OpenDesign is rebuilding tokens',
  'dsFlow.jobRevising': 'OpenDesign is revising',
  'dsFlow.jobStillWorking': 'OpenDesign is still working',
  'dsFlow.loadingDesignSystem': 'Loading design system...',
  'dsFlow.metaEvidenceNotes': 'Evidence notes',
  'dsFlow.metaScannedInventory': 'Scanned file inventory',
  'dsFlow.metaSnippetIndex': 'Snippet index',
  'dsFlow.metaTokenExtraction': 'Token extraction evidence',
  'dsFlow.metaTokenReport': 'Token contract quality report',
  'dsFlow.movedBackToDraft': 'Moved back to draft',
  'dsFlow.needsWorkSeed': 'Needs work on {title}: ',
  'dsFlow.no': 'No',
  'dsFlow.openingDesignSystemWorkspace': 'Opening the design system workspace...',
  'dsFlow.openingWorkspace': 'Opening the workspace...',
  'dsFlow.packageFallbackMeta': '{source} · DESIGN.md-only fallback',
  'dsFlow.packageLegacy': 'Legacy design system',
  'dsFlow.packageManifestMeta': '{source} · {mode} mode · manifest indexed',
  'dsFlow.packagePillFallback': 'Fallback',
  'dsFlow.packagePillReady': 'Hybrid ready',
  'dsFlow.packageStructured': 'Structured import package',
  'dsFlow.pendingRevision': 'Pending revision',
  'dsFlow.pickLocalAgentFirst': 'Pick a local agent first, then ask OpenDesign to update this design system.',
  'dsFlow.previewPages': 'Preview pages',
  'dsFlow.proposedChanges': 'Proposed changes',
  'dsFlow.publishCardReady': 'OpenDesign is ready for review. Give feedback on the work so far, then publish when it is useful for future projects.',
  'dsFlow.publishCardRevision': 'OpenDesign is applying your feedback. You can keep reviewing while the updated draft is prepared.',
  'dsFlow.publishCardTokenRebuild': 'OpenDesign is preparing a token contract rebuild for review. The active contract stays unchanged until you accept it.',
  'dsFlow.publishCardWorking': 'OpenDesign is still working, but you can start giving feedback on the work so far.',
  'dsFlow.pullLayer': 'Pull layer',
  'dsFlow.rebuildTokenContract': 'Rebuild token contract',
  'dsFlow.reviewDraftTitle': 'Review draft design system',
  'dsFlow.revisionAccept': 'Accept',
  'dsFlow.revisionAccepted': 'Revision accepted',
  'dsFlow.revisionAcceptFailed': 'Could not accept revision',
  'dsFlow.revisionHistory': 'Revision history',
  'dsFlow.revisionMsgAccepted': 'Accepted. The design system draft now includes this update.',
  'dsFlow.revisionMsgPending': 'I prepared a proposed update. Review the diff card on the right, then accept it or ask for another change.',
  'dsFlow.revisionMsgRejected': 'Rejected. I left the current design system unchanged.',
  'dsFlow.revisionProgressUnavailable': 'Could not read revision progress',
  'dsFlow.revisionReady': 'Revision ready for review',
  'dsFlow.revisionReject': 'Reject',
  'dsFlow.revisionRejected': 'Revision rejected',
  'dsFlow.revisionRejectFailed': 'Could not reject revision',
  'dsFlow.revisionStopped': 'Revision stopped',
  'dsFlow.revisionStoppedWithError': 'Revision stopped: {error}',
  'dsFlow.saveChangesFailed': 'Could not save changes',
  'dsFlow.savedDesignMd': 'Saved DESIGN.md',
  'dsFlow.sectionDraftBody': 'Draft body',
  'dsFlow.sectionFallbackTitle': 'Section',
  'dsFlow.sectionMarkedLooksGood': '{title} marked as looks good',
  'dsFlow.sectionNoContent': 'No content yet.',
  'dsFlow.sectionNoDetails': 'No details yet.',
  'dsFlow.setDefaultAction': 'Default for new chats',
  'dsFlow.setDefaultTitle': 'Preselect this design system for new chats and new projects.',
  'dsFlow.sourceEvidence': 'Source evidence',
  'dsFlow.sourceTypeBundled': 'Bundled',
  'dsFlow.sourceTypeDefault': 'Design system',
  'dsFlow.sourceTypeGithub': 'GitHub import',
  'dsFlow.sourceTypeInstalled': 'Installed',
  'dsFlow.sourceTypeLocal': 'Local import',
  'dsFlow.sourceTypeUser': 'User workspace',
  'dsFlow.statusUpdateFailed': 'Could not update status',
  'dsFlow.stepReadCurrentSystem': 'Read current system',
  'dsFlow.stepRefreshReview': 'Refresh review',
  'dsFlow.stepUpdateDesignFiles': 'Update design files',
  'dsFlow.subtitleBrand': 'Logo, voice and usage rules',
  'dsFlow.subtitleColor': 'Palette and semantic roles',
  'dsFlow.subtitleComponents': 'Reusable interface patterns',
  'dsFlow.subtitleDefault': 'Design guidance',
  'dsFlow.subtitleSpacing': 'Spacing scale and radius tokens',
  'dsFlow.subtitleTypography': 'Text hierarchy and styles',
  'dsFlow.tabDesignFiles': 'Design Files',
  'dsFlow.tabDesignSystem': 'Design System',
  'dsFlow.tokenContractLabel': 'Token contract',
  'dsFlow.tokenContractRebuildRecommended': 'rebuild recommended',
  'dsFlow.tokenContractReportAvailable': 'quality report available',
  'dsFlow.tokenContractScore': 'score {score}',
  'dsFlow.tokenRebuildStarted': 'Token contract rebuild started',
  'dsFlow.tokenRebuildStartFailed': 'Could not start token contract rebuild',
  'dsFlow.workspaceOpenFailed': 'Could not open the design system workspace.',
  'dsFlow.workspaceUpdatedReview': 'Workspace updated. Review the files or ask for another change.',
  'dsFlow.workspaceUpdatedSynced': 'Workspace updated and DESIGN.md synced for review.',
  'dsFlow.workspaceUpdatedWithAudit': 'Workspace updated. {summary}',
  'dsFlow.yes': 'Yes',
  'pluginDetail.backToList': 'Back to list',
  'pluginDetail.quickCommands': 'Quick commands',
  'pluginDetail.noQuickCommands': 'No quick commands available.',
  'pluginDetail.dataConnections': 'Data connections',
  'pluginDetail.noDataConnections': 'This suite does not require any external data connections.',
  'pluginDetail.knowledgeSkills': 'Knowledge skills',
  'pluginDetail.noKnowledgeSkills': 'This suite has no standalone knowledge skills yet.',
  'pluginDetail.officialBadge': 'OpenDesign official',
  'pluginDetail.loadFailed': 'Failed to load plugin: {error}',
  'pluginDetail.applyFailed': 'Apply failed. Make sure the daemon is reachable.',
  'pluginDetail.examples': 'Examples',
  'skillDetail.providedBy': 'provided by {author}',
  'skillDetail.markdownNotice': 'The following content is taken verbatim from this skill’s SKILL.md',
  'skillDetail.loadFailed': 'Couldn’t load this skill’s SKILL.md.',
  'skillDetail.previewAria': '{title} SKILL.md preview',
  'common.dismiss': 'Dismiss',
  'campaign.deepseekV4Flash.headline': 'Kali ini, kecerdasan kelas atas. Tanpa batas.',
  'campaign.deepseekV4Flash.description': 'Landing, situs, deck, dan gambar — sebanyak yang Anda butuhkan.',
  'campaign.deepseekV4Flash.benefit': 'DeepSeek V4 Pro dan V4 Flash tanpa batas',
  'campaign.deepseekV4Flash.timing': '13–27 Agu: gratis selama jendela kampanye',
  'campaign.deepseekV4Flash.ruleSummary': 'Pada 13–27 Agu, pengguna berbayar dapat memakai DeepSeek V4 Pro dan V4 Flash gratis di OpenDesign. Penyalahgunaan berskala besar dapat menghentikan akses kampanye.',
  'campaign.deepseekV4Flash.windowLabel': '13–27 Agu',
  'campaign.deepseekV4Flash.weekFreeSuffix': 'dua minggu gratis',
  'campaign.deepseekV4Flash.boundary': 'Kuota model tanpa batas dan jumlah generate gratis di paket hanya berlaku di dalam OpenDesign — bukan lewat MCP, CLI, API, atau permukaan lain. Interpretasi akhir ada di OpenDesign. Beberapa model mungkin perlu antre pada jam sibuk.',
  'campaign.deepseekV4Flash.countdownLabel': 'Hitung mundur kampanye',
  'campaign.deepseekV4Flash.countdownEnded': 'Kampanye berakhir',
  'campaign.deepseekV4Flash.countdownRemaining': '{days}h {hms}',
  'campaign.deepseekV4Flash.closeAria': 'Tutup',
  'campaign.deepseekV4Flash.unlocked': 'Terbuka',
  'campaign.deepseekV4Flash.locked': 'Terkunci',
  'campaign.deepseekV4Flash.later': 'Nanti saja',
  'campaign.deepseekV4Flash.paid.eyebrow': 'Dua minggu gratis',
  'campaign.deepseekV4Flash.paid.status': 'Terbuka · 13–27 Agu',
  'campaign.deepseekV4Flash.paid.cta': 'Pakai sekarang',
  'campaign.deepseekV4Flash.paid.modelBadge': 'Tanpa batas',
  'campaign.deepseekV4Flash.unpaid.eyebrow': 'Gratis untuk paket berbayar',
  'campaign.deepseekV4Flash.unpaid.status': 'Upgrade untuk membuka · hingga 27 Agu',
  'campaign.deepseekV4Flash.unpaid.cta': 'Upgrade dan pakai',
  'campaign.deepseekV4Flash.unpaid.modelBadge': 'Perlu upgrade',
  'campaign.deepseekV4Flash.unpaid.tooltip': 'Berlangganan selama jendela kampanye untuk memakai gratis; berakhir 27 Agu.',
  'campaign.deepseekV4Flash.restricted.modelBadge': 'Dijeda',
  'campaign.deepseekV4Flash.restricted.tooltip': 'Penggunaan volume tinggi yang tidak biasa terdeteksi, jadi akses kampanye dijeda. Hubungi dukungan jika butuh bantuan.',
  'campaign.deepseekV4Flash.workbenchBadge': 'DeepSeek V4 Pro + V4 Flash tanpa batas dan gratis',
  'campaign.deepseekV4Flash.workbenchBadgeAria': 'DeepSeek V4 Pro dan V4 Flash tanpa batas dan gratis — lihat harga',

  'experienceSurvey.tag': "Kami ingin dengar masukan Anda — bantu sempurnakan OpenDesign",
  'experienceSurvey.close': "Tutup",
  'experienceSurvey.recommendation': "Seberapa besar kemungkinan Anda merekomendasikan OpenDesign ke rekan atau teman?",
  'experienceSurvey.recommendationLow': "Sangat tidak mungkin",
  'experienceSurvey.recommendationHigh': "Sangat mungkin",
  'experienceSurvey.improvement': "Mana yang harus kami perbaiki lebih dulu?",
  'experienceSurvey.improvement.wrongOutput': "Bukan yang saya minta",
  'experienceSurvey.improvement.falseDone': "Katanya selesai, tapi tidak berubah",
  'experienceSurvey.improvement.hardToUse': "Sulit digunakan",
  'experienceSurvey.improvement.upgradePrompts': "Terlalu banyak ajakan berlangganan",
  'experienceSurvey.improvement.stuck': "Macet atau gagal",
  'experienceSurvey.improvement.slow': "Terlalu lambat",
  'experienceSurvey.improvement.looks': "Hasilnya kurang bagus",
  'experienceSurvey.improvement.regression': "Merusak bagian lain",
  'experienceSurvey.improvement.other': "Hal lain",
  'experienceSurvey.otherPlaceholder': "Ceritakan dengan kata-kata Anda",
  'experienceSurvey.submit': "Kirim",
  'experienceSurvey.skip': "Lewati",
  'experienceSurvey.thanksTitle': "Terima kasih!",
  'experienceSurvey.thanksBody': "Masukan Anda langsung sampai ke tim.",
  'chat.record.verb.read': "Dibaca",
  'chat.record.verb.write': "Dibuat",
  'chat.record.verb.edit': "Diubah",
  'chat.record.verb.search': "Dicari",
  'chat.record.verb.exec': "Dijalankan",
  'chat.record.failed': "Gagal",
  'chat.record.hits': "{count} hasil",
  'chat.record.slowUpstream': 'Penyedia lambat merespons — menunggu {seconds}d',
  'chat.record.running': "Berjalan",
  'chat.record.thinking': "Berpikir",
  'chat.record.thinkingTokens': "{count} token",
  'chat.record.thoughts': "Proses berpikir",
  'chat.record.done': "Selesai",
  'chat.record.failedTurn': "Gagal dijalankan",
  'chat.record.plan': "Rencana · {count} langkah",
  'chat.record.planStep': "Langkah {current} dari {total}",
  'chat.record.imageBatch': "Membuat ilustrasi",
  'chat.record.imageCount': "{count} gambar",
  'chat.record.retry': "Coba lagi",
  'chat.record.viewImage': "Lihat gambar {index}",
  'chat.record.viewLarge': "Lihat ukuran penuh",
  'chat.record.imagePending': "Membuat ilustrasi…",
  'chat.record.audioBatch': "Membuat audio",
  'chat.record.videoBatch': "Membuat video",
  'chat.record.audioCount': "{count} klip",
  'chat.record.videoCount': "{count} video",
  'chat.record.audioPending': "Membuat audio…",
  'chat.record.videoPending': "Membuat video…",
  'chat.record.viewAudio': "Buka audio {index}",
  'chat.record.viewVideo': "Buka video {index}",
  'chat.designSystemStatus.title': "Membuat workspace design system",
  'chat.designSystemStatus.description': "Open Design sedang memakai sumber penyiapan untuk membuat proyek ini.",
  'labs.title': "Open Design Labs",
  'labs.itemAbout': "Tentang {name}",
  'labs.navHint': "Coba fitur sebelum dirilis.",
  'labs.pageDesc': "Dapatkan akses awal ke kemampuan yang belum dirilis. Umumnya lebih baik dari perilaku saat ini, dan mematikannya langsung mengembalikan keadaan sekarang.",
  'labs.harnessName': "Design Harness",
  'labs.harnessHint': "Setelah diaktifkan, generasi berikutnya memakai strategi terbaru OpenDesign dengan hasil yang jauh lebih rapi (beta)",
  'labs.harnessTooltip': "Beralih ke agent harness yang dibangun Open Design untuk pekerjaan desain. Tata letak, struktur, dan kelengkapan hasil terasa jauh lebih baik.",
  'labs.harnessScope': "Saat ini mencakup prototipe, slide, aset pemasaran, dan Hyperframes. Sebagian agent belum didukung.",
  'labs.envOverrideNotice': "Pengaturan ini dikendalikan variabel lingkungan, jadi tidak bisa diubah di sini.",
  'labs.loadFailedNotice': "Tidak bisa membaca pengaturan ini. Pastikan daemon lokal sedang berjalan.",
  'labs.optOutPrompt': "Kembali ke metode sebelumnya. Apa yang kurang pas?",
  'labs.optOutWorseOutput': "Hasil jadi lebih buruk",
  'labs.optOutTooSlow': "Terlalu lambat",
  'labs.optOutNotWhatIWanted': "Bukan yang saya inginkan",
  'labs.optOutOther': "Lainnya",
  'labs.optOutSkip': "Lewati",
  'labs.optOutOtherPlaceholder': "Apa yang kurang pas secara spesifik?",
  'labs.optOutSubmit': "Kirim",
  'chat.conversationsSearchPlaceholder': "Cari percakapan",
  'chat.conversationsNoMatches': "Tidak ada percakapan yang cocok.",
  'chat.attachments.preview': "Pratinjau {name}",
  'chat.record.canceled': "Dibatalkan",
  'chat.record.pending': "Belum dimulai",
  'chat.record.unfinished': "Belum selesai",
};
